/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** `asc`/`desc` scalar type */
  AscDesc: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AccruedFee = {
  __typename?: 'AccruedFee';
  accruedTimes: Array<AccruedTime>;
  actualFee: Scalars['Float']['output'];
  actualFeePercentage: Scalars['Float']['output'];
  actualFeeRiskLevel: RiskLevel;
  actualFeeVariance: Scalars['Float']['output'];
  actualGpm: Scalars['Float']['output'];
  actualGpmRiskLevel: RiskLevel;
  actualTimeAccrued: Scalars['Float']['output'];
  agreedPrice: Maybe<PriceOrPriceRange>;
  amountBilled: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  clientId: Scalars['Float']['output'];
  clientName: Scalars['String']['output'];
  collaborators: Array<Collaborator>;
  currencySymbol: Scalars['String']['output'];
  externalMatterId: Maybe<Scalars['Float']['output']>;
  gpmDangerThreshold: Scalars['Float']['output'];
  gpmSource: Scalars['String']['output'];
  gpmWarningThreshold: Maybe<Scalars['Float']['output']>;
  invoices: Array<Invoice>;
  leadFeeEarner: Maybe<FeeEarner>;
  matter: Matter;
  matterCreatedAt: Scalars['DateTimeISO']['output'];
  matterId: Scalars['Float']['output'];
  matterTitle: Scalars['String']['output'];
  mostRecentTimeEntry: Maybe<Scalars['DateTimeISO']['output']>;
  percentageOnTarget: Scalars['Float']['output'];
  plannedFee: PriceOrPriceRange;
  plannedGpm: Scalars['Float']['output'];
  pricingType: PricingTypeEnum;
  subMatters: Array<AccruedFee>;
};

export type AccruedFeeForUserPagination = {
  matterStatus?: InputMaybe<MatterStatus>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AccruedFeePagination = {
  matterStatus?: InputMaybe<MatterStatus>;
  organisationUnitId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AccruedFeesForUser = {
  __typename?: 'AccruedFeesForUser';
  items: Array<AccruedFee>;
  total: Scalars['Int']['output'];
};

export type AccruedTime = {
  __typename?: 'AccruedTime';
  actualCost: Scalars['Float']['output'];
  actualCostSinceLastInvoice: Scalars['Float']['output'];
  actualDuration: Scalars['Float']['output'];
  actualDurationSinceLastInvoice: Scalars['Float']['output'];
  actualFee: Scalars['Float']['output'];
  actualFeeSinceLastInvoice: Scalars['Float']['output'];
  currencySymbol: Scalars['String']['output'];
  durationAsPercentageOfTotalMatterDuration: Scalars['Float']['output'];
  feeEarnerId: Scalars['Float']['output'];
  feeEarnerLevelDescription: Scalars['String']['output'];
  feeEarnerName: Scalars['String']['output'];
};

export type AggregateUsageData = {
  __typename?: 'AggregateUsageData';
  externalMattersByStatus: Array<CountByField>;
  mattersByLinkedUnlinked: Array<CountByField>;
  mattersByPracticeArea: Array<CountByField>;
  mattersByStatus: Array<CountByField>;
  mattersByUser: Array<CountByField>;
  practiceAreas: Array<AggregratePracticeAreaData>;
  templatesByPracticeArea: Array<CountByField>;
  totalCount: Scalars['Float']['output'];
};

export type AggregratePracticeAreaData = {
  __typename?: 'AggregratePracticeAreaData';
  byLinkedUnlinked: Array<CountByField>;
  byStatus: Array<CountByField>;
  practiceArea: PracticeArea;
  templatesByTemplateType: Array<CountByField>;
};

export type AllItemsResult = {
  __typename?: 'AllItemsResult';
  disbursements: TotalWithGroupsResult;
  discounts: GroupsResultMixedUnits;
  legalFees: TotalWithLegalFeeGroupsResult;
  uplifts: GroupsResultMixedUnits;
};

export type AnalysisAndRecommendations = {
  __typename?: 'AnalysisAndRecommendations';
  analysis: Scalars['String']['output'];
  recommendations: Array<Scalars['String']['output']>;
};

export type AssignedResource = {
  __typename?: 'AssignedResource';
  feeEarnerLevelDescription: Scalars['String']['output'];
  feeEarnerName: Maybe<Scalars['String']['output']>;
  rate: PriceOrPriceRange;
};

export type Assumption = {
  __typename?: 'Assumption';
  autoFocus: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  default: Maybe<Scalars['Boolean']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  fromLibraryAssumptionId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mandatory: Maybe<Scalars['Boolean']['output']>;
  matterId: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AssumptionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fromLibraryAssumption?: InputMaybe<LibraryAssumptionCreateNestedOneWithoutAssumptionsInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutAssumptionsInput;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AssumptionCreateManyFromLibraryAssumptionInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  matterId: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AssumptionCreateManyFromLibraryAssumptionInputEnvelope = {
  data: Array<AssumptionCreateManyFromLibraryAssumptionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssumptionCreateManyMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fromLibraryAssumptionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AssumptionCreateManyMatterInputEnvelope = {
  data: Array<AssumptionCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssumptionCreateNestedManyWithoutFromLibraryAssumptionInput = {
  connect?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AssumptionCreateOrConnectWithoutFromLibraryAssumptionInput>>;
  create?: InputMaybe<Array<AssumptionCreateWithoutFromLibraryAssumptionInput>>;
  createMany?: InputMaybe<AssumptionCreateManyFromLibraryAssumptionInputEnvelope>;
};

export type AssumptionCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AssumptionCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<AssumptionCreateWithoutMatterInput>>;
  createMany?: InputMaybe<AssumptionCreateManyMatterInputEnvelope>;
};

export type AssumptionCreateOrConnectWithoutFromLibraryAssumptionInput = {
  create: AssumptionCreateWithoutFromLibraryAssumptionInput;
  where: AssumptionWhereUniqueInput;
};

export type AssumptionCreateOrConnectWithoutMatterInput = {
  create: AssumptionCreateWithoutMatterInput;
  where: AssumptionWhereUniqueInput;
};

export type AssumptionCreateWithoutFromLibraryAssumptionInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutAssumptionsInput;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AssumptionCreateWithoutMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fromLibraryAssumption?: InputMaybe<LibraryAssumptionCreateNestedOneWithoutAssumptionsInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AssumptionListRelationFilter = {
  every?: InputMaybe<AssumptionWhereInput>;
  none?: InputMaybe<AssumptionWhereInput>;
  some?: InputMaybe<AssumptionWhereInput>;
};

export type AssumptionScalarWhereInput = {
  AND?: InputMaybe<Array<AssumptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<AssumptionScalarWhereInput>>;
  OR?: InputMaybe<Array<AssumptionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fromLibraryAssumptionId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AssumptionUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fromLibraryAssumption?: InputMaybe<LibraryAssumptionUpdateOneWithoutAssumptionsNestedInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutAssumptionsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AssumptionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AssumptionUpdateManyWithWhereWithoutFromLibraryAssumptionInput = {
  data: AssumptionUpdateManyMutationInput;
  where: AssumptionScalarWhereInput;
};

export type AssumptionUpdateManyWithWhereWithoutMatterInput = {
  data: AssumptionUpdateManyMutationInput;
  where: AssumptionScalarWhereInput;
};

export type AssumptionUpdateManyWithoutFromLibraryAssumptionNestedInput = {
  connect?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AssumptionCreateOrConnectWithoutFromLibraryAssumptionInput>>;
  create?: InputMaybe<Array<AssumptionCreateWithoutFromLibraryAssumptionInput>>;
  createMany?: InputMaybe<AssumptionCreateManyFromLibraryAssumptionInputEnvelope>;
  delete?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AssumptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  set?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  update?: InputMaybe<Array<AssumptionUpdateWithWhereUniqueWithoutFromLibraryAssumptionInput>>;
  updateMany?: InputMaybe<Array<AssumptionUpdateManyWithWhereWithoutFromLibraryAssumptionInput>>;
  upsert?: InputMaybe<Array<AssumptionUpsertWithWhereUniqueWithoutFromLibraryAssumptionInput>>;
};

export type AssumptionUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AssumptionCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<AssumptionCreateWithoutMatterInput>>;
  createMany?: InputMaybe<AssumptionCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AssumptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  set?: InputMaybe<Array<AssumptionWhereUniqueInput>>;
  update?: InputMaybe<Array<AssumptionUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<AssumptionUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<AssumptionUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type AssumptionUpdateWithWhereUniqueWithoutFromLibraryAssumptionInput = {
  data: AssumptionUpdateWithoutFromLibraryAssumptionInput;
  where: AssumptionWhereUniqueInput;
};

export type AssumptionUpdateWithWhereUniqueWithoutMatterInput = {
  data: AssumptionUpdateWithoutMatterInput;
  where: AssumptionWhereUniqueInput;
};

export type AssumptionUpdateWithoutFromLibraryAssumptionInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutAssumptionsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AssumptionUpdateWithoutMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fromLibraryAssumption?: InputMaybe<LibraryAssumptionUpdateOneWithoutAssumptionsNestedInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AssumptionUpsertWithWhereUniqueWithoutFromLibraryAssumptionInput = {
  create: AssumptionCreateWithoutFromLibraryAssumptionInput;
  update: AssumptionUpdateWithoutFromLibraryAssumptionInput;
  where: AssumptionWhereUniqueInput;
};

export type AssumptionUpsertWithWhereUniqueWithoutMatterInput = {
  create: AssumptionCreateWithoutMatterInput;
  update: AssumptionUpdateWithoutMatterInput;
  where: AssumptionWhereUniqueInput;
};

export type AssumptionWhereInput = {
  AND?: InputMaybe<Array<AssumptionWhereInput>>;
  NOT?: InputMaybe<Array<AssumptionWhereInput>>;
  OR?: InputMaybe<Array<AssumptionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fromLibraryAssumption?: InputMaybe<LibraryAssumptionNullableRelationFilter>;
  fromLibraryAssumptionId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AssumptionWhereUniqueInput = {
  AND?: InputMaybe<Array<AssumptionWhereInput>>;
  NOT?: InputMaybe<Array<AssumptionWhereInput>>;
  OR?: InputMaybe<Array<AssumptionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fromLibraryAssumption?: InputMaybe<LibraryAssumptionNullableRelationFilter>;
  fromLibraryAssumptionId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BaseAccruedFee = {
  __typename?: 'BaseAccruedFee';
  accruedTimes: Array<AccruedTime>;
  actualFee: Scalars['Float']['output'];
  actualGpm: Scalars['Float']['output'];
  actualTimeAccrued: Scalars['Float']['output'];
  amountBilled: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  clientName: Scalars['String']['output'];
  currencySymbol: Scalars['String']['output'];
  externalMatterId: Scalars['Float']['output'];
  invoices: Array<Invoice>;
  matterTitle: Scalars['String']['output'];
};

export type BaseMatterResult = {
  __typename?: 'BaseMatterResult';
  client: Maybe<Client>;
  collaborators: Maybe<Array<Collaborator>>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  currency: Maybe<Currency>;
  externalMatterId: Maybe<Scalars['Int']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isFavourite: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  organisationalUnit: Maybe<OrganisationalUnit>;
  priceOptions: Maybe<PriceOptions>;
  reference: Scalars['String']['output'];
  status: MatterStatus;
  teamMemberships: Maybe<Array<TeamMembership>>;
  template: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type Brand = {
  __typename?: 'Brand';
  createdAt: Scalars['DateTimeISO']['output'];
  footer: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  includeRatesInProposalOutput: Scalars['Boolean']['output'];
  includeTasksInProposalOutput: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  lineBreakInLists: Scalars['Boolean']['output'];
  numberedListFormat: Scalars['String']['output'];
  organisationLogo: Maybe<Scalars['String']['output']>;
  organisationName: Maybe<Scalars['String']['output']>;
  proposalFont: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BrandCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<BrandWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BrandCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<BrandCreateWithoutMattersInput>;
};

export type BrandCreateNestedOneWithoutParentMattersInput = {
  connect?: InputMaybe<BrandWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BrandCreateOrConnectWithoutParentMattersInput>;
  create?: InputMaybe<BrandCreateWithoutParentMattersInput>;
};

export type BrandCreateOrConnectWithoutMattersInput = {
  create: BrandCreateWithoutMattersInput;
  where: BrandWhereUniqueInput;
};

export type BrandCreateOrConnectWithoutParentMattersInput = {
  create: BrandCreateWithoutParentMattersInput;
  where: BrandWhereUniqueInput;
};

export type BrandCreateWithoutMattersInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  lineBreakInLists?: InputMaybe<Scalars['Boolean']['input']>;
  numberedListFormat?: InputMaybe<Scalars['String']['input']>;
  organisationLogo?: InputMaybe<Scalars['String']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutBrandInput>;
  proposalFont?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BrandCreateWithoutParentMattersInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  lineBreakInLists?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutBrandInput>;
  numberedListFormat?: InputMaybe<Scalars['String']['input']>;
  organisationLogo?: InputMaybe<Scalars['String']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  proposalFont?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BrandInput = {
  footer?: InputMaybe<Scalars['Upload']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  organisationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  proposalFont?: InputMaybe<Scalars['String']['input']>;
};

export type BrandNullableRelationFilter = {
  is?: InputMaybe<BrandWhereInput>;
  isNot?: InputMaybe<BrandWhereInput>;
};

export type BrandUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<BrandWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BrandCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<BrandCreateWithoutMattersInput>;
  delete?: InputMaybe<BrandWhereInput>;
  disconnect?: InputMaybe<BrandWhereInput>;
  update?: InputMaybe<BrandUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<BrandUpsertWithoutMattersInput>;
};

export type BrandUpdateOneWithoutParentMattersNestedInput = {
  connect?: InputMaybe<BrandWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BrandCreateOrConnectWithoutParentMattersInput>;
  create?: InputMaybe<BrandCreateWithoutParentMattersInput>;
  delete?: InputMaybe<BrandWhereInput>;
  disconnect?: InputMaybe<BrandWhereInput>;
  update?: InputMaybe<BrandUpdateToOneWithWhereWithoutParentMattersInput>;
  upsert?: InputMaybe<BrandUpsertWithoutParentMattersInput>;
};

export type BrandUpdateToOneWithWhereWithoutMattersInput = {
  data: BrandUpdateWithoutMattersInput;
  where?: InputMaybe<BrandWhereInput>;
};

export type BrandUpdateToOneWithWhereWithoutParentMattersInput = {
  data: BrandUpdateWithoutParentMattersInput;
  where?: InputMaybe<BrandWhereInput>;
};

export type BrandUpdateWithoutMattersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  footer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<BoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lineBreakInLists?: InputMaybe<BoolFieldUpdateOperationsInput>;
  numberedListFormat?: InputMaybe<StringFieldUpdateOperationsInput>;
  organisationLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organisationName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutBrandNestedInput>;
  proposalFont?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BrandUpdateWithoutParentMattersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  footer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<BoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lineBreakInLists?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutBrandNestedInput>;
  numberedListFormat?: InputMaybe<StringFieldUpdateOperationsInput>;
  organisationLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organisationName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proposalFont?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BrandUpsertWithoutMattersInput = {
  create: BrandCreateWithoutMattersInput;
  update: BrandUpdateWithoutMattersInput;
  where?: InputMaybe<BrandWhereInput>;
};

export type BrandUpsertWithoutParentMattersInput = {
  create: BrandCreateWithoutParentMattersInput;
  update: BrandUpdateWithoutParentMattersInput;
  where?: InputMaybe<BrandWhereInput>;
};

export type BrandWhereInput = {
  AND?: InputMaybe<Array<BrandWhereInput>>;
  NOT?: InputMaybe<Array<BrandWhereInput>>;
  OR?: InputMaybe<Array<BrandWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  footer?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeRatesInProposalOutput?: InputMaybe<BoolFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  lineBreakInLists?: InputMaybe<BoolFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  numberedListFormat?: InputMaybe<StringFilter>;
  organisationLogo?: InputMaybe<StringNullableFilter>;
  organisationName?: InputMaybe<StringNullableFilter>;
  parentMatters?: InputMaybe<ParentMatterListRelationFilter>;
  proposalFont?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BrandWhereUniqueInput = {
  AND?: InputMaybe<Array<BrandWhereInput>>;
  NOT?: InputMaybe<Array<BrandWhereInput>>;
  OR?: InputMaybe<Array<BrandWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  footer?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeRatesInProposalOutput?: InputMaybe<BoolFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  lineBreakInLists?: InputMaybe<BoolFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  numberedListFormat?: InputMaybe<StringFilter>;
  organisationLogo?: InputMaybe<StringNullableFilter>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  parentMatters?: InputMaybe<ParentMatterListRelationFilter>;
  proposalFont?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ChartDatum = {
  source: Scalars['String']['input'];
  x: Scalars['String']['input'];
  y: Scalars['Float']['input'];
};

export type ChosenAndSuggested = {
  __typename?: 'ChosenAndSuggested';
  chosen: Array<Scalars['String']['output']>;
  suggested: Array<Scalars['String']['output']>;
};

export type ClarifyingQuestion = {
  __typename?: 'ClarifyingQuestion';
  allowOther: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<QuestionOption>;
  otherPlaceholder: Maybe<Scalars['String']['output']>;
};

export type Client = {
  __typename?: 'Client';
  createdAt: Scalars['DateTimeISO']['output'];
  currency: Maybe<Currency>;
  currencyId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  excludeTax: Scalars['Boolean']['output'];
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  gpmDangerThreshold: Maybe<Scalars['Int']['output']>;
  gpmWarningThreshold: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ClientAddressCreateNestedOneWithoutClientInput = {
  connect?: InputMaybe<ClientAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientAddressCreateOrConnectWithoutClientInput>;
  create?: InputMaybe<ClientAddressCreateWithoutClientInput>;
};

export type ClientAddressCreateOrConnectWithoutClientInput = {
  create: ClientAddressCreateWithoutClientInput;
  where: ClientAddressWhereUniqueInput;
};

export type ClientAddressCreateWithoutClientInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type ClientAddressNullableRelationFilter = {
  is?: InputMaybe<ClientAddressWhereInput>;
  isNot?: InputMaybe<ClientAddressWhereInput>;
};

export type ClientAddressUpdateOneWithoutClientNestedInput = {
  connect?: InputMaybe<ClientAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientAddressCreateOrConnectWithoutClientInput>;
  create?: InputMaybe<ClientAddressCreateWithoutClientInput>;
  delete?: InputMaybe<ClientAddressWhereInput>;
  disconnect?: InputMaybe<ClientAddressWhereInput>;
  update?: InputMaybe<ClientAddressUpdateToOneWithWhereWithoutClientInput>;
  upsert?: InputMaybe<ClientAddressUpsertWithoutClientInput>;
};

export type ClientAddressUpdateToOneWithWhereWithoutClientInput = {
  data: ClientAddressUpdateWithoutClientInput;
  where?: InputMaybe<ClientAddressWhereInput>;
};

export type ClientAddressUpdateWithoutClientInput = {
  addressLine1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  town?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ClientAddressUpsertWithoutClientInput = {
  create: ClientAddressCreateWithoutClientInput;
  update: ClientAddressUpdateWithoutClientInput;
  where?: InputMaybe<ClientAddressWhereInput>;
};

export type ClientAddressWhereInput = {
  AND?: InputMaybe<Array<ClientAddressWhereInput>>;
  NOT?: InputMaybe<Array<ClientAddressWhereInput>>;
  OR?: InputMaybe<Array<ClientAddressWhereInput>>;
  addressLine1?: InputMaybe<StringNullableFilter>;
  addressLine2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  client?: InputMaybe<ClientRelationFilter>;
  clientId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  postcode?: InputMaybe<StringNullableFilter>;
  town?: InputMaybe<StringNullableFilter>;
};

export type ClientAddressWhereUniqueInput = {
  AND?: InputMaybe<Array<ClientAddressWhereInput>>;
  NOT?: InputMaybe<Array<ClientAddressWhereInput>>;
  OR?: InputMaybe<Array<ClientAddressWhereInput>>;
  addressLine1?: InputMaybe<StringNullableFilter>;
  addressLine2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  client?: InputMaybe<ClientRelationFilter>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<StringNullableFilter>;
  town?: InputMaybe<StringNullableFilter>;
};

export type ClientCreateInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutClientInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutClientInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutClientInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  notificationRule?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutClientInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedManyWithoutClientInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateManyCurrencyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateManyCurrencyInputEnvelope = {
  data: Array<ClientCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<ClientWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<ClientCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<ClientCreateManyCurrencyInputEnvelope>;
};

export type ClientCreateNestedOneWithoutExternalMattersInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutExternalMattersInput>;
  create?: InputMaybe<ClientCreateWithoutExternalMattersInput>;
};

export type ClientCreateNestedOneWithoutMatterPermissionsInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutMatterPermissionsInput>;
  create?: InputMaybe<ClientCreateWithoutMatterPermissionsInput>;
};

export type ClientCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<ClientCreateWithoutMattersInput>;
};

export type ClientCreateNestedOneWithoutNotificationRuleInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutNotificationRuleInput>;
  create?: InputMaybe<ClientCreateWithoutNotificationRuleInput>;
};

export type ClientCreateNestedOneWithoutParentMatterInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutParentMatterInput>;
  create?: InputMaybe<ClientCreateWithoutParentMatterInput>;
};

export type ClientCreateNestedOneWithoutRatesInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<ClientCreateWithoutRatesInput>;
};

export type ClientCreateOrConnectWithoutCurrencyInput = {
  create: ClientCreateWithoutCurrencyInput;
  where: ClientWhereUniqueInput;
};

export type ClientCreateOrConnectWithoutExternalMattersInput = {
  create: ClientCreateWithoutExternalMattersInput;
  where: ClientWhereUniqueInput;
};

export type ClientCreateOrConnectWithoutMatterPermissionsInput = {
  create: ClientCreateWithoutMatterPermissionsInput;
  where: ClientWhereUniqueInput;
};

export type ClientCreateOrConnectWithoutMattersInput = {
  create: ClientCreateWithoutMattersInput;
  where: ClientWhereUniqueInput;
};

export type ClientCreateOrConnectWithoutNotificationRuleInput = {
  create: ClientCreateWithoutNotificationRuleInput;
  where: ClientWhereUniqueInput;
};

export type ClientCreateOrConnectWithoutParentMatterInput = {
  create: ClientCreateWithoutParentMatterInput;
  where: ClientWhereUniqueInput;
};

export type ClientCreateOrConnectWithoutRatesInput = {
  create: ClientCreateWithoutRatesInput;
  where: ClientWhereUniqueInput;
};

export type ClientCreateWithoutCurrencyInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutClientInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutClientInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  notificationRule?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutClientInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedManyWithoutClientInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateWithoutExternalMattersInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutClientInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutClientInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  notificationRule?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutClientInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedManyWithoutClientInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateWithoutMatterPermissionsInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutClientInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutClientInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  notificationRule?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutClientInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedManyWithoutClientInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateWithoutMattersInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutClientInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutClientInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  notificationRule?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutClientInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedManyWithoutClientInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateWithoutNotificationRuleInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutClientInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutClientInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutClientInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  parentMatter?: InputMaybe<ParentMatterCreateNestedManyWithoutClientInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateWithoutParentMatterInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutClientInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutClientInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutClientInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  notificationRule?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutClientInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientCreateWithoutRatesInput = {
  address?: InputMaybe<ClientAddressCreateNestedOneWithoutClientInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutClientInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutClientInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutClientInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutClientInput>;
  name: Scalars['String']['input'];
  notificationRule?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutClientInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedManyWithoutClientInput>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientListRelationFilter = {
  every?: InputMaybe<ClientWhereInput>;
  none?: InputMaybe<ClientWhereInput>;
  some?: InputMaybe<ClientWhereInput>;
};

export type ClientNullableRelationFilter = {
  is?: InputMaybe<ClientWhereInput>;
  isNot?: InputMaybe<ClientWhereInput>;
};

export type ClientPermissionCreateManyClientInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type ClientPermissionCreateManyClientInputEnvelope = {
  data: Array<ClientPermissionCreateManyClientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientPermissionCreateManyUserInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientPermissionCreateManyUserInputEnvelope = {
  data: Array<ClientPermissionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientPermissionCreateNestedManyWithoutClientInput = {
  connect?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientPermissionCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<ClientPermissionCreateWithoutClientInput>>;
  createMany?: InputMaybe<ClientPermissionCreateManyClientInputEnvelope>;
};

export type ClientPermissionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientPermissionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ClientPermissionCreateWithoutUserInput>>;
  createMany?: InputMaybe<ClientPermissionCreateManyUserInputEnvelope>;
};

export type ClientPermissionCreateOrConnectWithoutClientInput = {
  create: ClientPermissionCreateWithoutClientInput;
  where: ClientPermissionWhereUniqueInput;
};

export type ClientPermissionCreateOrConnectWithoutUserInput = {
  create: ClientPermissionCreateWithoutUserInput;
  where: ClientPermissionWhereUniqueInput;
};

export type ClientPermissionCreateWithoutClientInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutClientPermissionsInput;
};

export type ClientPermissionCreateWithoutUserInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  client: ClientCreateNestedOneWithoutMatterPermissionsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientPermissionListRelationFilter = {
  every?: InputMaybe<ClientPermissionWhereInput>;
  none?: InputMaybe<ClientPermissionWhereInput>;
  some?: InputMaybe<ClientPermissionWhereInput>;
};

export type ClientPermissionScalarWhereInput = {
  AND?: InputMaybe<Array<ClientPermissionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ClientPermissionScalarWhereInput>>;
  OR?: InputMaybe<Array<ClientPermissionScalarWhereInput>>;
  access?: InputMaybe<BoolFilter>;
  clientId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type ClientPermissionUpdateManyMutationInput = {
  access?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientPermissionUpdateManyWithWhereWithoutClientInput = {
  data: ClientPermissionUpdateManyMutationInput;
  where: ClientPermissionScalarWhereInput;
};

export type ClientPermissionUpdateManyWithWhereWithoutUserInput = {
  data: ClientPermissionUpdateManyMutationInput;
  where: ClientPermissionScalarWhereInput;
};

export type ClientPermissionUpdateManyWithoutClientNestedInput = {
  connect?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientPermissionCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<ClientPermissionCreateWithoutClientInput>>;
  createMany?: InputMaybe<ClientPermissionCreateManyClientInputEnvelope>;
  delete?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientPermissionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientPermissionUpdateWithWhereUniqueWithoutClientInput>>;
  updateMany?: InputMaybe<Array<ClientPermissionUpdateManyWithWhereWithoutClientInput>>;
  upsert?: InputMaybe<Array<ClientPermissionUpsertWithWhereUniqueWithoutClientInput>>;
};

export type ClientPermissionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientPermissionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ClientPermissionCreateWithoutUserInput>>;
  createMany?: InputMaybe<ClientPermissionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientPermissionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientPermissionWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientPermissionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ClientPermissionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ClientPermissionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ClientPermissionUpdateWithWhereUniqueWithoutClientInput = {
  data: ClientPermissionUpdateWithoutClientInput;
  where: ClientPermissionWhereUniqueInput;
};

export type ClientPermissionUpdateWithWhereUniqueWithoutUserInput = {
  data: ClientPermissionUpdateWithoutUserInput;
  where: ClientPermissionWhereUniqueInput;
};

export type ClientPermissionUpdateWithoutClientInput = {
  access?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutClientPermissionsNestedInput>;
};

export type ClientPermissionUpdateWithoutUserInput = {
  access?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneRequiredWithoutMatterPermissionsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientPermissionUpsertWithWhereUniqueWithoutClientInput = {
  create: ClientPermissionCreateWithoutClientInput;
  update: ClientPermissionUpdateWithoutClientInput;
  where: ClientPermissionWhereUniqueInput;
};

export type ClientPermissionUpsertWithWhereUniqueWithoutUserInput = {
  create: ClientPermissionCreateWithoutUserInput;
  update: ClientPermissionUpdateWithoutUserInput;
  where: ClientPermissionWhereUniqueInput;
};

export type ClientPermissionWhereInput = {
  AND?: InputMaybe<Array<ClientPermissionWhereInput>>;
  NOT?: InputMaybe<Array<ClientPermissionWhereInput>>;
  OR?: InputMaybe<Array<ClientPermissionWhereInput>>;
  access?: InputMaybe<BoolFilter>;
  client?: InputMaybe<ClientRelationFilter>;
  clientId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type ClientPermissionWhereUniqueInput = {
  AND?: InputMaybe<Array<ClientPermissionWhereInput>>;
  NOT?: InputMaybe<Array<ClientPermissionWhereInput>>;
  OR?: InputMaybe<Array<ClientPermissionWhereInput>>;
  access?: InputMaybe<BoolFilter>;
  client?: InputMaybe<ClientRelationFilter>;
  clientId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type ClientRelationFilter = {
  is?: InputMaybe<ClientWhereInput>;
  isNot?: InputMaybe<ClientWhereInput>;
};

export type ClientReport = {
  __typename?: 'ClientReport';
  actualFee: Scalars['Float']['output'];
  actualFeePercentage: Scalars['Float']['output'];
  amountBilled: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  billingChart: Scalars['String']['output'];
  clientAddressLine1: Scalars['String']['output'];
  clientAddressLine2: Scalars['String']['output'];
  clientCity: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  clientPostcode: Scalars['String']['output'];
  clientTown: Scalars['String']['output'];
  costProjectionDiagram: Scalars['String']['output'];
  cumulativeAccruedFees: Array<CumulativeAccruedFee>;
  currencySymbol: Scalars['String']['output'];
  deadline: Maybe<Scalars['DateTimeISO']['output']>;
  hasInvoices: Scalars['Boolean']['output'];
  includeBillingChart: Scalars['Boolean']['output'];
  includeCostProjectionDiagram: Scalars['Boolean']['output'];
  invoices: Array<Invoice>;
  matterCompletionLogs: Array<MatterCompletionLog>;
  matterTitle: Scalars['String']['output'];
  overBudget: Scalars['Float']['output'];
  plannedFee: PriceOrPriceRange;
  totalAccruedTime: Scalars['Float']['output'];
};

export type ClientReportOptionsUpdateResult = {
  __typename?: 'ClientReportOptionsUpdateResult';
  includeBillingChart: Scalars['Boolean']['output'];
  includeCostProjectionDiagram: Scalars['Boolean']['output'];
};

export type ClientReportOutputCreateManyCreatedByUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplateId: Scalars['Int']['input'];
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputCreateManyCreatedByUserInputEnvelope = {
  data: Array<ClientReportOutputCreateManyCreatedByUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientReportOutputCreateManyDesignTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputCreateManyDesignTemplateInputEnvelope = {
  data: Array<ClientReportOutputCreateManyDesignTemplateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientReportOutputCreateNestedManyWithoutCreatedByUserInput = {
  connect?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ClientReportOutputCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ClientReportOutputCreateManyCreatedByUserInputEnvelope>;
};

export type ClientReportOutputCreateNestedManyWithoutDesignTemplateInput = {
  connect?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputCreateOrConnectWithoutDesignTemplateInput>>;
  create?: InputMaybe<Array<ClientReportOutputCreateWithoutDesignTemplateInput>>;
  createMany?: InputMaybe<ClientReportOutputCreateManyDesignTemplateInputEnvelope>;
};

export type ClientReportOutputCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<ClientReportOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientReportOutputCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ClientReportOutputCreateWithoutMatterInput>;
};

export type ClientReportOutputCreateNestedOneWithoutPartsInput = {
  connect?: InputMaybe<ClientReportOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientReportOutputCreateOrConnectWithoutPartsInput>;
  create?: InputMaybe<ClientReportOutputCreateWithoutPartsInput>;
};

export type ClientReportOutputCreateOrConnectWithoutCreatedByUserInput = {
  create: ClientReportOutputCreateWithoutCreatedByUserInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputCreateOrConnectWithoutDesignTemplateInput = {
  create: ClientReportOutputCreateWithoutDesignTemplateInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputCreateOrConnectWithoutMatterInput = {
  create: ClientReportOutputCreateWithoutMatterInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputCreateOrConnectWithoutPartsInput = {
  create: ClientReportOutputCreateWithoutPartsInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputCreateWithoutCreatedByUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplate: OutputDesignCreateNestedOneWithoutClientReportOutputInput;
  htmlContent: Scalars['String']['input'];
  matter: MatterCreateNestedOneWithoutClientReportOutputInput;
  parts?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutClientReportOutputInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputCreateWithoutDesignTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matter: MatterCreateNestedOneWithoutClientReportOutputInput;
  parts?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutClientReportOutputInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputCreateWithoutMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplate: OutputDesignCreateNestedOneWithoutClientReportOutputInput;
  htmlContent: Scalars['String']['input'];
  parts?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutClientReportOutputInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputCreateWithoutPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplate: OutputDesignCreateNestedOneWithoutClientReportOutputInput;
  htmlContent: Scalars['String']['input'];
  matter: MatterCreateNestedOneWithoutClientReportOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputListRelationFilter = {
  every?: InputMaybe<ClientReportOutputWhereInput>;
  none?: InputMaybe<ClientReportOutputWhereInput>;
  some?: InputMaybe<ClientReportOutputWhereInput>;
};

export type ClientReportOutputNullableRelationFilter = {
  is?: InputMaybe<ClientReportOutputWhereInput>;
  isNot?: InputMaybe<ClientReportOutputWhereInput>;
};

export type ClientReportOutputPartCreateManyClientReportOutputInput = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputPartCreateManyClientReportOutputInputEnvelope = {
  data: Array<ClientReportOutputPartCreateManyClientReportOutputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientReportOutputPartCreateManyCreatedByUserInput = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputPartCreateManyCreatedByUserInputEnvelope = {
  data: Array<ClientReportOutputPartCreateManyCreatedByUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientReportOutputPartCreateNestedManyWithoutClientReportOutputInput = {
  connect?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputPartCreateOrConnectWithoutClientReportOutputInput>>;
  create?: InputMaybe<Array<ClientReportOutputPartCreateWithoutClientReportOutputInput>>;
  createMany?: InputMaybe<ClientReportOutputPartCreateManyClientReportOutputInputEnvelope>;
};

export type ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput = {
  connect?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputPartCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ClientReportOutputPartCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ClientReportOutputPartCreateManyCreatedByUserInputEnvelope>;
};

export type ClientReportOutputPartCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<ClientReportOutputPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientReportOutputPartCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ClientReportOutputPartCreateWithoutMatterInput>;
};

export type ClientReportOutputPartCreateOrConnectWithoutClientReportOutputInput = {
  create: ClientReportOutputPartCreateWithoutClientReportOutputInput;
  where: ClientReportOutputPartWhereUniqueInput;
};

export type ClientReportOutputPartCreateOrConnectWithoutCreatedByUserInput = {
  create: ClientReportOutputPartCreateWithoutCreatedByUserInput;
  where: ClientReportOutputPartWhereUniqueInput;
};

export type ClientReportOutputPartCreateOrConnectWithoutMatterInput = {
  create: ClientReportOutputPartCreateWithoutMatterInput;
  where: ClientReportOutputPartWhereUniqueInput;
};

export type ClientReportOutputPartCreateWithoutClientReportOutputInput = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matter?: InputMaybe<MatterCreateNestedManyWithoutClientReportOutputPartInput>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputPartCreateWithoutCreatedByUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutPartsInput>;
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matter?: InputMaybe<MatterCreateNestedManyWithoutClientReportOutputPartInput>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputPartCreateWithoutMatterInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutPartsInput>;
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ClientReportOutputPartListRelationFilter = {
  every?: InputMaybe<ClientReportOutputPartWhereInput>;
  none?: InputMaybe<ClientReportOutputPartWhereInput>;
  some?: InputMaybe<ClientReportOutputPartWhereInput>;
};

export type ClientReportOutputPartMatterAfterUniqueCompoundUniqueInput = {
  after: Scalars['Boolean']['input'];
  matterId: Scalars['Int']['input'];
};

export type ClientReportOutputPartMatterBeforeUniqueCompoundUniqueInput = {
  before: Scalars['Boolean']['input'];
  matterId: Scalars['Int']['input'];
};

export type ClientReportOutputPartNullableRelationFilter = {
  is?: InputMaybe<ClientReportOutputPartWhereInput>;
  isNot?: InputMaybe<ClientReportOutputPartWhereInput>;
};

export type ClientReportOutputPartScalarWhereInput = {
  AND?: InputMaybe<Array<ClientReportOutputPartScalarWhereInput>>;
  NOT?: InputMaybe<Array<ClientReportOutputPartScalarWhereInput>>;
  OR?: InputMaybe<Array<ClientReportOutputPartScalarWhereInput>>;
  after?: InputMaybe<BoolFilter>;
  before?: InputMaybe<BoolFilter>;
  clientReportOutputId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientReportOutputPartUpdateManyMutationInput = {
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputPartUpdateManyWithWhereWithoutClientReportOutputInput = {
  data: ClientReportOutputPartUpdateManyMutationInput;
  where: ClientReportOutputPartScalarWhereInput;
};

export type ClientReportOutputPartUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: ClientReportOutputPartUpdateManyMutationInput;
  where: ClientReportOutputPartScalarWhereInput;
};

export type ClientReportOutputPartUpdateManyWithoutClientReportOutputNestedInput = {
  connect?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputPartCreateOrConnectWithoutClientReportOutputInput>>;
  create?: InputMaybe<Array<ClientReportOutputPartCreateWithoutClientReportOutputInput>>;
  createMany?: InputMaybe<ClientReportOutputPartCreateManyClientReportOutputInputEnvelope>;
  delete?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientReportOutputPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientReportOutputPartUpdateWithWhereUniqueWithoutClientReportOutputInput>>;
  updateMany?: InputMaybe<Array<ClientReportOutputPartUpdateManyWithWhereWithoutClientReportOutputInput>>;
  upsert?: InputMaybe<Array<ClientReportOutputPartUpsertWithWhereUniqueWithoutClientReportOutputInput>>;
};

export type ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputPartCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ClientReportOutputPartCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ClientReportOutputPartCreateManyCreatedByUserInputEnvelope>;
  delete?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientReportOutputPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientReportOutputPartWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientReportOutputPartUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: InputMaybe<Array<ClientReportOutputPartUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: InputMaybe<Array<ClientReportOutputPartUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type ClientReportOutputPartUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<ClientReportOutputPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientReportOutputPartCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ClientReportOutputPartCreateWithoutMatterInput>;
  delete?: InputMaybe<ClientReportOutputPartWhereInput>;
  disconnect?: InputMaybe<ClientReportOutputPartWhereInput>;
  update?: InputMaybe<ClientReportOutputPartUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<ClientReportOutputPartUpsertWithoutMatterInput>;
};

export type ClientReportOutputPartUpdateToOneWithWhereWithoutMatterInput = {
  data: ClientReportOutputPartUpdateWithoutMatterInput;
  where?: InputMaybe<ClientReportOutputPartWhereInput>;
};

export type ClientReportOutputPartUpdateWithWhereUniqueWithoutClientReportOutputInput = {
  data: ClientReportOutputPartUpdateWithoutClientReportOutputInput;
  where: ClientReportOutputPartWhereUniqueInput;
};

export type ClientReportOutputPartUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: ClientReportOutputPartUpdateWithoutCreatedByUserInput;
  where: ClientReportOutputPartWhereUniqueInput;
};

export type ClientReportOutputPartUpdateWithoutClientReportOutputInput = {
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateManyWithoutClientReportOutputPartNestedInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputPartUpdateWithoutCreatedByUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutPartsNestedInput>;
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateManyWithoutClientReportOutputPartNestedInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputPartUpdateWithoutMatterInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutPartsNestedInput>;
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputPartUpsertWithWhereUniqueWithoutClientReportOutputInput = {
  create: ClientReportOutputPartCreateWithoutClientReportOutputInput;
  update: ClientReportOutputPartUpdateWithoutClientReportOutputInput;
  where: ClientReportOutputPartWhereUniqueInput;
};

export type ClientReportOutputPartUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: ClientReportOutputPartCreateWithoutCreatedByUserInput;
  update: ClientReportOutputPartUpdateWithoutCreatedByUserInput;
  where: ClientReportOutputPartWhereUniqueInput;
};

export type ClientReportOutputPartUpsertWithoutMatterInput = {
  create: ClientReportOutputPartCreateWithoutMatterInput;
  update: ClientReportOutputPartUpdateWithoutMatterInput;
  where?: InputMaybe<ClientReportOutputPartWhereInput>;
};

export type ClientReportOutputPartWhereInput = {
  AND?: InputMaybe<Array<ClientReportOutputPartWhereInput>>;
  ClientReportOutput?: InputMaybe<ClientReportOutputNullableRelationFilter>;
  NOT?: InputMaybe<Array<ClientReportOutputPartWhereInput>>;
  OR?: InputMaybe<Array<ClientReportOutputPartWhereInput>>;
  after?: InputMaybe<BoolFilter>;
  before?: InputMaybe<BoolFilter>;
  clientReportOutputId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterListRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientReportOutputPartWhereUniqueInput = {
  AND?: InputMaybe<Array<ClientReportOutputPartWhereInput>>;
  ClientReportOutput?: InputMaybe<ClientReportOutputNullableRelationFilter>;
  MatterAfterUnique?: InputMaybe<ClientReportOutputPartMatterAfterUniqueCompoundUniqueInput>;
  MatterBeforeUnique?: InputMaybe<ClientReportOutputPartMatterBeforeUniqueCompoundUniqueInput>;
  NOT?: InputMaybe<Array<ClientReportOutputPartWhereInput>>;
  OR?: InputMaybe<Array<ClientReportOutputPartWhereInput>>;
  after?: InputMaybe<BoolFilter>;
  before?: InputMaybe<BoolFilter>;
  clientReportOutputId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterListRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientReportOutputScalarWhereInput = {
  AND?: InputMaybe<Array<ClientReportOutputScalarWhereInput>>;
  NOT?: InputMaybe<Array<ClientReportOutputScalarWhereInput>>;
  OR?: InputMaybe<Array<ClientReportOutputScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designTemplateId?: InputMaybe<IntFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientReportOutputUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: ClientReportOutputUpdateManyMutationInput;
  where: ClientReportOutputScalarWhereInput;
};

export type ClientReportOutputUpdateManyWithWhereWithoutDesignTemplateInput = {
  data: ClientReportOutputUpdateManyMutationInput;
  where: ClientReportOutputScalarWhereInput;
};

export type ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ClientReportOutputCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ClientReportOutputCreateManyCreatedByUserInputEnvelope>;
  delete?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientReportOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientReportOutputUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: InputMaybe<Array<ClientReportOutputUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: InputMaybe<Array<ClientReportOutputUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type ClientReportOutputUpdateManyWithoutDesignTemplateNestedInput = {
  connect?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientReportOutputCreateOrConnectWithoutDesignTemplateInput>>;
  create?: InputMaybe<Array<ClientReportOutputCreateWithoutDesignTemplateInput>>;
  createMany?: InputMaybe<ClientReportOutputCreateManyDesignTemplateInputEnvelope>;
  delete?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientReportOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientReportOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientReportOutputUpdateWithWhereUniqueWithoutDesignTemplateInput>>;
  updateMany?: InputMaybe<Array<ClientReportOutputUpdateManyWithWhereWithoutDesignTemplateInput>>;
  upsert?: InputMaybe<Array<ClientReportOutputUpsertWithWhereUniqueWithoutDesignTemplateInput>>;
};

export type ClientReportOutputUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<ClientReportOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientReportOutputCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ClientReportOutputCreateWithoutMatterInput>;
  delete?: InputMaybe<ClientReportOutputWhereInput>;
  disconnect?: InputMaybe<ClientReportOutputWhereInput>;
  update?: InputMaybe<ClientReportOutputUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<ClientReportOutputUpsertWithoutMatterInput>;
};

export type ClientReportOutputUpdateOneWithoutPartsNestedInput = {
  connect?: InputMaybe<ClientReportOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientReportOutputCreateOrConnectWithoutPartsInput>;
  create?: InputMaybe<ClientReportOutputCreateWithoutPartsInput>;
  delete?: InputMaybe<ClientReportOutputWhereInput>;
  disconnect?: InputMaybe<ClientReportOutputWhereInput>;
  update?: InputMaybe<ClientReportOutputUpdateToOneWithWhereWithoutPartsInput>;
  upsert?: InputMaybe<ClientReportOutputUpsertWithoutPartsInput>;
};

export type ClientReportOutputUpdateToOneWithWhereWithoutMatterInput = {
  data: ClientReportOutputUpdateWithoutMatterInput;
  where?: InputMaybe<ClientReportOutputWhereInput>;
};

export type ClientReportOutputUpdateToOneWithWhereWithoutPartsInput = {
  data: ClientReportOutputUpdateWithoutPartsInput;
  where?: InputMaybe<ClientReportOutputWhereInput>;
};

export type ClientReportOutputUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: ClientReportOutputUpdateWithoutCreatedByUserInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputUpdateWithWhereUniqueWithoutDesignTemplateInput = {
  data: ClientReportOutputUpdateWithoutDesignTemplateInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputUpdateWithoutCreatedByUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  designTemplate?: InputMaybe<OutputDesignUpdateOneRequiredWithoutClientReportOutputNestedInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutClientReportOutputNestedInput>;
  parts?: InputMaybe<ClientReportOutputPartUpdateManyWithoutClientReportOutputNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputUpdateWithoutDesignTemplateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutClientReportOutputNestedInput>;
  parts?: InputMaybe<ClientReportOutputPartUpdateManyWithoutClientReportOutputNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputUpdateWithoutMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  designTemplate?: InputMaybe<OutputDesignUpdateOneRequiredWithoutClientReportOutputNestedInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  parts?: InputMaybe<ClientReportOutputPartUpdateManyWithoutClientReportOutputNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputUpdateWithoutPartsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  designTemplate?: InputMaybe<OutputDesignUpdateOneRequiredWithoutClientReportOutputNestedInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutClientReportOutputNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientReportOutputUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: ClientReportOutputCreateWithoutCreatedByUserInput;
  update: ClientReportOutputUpdateWithoutCreatedByUserInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputUpsertWithWhereUniqueWithoutDesignTemplateInput = {
  create: ClientReportOutputCreateWithoutDesignTemplateInput;
  update: ClientReportOutputUpdateWithoutDesignTemplateInput;
  where: ClientReportOutputWhereUniqueInput;
};

export type ClientReportOutputUpsertWithoutMatterInput = {
  create: ClientReportOutputCreateWithoutMatterInput;
  update: ClientReportOutputUpdateWithoutMatterInput;
  where?: InputMaybe<ClientReportOutputWhereInput>;
};

export type ClientReportOutputUpsertWithoutPartsInput = {
  create: ClientReportOutputCreateWithoutPartsInput;
  update: ClientReportOutputUpdateWithoutPartsInput;
  where?: InputMaybe<ClientReportOutputWhereInput>;
};

export type ClientReportOutputWhereInput = {
  AND?: InputMaybe<Array<ClientReportOutputWhereInput>>;
  NOT?: InputMaybe<Array<ClientReportOutputWhereInput>>;
  OR?: InputMaybe<Array<ClientReportOutputWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designTemplate?: InputMaybe<OutputDesignRelationFilter>;
  designTemplateId?: InputMaybe<IntFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  parts?: InputMaybe<ClientReportOutputPartListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientReportOutputWhereUniqueInput = {
  AND?: InputMaybe<Array<ClientReportOutputWhereInput>>;
  NOT?: InputMaybe<Array<ClientReportOutputWhereInput>>;
  OR?: InputMaybe<Array<ClientReportOutputWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designTemplate?: InputMaybe<OutputDesignRelationFilter>;
  designTemplateId?: InputMaybe<IntFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  parts?: InputMaybe<ClientReportOutputPartListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientReportResult = {
  __typename?: 'ClientReportResult';
  clientReport: ClientReport;
  html: Scalars['String']['output'];
  outputTemplateId: Scalars['Int']['output'];
  outputTemplateName: Scalars['String']['output'];
};

export type ClientResult = {
  __typename?: 'ClientResult';
  clients: Array<Client>;
  total: Scalars['Int']['output'];
};

export type ClientScalarWhereInput = {
  AND?: InputMaybe<Array<ClientScalarWhereInput>>;
  NOT?: InputMaybe<Array<ClientScalarWhereInput>>;
  OR?: InputMaybe<Array<ClientScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  excludeTax?: InputMaybe<BoolFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  gpmDangerThreshold?: InputMaybe<IntNullableFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientUpdateInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutClientNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutClientNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutClientNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleClientsUpdateManyWithoutClientNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateManyWithoutClientNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateManyWithWhereWithoutCurrencyInput = {
  data: ClientUpdateManyMutationInput;
  where: ClientScalarWhereInput;
};

export type ClientUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<ClientWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<ClientCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<ClientCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<ClientWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<ClientUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<ClientUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type ClientUpdateOneRequiredWithoutMatterPermissionsNestedInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutMatterPermissionsInput>;
  create?: InputMaybe<ClientCreateWithoutMatterPermissionsInput>;
  update?: InputMaybe<ClientUpdateToOneWithWhereWithoutMatterPermissionsInput>;
  upsert?: InputMaybe<ClientUpsertWithoutMatterPermissionsInput>;
};

export type ClientUpdateOneRequiredWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutNotificationRuleInput>;
  create?: InputMaybe<ClientCreateWithoutNotificationRuleInput>;
  update?: InputMaybe<ClientUpdateToOneWithWhereWithoutNotificationRuleInput>;
  upsert?: InputMaybe<ClientUpsertWithoutNotificationRuleInput>;
};

export type ClientUpdateOneWithoutExternalMattersNestedInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutExternalMattersInput>;
  create?: InputMaybe<ClientCreateWithoutExternalMattersInput>;
  delete?: InputMaybe<ClientWhereInput>;
  disconnect?: InputMaybe<ClientWhereInput>;
  update?: InputMaybe<ClientUpdateToOneWithWhereWithoutExternalMattersInput>;
  upsert?: InputMaybe<ClientUpsertWithoutExternalMattersInput>;
};

export type ClientUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<ClientCreateWithoutMattersInput>;
  delete?: InputMaybe<ClientWhereInput>;
  disconnect?: InputMaybe<ClientWhereInput>;
  update?: InputMaybe<ClientUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<ClientUpsertWithoutMattersInput>;
};

export type ClientUpdateOneWithoutParentMatterNestedInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutParentMatterInput>;
  create?: InputMaybe<ClientCreateWithoutParentMatterInput>;
  delete?: InputMaybe<ClientWhereInput>;
  disconnect?: InputMaybe<ClientWhereInput>;
  update?: InputMaybe<ClientUpdateToOneWithWhereWithoutParentMatterInput>;
  upsert?: InputMaybe<ClientUpsertWithoutParentMatterInput>;
};

export type ClientUpdateOneWithoutRatesNestedInput = {
  connect?: InputMaybe<ClientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<ClientCreateWithoutRatesInput>;
  delete?: InputMaybe<ClientWhereInput>;
  disconnect?: InputMaybe<ClientWhereInput>;
  update?: InputMaybe<ClientUpdateToOneWithWhereWithoutRatesInput>;
  upsert?: InputMaybe<ClientUpsertWithoutRatesInput>;
};

export type ClientUpdateToOneWithWhereWithoutExternalMattersInput = {
  data: ClientUpdateWithoutExternalMattersInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpdateToOneWithWhereWithoutMatterPermissionsInput = {
  data: ClientUpdateWithoutMatterPermissionsInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpdateToOneWithWhereWithoutMattersInput = {
  data: ClientUpdateWithoutMattersInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpdateToOneWithWhereWithoutNotificationRuleInput = {
  data: ClientUpdateWithoutNotificationRuleInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpdateToOneWithWhereWithoutParentMatterInput = {
  data: ClientUpdateWithoutParentMatterInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpdateToOneWithWhereWithoutRatesInput = {
  data: ClientUpdateWithoutRatesInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: ClientUpdateWithoutCurrencyInput;
  where: ClientWhereUniqueInput;
};

export type ClientUpdateWithoutCurrencyInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutClientNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutClientNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleClientsUpdateManyWithoutClientNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateManyWithoutClientNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateWithoutExternalMattersInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutClientNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutClientNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleClientsUpdateManyWithoutClientNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateManyWithoutClientNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateWithoutMatterPermissionsInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutClientNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutClientNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleClientsUpdateManyWithoutClientNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateManyWithoutClientNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateWithoutMattersInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutClientNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutClientNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleClientsUpdateManyWithoutClientNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateManyWithoutClientNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateWithoutNotificationRuleInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutClientNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutClientNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutClientNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateManyWithoutClientNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateWithoutParentMatterInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutClientNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutClientNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutClientNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleClientsUpdateManyWithoutClientNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateWithoutRatesInput = {
  address?: InputMaybe<ClientAddressUpdateOneWithoutClientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutClientNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludeTax?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutClientNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutClientNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutClientNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleClientsUpdateManyWithoutClientNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateManyWithoutClientNestedInput>;
  type?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: ClientCreateWithoutCurrencyInput;
  update: ClientUpdateWithoutCurrencyInput;
  where: ClientWhereUniqueInput;
};

export type ClientUpsertWithoutExternalMattersInput = {
  create: ClientCreateWithoutExternalMattersInput;
  update: ClientUpdateWithoutExternalMattersInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpsertWithoutMatterPermissionsInput = {
  create: ClientCreateWithoutMatterPermissionsInput;
  update: ClientUpdateWithoutMatterPermissionsInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpsertWithoutMattersInput = {
  create: ClientCreateWithoutMattersInput;
  update: ClientUpdateWithoutMattersInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpsertWithoutNotificationRuleInput = {
  create: ClientCreateWithoutNotificationRuleInput;
  update: ClientUpdateWithoutNotificationRuleInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpsertWithoutParentMatterInput = {
  create: ClientCreateWithoutParentMatterInput;
  update: ClientUpdateWithoutParentMatterInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientUpsertWithoutRatesInput = {
  create: ClientCreateWithoutRatesInput;
  update: ClientUpdateWithoutRatesInput;
  where?: InputMaybe<ClientWhereInput>;
};

export type ClientWhereInput = {
  AND?: InputMaybe<Array<ClientWhereInput>>;
  NOT?: InputMaybe<Array<ClientWhereInput>>;
  OR?: InputMaybe<Array<ClientWhereInput>>;
  address?: InputMaybe<ClientAddressNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  excludeTax?: InputMaybe<BoolFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatters?: InputMaybe<ExternalMatterListRelationFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  gpmDangerThreshold?: InputMaybe<IntNullableFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterPermissions?: InputMaybe<ClientPermissionListRelationFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  notificationRule?: InputMaybe<NotificationRuleClientsListRelationFilter>;
  parentMatter?: InputMaybe<ParentMatterListRelationFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  type?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientWhereUniqueInput = {
  AND?: InputMaybe<Array<ClientWhereInput>>;
  NOT?: InputMaybe<Array<ClientWhereInput>>;
  OR?: InputMaybe<Array<ClientWhereInput>>;
  address?: InputMaybe<ClientAddressNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  excludeTax?: InputMaybe<BoolFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterListRelationFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  gpmDangerThreshold?: InputMaybe<IntNullableFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterPermissions?: InputMaybe<ClientPermissionListRelationFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  notificationRule?: InputMaybe<NotificationRuleClientsListRelationFilter>;
  parentMatter?: InputMaybe<ParentMatterListRelationFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  type?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Collaborator = {
  __typename?: 'Collaborator';
  createdAt: Scalars['DateTimeISO']['output'];
  createdByUser: User;
  createdByUserId: Scalars['Int']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  matterId: Maybe<Scalars['Int']['output']>;
  parentMatterId: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type CollaboratorCreateManyCreatedByUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type CollaboratorCreateManyCreatedByUserInputEnvelope = {
  data: Array<CollaboratorCreateManyCreatedByUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaboratorCreateManyMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUserId: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type CollaboratorCreateManyMatterInputEnvelope = {
  data: Array<CollaboratorCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaboratorCreateManyParentMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUserId: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type CollaboratorCreateManyParentMatterInputEnvelope = {
  data: Array<CollaboratorCreateManyParentMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaboratorCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUserId: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CollaboratorCreateManyUserInputEnvelope = {
  data: Array<CollaboratorCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaboratorCreateNestedManyWithoutCreatedByUserInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyCreatedByUserInputEnvelope>;
};

export type CollaboratorCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutMatterInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyMatterInputEnvelope>;
};

export type CollaboratorCreateNestedManyWithoutParentMatterInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutParentMatterInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutParentMatterInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyParentMatterInputEnvelope>;
};

export type CollaboratorCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutUserInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyUserInputEnvelope>;
};

export type CollaboratorCreateOrConnectWithoutCreatedByUserInput = {
  create: CollaboratorCreateWithoutCreatedByUserInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorCreateOrConnectWithoutMatterInput = {
  create: CollaboratorCreateWithoutMatterInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorCreateOrConnectWithoutParentMatterInput = {
  create: CollaboratorCreateWithoutParentMatterInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorCreateOrConnectWithoutUserInput = {
  create: CollaboratorCreateWithoutUserInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorCreateWithoutCreatedByUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutCollaboratorsInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedOneWithoutCollaboratorsInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutCollaboratorUserInput;
};

export type CollaboratorCreateWithoutMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUser: UserCreateNestedOneWithoutCollaboratorCreatedByUserInput;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedOneWithoutCollaboratorsInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutCollaboratorUserInput;
};

export type CollaboratorCreateWithoutParentMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUser: UserCreateNestedOneWithoutCollaboratorCreatedByUserInput;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutCollaboratorsInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutCollaboratorUserInput;
};

export type CollaboratorCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUser: UserCreateNestedOneWithoutCollaboratorCreatedByUserInput;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutCollaboratorsInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedOneWithoutCollaboratorsInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CollaboratorListRelationFilter = {
  every?: InputMaybe<CollaboratorWhereInput>;
  none?: InputMaybe<CollaboratorWhereInput>;
  some?: InputMaybe<CollaboratorWhereInput>;
};

export type CollaboratorScalarWhereInput = {
  AND?: InputMaybe<Array<CollaboratorScalarWhereInput>>;
  NOT?: InputMaybe<Array<CollaboratorScalarWhereInput>>;
  OR?: InputMaybe<Array<CollaboratorScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByUserId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CollaboratorUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CollaboratorUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: CollaboratorUpdateManyMutationInput;
  where: CollaboratorScalarWhereInput;
};

export type CollaboratorUpdateManyWithWhereWithoutMatterInput = {
  data: CollaboratorUpdateManyMutationInput;
  where: CollaboratorScalarWhereInput;
};

export type CollaboratorUpdateManyWithWhereWithoutParentMatterInput = {
  data: CollaboratorUpdateManyMutationInput;
  where: CollaboratorScalarWhereInput;
};

export type CollaboratorUpdateManyWithWhereWithoutUserInput = {
  data: CollaboratorUpdateManyMutationInput;
  where: CollaboratorScalarWhereInput;
};

export type CollaboratorUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyCreatedByUserInputEnvelope>;
  delete?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CollaboratorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  set?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  update?: InputMaybe<Array<CollaboratorUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: InputMaybe<Array<CollaboratorUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: InputMaybe<Array<CollaboratorUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type CollaboratorUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutMatterInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CollaboratorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  set?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  update?: InputMaybe<Array<CollaboratorUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<CollaboratorUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<CollaboratorUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type CollaboratorUpdateManyWithoutParentMatterNestedInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutParentMatterInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutParentMatterInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyParentMatterInputEnvelope>;
  delete?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CollaboratorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  set?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  update?: InputMaybe<Array<CollaboratorUpdateWithWhereUniqueWithoutParentMatterInput>>;
  updateMany?: InputMaybe<Array<CollaboratorUpdateManyWithWhereWithoutParentMatterInput>>;
  upsert?: InputMaybe<Array<CollaboratorUpsertWithWhereUniqueWithoutParentMatterInput>>;
};

export type CollaboratorUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CollaboratorCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CollaboratorCreateWithoutUserInput>>;
  createMany?: InputMaybe<CollaboratorCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CollaboratorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  set?: InputMaybe<Array<CollaboratorWhereUniqueInput>>;
  update?: InputMaybe<Array<CollaboratorUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CollaboratorUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CollaboratorUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CollaboratorUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: CollaboratorUpdateWithoutCreatedByUserInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorUpdateWithWhereUniqueWithoutMatterInput = {
  data: CollaboratorUpdateWithoutMatterInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorUpdateWithWhereUniqueWithoutParentMatterInput = {
  data: CollaboratorUpdateWithoutParentMatterInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorUpdateWithWhereUniqueWithoutUserInput = {
  data: CollaboratorUpdateWithoutUserInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorUpdateWithoutCreatedByUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutCollaboratorsNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateOneWithoutCollaboratorsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCollaboratorUserNestedInput>;
};

export type CollaboratorUpdateWithoutMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdByUser?: InputMaybe<UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateOneWithoutCollaboratorsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCollaboratorUserNestedInput>;
};

export type CollaboratorUpdateWithoutParentMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdByUser?: InputMaybe<UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutCollaboratorsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCollaboratorUserNestedInput>;
};

export type CollaboratorUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdByUser?: InputMaybe<UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutCollaboratorsNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateOneWithoutCollaboratorsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CollaboratorUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: CollaboratorCreateWithoutCreatedByUserInput;
  update: CollaboratorUpdateWithoutCreatedByUserInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorUpsertWithWhereUniqueWithoutMatterInput = {
  create: CollaboratorCreateWithoutMatterInput;
  update: CollaboratorUpdateWithoutMatterInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorUpsertWithWhereUniqueWithoutParentMatterInput = {
  create: CollaboratorCreateWithoutParentMatterInput;
  update: CollaboratorUpdateWithoutParentMatterInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorUpsertWithWhereUniqueWithoutUserInput = {
  create: CollaboratorCreateWithoutUserInput;
  update: CollaboratorUpdateWithoutUserInput;
  where: CollaboratorWhereUniqueInput;
};

export type CollaboratorWhereInput = {
  AND?: InputMaybe<Array<CollaboratorWhereInput>>;
  NOT?: InputMaybe<Array<CollaboratorWhereInput>>;
  OR?: InputMaybe<Array<CollaboratorWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByUser?: InputMaybe<UserRelationFilter>;
  createdByUserId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  parentMatter?: InputMaybe<ParentMatterNullableRelationFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CollaboratorWhereUniqueInput = {
  AND?: InputMaybe<Array<CollaboratorWhereInput>>;
  NOT?: InputMaybe<Array<CollaboratorWhereInput>>;
  OR?: InputMaybe<Array<CollaboratorWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByUser?: InputMaybe<UserRelationFilter>;
  createdByUserId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  parentMatter?: InputMaybe<ParentMatterNullableRelationFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type CopyLibraryPhaseResult = {
  __typename?: 'CopyLibraryPhaseResult';
  assumptions: Array<Assumption>;
  disbursements: Array<Disbursement>;
  exclusions: Array<Exclusion>;
  phase: Phase;
};

export type CopyMatterDetailsOptions = {
  copyPricing?: InputMaybe<Scalars['Boolean']['input']>;
  copyResourcing?: InputMaybe<Scalars['Boolean']['input']>;
  copyScope?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CopyMatterPhasesResult = {
  __typename?: 'CopyMatterPhasesResult';
  assumptions: Array<Assumption>;
  disbursements: Array<Disbursement>;
  exclusions: Array<Exclusion>;
  phases: Array<Phase>;
};

export type CountByField = {
  __typename?: 'CountByField';
  count: Scalars['Float']['output'];
  field: Scalars['String']['output'];
  id: Maybe<Scalars['Int']['output']>;
  metaData: Maybe<Array<MetaData>>;
};

export type CreateFromOptions = {
  copyMatterDetails?: InputMaybe<CopyMatterDetailsOptions>;
  historicalMatterId?: InputMaybe<Scalars['Int']['input']>;
  rateReplacements?: InputMaybe<Array<RateReplacement>>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGroupItem = {
  description: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  outputDesignId?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateManyTechnologyRatesInput = {
  data: Array<TechnologyRatesCreateManyItemInput>;
};

export type CreateManyTechnologyRatesResult = {
  __typename?: 'CreateManyTechnologyRatesResult';
  count: Scalars['Int']['output'];
};

export type CumulativeAccruedFee = {
  __typename?: 'CumulativeAccruedFee';
  amount: Scalars['Int']['output'];
  date: Scalars['DateTimeISO']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  baseCurrency: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  conversionRate: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  dateFrom: Maybe<Scalars['DateTimeISO']['output']>;
  dateTo: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rounding: Maybe<Scalars['Int']['output']>;
  roundingMethod: Maybe<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type CurrencyCreateNestedOneWithoutClientInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutClientInput>;
  create?: InputMaybe<CurrencyCreateWithoutClientInput>;
};

export type CurrencyCreateNestedOneWithoutExternalMatterInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutExternalMatterInput>;
  create?: InputMaybe<CurrencyCreateWithoutExternalMatterInput>;
};

export type CurrencyCreateNestedOneWithoutFeeEarnerInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutFeeEarnerInput>;
  create?: InputMaybe<CurrencyCreateWithoutFeeEarnerInput>;
};

export type CurrencyCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<CurrencyCreateWithoutMatterInput>;
};

export type CurrencyCreateNestedOneWithoutMatterInvoiceInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutMatterInvoiceInput>;
  create?: InputMaybe<CurrencyCreateWithoutMatterInvoiceInput>;
};

export type CurrencyCreateNestedOneWithoutNotificationRuleInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutNotificationRuleInput>;
  create?: InputMaybe<CurrencyCreateWithoutNotificationRuleInput>;
};

export type CurrencyCreateNestedOneWithoutRateInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutRateInput>;
  create?: InputMaybe<CurrencyCreateWithoutRateInput>;
};

export type CurrencyCreateNestedOneWithoutTechnologyChargeInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutTechnologyChargeInput>;
  create?: InputMaybe<CurrencyCreateWithoutTechnologyChargeInput>;
};

export type CurrencyCreateNestedOneWithoutTechnologyRatesInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutTechnologyRatesInput>;
  create?: InputMaybe<CurrencyCreateWithoutTechnologyRatesInput>;
};

export type CurrencyCreateNestedOneWithoutTimeEntryInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutTimeEntryInput>;
  create?: InputMaybe<CurrencyCreateWithoutTimeEntryInput>;
};

export type CurrencyCreateOrConnectWithoutClientInput = {
  create: CurrencyCreateWithoutClientInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutExternalMatterInput = {
  create: CurrencyCreateWithoutExternalMatterInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutFeeEarnerInput = {
  create: CurrencyCreateWithoutFeeEarnerInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutMatterInput = {
  create: CurrencyCreateWithoutMatterInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutMatterInvoiceInput = {
  create: CurrencyCreateWithoutMatterInvoiceInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutNotificationRuleInput = {
  create: CurrencyCreateWithoutNotificationRuleInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutRateInput = {
  create: CurrencyCreateWithoutRateInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutSettingsInput = {
  create: CurrencyCreateWithoutSettingsInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutTechnologyChargeInput = {
  create: CurrencyCreateWithoutTechnologyChargeInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutTechnologyRatesInput = {
  create: CurrencyCreateWithoutTechnologyRatesInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutTimeEntryInput = {
  create: CurrencyCreateWithoutTimeEntryInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateWithoutClientInput = {
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutExternalMatterInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutFeeEarnerInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutMatterInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutMatterInvoiceInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutNotificationRuleInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutRateInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutSettingsInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutTechnologyChargeInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutTechnologyRatesInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyCreateWithoutTimeEntryInput = {
  Client?: InputMaybe<ClientCreateNestedManyWithoutCurrencyInput>;
  ExternalMatter?: InputMaybe<ExternalMatterCreateNestedManyWithoutCurrencyInput>;
  FeeEarner?: InputMaybe<FeeEarnerCreateNestedManyWithoutCurrencyInput>;
  Matter?: InputMaybe<MatterCreateNestedManyWithoutCurrencyInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceCreateNestedManyWithoutCurrencyInput>;
  NotificationRule?: InputMaybe<NotificationRuleCreateNestedManyWithoutCurrencyInput>;
  Rate?: InputMaybe<RateCreateNestedManyWithoutCurrencyInput>;
  Settings?: InputMaybe<SettingsCreateNestedManyWithoutCurrencyInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeCreateNestedManyWithoutCurrencyInput>;
  baseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  roundingMethod?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutCurrencyInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CurrencyNullableRelationFilter = {
  is?: InputMaybe<CurrencyWhereInput>;
  isNot?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyRelationFilter = {
  is?: InputMaybe<CurrencyWhereInput>;
  isNot?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateOneRequiredWithoutMatterInvoiceNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutMatterInvoiceInput>;
  create?: InputMaybe<CurrencyCreateWithoutMatterInvoiceInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutMatterInvoiceInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutMatterInvoiceInput>;
};

export type CurrencyUpdateOneRequiredWithoutTechnologyRatesNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutTechnologyRatesInput>;
  create?: InputMaybe<CurrencyCreateWithoutTechnologyRatesInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutTechnologyRatesInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutTechnologyRatesInput>;
};

export type CurrencyUpdateOneWithoutClientNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutClientInput>;
  create?: InputMaybe<CurrencyCreateWithoutClientInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutClientInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutClientInput>;
};

export type CurrencyUpdateOneWithoutExternalMatterNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutExternalMatterInput>;
  create?: InputMaybe<CurrencyCreateWithoutExternalMatterInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutExternalMatterInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutExternalMatterInput>;
};

export type CurrencyUpdateOneWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutFeeEarnerInput>;
  create?: InputMaybe<CurrencyCreateWithoutFeeEarnerInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutFeeEarnerInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutFeeEarnerInput>;
};

export type CurrencyUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<CurrencyCreateWithoutMatterInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutMatterInput>;
};

export type CurrencyUpdateOneWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutNotificationRuleInput>;
  create?: InputMaybe<CurrencyCreateWithoutNotificationRuleInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutNotificationRuleInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutNotificationRuleInput>;
};

export type CurrencyUpdateOneWithoutRateNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutRateInput>;
  create?: InputMaybe<CurrencyCreateWithoutRateInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutRateInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutRateInput>;
};

export type CurrencyUpdateOneWithoutSettingsNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutSettingsInput>;
  create?: InputMaybe<CurrencyCreateWithoutSettingsInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutSettingsInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutSettingsInput>;
};

export type CurrencyUpdateOneWithoutTechnologyChargeNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutTechnologyChargeInput>;
  create?: InputMaybe<CurrencyCreateWithoutTechnologyChargeInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutTechnologyChargeInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutTechnologyChargeInput>;
};

export type CurrencyUpdateOneWithoutTimeEntryNestedInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutTimeEntryInput>;
  create?: InputMaybe<CurrencyCreateWithoutTimeEntryInput>;
  delete?: InputMaybe<CurrencyWhereInput>;
  disconnect?: InputMaybe<CurrencyWhereInput>;
  update?: InputMaybe<CurrencyUpdateToOneWithWhereWithoutTimeEntryInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutTimeEntryInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutClientInput = {
  data: CurrencyUpdateWithoutClientInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutExternalMatterInput = {
  data: CurrencyUpdateWithoutExternalMatterInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutFeeEarnerInput = {
  data: CurrencyUpdateWithoutFeeEarnerInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutMatterInput = {
  data: CurrencyUpdateWithoutMatterInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutMatterInvoiceInput = {
  data: CurrencyUpdateWithoutMatterInvoiceInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutNotificationRuleInput = {
  data: CurrencyUpdateWithoutNotificationRuleInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutRateInput = {
  data: CurrencyUpdateWithoutRateInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutSettingsInput = {
  data: CurrencyUpdateWithoutSettingsInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutTechnologyChargeInput = {
  data: CurrencyUpdateWithoutTechnologyChargeInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutTechnologyRatesInput = {
  data: CurrencyUpdateWithoutTechnologyRatesInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateToOneWithWhereWithoutTimeEntryInput = {
  data: CurrencyUpdateWithoutTimeEntryInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpdateWithoutClientInput = {
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutExternalMatterInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutFeeEarnerInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutMatterInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutMatterInvoiceInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutNotificationRuleInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutRateInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutSettingsInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutTechnologyChargeInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutTechnologyRatesInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutTimeEntryInput = {
  Client?: InputMaybe<ClientUpdateManyWithoutCurrencyNestedInput>;
  ExternalMatter?: InputMaybe<ExternalMatterUpdateManyWithoutCurrencyNestedInput>;
  FeeEarner?: InputMaybe<FeeEarnerUpdateManyWithoutCurrencyNestedInput>;
  Matter?: InputMaybe<MatterUpdateManyWithoutCurrencyNestedInput>;
  MatterInvoice?: InputMaybe<MatterInvoiceUpdateManyWithoutCurrencyNestedInput>;
  NotificationRule?: InputMaybe<NotificationRuleUpdateManyWithoutCurrencyNestedInput>;
  Rate?: InputMaybe<RateUpdateManyWithoutCurrencyNestedInput>;
  Settings?: InputMaybe<SettingsUpdateManyWithoutCurrencyNestedInput>;
  TechnologyCharge?: InputMaybe<TechnologyChargeUpdateManyWithoutCurrencyNestedInput>;
  baseCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rounding?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roundingMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  symbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutCurrencyNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CurrencyUpsertWithoutClientInput = {
  create: CurrencyCreateWithoutClientInput;
  update: CurrencyUpdateWithoutClientInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutExternalMatterInput = {
  create: CurrencyCreateWithoutExternalMatterInput;
  update: CurrencyUpdateWithoutExternalMatterInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutFeeEarnerInput = {
  create: CurrencyCreateWithoutFeeEarnerInput;
  update: CurrencyUpdateWithoutFeeEarnerInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutMatterInput = {
  create: CurrencyCreateWithoutMatterInput;
  update: CurrencyUpdateWithoutMatterInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutMatterInvoiceInput = {
  create: CurrencyCreateWithoutMatterInvoiceInput;
  update: CurrencyUpdateWithoutMatterInvoiceInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutNotificationRuleInput = {
  create: CurrencyCreateWithoutNotificationRuleInput;
  update: CurrencyUpdateWithoutNotificationRuleInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutRateInput = {
  create: CurrencyCreateWithoutRateInput;
  update: CurrencyUpdateWithoutRateInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutSettingsInput = {
  create: CurrencyCreateWithoutSettingsInput;
  update: CurrencyUpdateWithoutSettingsInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutTechnologyChargeInput = {
  create: CurrencyCreateWithoutTechnologyChargeInput;
  update: CurrencyUpdateWithoutTechnologyChargeInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutTechnologyRatesInput = {
  create: CurrencyCreateWithoutTechnologyRatesInput;
  update: CurrencyUpdateWithoutTechnologyRatesInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyUpsertWithoutTimeEntryInput = {
  create: CurrencyCreateWithoutTimeEntryInput;
  update: CurrencyUpdateWithoutTimeEntryInput;
  where?: InputMaybe<CurrencyWhereInput>;
};

export type CurrencyWhereInput = {
  AND?: InputMaybe<Array<CurrencyWhereInput>>;
  Client?: InputMaybe<ClientListRelationFilter>;
  ExternalMatter?: InputMaybe<ExternalMatterListRelationFilter>;
  FeeEarner?: InputMaybe<FeeEarnerListRelationFilter>;
  Matter?: InputMaybe<MatterListRelationFilter>;
  MatterInvoice?: InputMaybe<MatterInvoiceListRelationFilter>;
  NOT?: InputMaybe<Array<CurrencyWhereInput>>;
  NotificationRule?: InputMaybe<NotificationRuleListRelationFilter>;
  OR?: InputMaybe<Array<CurrencyWhereInput>>;
  Rate?: InputMaybe<RateListRelationFilter>;
  Settings?: InputMaybe<SettingsListRelationFilter>;
  TechnologyCharge?: InputMaybe<TechnologyChargeListRelationFilter>;
  TimeEntry?: InputMaybe<TimeEntryListRelationFilter>;
  baseCurrency?: InputMaybe<BoolNullableFilter>;
  code?: InputMaybe<StringFilter>;
  conversionRate?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateFrom?: InputMaybe<DateTimeNullableFilter>;
  dateTo?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  rounding?: InputMaybe<IntNullableFilter>;
  roundingMethod?: InputMaybe<StringNullableFilter>;
  symbol?: InputMaybe<StringFilter>;
  technologyRates?: InputMaybe<TechnologyRatesListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CurrencyWhereUniqueInput = {
  AND?: InputMaybe<Array<CurrencyWhereInput>>;
  Client?: InputMaybe<ClientListRelationFilter>;
  ExternalMatter?: InputMaybe<ExternalMatterListRelationFilter>;
  FeeEarner?: InputMaybe<FeeEarnerListRelationFilter>;
  Matter?: InputMaybe<MatterListRelationFilter>;
  MatterInvoice?: InputMaybe<MatterInvoiceListRelationFilter>;
  NOT?: InputMaybe<Array<CurrencyWhereInput>>;
  NotificationRule?: InputMaybe<NotificationRuleListRelationFilter>;
  OR?: InputMaybe<Array<CurrencyWhereInput>>;
  Rate?: InputMaybe<RateListRelationFilter>;
  Settings?: InputMaybe<SettingsListRelationFilter>;
  TechnologyCharge?: InputMaybe<TechnologyChargeListRelationFilter>;
  TimeEntry?: InputMaybe<TimeEntryListRelationFilter>;
  baseCurrency?: InputMaybe<BoolNullableFilter>;
  code?: InputMaybe<Scalars['String']['input']>;
  conversionRate?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateFrom?: InputMaybe<DateTimeNullableFilter>;
  dateTo?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  rounding?: InputMaybe<IntNullableFilter>;
  roundingMethod?: InputMaybe<StringNullableFilter>;
  symbol?: InputMaybe<StringFilter>;
  technologyRates?: InputMaybe<TechnologyRatesListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  id: Maybe<Scalars['ID']['output']>;
};

export type CurrentUserDataResult = {
  __typename?: 'CurrentUserDataResult';
  currencyId: Maybe<Scalars['Float']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  feeEarnerId: Maybe<Scalars['Int']['output']>;
  feeEarnerLevelDescription: Maybe<Scalars['String']['output']>;
  feeEarnerLevelId: Maybe<Scalars['Float']['output']>;
  officeLocationId: Maybe<Scalars['Int']['output']>;
  officeLocationName: Maybe<Scalars['String']['output']>;
  organisationalUnitId: Maybe<Scalars['Float']['output']>;
  practiceAreaId: Maybe<Scalars['Float']['output']>;
  practiceAreaName: Maybe<Scalars['String']['output']>;
  quickUpdateShownAt: Maybe<Scalars['DateTimeISO']['output']>;
  restrictedGpmVisible: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['Float']['output'];
};

export type DataFrameImportResult = {
  __typename?: 'DataFrameImportResult';
  details: Array<DataImportDetail>;
  message: Scalars['String']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type DataImportDetail = {
  __typename?: 'DataImportDetail';
  messages: Array<Scalars['String']['output']>;
  rowNumber: Maybe<Scalars['Float']['output']>;
  type: DataImportDetailType;
};

export enum DataImportDetailType {
  Error = 'Error',
  Information = 'Information'
}

/** The type of entity being imported */
export enum DataImportEntityType {
  Client = 'Client',
  ClientPermissions = 'ClientPermissions',
  Currency = 'Currency',
  ExternalMatter = 'ExternalMatter',
  FeeEarner = 'FeeEarner',
  FeeEarnerLevel = 'FeeEarnerLevel',
  LibraryAssumption = 'LibraryAssumption',
  LibraryDisbursement = 'LibraryDisbursement',
  LibraryExclusion = 'LibraryExclusion',
  LibraryUplift = 'LibraryUplift',
  Matter = 'Matter',
  MatterInvoice = 'MatterInvoice',
  MatterPermissions = 'MatterPermissions',
  OfficeLocation = 'OfficeLocation',
  OrganisationalUnit = 'OrganisationalUnit',
  PermissionSettings = 'PermissionSettings',
  Rate = 'Rate',
  TimeEntry = 'TimeEntry',
  User = 'User'
}

export type DataImportProcessedPayload = {
  __typename?: 'DataImportProcessedPayload';
  created: Scalars['Float']['output'];
  deleted: Scalars['Float']['output'];
  entityType: Scalars['String']['output'];
  errorMessage: Maybe<Scalars['String']['output']>;
  importErrors: Array<Scalars['String']['output']>;
  totalErrors: Scalars['Float']['output'];
  updated: Scalars['Float']['output'];
  userId: Maybe<Scalars['Float']['output']>;
};

export type DataImportProgress = {
  __typename?: 'DataImportProgress';
  hasError: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
  userId: Scalars['Float']['output'];
};

export type DataImportRecord = {
  __typename?: 'DataImportRecord';
  createdAt: Scalars['DateTimeISO']['output'];
  createdCount: Scalars['Float']['output'];
  deletedCount: Scalars['Float']['output'];
  entityType: DataImportEntityType;
  errorMessage: Maybe<Scalars['String']['output']>;
  updatedCount: Scalars['Float']['output'];
};

export type DataImportRecordsInput = {
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  entityTypes?: InputMaybe<Array<DataImportEntityType>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DataImportResult = {
  __typename?: 'DataImportResult';
  dataFrameResults: Array<DataFrameImportResult>;
};

export type DataImportSchemaDefinition = {
  __typename?: 'DataImportSchemaDefinition';
  properties: Array<DataImportSchemaProperty>;
};

export type DataImportSchemaProperty = {
  __typename?: 'DataImportSchemaProperty';
  default: Maybe<Scalars['String']['output']>;
  format: Maybe<Scalars['String']['output']>;
  maxLength: Maybe<Scalars['Float']['output']>;
  minLength: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DeleteAllNotificationsResult = {
  __typename?: 'DeleteAllNotificationsResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteAssumptionsResult = {
  __typename?: 'DeleteAssumptionsResult';
  assumptionIds: Array<Scalars['Int']['output']>;
};

export type DeleteBrandResult = {
  __typename?: 'DeleteBrandResult';
  brandId: Scalars['Int']['output'];
};

export type DeleteDisbursementResult = {
  __typename?: 'DeleteDisbursementResult';
  disbursementId: Scalars['Int']['output'];
};

export type DeleteDiscountResult = {
  __typename?: 'DeleteDiscountResult';
  discountId: Scalars['Float']['output'];
};

export type DeleteExclusionsResult = {
  __typename?: 'DeleteExclusionsResult';
  exclusionIds: Array<Scalars['Int']['output']>;
};

export type DeleteNotificationResult = {
  __typename?: 'DeleteNotificationResult';
  notificationId: Scalars['Float']['output'];
};

export type DeleteNotificationRuleResult = {
  __typename?: 'DeleteNotificationRuleResult';
  notificationRuleId: Scalars['Float']['output'];
};

export type DeleteNotificationRulesResult = {
  __typename?: 'DeleteNotificationRulesResult';
  notificationRuleIds: Maybe<Array<Scalars['Float']['output']>>;
};

export type DeletePhaseResult = {
  __typename?: 'DeletePhaseResult';
  phaseId: Scalars['Float']['output'];
};

export type DeletePhasesResult = {
  __typename?: 'DeletePhasesResult';
  phasesIds: Array<Scalars['Int']['output']>;
};

export type DeleteTaskResult = {
  __typename?: 'DeleteTaskResult';
  taskId: Scalars['Float']['output'];
};

export type DeleteTasksResult = {
  __typename?: 'DeleteTasksResult';
  tasksIds: Array<Scalars['Int']['output']>;
};

export type DeleteTechnologyChargeResult = {
  __typename?: 'DeleteTechnologyChargeResult';
  technologyChargeId: Scalars['Int']['output'];
};

export type DeleteUpliftResult = {
  __typename?: 'DeleteUpliftResult';
  upliftId: Scalars['Float']['output'];
};

export type DeleteWorkResult = {
  __typename?: 'DeleteWorkResult';
  workId: Scalars['Float']['output'];
};

export type DisburmentUpdate = {
  data: DisbursementUpdateInput;
  id: Scalars['Int']['input'];
};

export type Disbursement = {
  __typename?: 'Disbursement';
  amount: Scalars['Float']['output'];
  autoFocus: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  matterId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  vatStatus: TaxLabelStatus;
};

export type DisbursementCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matter: MatterCreateNestedOneWithoutDisbursementsInput;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vatStatus: TaxLabelStatus;
};

export type DisbursementCreateManyMatterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vatStatus: TaxLabelStatus;
};

export type DisbursementCreateManyMatterInputEnvelope = {
  data: Array<DisbursementCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisbursementCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<DisbursementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisbursementCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<DisbursementCreateWithoutMatterInput>>;
  createMany?: InputMaybe<DisbursementCreateManyMatterInputEnvelope>;
};

export type DisbursementCreateOrConnectWithoutMatterInput = {
  create: DisbursementCreateWithoutMatterInput;
  where: DisbursementWhereUniqueInput;
};

export type DisbursementCreateWithoutMatterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vatStatus: TaxLabelStatus;
};

export type DisbursementLineItem = {
  __typename?: 'DisbursementLineItem';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  vatStatus: TaxLabelStatusEnum;
};

export type DisbursementLineItemInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vatStatus?: InputMaybe<Scalars['String']['input']>;
};

export type DisbursementListRelationFilter = {
  every?: InputMaybe<DisbursementWhereInput>;
  none?: InputMaybe<DisbursementWhereInput>;
  some?: InputMaybe<DisbursementWhereInput>;
};

export type DisbursementScalarWhereInput = {
  AND?: InputMaybe<Array<DisbursementScalarWhereInput>>;
  NOT?: InputMaybe<Array<DisbursementScalarWhereInput>>;
  OR?: InputMaybe<Array<DisbursementScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFilter>;
};

export type DisbursementUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutDisbursementsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFieldUpdateOperationsInput>;
};

export type DisbursementUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFieldUpdateOperationsInput>;
};

export type DisbursementUpdateManyWithWhereWithoutMatterInput = {
  data: DisbursementUpdateManyMutationInput;
  where: DisbursementScalarWhereInput;
};

export type DisbursementUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<DisbursementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisbursementCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<DisbursementCreateWithoutMatterInput>>;
  createMany?: InputMaybe<DisbursementCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<DisbursementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisbursementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisbursementWhereUniqueInput>>;
  set?: InputMaybe<Array<DisbursementWhereUniqueInput>>;
  update?: InputMaybe<Array<DisbursementUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<DisbursementUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<DisbursementUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type DisbursementUpdateWithWhereUniqueWithoutMatterInput = {
  data: DisbursementUpdateWithoutMatterInput;
  where: DisbursementWhereUniqueInput;
};

export type DisbursementUpdateWithoutMatterInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFieldUpdateOperationsInput>;
};

export type DisbursementUpsertWithWhereUniqueWithoutMatterInput = {
  create: DisbursementCreateWithoutMatterInput;
  update: DisbursementUpdateWithoutMatterInput;
  where: DisbursementWhereUniqueInput;
};

export type DisbursementWhereInput = {
  AND?: InputMaybe<Array<DisbursementWhereInput>>;
  NOT?: InputMaybe<Array<DisbursementWhereInput>>;
  OR?: InputMaybe<Array<DisbursementWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFilter>;
};

export type DisbursementWhereUniqueInput = {
  AND?: InputMaybe<Array<DisbursementWhereInput>>;
  NOT?: InputMaybe<Array<DisbursementWhereInput>>;
  OR?: InputMaybe<Array<DisbursementWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFilter>;
};

export type Discount = {
  __typename?: 'Discount';
  amount: Scalars['Float']['output'];
  autoFocus: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  matterId: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  type: DiscountType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type DiscountCreateInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matter: MatterCreateNestedOneWithoutDiscountsInput;
  order: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  type: DiscountType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DiscountCreateManyMatterInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  type: DiscountType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DiscountCreateManyMatterInputEnvelope = {
  data: Array<DiscountCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiscountCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<DiscountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DiscountCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<DiscountCreateWithoutMatterInput>>;
  createMany?: InputMaybe<DiscountCreateManyMatterInputEnvelope>;
};

export type DiscountCreateOrConnectWithoutMatterInput = {
  create: DiscountCreateWithoutMatterInput;
  where: DiscountWhereUniqueInput;
};

export type DiscountCreateWithoutMatterInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  order: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  type: DiscountType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DiscountListRelationFilter = {
  every?: InputMaybe<DiscountWhereInput>;
  none?: InputMaybe<DiscountWhereInput>;
  some?: InputMaybe<DiscountWhereInput>;
};

export type DiscountScalarWhereInput = {
  AND?: InputMaybe<Array<DiscountScalarWhereInput>>;
  NOT?: InputMaybe<Array<DiscountScalarWhereInput>>;
  OR?: InputMaybe<Array<DiscountScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  reason?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumDiscountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DiscountType {
  Amount = 'Amount',
  Percent = 'Percent'
}

export type DiscountUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutDiscountsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountUpdateManyWithWhereWithoutMatterInput = {
  data: DiscountUpdateManyMutationInput;
  where: DiscountScalarWhereInput;
};

export type DiscountUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<DiscountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DiscountCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<DiscountCreateWithoutMatterInput>>;
  createMany?: InputMaybe<DiscountCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<DiscountWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DiscountScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DiscountWhereUniqueInput>>;
  set?: InputMaybe<Array<DiscountWhereUniqueInput>>;
  update?: InputMaybe<Array<DiscountUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<DiscountUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<DiscountUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type DiscountUpdateWithWhereUniqueWithoutMatterInput = {
  data: DiscountUpdateWithoutMatterInput;
  where: DiscountWhereUniqueInput;
};

export type DiscountUpdateWithoutMatterInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountUpsertWithWhereUniqueWithoutMatterInput = {
  create: DiscountCreateWithoutMatterInput;
  update: DiscountUpdateWithoutMatterInput;
  where: DiscountWhereUniqueInput;
};

export type DiscountWhereInput = {
  AND?: InputMaybe<Array<DiscountWhereInput>>;
  NOT?: InputMaybe<Array<DiscountWhereInput>>;
  OR?: InputMaybe<Array<DiscountWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  reason?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumDiscountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DiscountWhereUniqueInput = {
  AND?: InputMaybe<Array<DiscountWhereInput>>;
  NOT?: InputMaybe<Array<DiscountWhereInput>>;
  OR?: InputMaybe<Array<DiscountWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  reason?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumDiscountTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DynamicTag = {
  __typename?: 'DynamicTag';
  dynamicTagEntries: Array<DynamicTagEntries>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type DynamicTagCondition = {
  __typename?: 'DynamicTagCondition';
  condition: Maybe<DynamicTagConditionAndOr>;
  id: Scalars['Int']['output'];
  officeId: Maybe<Scalars['Int']['output']>;
  organisationalUnitId: Maybe<Scalars['Int']['output']>;
};

export enum DynamicTagConditionAndOr {
  And = 'And',
  Or = 'Or'
}

export type DynamicTagConditionCreateNestedOneWithoutDynamicTagEntriesInput = {
  connect?: InputMaybe<DynamicTagConditionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DynamicTagConditionCreateOrConnectWithoutDynamicTagEntriesInput>;
  create?: InputMaybe<DynamicTagConditionCreateWithoutDynamicTagEntriesInput>;
};

export type DynamicTagConditionCreateOrConnectWithoutDynamicTagEntriesInput = {
  create: DynamicTagConditionCreateWithoutDynamicTagEntriesInput;
  where: DynamicTagConditionWhereUniqueInput;
};

export type DynamicTagConditionCreateWithoutDynamicTagEntriesInput = {
  condition?: InputMaybe<DynamicTagConditionAndOr>;
  officeId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
};

export type DynamicTagConditionNullableRelationFilter = {
  is?: InputMaybe<DynamicTagConditionWhereInput>;
  isNot?: InputMaybe<DynamicTagConditionWhereInput>;
};

export type DynamicTagConditionUpdateOneWithoutDynamicTagEntriesNestedInput = {
  connect?: InputMaybe<DynamicTagConditionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DynamicTagConditionCreateOrConnectWithoutDynamicTagEntriesInput>;
  create?: InputMaybe<DynamicTagConditionCreateWithoutDynamicTagEntriesInput>;
  delete?: InputMaybe<DynamicTagConditionWhereInput>;
  disconnect?: InputMaybe<DynamicTagConditionWhereInput>;
  update?: InputMaybe<DynamicTagConditionUpdateToOneWithWhereWithoutDynamicTagEntriesInput>;
  upsert?: InputMaybe<DynamicTagConditionUpsertWithoutDynamicTagEntriesInput>;
};

export type DynamicTagConditionUpdateToOneWithWhereWithoutDynamicTagEntriesInput = {
  data: DynamicTagConditionUpdateWithoutDynamicTagEntriesInput;
  where?: InputMaybe<DynamicTagConditionWhereInput>;
};

export type DynamicTagConditionUpdateWithoutDynamicTagEntriesInput = {
  condition?: InputMaybe<NullableEnumDynamicTagConditionAndOrFieldUpdateOperationsInput>;
  officeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnitId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type DynamicTagConditionUpsertWithoutDynamicTagEntriesInput = {
  create: DynamicTagConditionCreateWithoutDynamicTagEntriesInput;
  update: DynamicTagConditionUpdateWithoutDynamicTagEntriesInput;
  where?: InputMaybe<DynamicTagConditionWhereInput>;
};

export type DynamicTagConditionWhereInput = {
  AND?: InputMaybe<Array<DynamicTagConditionWhereInput>>;
  NOT?: InputMaybe<Array<DynamicTagConditionWhereInput>>;
  OR?: InputMaybe<Array<DynamicTagConditionWhereInput>>;
  condition?: InputMaybe<EnumDynamicTagConditionAndOrNullableFilter>;
  dynamicTagEntries?: InputMaybe<DynamicTagEntriesListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  officeId?: InputMaybe<IntNullableFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
};

export type DynamicTagConditionWhereUniqueInput = {
  AND?: InputMaybe<Array<DynamicTagConditionWhereInput>>;
  NOT?: InputMaybe<Array<DynamicTagConditionWhereInput>>;
  OR?: InputMaybe<Array<DynamicTagConditionWhereInput>>;
  condition?: InputMaybe<EnumDynamicTagConditionAndOrNullableFilter>;
  dynamicTagEntries?: InputMaybe<DynamicTagEntriesListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeId?: InputMaybe<IntNullableFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
};

export enum DynamicTagContentType {
  Html = 'Html',
  Image = 'Image',
  Text = 'Text'
}

export type DynamicTagCreateInput = {
  dynamicTagEntries?: InputMaybe<DynamicTagEntriesCreateNestedManyWithoutDynamicTagInput>;
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type DynamicTagEntries = {
  __typename?: 'DynamicTagEntries';
  condition: Maybe<DynamicTagCondition>;
  contentType: DynamicTagContentType;
  contents: Scalars['String']['output'];
  dynamicTagConditionId: Maybe<Scalars['Int']['output']>;
  dynamicTagId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
};

export type DynamicTagEntriesCreateManyDynamicTagInput = {
  contentType: DynamicTagContentType;
  contents: Scalars['String']['input'];
  dynamicTagConditionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DynamicTagEntriesCreateManyDynamicTagInputEnvelope = {
  data: Array<DynamicTagEntriesCreateManyDynamicTagInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DynamicTagEntriesCreateNestedManyWithoutDynamicTagInput = {
  connect?: InputMaybe<Array<DynamicTagEntriesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DynamicTagEntriesCreateOrConnectWithoutDynamicTagInput>>;
  create?: InputMaybe<Array<DynamicTagEntriesCreateWithoutDynamicTagInput>>;
  createMany?: InputMaybe<DynamicTagEntriesCreateManyDynamicTagInputEnvelope>;
};

export type DynamicTagEntriesCreateOrConnectWithoutDynamicTagInput = {
  create: DynamicTagEntriesCreateWithoutDynamicTagInput;
  where: DynamicTagEntriesWhereUniqueInput;
};

export type DynamicTagEntriesCreateWithoutDynamicTagInput = {
  condition?: InputMaybe<DynamicTagConditionCreateNestedOneWithoutDynamicTagEntriesInput>;
  contentType: DynamicTagContentType;
  contents: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type DynamicTagEntriesListRelationFilter = {
  every?: InputMaybe<DynamicTagEntriesWhereInput>;
  none?: InputMaybe<DynamicTagEntriesWhereInput>;
  some?: InputMaybe<DynamicTagEntriesWhereInput>;
};

export type DynamicTagEntriesScalarWhereInput = {
  AND?: InputMaybe<Array<DynamicTagEntriesScalarWhereInput>>;
  NOT?: InputMaybe<Array<DynamicTagEntriesScalarWhereInput>>;
  OR?: InputMaybe<Array<DynamicTagEntriesScalarWhereInput>>;
  contentType?: InputMaybe<EnumDynamicTagContentTypeFilter>;
  contents?: InputMaybe<StringFilter>;
  dynamicTagConditionId?: InputMaybe<IntNullableFilter>;
  dynamicTagId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
};

export type DynamicTagEntriesUpdateManyMutationInput = {
  contentType?: InputMaybe<EnumDynamicTagContentTypeFieldUpdateOperationsInput>;
  contents?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DynamicTagEntriesUpdateManyWithWhereWithoutDynamicTagInput = {
  data: DynamicTagEntriesUpdateManyMutationInput;
  where: DynamicTagEntriesScalarWhereInput;
};

export type DynamicTagEntriesUpdateManyWithoutDynamicTagNestedInput = {
  connect?: InputMaybe<Array<DynamicTagEntriesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DynamicTagEntriesCreateOrConnectWithoutDynamicTagInput>>;
  create?: InputMaybe<Array<DynamicTagEntriesCreateWithoutDynamicTagInput>>;
  createMany?: InputMaybe<DynamicTagEntriesCreateManyDynamicTagInputEnvelope>;
  delete?: InputMaybe<Array<DynamicTagEntriesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DynamicTagEntriesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DynamicTagEntriesWhereUniqueInput>>;
  set?: InputMaybe<Array<DynamicTagEntriesWhereUniqueInput>>;
  update?: InputMaybe<Array<DynamicTagEntriesUpdateWithWhereUniqueWithoutDynamicTagInput>>;
  updateMany?: InputMaybe<Array<DynamicTagEntriesUpdateManyWithWhereWithoutDynamicTagInput>>;
  upsert?: InputMaybe<Array<DynamicTagEntriesUpsertWithWhereUniqueWithoutDynamicTagInput>>;
};

export type DynamicTagEntriesUpdateWithWhereUniqueWithoutDynamicTagInput = {
  data: DynamicTagEntriesUpdateWithoutDynamicTagInput;
  where: DynamicTagEntriesWhereUniqueInput;
};

export type DynamicTagEntriesUpdateWithoutDynamicTagInput = {
  condition?: InputMaybe<DynamicTagConditionUpdateOneWithoutDynamicTagEntriesNestedInput>;
  contentType?: InputMaybe<EnumDynamicTagContentTypeFieldUpdateOperationsInput>;
  contents?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DynamicTagEntriesUpsertWithWhereUniqueWithoutDynamicTagInput = {
  create: DynamicTagEntriesCreateWithoutDynamicTagInput;
  update: DynamicTagEntriesUpdateWithoutDynamicTagInput;
  where: DynamicTagEntriesWhereUniqueInput;
};

export type DynamicTagEntriesWhereInput = {
  AND?: InputMaybe<Array<DynamicTagEntriesWhereInput>>;
  NOT?: InputMaybe<Array<DynamicTagEntriesWhereInput>>;
  OR?: InputMaybe<Array<DynamicTagEntriesWhereInput>>;
  condition?: InputMaybe<DynamicTagConditionNullableRelationFilter>;
  contentType?: InputMaybe<EnumDynamicTagContentTypeFilter>;
  contents?: InputMaybe<StringFilter>;
  dynamicTag?: InputMaybe<DynamicTagRelationFilter>;
  dynamicTagConditionId?: InputMaybe<IntNullableFilter>;
  dynamicTagId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
};

export type DynamicTagEntriesWhereUniqueInput = {
  AND?: InputMaybe<Array<DynamicTagEntriesWhereInput>>;
  NOT?: InputMaybe<Array<DynamicTagEntriesWhereInput>>;
  OR?: InputMaybe<Array<DynamicTagEntriesWhereInput>>;
  condition?: InputMaybe<DynamicTagConditionNullableRelationFilter>;
  contentType?: InputMaybe<EnumDynamicTagContentTypeFilter>;
  contents?: InputMaybe<StringFilter>;
  dynamicTag?: InputMaybe<DynamicTagRelationFilter>;
  dynamicTagConditionId?: InputMaybe<IntNullableFilter>;
  dynamicTagId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<IntFilter>;
};

export type DynamicTagRelationFilter = {
  is?: InputMaybe<DynamicTagWhereInput>;
  isNot?: InputMaybe<DynamicTagWhereInput>;
};

export type DynamicTagUpdateInput = {
  dynamicTagEntries?: InputMaybe<DynamicTagEntriesUpdateManyWithoutDynamicTagNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DynamicTagWhereInput = {
  AND?: InputMaybe<Array<DynamicTagWhereInput>>;
  NOT?: InputMaybe<Array<DynamicTagWhereInput>>;
  OR?: InputMaybe<Array<DynamicTagWhereInput>>;
  dynamicTagEntries?: InputMaybe<DynamicTagEntriesListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
};

export type EnumDiscountTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DiscountType>;
};

export type EnumDiscountTypeFilter = {
  equals?: InputMaybe<DiscountType>;
  in?: InputMaybe<Array<DiscountType>>;
  not?: InputMaybe<NestedEnumDiscountTypeFilter>;
  notIn?: InputMaybe<Array<DiscountType>>;
};

export type EnumDynamicTagConditionAndOrNullableFilter = {
  equals?: InputMaybe<DynamicTagConditionAndOr>;
  in?: InputMaybe<Array<DynamicTagConditionAndOr>>;
  not?: InputMaybe<NestedEnumDynamicTagConditionAndOrNullableFilter>;
  notIn?: InputMaybe<Array<DynamicTagConditionAndOr>>;
};

export type EnumDynamicTagContentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DynamicTagContentType>;
};

export type EnumDynamicTagContentTypeFilter = {
  equals?: InputMaybe<DynamicTagContentType>;
  in?: InputMaybe<Array<DynamicTagContentType>>;
  not?: InputMaybe<NestedEnumDynamicTagContentTypeFilter>;
  notIn?: InputMaybe<Array<DynamicTagContentType>>;
};

export type EnumExternalMatterStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ExternalMatterStatus>;
};

export type EnumExternalMatterStatusFilter = {
  equals?: InputMaybe<ExternalMatterStatus>;
  in?: InputMaybe<Array<ExternalMatterStatus>>;
  not?: InputMaybe<NestedEnumExternalMatterStatusFilter>;
  notIn?: InputMaybe<Array<ExternalMatterStatus>>;
};

export type EnumExternalMatterTaxStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ExternalMatterTaxStatus>;
};

export type EnumExternalMatterTaxStatusFilter = {
  equals?: InputMaybe<ExternalMatterTaxStatus>;
  in?: InputMaybe<Array<ExternalMatterTaxStatus>>;
  not?: InputMaybe<NestedEnumExternalMatterTaxStatusFilter>;
  notIn?: InputMaybe<Array<ExternalMatterTaxStatus>>;
};

export type EnumGroupedEntityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<GroupedEntityType>;
};

export type EnumGroupedEntityTypeFilter = {
  equals?: InputMaybe<GroupedEntityType>;
  in?: InputMaybe<Array<GroupedEntityType>>;
  not?: InputMaybe<NestedEnumGroupedEntityTypeFilter>;
  notIn?: InputMaybe<Array<GroupedEntityType>>;
};

export type EnumInvoiceStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<InvoiceStatus>;
};

export type EnumInvoiceStatusFilter = {
  equals?: InputMaybe<InvoiceStatus>;
  in?: InputMaybe<Array<InvoiceStatus>>;
  not?: InputMaybe<NestedEnumInvoiceStatusFilter>;
  notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type EnumMatterStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<MatterStatus>;
};

export type EnumMatterStatusFilter = {
  equals?: InputMaybe<MatterStatus>;
  in?: InputMaybe<Array<MatterStatus>>;
  not?: InputMaybe<NestedEnumMatterStatusFilter>;
  notIn?: InputMaybe<Array<MatterStatus>>;
};

export type EnumMatterTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<MatterType>;
};

export type EnumMatterTypeFilter = {
  equals?: InputMaybe<MatterType>;
  in?: InputMaybe<Array<MatterType>>;
  not?: InputMaybe<NestedEnumMatterTypeFilter>;
  notIn?: InputMaybe<Array<MatterType>>;
};

export type EnumNotificationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationType>;
};

export type EnumNotificationTypeFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type EnumOutputDesignTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<OutputDesignType>;
};

export type EnumOutputDesignTypeFilter = {
  equals?: InputMaybe<OutputDesignType>;
  in?: InputMaybe<Array<OutputDesignType>>;
  not?: InputMaybe<NestedEnumOutputDesignTypeFilter>;
  notIn?: InputMaybe<Array<OutputDesignType>>;
};

export type EnumPricingLevelFieldUpdateOperationsInput = {
  set?: InputMaybe<PricingLevel>;
};

export type EnumPricingLevelFilter = {
  equals?: InputMaybe<PricingLevel>;
  in?: InputMaybe<Array<PricingLevel>>;
  not?: InputMaybe<NestedEnumPricingLevelFilter>;
  notIn?: InputMaybe<Array<PricingLevel>>;
};

export type EnumPricingTargetNullableFilter = {
  equals?: InputMaybe<PricingTarget>;
  in?: InputMaybe<Array<PricingTarget>>;
  not?: InputMaybe<NestedEnumPricingTargetNullableFilter>;
  notIn?: InputMaybe<Array<PricingTarget>>;
};

export type EnumPricingTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PricingType>;
};

export type EnumPricingTypeFilter = {
  equals?: InputMaybe<PricingType>;
  in?: InputMaybe<Array<PricingType>>;
  not?: InputMaybe<NestedEnumPricingTypeFilter>;
  notIn?: InputMaybe<Array<PricingType>>;
};

export type EnumTaxLabelFieldUpdateOperationsInput = {
  set?: InputMaybe<TaxLabel>;
};

export type EnumTaxLabelFilter = {
  equals?: InputMaybe<TaxLabel>;
  in?: InputMaybe<Array<TaxLabel>>;
  not?: InputMaybe<NestedEnumTaxLabelFilter>;
  notIn?: InputMaybe<Array<TaxLabel>>;
};

export type EnumTaxLabelNullableFilter = {
  equals?: InputMaybe<TaxLabel>;
  in?: InputMaybe<Array<TaxLabel>>;
  not?: InputMaybe<NestedEnumTaxLabelNullableFilter>;
  notIn?: InputMaybe<Array<TaxLabel>>;
};

export type EnumTaxLabelStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<TaxLabelStatus>;
};

export type EnumTaxLabelStatusFilter = {
  equals?: InputMaybe<TaxLabelStatus>;
  in?: InputMaybe<Array<TaxLabelStatus>>;
  not?: InputMaybe<NestedEnumTaxLabelStatusFilter>;
  notIn?: InputMaybe<Array<TaxLabelStatus>>;
};

export type EnumTaxStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<TaxStatus>;
};

export type EnumTaxStatusFilter = {
  equals?: InputMaybe<TaxStatus>;
  in?: InputMaybe<Array<TaxStatus>>;
  not?: InputMaybe<NestedEnumTaxStatusFilter>;
  notIn?: InputMaybe<Array<TaxStatus>>;
};

export type EnumTechnologyChargeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TechnologyChargeType>;
};

export type EnumTechnologyChargeTypeFilter = {
  equals?: InputMaybe<TechnologyChargeType>;
  in?: InputMaybe<Array<TechnologyChargeType>>;
  not?: InputMaybe<NestedEnumTechnologyChargeTypeFilter>;
  notIn?: InputMaybe<Array<TechnologyChargeType>>;
};

export type EnumTemplateTypeNullableFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeNullableFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type EnumUpliftTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UpliftType>;
};

export type EnumUpliftTypeFilter = {
  equals?: InputMaybe<UpliftType>;
  in?: InputMaybe<Array<UpliftType>>;
  not?: InputMaybe<NestedEnumUpliftTypeFilter>;
  notIn?: InputMaybe<Array<UpliftType>>;
};

export type Exclusion = {
  __typename?: 'Exclusion';
  autoFocus: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  default: Maybe<Scalars['Boolean']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  fromLibraryExclusionId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mandatory: Maybe<Scalars['Boolean']['output']>;
  matterId: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ExclusionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fromLibraryExclusion?: InputMaybe<LibraryExclusionCreateNestedOneWithoutExclusionsInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutExclusionsInput;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExclusionCreateManyFromLibraryExclusionInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  matterId: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExclusionCreateManyFromLibraryExclusionInputEnvelope = {
  data: Array<ExclusionCreateManyFromLibraryExclusionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExclusionCreateManyMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fromLibraryExclusionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExclusionCreateManyMatterInputEnvelope = {
  data: Array<ExclusionCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExclusionCreateNestedManyWithoutFromLibraryExclusionInput = {
  connect?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExclusionCreateOrConnectWithoutFromLibraryExclusionInput>>;
  create?: InputMaybe<Array<ExclusionCreateWithoutFromLibraryExclusionInput>>;
  createMany?: InputMaybe<ExclusionCreateManyFromLibraryExclusionInputEnvelope>;
};

export type ExclusionCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExclusionCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<ExclusionCreateWithoutMatterInput>>;
  createMany?: InputMaybe<ExclusionCreateManyMatterInputEnvelope>;
};

export type ExclusionCreateOrConnectWithoutFromLibraryExclusionInput = {
  create: ExclusionCreateWithoutFromLibraryExclusionInput;
  where: ExclusionWhereUniqueInput;
};

export type ExclusionCreateOrConnectWithoutMatterInput = {
  create: ExclusionCreateWithoutMatterInput;
  where: ExclusionWhereUniqueInput;
};

export type ExclusionCreateWithoutFromLibraryExclusionInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutExclusionsInput;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExclusionCreateWithoutMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fromLibraryExclusion?: InputMaybe<LibraryExclusionCreateNestedOneWithoutExclusionsInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExclusionListRelationFilter = {
  every?: InputMaybe<ExclusionWhereInput>;
  none?: InputMaybe<ExclusionWhereInput>;
  some?: InputMaybe<ExclusionWhereInput>;
};

export type ExclusionScalarWhereInput = {
  AND?: InputMaybe<Array<ExclusionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ExclusionScalarWhereInput>>;
  OR?: InputMaybe<Array<ExclusionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fromLibraryExclusionId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExclusionUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fromLibraryExclusion?: InputMaybe<LibraryExclusionUpdateOneWithoutExclusionsNestedInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutExclusionsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExclusionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExclusionUpdateManyWithWhereWithoutFromLibraryExclusionInput = {
  data: ExclusionUpdateManyMutationInput;
  where: ExclusionScalarWhereInput;
};

export type ExclusionUpdateManyWithWhereWithoutMatterInput = {
  data: ExclusionUpdateManyMutationInput;
  where: ExclusionScalarWhereInput;
};

export type ExclusionUpdateManyWithoutFromLibraryExclusionNestedInput = {
  connect?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExclusionCreateOrConnectWithoutFromLibraryExclusionInput>>;
  create?: InputMaybe<Array<ExclusionCreateWithoutFromLibraryExclusionInput>>;
  createMany?: InputMaybe<ExclusionCreateManyFromLibraryExclusionInputEnvelope>;
  delete?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExclusionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  set?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  update?: InputMaybe<Array<ExclusionUpdateWithWhereUniqueWithoutFromLibraryExclusionInput>>;
  updateMany?: InputMaybe<Array<ExclusionUpdateManyWithWhereWithoutFromLibraryExclusionInput>>;
  upsert?: InputMaybe<Array<ExclusionUpsertWithWhereUniqueWithoutFromLibraryExclusionInput>>;
};

export type ExclusionUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExclusionCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<ExclusionCreateWithoutMatterInput>>;
  createMany?: InputMaybe<ExclusionCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExclusionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  set?: InputMaybe<Array<ExclusionWhereUniqueInput>>;
  update?: InputMaybe<Array<ExclusionUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<ExclusionUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<ExclusionUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type ExclusionUpdateWithWhereUniqueWithoutFromLibraryExclusionInput = {
  data: ExclusionUpdateWithoutFromLibraryExclusionInput;
  where: ExclusionWhereUniqueInput;
};

export type ExclusionUpdateWithWhereUniqueWithoutMatterInput = {
  data: ExclusionUpdateWithoutMatterInput;
  where: ExclusionWhereUniqueInput;
};

export type ExclusionUpdateWithoutFromLibraryExclusionInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutExclusionsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExclusionUpdateWithoutMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fromLibraryExclusion?: InputMaybe<LibraryExclusionUpdateOneWithoutExclusionsNestedInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExclusionUpsertWithWhereUniqueWithoutFromLibraryExclusionInput = {
  create: ExclusionCreateWithoutFromLibraryExclusionInput;
  update: ExclusionUpdateWithoutFromLibraryExclusionInput;
  where: ExclusionWhereUniqueInput;
};

export type ExclusionUpsertWithWhereUniqueWithoutMatterInput = {
  create: ExclusionCreateWithoutMatterInput;
  update: ExclusionUpdateWithoutMatterInput;
  where: ExclusionWhereUniqueInput;
};

export type ExclusionWhereInput = {
  AND?: InputMaybe<Array<ExclusionWhereInput>>;
  NOT?: InputMaybe<Array<ExclusionWhereInput>>;
  OR?: InputMaybe<Array<ExclusionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fromLibraryExclusion?: InputMaybe<LibraryExclusionNullableRelationFilter>;
  fromLibraryExclusionId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExclusionWhereUniqueInput = {
  AND?: InputMaybe<Array<ExclusionWhereInput>>;
  NOT?: InputMaybe<Array<ExclusionWhereInput>>;
  OR?: InputMaybe<Array<ExclusionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fromLibraryExclusion?: InputMaybe<LibraryExclusionNullableRelationFilter>;
  fromLibraryExclusionId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExistingDynamicTagImages = {
  __typename?: 'ExistingDynamicTagImages';
  height: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type ExternalMatter = {
  __typename?: 'ExternalMatter';
  agreedPrice: Maybe<Scalars['Float']['output']>;
  autoClosed: Scalars['Boolean']['output'];
  client: Maybe<Client>;
  clientId: Maybe<Scalars['Int']['output']>;
  closed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency: Maybe<Currency>;
  currencyId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  deprecated: Scalars['Boolean']['output'];
  deprecatedReason: Maybe<Scalars['String']['output']>;
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalMatterEmbeddingId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  feeCharged: Maybe<Scalars['Float']['output']>;
  hasTimeEntries: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  leadFeeEarner: Maybe<FeeEarner>;
  leadFeeEarnerId: Maybe<Scalars['Int']['output']>;
  matter: Maybe<Matter>;
  organisationalUnit: Maybe<OrganisationalUnit>;
  organisationalUnitId: Maybe<Scalars['Int']['output']>;
  status: ExternalMatterStatus;
  taxStatus: ExternalMatterTaxStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ExternalMatterCreateInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateManyClientInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateManyClientInputEnvelope = {
  data: Array<ExternalMatterCreateManyClientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalMatterCreateManyCurrencyInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateManyCurrencyInputEnvelope = {
  data: Array<ExternalMatterCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalMatterCreateManyFeeEarnerInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateManyFeeEarnerInputEnvelope = {
  data: Array<ExternalMatterCreateManyFeeEarnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalMatterCreateManyOrganisationalUnitInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateManyOrganisationalUnitInputEnvelope = {
  data: Array<ExternalMatterCreateManyOrganisationalUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalMatterCreateNestedManyWithoutClientInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutClientInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyClientInputEnvelope>;
};

export type ExternalMatterCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyCurrencyInputEnvelope>;
};

export type ExternalMatterCreateNestedManyWithoutFeeEarnerInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyFeeEarnerInputEnvelope>;
};

export type ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyOrganisationalUnitInputEnvelope>;
};

export type ExternalMatterCreateNestedOneWithoutLinkingLogsInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutLinkingLogsInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutLinkingLogsInput>;
};

export type ExternalMatterCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutMatterInput>;
};

export type ExternalMatterCreateNestedOneWithoutMatterInvoicesInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutMatterInvoicesInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutMatterInvoicesInput>;
};

export type ExternalMatterCreateNestedOneWithoutMatterPermissionsInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutMatterPermissionsInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutMatterPermissionsInput>;
};

export type ExternalMatterCreateNestedOneWithoutRatesInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutRatesInput>;
};

export type ExternalMatterCreateNestedOneWithoutTimeEntriesInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutTimeEntriesInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutTimeEntriesInput>;
};

export type ExternalMatterCreateOrConnectWithoutClientInput = {
  create: ExternalMatterCreateWithoutClientInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutCurrencyInput = {
  create: ExternalMatterCreateWithoutCurrencyInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutFeeEarnerInput = {
  create: ExternalMatterCreateWithoutFeeEarnerInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutLinkingLogsInput = {
  create: ExternalMatterCreateWithoutLinkingLogsInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutMatterInput = {
  create: ExternalMatterCreateWithoutMatterInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutMatterInvoicesInput = {
  create: ExternalMatterCreateWithoutMatterInvoicesInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutMatterPermissionsInput = {
  create: ExternalMatterCreateWithoutMatterPermissionsInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutOrganisationalUnitInput = {
  create: ExternalMatterCreateWithoutOrganisationalUnitInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutRatesInput = {
  create: ExternalMatterCreateWithoutRatesInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateOrConnectWithoutTimeEntriesInput = {
  create: ExternalMatterCreateWithoutTimeEntriesInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterCreateWithoutClientInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutCurrencyInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutFeeEarnerInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutLinkingLogsInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutMatterInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutMatterInvoicesInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutMatterPermissionsInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutOrganisationalUnitInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutRatesInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutExternalMatterInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterCreateWithoutTimeEntriesInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutExternalMattersInput>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutExternalMatterInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutExternalMattersInput>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutExternalMatterInput>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutExternalMatterInput>;
  matterInvoices?: InputMaybe<MatterInvoiceCreateNestedManyWithoutExternalMatterInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutMatterInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutExternalMattersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutExternalMatterInput>;
  status: ExternalMatterStatus;
  taxStatus?: InputMaybe<ExternalMatterTaxStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterEmbeddingCreateNestedOneWithoutExternalMatterInput = {
  connect?: InputMaybe<ExternalMatterEmbeddingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterEmbeddingCreateOrConnectWithoutExternalMatterInput>;
  create?: InputMaybe<ExternalMatterEmbeddingCreateWithoutExternalMatterInput>;
};

export type ExternalMatterEmbeddingCreateOrConnectWithoutExternalMatterInput = {
  create: ExternalMatterEmbeddingCreateWithoutExternalMatterInput;
  where: ExternalMatterEmbeddingWhereUniqueInput;
};

export type ExternalMatterEmbeddingCreateWithoutExternalMatterInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExternalMatterEmbeddingNullableRelationFilter = {
  is?: InputMaybe<ExternalMatterEmbeddingWhereInput>;
  isNot?: InputMaybe<ExternalMatterEmbeddingWhereInput>;
};

export type ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput = {
  connect?: InputMaybe<ExternalMatterEmbeddingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterEmbeddingCreateOrConnectWithoutExternalMatterInput>;
  create?: InputMaybe<ExternalMatterEmbeddingCreateWithoutExternalMatterInput>;
  delete?: InputMaybe<ExternalMatterEmbeddingWhereInput>;
  disconnect?: InputMaybe<ExternalMatterEmbeddingWhereInput>;
  update?: InputMaybe<ExternalMatterEmbeddingUpdateToOneWithWhereWithoutExternalMatterInput>;
  upsert?: InputMaybe<ExternalMatterEmbeddingUpsertWithoutExternalMatterInput>;
};

export type ExternalMatterEmbeddingUpdateToOneWithWhereWithoutExternalMatterInput = {
  data: ExternalMatterEmbeddingUpdateWithoutExternalMatterInput;
  where?: InputMaybe<ExternalMatterEmbeddingWhereInput>;
};

export type ExternalMatterEmbeddingUpdateWithoutExternalMatterInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterEmbeddingUpsertWithoutExternalMatterInput = {
  create: ExternalMatterEmbeddingCreateWithoutExternalMatterInput;
  update: ExternalMatterEmbeddingUpdateWithoutExternalMatterInput;
  where?: InputMaybe<ExternalMatterEmbeddingWhereInput>;
};

export type ExternalMatterEmbeddingWhereInput = {
  AND?: InputMaybe<Array<ExternalMatterEmbeddingWhereInput>>;
  NOT?: InputMaybe<Array<ExternalMatterEmbeddingWhereInput>>;
  OR?: InputMaybe<Array<ExternalMatterEmbeddingWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalMatter?: InputMaybe<ExternalMatterNullableRelationFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExternalMatterEmbeddingWhereUniqueInput = {
  AND?: InputMaybe<Array<ExternalMatterEmbeddingWhereInput>>;
  NOT?: InputMaybe<Array<ExternalMatterEmbeddingWhereInput>>;
  OR?: InputMaybe<Array<ExternalMatterEmbeddingWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalMatter?: InputMaybe<ExternalMatterNullableRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExternalMatterListRelationFilter = {
  every?: InputMaybe<ExternalMatterWhereInput>;
  none?: InputMaybe<ExternalMatterWhereInput>;
  some?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterNullableRelationFilter = {
  is?: InputMaybe<ExternalMatterWhereInput>;
  isNot?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterRelationFilter = {
  is?: InputMaybe<ExternalMatterWhereInput>;
  isNot?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterScalarWhereInput = {
  AND?: InputMaybe<Array<ExternalMatterScalarWhereInput>>;
  NOT?: InputMaybe<Array<ExternalMatterScalarWhereInput>>;
  OR?: InputMaybe<Array<ExternalMatterScalarWhereInput>>;
  agreedPrice?: InputMaybe<FloatNullableFilter>;
  autoClosed?: InputMaybe<BoolFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  closed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatterEmbeddingId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeCharged?: InputMaybe<FloatNullableFilter>;
  hasTimeEntries?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  leadFeeEarnerId?: InputMaybe<IntNullableFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumExternalMatterStatusFilter>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ExternalMatterStatus {
  Assigned = 'Assigned',
  Unassigned = 'Unassigned'
}

export enum ExternalMatterTaxStatus {
  Exempt = 'Exempt',
  NoData = 'NoData',
  NotExempt = 'NotExempt'
}

export type ExternalMatterUnlinkedSummary = {
  __typename?: 'ExternalMatterUnlinkedSummary';
  totalAmount: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ExternalMatterUpdateManyMutationInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateManyWithWhereWithoutClientInput = {
  data: ExternalMatterUpdateManyMutationInput;
  where: ExternalMatterScalarWhereInput;
};

export type ExternalMatterUpdateManyWithWhereWithoutCurrencyInput = {
  data: ExternalMatterUpdateManyMutationInput;
  where: ExternalMatterScalarWhereInput;
};

export type ExternalMatterUpdateManyWithWhereWithoutFeeEarnerInput = {
  data: ExternalMatterUpdateManyMutationInput;
  where: ExternalMatterScalarWhereInput;
};

export type ExternalMatterUpdateManyWithWhereWithoutOrganisationalUnitInput = {
  data: ExternalMatterUpdateManyMutationInput;
  where: ExternalMatterScalarWhereInput;
};

export type ExternalMatterUpdateManyWithoutClientNestedInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutClientInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyClientInputEnvelope>;
  delete?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExternalMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ExternalMatterUpdateWithWhereUniqueWithoutClientInput>>;
  updateMany?: InputMaybe<Array<ExternalMatterUpdateManyWithWhereWithoutClientInput>>;
  upsert?: InputMaybe<Array<ExternalMatterUpsertWithWhereUniqueWithoutClientInput>>;
};

export type ExternalMatterUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExternalMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ExternalMatterUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<ExternalMatterUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<ExternalMatterUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type ExternalMatterUpdateManyWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyFeeEarnerInputEnvelope>;
  delete?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExternalMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ExternalMatterUpdateWithWhereUniqueWithoutFeeEarnerInput>>;
  updateMany?: InputMaybe<Array<ExternalMatterUpdateManyWithWhereWithoutFeeEarnerInput>>;
  upsert?: InputMaybe<Array<ExternalMatterUpsertWithWhereUniqueWithoutFeeEarnerInput>>;
};

export type ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput = {
  connect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalMatterCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<ExternalMatterCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<ExternalMatterCreateManyOrganisationalUnitInputEnvelope>;
  delete?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExternalMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ExternalMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ExternalMatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput>>;
  updateMany?: InputMaybe<Array<ExternalMatterUpdateManyWithWhereWithoutOrganisationalUnitInput>>;
  upsert?: InputMaybe<Array<ExternalMatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput>>;
};

export type ExternalMatterUpdateOneRequiredWithoutLinkingLogsNestedInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutLinkingLogsInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutLinkingLogsInput>;
  update?: InputMaybe<ExternalMatterUpdateToOneWithWhereWithoutLinkingLogsInput>;
  upsert?: InputMaybe<ExternalMatterUpsertWithoutLinkingLogsInput>;
};

export type ExternalMatterUpdateOneRequiredWithoutMatterInvoicesNestedInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutMatterInvoicesInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutMatterInvoicesInput>;
  update?: InputMaybe<ExternalMatterUpdateToOneWithWhereWithoutMatterInvoicesInput>;
  upsert?: InputMaybe<ExternalMatterUpsertWithoutMatterInvoicesInput>;
};

export type ExternalMatterUpdateOneRequiredWithoutMatterPermissionsNestedInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutMatterPermissionsInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutMatterPermissionsInput>;
  update?: InputMaybe<ExternalMatterUpdateToOneWithWhereWithoutMatterPermissionsInput>;
  upsert?: InputMaybe<ExternalMatterUpsertWithoutMatterPermissionsInput>;
};

export type ExternalMatterUpdateOneRequiredWithoutTimeEntriesNestedInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutTimeEntriesInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutTimeEntriesInput>;
  update?: InputMaybe<ExternalMatterUpdateToOneWithWhereWithoutTimeEntriesInput>;
  upsert?: InputMaybe<ExternalMatterUpsertWithoutTimeEntriesInput>;
};

export type ExternalMatterUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutMatterInput>;
  delete?: InputMaybe<ExternalMatterWhereInput>;
  disconnect?: InputMaybe<ExternalMatterWhereInput>;
  update?: InputMaybe<ExternalMatterUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<ExternalMatterUpsertWithoutMatterInput>;
};

export type ExternalMatterUpdateOneWithoutRatesNestedInput = {
  connect?: InputMaybe<ExternalMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ExternalMatterCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<ExternalMatterCreateWithoutRatesInput>;
  delete?: InputMaybe<ExternalMatterWhereInput>;
  disconnect?: InputMaybe<ExternalMatterWhereInput>;
  update?: InputMaybe<ExternalMatterUpdateToOneWithWhereWithoutRatesInput>;
  upsert?: InputMaybe<ExternalMatterUpsertWithoutRatesInput>;
};

export type ExternalMatterUpdateToOneWithWhereWithoutLinkingLogsInput = {
  data: ExternalMatterUpdateWithoutLinkingLogsInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpdateToOneWithWhereWithoutMatterInput = {
  data: ExternalMatterUpdateWithoutMatterInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpdateToOneWithWhereWithoutMatterInvoicesInput = {
  data: ExternalMatterUpdateWithoutMatterInvoicesInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpdateToOneWithWhereWithoutMatterPermissionsInput = {
  data: ExternalMatterUpdateWithoutMatterPermissionsInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpdateToOneWithWhereWithoutRatesInput = {
  data: ExternalMatterUpdateWithoutRatesInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpdateToOneWithWhereWithoutTimeEntriesInput = {
  data: ExternalMatterUpdateWithoutTimeEntriesInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpdateWithWhereUniqueWithoutClientInput = {
  data: ExternalMatterUpdateWithoutClientInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: ExternalMatterUpdateWithoutCurrencyInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpdateWithWhereUniqueWithoutFeeEarnerInput = {
  data: ExternalMatterUpdateWithoutFeeEarnerInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput = {
  data: ExternalMatterUpdateWithoutOrganisationalUnitInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpdateWithoutClientInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutCurrencyInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutFeeEarnerInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutLinkingLogsInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutMatterInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutMatterInvoicesInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutMatterPermissionsInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutOrganisationalUnitInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutRatesInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutExternalMatterNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpdateWithoutTimeEntriesInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutExternalMattersNestedInput>;
  closed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutExternalMatterNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingUpdateOneWithoutExternalMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutExternalMattersNestedInput>;
  hasTimeEntries?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutExternalMatterNestedInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutExternalMatterNestedInput>;
  matterInvoices?: InputMaybe<MatterInvoiceUpdateManyWithoutExternalMatterNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutMatterNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutExternalMatterNestedInput>;
  status?: InputMaybe<EnumExternalMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExternalMatterUpsertWithWhereUniqueWithoutClientInput = {
  create: ExternalMatterCreateWithoutClientInput;
  update: ExternalMatterUpdateWithoutClientInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: ExternalMatterCreateWithoutCurrencyInput;
  update: ExternalMatterUpdateWithoutCurrencyInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpsertWithWhereUniqueWithoutFeeEarnerInput = {
  create: ExternalMatterCreateWithoutFeeEarnerInput;
  update: ExternalMatterUpdateWithoutFeeEarnerInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput = {
  create: ExternalMatterCreateWithoutOrganisationalUnitInput;
  update: ExternalMatterUpdateWithoutOrganisationalUnitInput;
  where: ExternalMatterWhereUniqueInput;
};

export type ExternalMatterUpsertWithoutLinkingLogsInput = {
  create: ExternalMatterCreateWithoutLinkingLogsInput;
  update: ExternalMatterUpdateWithoutLinkingLogsInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpsertWithoutMatterInput = {
  create: ExternalMatterCreateWithoutMatterInput;
  update: ExternalMatterUpdateWithoutMatterInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpsertWithoutMatterInvoicesInput = {
  create: ExternalMatterCreateWithoutMatterInvoicesInput;
  update: ExternalMatterUpdateWithoutMatterInvoicesInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpsertWithoutMatterPermissionsInput = {
  create: ExternalMatterCreateWithoutMatterPermissionsInput;
  update: ExternalMatterUpdateWithoutMatterPermissionsInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpsertWithoutRatesInput = {
  create: ExternalMatterCreateWithoutRatesInput;
  update: ExternalMatterUpdateWithoutRatesInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterUpsertWithoutTimeEntriesInput = {
  create: ExternalMatterCreateWithoutTimeEntriesInput;
  update: ExternalMatterUpdateWithoutTimeEntriesInput;
  where?: InputMaybe<ExternalMatterWhereInput>;
};

export type ExternalMatterWhereInput = {
  AND?: InputMaybe<Array<ExternalMatterWhereInput>>;
  NOT?: InputMaybe<Array<ExternalMatterWhereInput>>;
  OR?: InputMaybe<Array<ExternalMatterWhereInput>>;
  agreedPrice?: InputMaybe<FloatNullableFilter>;
  autoClosed?: InputMaybe<BoolFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  closed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingNullableRelationFilter>;
  externalMatterEmbeddingId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeCharged?: InputMaybe<FloatNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  hasTimeEntries?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  leadFeeEarnerId?: InputMaybe<IntNullableFilter>;
  linkingLogs?: InputMaybe<LinkingLogListRelationFilter>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  matterInvoices?: InputMaybe<MatterInvoiceListRelationFilter>;
  matterPermissions?: InputMaybe<MatterPermissionListRelationFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  status?: InputMaybe<EnumExternalMatterStatusFilter>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFilter>;
  timeEntries?: InputMaybe<TimeEntryListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExternalMatterWhereUniqueInput = {
  AND?: InputMaybe<Array<ExternalMatterWhereInput>>;
  NOT?: InputMaybe<Array<ExternalMatterWhereInput>>;
  OR?: InputMaybe<Array<ExternalMatterWhereInput>>;
  agreedPrice?: InputMaybe<FloatNullableFilter>;
  autoClosed?: InputMaybe<BoolFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  closed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterEmbedding?: InputMaybe<ExternalMatterEmbeddingNullableRelationFilter>;
  externalMatterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeCharged?: InputMaybe<FloatNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  hasTimeEntries?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leadFeeEarnerId?: InputMaybe<IntNullableFilter>;
  linkingLogs?: InputMaybe<LinkingLogListRelationFilter>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  matterInvoices?: InputMaybe<MatterInvoiceListRelationFilter>;
  matterPermissions?: InputMaybe<MatterPermissionListRelationFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  status?: InputMaybe<EnumExternalMatterStatusFilter>;
  taxStatus?: InputMaybe<EnumExternalMatterTaxStatusFilter>;
  timeEntries?: InputMaybe<TimeEntryListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FeeEarner = {
  __typename?: 'FeeEarner';
  costRate: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  currencyId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  deprecated: Scalars['Boolean']['output'];
  deprecatedReason: Maybe<Scalars['String']['output']>;
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  feeEarnerLevel: Maybe<FeeEarnerLevel>;
  feeEarnerLevelId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  officeLocationId: Maybe<Scalars['Int']['output']>;
  organisationalUnitId: Maybe<Scalars['Int']['output']>;
  practiceArea: Maybe<OrganisationalUnit>;
  rates: Maybe<Array<RateResult>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type FeeEarnerCreateManyCurrencyInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeEarnerCreateManyCurrencyInputEnvelope = {
  data: Array<FeeEarnerCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeeEarnerCreateManyFeeEarnerLevelInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeEarnerCreateManyFeeEarnerLevelInputEnvelope = {
  data: Array<FeeEarnerCreateManyFeeEarnerLevelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeeEarnerCreateManyOfficeLocationInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeEarnerCreateManyOfficeLocationInputEnvelope = {
  data: Array<FeeEarnerCreateManyOfficeLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeeEarnerCreateManyOrganisationalUnitInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeEarnerCreateManyOrganisationalUnitInputEnvelope = {
  data: Array<FeeEarnerCreateManyOrganisationalUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeeEarnerCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyCurrencyInputEnvelope>;
};

export type FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyFeeEarnerLevelInputEnvelope>;
};

export type FeeEarnerCreateNestedManyWithoutOfficeLocationInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutOfficeLocationInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutOfficeLocationInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyOfficeLocationInputEnvelope>;
};

export type FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyOrganisationalUnitInputEnvelope>;
};

export type FeeEarnerCreateNestedOneWithoutExternalMattersInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutExternalMattersInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutExternalMattersInput>;
};

export type FeeEarnerCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutMattersInput>;
};

export type FeeEarnerCreateNestedOneWithoutRatesInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutRatesInput>;
};

export type FeeEarnerCreateNestedOneWithoutTeamMembershipsInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutTeamMembershipsInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutTeamMembershipsInput>;
};

export type FeeEarnerCreateNestedOneWithoutTimeEntriesInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutTimeEntriesInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutTimeEntriesInput>;
};

export type FeeEarnerCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutUsersInput>;
};

export type FeeEarnerCreateNestedOneWithoutWorkInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutWorkInput>;
};

export type FeeEarnerCreateOrConnectWithoutCurrencyInput = {
  create: FeeEarnerCreateWithoutCurrencyInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutExternalMattersInput = {
  create: FeeEarnerCreateWithoutExternalMattersInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutFeeEarnerLevelInput = {
  create: FeeEarnerCreateWithoutFeeEarnerLevelInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutMattersInput = {
  create: FeeEarnerCreateWithoutMattersInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutOfficeLocationInput = {
  create: FeeEarnerCreateWithoutOfficeLocationInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutOrganisationalUnitInput = {
  create: FeeEarnerCreateWithoutOrganisationalUnitInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutRatesInput = {
  create: FeeEarnerCreateWithoutRatesInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutTeamMembershipsInput = {
  create: FeeEarnerCreateWithoutTeamMembershipsInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutTimeEntriesInput = {
  create: FeeEarnerCreateWithoutTimeEntriesInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutUsersInput = {
  create: FeeEarnerCreateWithoutUsersInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateOrConnectWithoutWorkInput = {
  create: FeeEarnerCreateWithoutWorkInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerCreateWithoutCurrencyInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutExternalMattersInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutFeeEarnerLevelInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutMattersInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutOfficeLocationInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutOrganisationalUnitInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutRatesInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutTeamMembershipsInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutTimeEntriesInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutUsersInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerInput>;
};

export type FeeEarnerCreateWithoutWorkInput = {
  costRate?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutFeeEarnerInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutFeeEarnerInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutFeeEarnerInput>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutFeeEarnersInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerInput>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutFeeEarnerInput>;
  timeEntries?: InputMaybe<TimeEntryCreateNestedManyWithoutFeeEarnerInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  users?: InputMaybe<UserCreateNestedOneWithoutFeeEarnerInput>;
};

export type FeeEarnerInput = {
  isLevel?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['String']['input']>;
};

export type FeeEarnerLevel = {
  __typename?: 'FeeEarnerLevel';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  feeEarners: Maybe<Array<FeeEarner>>;
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  restrictedGpmVisible: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutFeeEarnersInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutFeeEarnersInput>;
};

export type FeeEarnerLevelCreateNestedOneWithoutNotifyNotificationRulesInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutNotifyNotificationRulesInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput>;
};

export type FeeEarnerLevelCreateNestedOneWithoutRatesInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutRatesInput>;
};

export type FeeEarnerLevelCreateNestedOneWithoutTriggeredNotificationRulesInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutTriggeredNotificationRulesInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput>;
};

export type FeeEarnerLevelCreateNestedOneWithoutWorkInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutWorkInput>;
};

export type FeeEarnerLevelCreateOrConnectWithoutFeeEarnersInput = {
  create: FeeEarnerLevelCreateWithoutFeeEarnersInput;
  where: FeeEarnerLevelWhereUniqueInput;
};

export type FeeEarnerLevelCreateOrConnectWithoutNotifyNotificationRulesInput = {
  create: FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput;
  where: FeeEarnerLevelWhereUniqueInput;
};

export type FeeEarnerLevelCreateOrConnectWithoutRatesInput = {
  create: FeeEarnerLevelCreateWithoutRatesInput;
  where: FeeEarnerLevelWhereUniqueInput;
};

export type FeeEarnerLevelCreateOrConnectWithoutTriggeredNotificationRulesInput = {
  create: FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput;
  where: FeeEarnerLevelWhereUniqueInput;
};

export type FeeEarnerLevelCreateOrConnectWithoutWorkInput = {
  create: FeeEarnerLevelCreateWithoutWorkInput;
  where: FeeEarnerLevelWhereUniqueInput;
};

export type FeeEarnerLevelCreateWithoutFeeEarnersInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput>;
  order: Scalars['Int']['input'];
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerLevelInput>;
  restrictedGpmVisible?: InputMaybe<Scalars['Boolean']['input']>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerLevelInput>;
};

export type FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput>;
  order: Scalars['Int']['input'];
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerLevelInput>;
  restrictedGpmVisible?: InputMaybe<Scalars['Boolean']['input']>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerLevelInput>;
};

export type FeeEarnerLevelCreateWithoutRatesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput>;
  order: Scalars['Int']['input'];
  restrictedGpmVisible?: InputMaybe<Scalars['Boolean']['input']>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerLevelInput>;
};

export type FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput>;
  order: Scalars['Int']['input'];
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerLevelInput>;
  restrictedGpmVisible?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutFeeEarnerLevelInput>;
};

export type FeeEarnerLevelCreateWithoutWorkInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput>;
  order: Scalars['Int']['input'];
  rates?: InputMaybe<RateCreateNestedManyWithoutFeeEarnerLevelInput>;
  restrictedGpmVisible?: InputMaybe<Scalars['Boolean']['input']>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeEarnerLevelNullableRelationFilter = {
  is?: InputMaybe<FeeEarnerLevelWhereInput>;
  isNot?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelRelationFilter = {
  is?: InputMaybe<FeeEarnerLevelWhereInput>;
  isNot?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerLevelNestedInput>;
  restrictedGpmVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerLevelNestedInput>;
};

export type FeeEarnerLevelUpdateOneRequiredWithoutNotifyNotificationRulesNestedInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutNotifyNotificationRulesInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput>;
  update?: InputMaybe<FeeEarnerLevelUpdateToOneWithWhereWithoutNotifyNotificationRulesInput>;
  upsert?: InputMaybe<FeeEarnerLevelUpsertWithoutNotifyNotificationRulesInput>;
};

export type FeeEarnerLevelUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutTriggeredNotificationRulesInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput>;
  update?: InputMaybe<FeeEarnerLevelUpdateToOneWithWhereWithoutTriggeredNotificationRulesInput>;
  upsert?: InputMaybe<FeeEarnerLevelUpsertWithoutTriggeredNotificationRulesInput>;
};

export type FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutFeeEarnersInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutFeeEarnersInput>;
  delete?: InputMaybe<FeeEarnerLevelWhereInput>;
  disconnect?: InputMaybe<FeeEarnerLevelWhereInput>;
  update?: InputMaybe<FeeEarnerLevelUpdateToOneWithWhereWithoutFeeEarnersInput>;
  upsert?: InputMaybe<FeeEarnerLevelUpsertWithoutFeeEarnersInput>;
};

export type FeeEarnerLevelUpdateOneWithoutRatesNestedInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutRatesInput>;
  delete?: InputMaybe<FeeEarnerLevelWhereInput>;
  disconnect?: InputMaybe<FeeEarnerLevelWhereInput>;
  update?: InputMaybe<FeeEarnerLevelUpdateToOneWithWhereWithoutRatesInput>;
  upsert?: InputMaybe<FeeEarnerLevelUpsertWithoutRatesInput>;
};

export type FeeEarnerLevelUpdateOneWithoutWorkNestedInput = {
  connect?: InputMaybe<FeeEarnerLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerLevelCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<FeeEarnerLevelCreateWithoutWorkInput>;
  delete?: InputMaybe<FeeEarnerLevelWhereInput>;
  disconnect?: InputMaybe<FeeEarnerLevelWhereInput>;
  update?: InputMaybe<FeeEarnerLevelUpdateToOneWithWhereWithoutWorkInput>;
  upsert?: InputMaybe<FeeEarnerLevelUpsertWithoutWorkInput>;
};

export type FeeEarnerLevelUpdateToOneWithWhereWithoutFeeEarnersInput = {
  data: FeeEarnerLevelUpdateWithoutFeeEarnersInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpdateToOneWithWhereWithoutNotifyNotificationRulesInput = {
  data: FeeEarnerLevelUpdateWithoutNotifyNotificationRulesInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpdateToOneWithWhereWithoutRatesInput = {
  data: FeeEarnerLevelUpdateWithoutRatesInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpdateToOneWithWhereWithoutTriggeredNotificationRulesInput = {
  data: FeeEarnerLevelUpdateWithoutTriggeredNotificationRulesInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpdateToOneWithWhereWithoutWorkInput = {
  data: FeeEarnerLevelUpdateWithoutWorkInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpdateWithoutFeeEarnersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerLevelNestedInput>;
  restrictedGpmVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerLevelNestedInput>;
};

export type FeeEarnerLevelUpdateWithoutNotifyNotificationRulesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerLevelNestedInput>;
  restrictedGpmVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerLevelNestedInput>;
};

export type FeeEarnerLevelUpdateWithoutRatesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  restrictedGpmVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerLevelNestedInput>;
};

export type FeeEarnerLevelUpdateWithoutTriggeredNotificationRulesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerLevelNestedInput>;
  restrictedGpmVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerLevelNestedInput>;
};

export type FeeEarnerLevelUpdateWithoutWorkInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerLevelNestedInput>;
  restrictedGpmVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FeeEarnerLevelUpsertWithoutFeeEarnersInput = {
  create: FeeEarnerLevelCreateWithoutFeeEarnersInput;
  update: FeeEarnerLevelUpdateWithoutFeeEarnersInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpsertWithoutNotifyNotificationRulesInput = {
  create: FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput;
  update: FeeEarnerLevelUpdateWithoutNotifyNotificationRulesInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpsertWithoutRatesInput = {
  create: FeeEarnerLevelCreateWithoutRatesInput;
  update: FeeEarnerLevelUpdateWithoutRatesInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpsertWithoutTriggeredNotificationRulesInput = {
  create: FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput;
  update: FeeEarnerLevelUpdateWithoutTriggeredNotificationRulesInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelUpsertWithoutWorkInput = {
  create: FeeEarnerLevelCreateWithoutWorkInput;
  update: FeeEarnerLevelUpdateWithoutWorkInput;
  where?: InputMaybe<FeeEarnerLevelWhereInput>;
};

export type FeeEarnerLevelWhereInput = {
  AND?: InputMaybe<Array<FeeEarnerLevelWhereInput>>;
  NOT?: InputMaybe<Array<FeeEarnerLevelWhereInput>>;
  OR?: InputMaybe<Array<FeeEarnerLevelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarners?: InputMaybe<FeeEarnerListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  restrictedGpmVisible?: InputMaybe<BoolFilter>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type FeeEarnerLevelWhereUniqueInput = {
  AND?: InputMaybe<Array<FeeEarnerLevelWhereInput>>;
  NOT?: InputMaybe<Array<FeeEarnerLevelWhereInput>>;
  OR?: InputMaybe<Array<FeeEarnerLevelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarners?: InputMaybe<FeeEarnerListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notifyNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  restrictedGpmVisible?: InputMaybe<BoolFilter>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type FeeEarnerLevelsResult = {
  __typename?: 'FeeEarnerLevelsResult';
  records: Array<FeeEarnerLevel>;
};

export type FeeEarnerListRelationFilter = {
  every?: InputMaybe<FeeEarnerWhereInput>;
  none?: InputMaybe<FeeEarnerWhereInput>;
  some?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerNullableRelationFilter = {
  is?: InputMaybe<FeeEarnerWhereInput>;
  isNot?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerRelationFilter = {
  is?: InputMaybe<FeeEarnerWhereInput>;
  isNot?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerScalarWhereInput = {
  AND?: InputMaybe<Array<FeeEarnerScalarWhereInput>>;
  NOT?: InputMaybe<Array<FeeEarnerScalarWhereInput>>;
  OR?: InputMaybe<Array<FeeEarnerScalarWhereInput>>;
  costRate?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FeeEarnerUpdateManyMutationInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FeeEarnerUpdateManyWithWhereWithoutCurrencyInput = {
  data: FeeEarnerUpdateManyMutationInput;
  where: FeeEarnerScalarWhereInput;
};

export type FeeEarnerUpdateManyWithWhereWithoutFeeEarnerLevelInput = {
  data: FeeEarnerUpdateManyMutationInput;
  where: FeeEarnerScalarWhereInput;
};

export type FeeEarnerUpdateManyWithWhereWithoutOfficeLocationInput = {
  data: FeeEarnerUpdateManyMutationInput;
  where: FeeEarnerScalarWhereInput;
};

export type FeeEarnerUpdateManyWithWhereWithoutOrganisationalUnitInput = {
  data: FeeEarnerUpdateManyMutationInput;
  where: FeeEarnerScalarWhereInput;
};

export type FeeEarnerUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FeeEarnerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  set?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  update?: InputMaybe<Array<FeeEarnerUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<FeeEarnerUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<FeeEarnerUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyFeeEarnerLevelInputEnvelope>;
  delete?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FeeEarnerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  set?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  update?: InputMaybe<Array<FeeEarnerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput>>;
  updateMany?: InputMaybe<Array<FeeEarnerUpdateManyWithWhereWithoutFeeEarnerLevelInput>>;
  upsert?: InputMaybe<Array<FeeEarnerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput>>;
};

export type FeeEarnerUpdateManyWithoutOfficeLocationNestedInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutOfficeLocationInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutOfficeLocationInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyOfficeLocationInputEnvelope>;
  delete?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FeeEarnerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  set?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  update?: InputMaybe<Array<FeeEarnerUpdateWithWhereUniqueWithoutOfficeLocationInput>>;
  updateMany?: InputMaybe<Array<FeeEarnerUpdateManyWithWhereWithoutOfficeLocationInput>>;
  upsert?: InputMaybe<Array<FeeEarnerUpsertWithWhereUniqueWithoutOfficeLocationInput>>;
};

export type FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput = {
  connect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FeeEarnerCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<FeeEarnerCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<FeeEarnerCreateManyOrganisationalUnitInputEnvelope>;
  delete?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FeeEarnerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  set?: InputMaybe<Array<FeeEarnerWhereUniqueInput>>;
  update?: InputMaybe<Array<FeeEarnerUpdateWithWhereUniqueWithoutOrganisationalUnitInput>>;
  updateMany?: InputMaybe<Array<FeeEarnerUpdateManyWithWhereWithoutOrganisationalUnitInput>>;
  upsert?: InputMaybe<Array<FeeEarnerUpsertWithWhereUniqueWithoutOrganisationalUnitInput>>;
};

export type FeeEarnerUpdateOneRequiredWithoutTimeEntriesNestedInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutTimeEntriesInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutTimeEntriesInput>;
  update?: InputMaybe<FeeEarnerUpdateToOneWithWhereWithoutTimeEntriesInput>;
  upsert?: InputMaybe<FeeEarnerUpsertWithoutTimeEntriesInput>;
};

export type FeeEarnerUpdateOneWithoutExternalMattersNestedInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutExternalMattersInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutExternalMattersInput>;
  delete?: InputMaybe<FeeEarnerWhereInput>;
  disconnect?: InputMaybe<FeeEarnerWhereInput>;
  update?: InputMaybe<FeeEarnerUpdateToOneWithWhereWithoutExternalMattersInput>;
  upsert?: InputMaybe<FeeEarnerUpsertWithoutExternalMattersInput>;
};

export type FeeEarnerUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutMattersInput>;
  delete?: InputMaybe<FeeEarnerWhereInput>;
  disconnect?: InputMaybe<FeeEarnerWhereInput>;
  update?: InputMaybe<FeeEarnerUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<FeeEarnerUpsertWithoutMattersInput>;
};

export type FeeEarnerUpdateOneWithoutRatesNestedInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutRatesInput>;
  delete?: InputMaybe<FeeEarnerWhereInput>;
  disconnect?: InputMaybe<FeeEarnerWhereInput>;
  update?: InputMaybe<FeeEarnerUpdateToOneWithWhereWithoutRatesInput>;
  upsert?: InputMaybe<FeeEarnerUpsertWithoutRatesInput>;
};

export type FeeEarnerUpdateOneWithoutTeamMembershipsNestedInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutTeamMembershipsInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutTeamMembershipsInput>;
  delete?: InputMaybe<FeeEarnerWhereInput>;
  disconnect?: InputMaybe<FeeEarnerWhereInput>;
  update?: InputMaybe<FeeEarnerUpdateToOneWithWhereWithoutTeamMembershipsInput>;
  upsert?: InputMaybe<FeeEarnerUpsertWithoutTeamMembershipsInput>;
};

export type FeeEarnerUpdateOneWithoutUsersNestedInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutUsersInput>;
  delete?: InputMaybe<FeeEarnerWhereInput>;
  disconnect?: InputMaybe<FeeEarnerWhereInput>;
  update?: InputMaybe<FeeEarnerUpdateToOneWithWhereWithoutUsersInput>;
  upsert?: InputMaybe<FeeEarnerUpsertWithoutUsersInput>;
};

export type FeeEarnerUpdateOneWithoutWorkNestedInput = {
  connect?: InputMaybe<FeeEarnerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeeEarnerCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<FeeEarnerCreateWithoutWorkInput>;
  delete?: InputMaybe<FeeEarnerWhereInput>;
  disconnect?: InputMaybe<FeeEarnerWhereInput>;
  update?: InputMaybe<FeeEarnerUpdateToOneWithWhereWithoutWorkInput>;
  upsert?: InputMaybe<FeeEarnerUpsertWithoutWorkInput>;
};

export type FeeEarnerUpdateToOneWithWhereWithoutExternalMattersInput = {
  data: FeeEarnerUpdateWithoutExternalMattersInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpdateToOneWithWhereWithoutMattersInput = {
  data: FeeEarnerUpdateWithoutMattersInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpdateToOneWithWhereWithoutRatesInput = {
  data: FeeEarnerUpdateWithoutRatesInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpdateToOneWithWhereWithoutTeamMembershipsInput = {
  data: FeeEarnerUpdateWithoutTeamMembershipsInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpdateToOneWithWhereWithoutTimeEntriesInput = {
  data: FeeEarnerUpdateWithoutTimeEntriesInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpdateToOneWithWhereWithoutUsersInput = {
  data: FeeEarnerUpdateWithoutUsersInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpdateToOneWithWhereWithoutWorkInput = {
  data: FeeEarnerUpdateWithoutWorkInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: FeeEarnerUpdateWithoutCurrencyInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput = {
  data: FeeEarnerUpdateWithoutFeeEarnerLevelInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpdateWithWhereUniqueWithoutOfficeLocationInput = {
  data: FeeEarnerUpdateWithoutOfficeLocationInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpdateWithWhereUniqueWithoutOrganisationalUnitInput = {
  data: FeeEarnerUpdateWithoutOrganisationalUnitInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpdateWithoutCurrencyInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutExternalMattersInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutFeeEarnerLevelInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutMattersInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutOfficeLocationInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutOrganisationalUnitInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutRatesInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutTeamMembershipsInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutTimeEntriesInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutUsersInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpdateWithoutWorkInput = {
  costRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutFeeEarnerNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutFeeEarnerNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutFeeEarnerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutFeeEarnersNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutFeeEarnerNestedInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutFeeEarnerNestedInput>;
  timeEntries?: InputMaybe<TimeEntryUpdateManyWithoutFeeEarnerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateOneWithoutFeeEarnerNestedInput>;
};

export type FeeEarnerUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: FeeEarnerCreateWithoutCurrencyInput;
  update: FeeEarnerUpdateWithoutCurrencyInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput = {
  create: FeeEarnerCreateWithoutFeeEarnerLevelInput;
  update: FeeEarnerUpdateWithoutFeeEarnerLevelInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpsertWithWhereUniqueWithoutOfficeLocationInput = {
  create: FeeEarnerCreateWithoutOfficeLocationInput;
  update: FeeEarnerUpdateWithoutOfficeLocationInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpsertWithWhereUniqueWithoutOrganisationalUnitInput = {
  create: FeeEarnerCreateWithoutOrganisationalUnitInput;
  update: FeeEarnerUpdateWithoutOrganisationalUnitInput;
  where: FeeEarnerWhereUniqueInput;
};

export type FeeEarnerUpsertWithoutExternalMattersInput = {
  create: FeeEarnerCreateWithoutExternalMattersInput;
  update: FeeEarnerUpdateWithoutExternalMattersInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpsertWithoutMattersInput = {
  create: FeeEarnerCreateWithoutMattersInput;
  update: FeeEarnerUpdateWithoutMattersInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpsertWithoutRatesInput = {
  create: FeeEarnerCreateWithoutRatesInput;
  update: FeeEarnerUpdateWithoutRatesInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpsertWithoutTeamMembershipsInput = {
  create: FeeEarnerCreateWithoutTeamMembershipsInput;
  update: FeeEarnerUpdateWithoutTeamMembershipsInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpsertWithoutTimeEntriesInput = {
  create: FeeEarnerCreateWithoutTimeEntriesInput;
  update: FeeEarnerUpdateWithoutTimeEntriesInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpsertWithoutUsersInput = {
  create: FeeEarnerCreateWithoutUsersInput;
  update: FeeEarnerUpdateWithoutUsersInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerUpsertWithoutWorkInput = {
  create: FeeEarnerCreateWithoutWorkInput;
  update: FeeEarnerUpdateWithoutWorkInput;
  where?: InputMaybe<FeeEarnerWhereInput>;
};

export type FeeEarnerWhereInput = {
  AND?: InputMaybe<Array<FeeEarnerWhereInput>>;
  NOT?: InputMaybe<Array<FeeEarnerWhereInput>>;
  OR?: InputMaybe<Array<FeeEarnerWhereInput>>;
  costRate?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatters?: InputMaybe<ExternalMatterListRelationFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelNullableRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  officeLocation?: InputMaybe<OfficeLocationNullableRelationFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  teamMemberships?: InputMaybe<TeamMembershipListRelationFilter>;
  timeEntries?: InputMaybe<TimeEntryListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  users?: InputMaybe<UserNullableRelationFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type FeeEarnerWhereUniqueInput = {
  AND?: InputMaybe<Array<FeeEarnerWhereInput>>;
  NOT?: InputMaybe<Array<FeeEarnerWhereInput>>;
  OR?: InputMaybe<Array<FeeEarnerWhereInput>>;
  costRate?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterListRelationFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelNullableRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  officeLocation?: InputMaybe<OfficeLocationNullableRelationFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  teamMemberships?: InputMaybe<TeamMembershipListRelationFilter>;
  timeEntries?: InputMaybe<TimeEntryListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  users?: InputMaybe<UserNullableRelationFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type FeeRiskPriceOptions = {
  __typename?: 'FeeRiskPriceOptions';
  cappedChosen: Maybe<Scalars['Float']['output']>;
  estimatedRangeChosenLower: Maybe<Scalars['Float']['output']>;
  estimatedRangeChosenUpper: Maybe<Scalars['Float']['output']>;
  feeRiskLower: Maybe<Scalars['Float']['output']>;
  feeRiskUpper: Maybe<Scalars['Float']['output']>;
  fixedChosen: Maybe<Scalars['Float']['output']>;
};

export type FilterArg = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FilteredExternalMattersInput = {
  filter: ExternalMatterWhereInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type FilteredExternalMattersResult = {
  __typename?: 'FilteredExternalMattersResult';
  externalMatters: Array<ExternalMatter>;
  total: Scalars['Int']['output'];
};

export type FilteredMattersInput = {
  filter: FilteredMattersVariables;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilteredMattersInputOrderBy>>;
};

export type FilteredMattersInputOrderBy = {
  client?: InputMaybe<FilteredMattersInputOrderByClient>;
  createdBy?: InputMaybe<FilteredMattersInputOrderByCreatedBy>;
  title?: InputMaybe<Scalars['AscDesc']['input']>;
  updatedAt?: InputMaybe<Scalars['AscDesc']['input']>;
};

export type FilteredMattersInputOrderByClient = {
  name?: InputMaybe<Scalars['AscDesc']['input']>;
};

export type FilteredMattersInputOrderByCreatedBy = {
  displayName?: InputMaybe<Scalars['AscDesc']['input']>;
};

export type FilteredMattersOrderBy = {
  organisationalUnit?: InputMaybe<Scalars['AscDesc']['input']>;
  title?: InputMaybe<Scalars['AscDesc']['input']>;
  updatedAt?: InputMaybe<Scalars['AscDesc']['input']>;
};

export type FilteredMattersVariables = {
  clientId?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeMatterId?: InputMaybe<Scalars['Int']['input']>;
  favourite?: InputMaybe<Scalars['Boolean']['input']>;
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  pinnedToId?: InputMaybe<Scalars['Int']['input']>;
  recent?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<MatterStatus>>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAtFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAtTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FindSimilarExternalMattersForMattersInput = {
  distanceThreshold?: InputMaybe<Scalars['Float']['input']>;
  matterIds: Array<Scalars['Int']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FooterInput = {
  footerImage: Scalars['Upload']['input'];
  outputDesignId: Scalars['Float']['input'];
};

export type GenerateSummaryInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  matterTitle: Scalars['String']['input'];
  questionResponses: Array<QuestionResponse>;
};

export type GpmDangerThresholdResult = {
  __typename?: 'GpmDangerThresholdResult';
  gpmDangerThreshold: Scalars['Int']['output'];
  gpmWarningThreshold: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
};

export type GroupItem = {
  __typename?: 'GroupItem';
  children: Maybe<Array<GroupItem>>;
  description: Maybe<Scalars['String']['output']>;
  entityType: GroupedEntityType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outputDesigns: Maybe<Array<OutputDesign>>;
  parent: Maybe<GroupItem>;
  parentId: Maybe<Scalars['Int']['output']>;
};

export type GroupItemCreateManyParentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entityType: GroupedEntityType;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GroupItemCreateManyParentInputEnvelope = {
  data: Array<GroupItemCreateManyParentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupItemCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<GroupItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GroupItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<GroupItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<GroupItemCreateManyParentInputEnvelope>;
};

export type GroupItemCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<GroupItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GroupItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<GroupItemCreateWithoutChildrenInput>;
};

export type GroupItemCreateNestedOneWithoutOrganisationalUnitInput = {
  connect?: InputMaybe<GroupItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GroupItemCreateOrConnectWithoutOrganisationalUnitInput>;
  create?: InputMaybe<GroupItemCreateWithoutOrganisationalUnitInput>;
};

export type GroupItemCreateNestedOneWithoutOutputDesignsInput = {
  connect?: InputMaybe<GroupItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GroupItemCreateOrConnectWithoutOutputDesignsInput>;
  create?: InputMaybe<GroupItemCreateWithoutOutputDesignsInput>;
};

export type GroupItemCreateOrConnectWithoutChildrenInput = {
  create: GroupItemCreateWithoutChildrenInput;
  where: GroupItemWhereUniqueInput;
};

export type GroupItemCreateOrConnectWithoutOrganisationalUnitInput = {
  create: GroupItemCreateWithoutOrganisationalUnitInput;
  where: GroupItemWhereUniqueInput;
};

export type GroupItemCreateOrConnectWithoutOutputDesignsInput = {
  create: GroupItemCreateWithoutOutputDesignsInput;
  where: GroupItemWhereUniqueInput;
};

export type GroupItemCreateOrConnectWithoutParentInput = {
  create: GroupItemCreateWithoutParentInput;
  where: GroupItemWhereUniqueInput;
};

export type GroupItemCreateWithoutChildrenInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutGroupItemInput>;
  OutputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutGroupItemInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType: GroupedEntityType;
  name: Scalars['String']['input'];
  parent?: InputMaybe<GroupItemCreateNestedOneWithoutChildrenInput>;
  tags?: InputMaybe<TagCreateNestedManyWithoutGroupItemInput>;
};

export type GroupItemCreateWithoutOrganisationalUnitInput = {
  OutputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutGroupItemInput>;
  children?: InputMaybe<GroupItemCreateNestedManyWithoutParentInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType: GroupedEntityType;
  name: Scalars['String']['input'];
  parent?: InputMaybe<GroupItemCreateNestedOneWithoutChildrenInput>;
  tags?: InputMaybe<TagCreateNestedManyWithoutGroupItemInput>;
};

export type GroupItemCreateWithoutOutputDesignsInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutGroupItemInput>;
  children?: InputMaybe<GroupItemCreateNestedManyWithoutParentInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType: GroupedEntityType;
  name: Scalars['String']['input'];
  parent?: InputMaybe<GroupItemCreateNestedOneWithoutChildrenInput>;
  tags?: InputMaybe<TagCreateNestedManyWithoutGroupItemInput>;
};

export type GroupItemCreateWithoutParentInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutGroupItemInput>;
  OutputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutGroupItemInput>;
  children?: InputMaybe<GroupItemCreateNestedManyWithoutParentInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType: GroupedEntityType;
  name: Scalars['String']['input'];
  tags?: InputMaybe<TagCreateNestedManyWithoutGroupItemInput>;
};

export type GroupItemListRelationFilter = {
  every?: InputMaybe<GroupItemWhereInput>;
  none?: InputMaybe<GroupItemWhereInput>;
  some?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemNullableRelationFilter = {
  is?: InputMaybe<GroupItemWhereInput>;
  isNot?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemScalarWhereInput = {
  AND?: InputMaybe<Array<GroupItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<GroupItemScalarWhereInput>>;
  OR?: InputMaybe<Array<GroupItemScalarWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
};

export type GroupItemUpdateInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitUpdateManyWithoutGroupItemNestedInput>;
  OutputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutGroupItemNestedInput>;
  children?: InputMaybe<GroupItemUpdateManyWithoutParentNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<GroupItemUpdateOneWithoutChildrenNestedInput>;
  tags?: InputMaybe<TagUpdateManyWithoutGroupItemNestedInput>;
};

export type GroupItemUpdateManyMutationInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GroupItemUpdateManyWithWhereWithoutParentInput = {
  data: GroupItemUpdateManyMutationInput;
  where: GroupItemScalarWhereInput;
};

export type GroupItemUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<GroupItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GroupItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<GroupItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<GroupItemCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<GroupItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GroupItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GroupItemWhereUniqueInput>>;
  set?: InputMaybe<Array<GroupItemWhereUniqueInput>>;
  update?: InputMaybe<Array<GroupItemUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<GroupItemUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<GroupItemUpsertWithWhereUniqueWithoutParentInput>>;
};

export type GroupItemUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<GroupItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GroupItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<GroupItemCreateWithoutChildrenInput>;
  delete?: InputMaybe<GroupItemWhereInput>;
  disconnect?: InputMaybe<GroupItemWhereInput>;
  update?: InputMaybe<GroupItemUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<GroupItemUpsertWithoutChildrenInput>;
};

export type GroupItemUpdateOneWithoutOrganisationalUnitNestedInput = {
  connect?: InputMaybe<GroupItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GroupItemCreateOrConnectWithoutOrganisationalUnitInput>;
  create?: InputMaybe<GroupItemCreateWithoutOrganisationalUnitInput>;
  delete?: InputMaybe<GroupItemWhereInput>;
  disconnect?: InputMaybe<GroupItemWhereInput>;
  update?: InputMaybe<GroupItemUpdateToOneWithWhereWithoutOrganisationalUnitInput>;
  upsert?: InputMaybe<GroupItemUpsertWithoutOrganisationalUnitInput>;
};

export type GroupItemUpdateOneWithoutOutputDesignsNestedInput = {
  connect?: InputMaybe<GroupItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GroupItemCreateOrConnectWithoutOutputDesignsInput>;
  create?: InputMaybe<GroupItemCreateWithoutOutputDesignsInput>;
  delete?: InputMaybe<GroupItemWhereInput>;
  disconnect?: InputMaybe<GroupItemWhereInput>;
  update?: InputMaybe<GroupItemUpdateToOneWithWhereWithoutOutputDesignsInput>;
  upsert?: InputMaybe<GroupItemUpsertWithoutOutputDesignsInput>;
};

export type GroupItemUpdateToOneWithWhereWithoutChildrenInput = {
  data: GroupItemUpdateWithoutChildrenInput;
  where?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemUpdateToOneWithWhereWithoutOrganisationalUnitInput = {
  data: GroupItemUpdateWithoutOrganisationalUnitInput;
  where?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemUpdateToOneWithWhereWithoutOutputDesignsInput = {
  data: GroupItemUpdateWithoutOutputDesignsInput;
  where?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemUpdateWithWhereUniqueWithoutParentInput = {
  data: GroupItemUpdateWithoutParentInput;
  where: GroupItemWhereUniqueInput;
};

export type GroupItemUpdateWithoutChildrenInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitUpdateManyWithoutGroupItemNestedInput>;
  OutputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutGroupItemNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<GroupItemUpdateOneWithoutChildrenNestedInput>;
  tags?: InputMaybe<TagUpdateManyWithoutGroupItemNestedInput>;
};

export type GroupItemUpdateWithoutOrganisationalUnitInput = {
  OutputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutGroupItemNestedInput>;
  children?: InputMaybe<GroupItemUpdateManyWithoutParentNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<GroupItemUpdateOneWithoutChildrenNestedInput>;
  tags?: InputMaybe<TagUpdateManyWithoutGroupItemNestedInput>;
};

export type GroupItemUpdateWithoutOutputDesignsInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitUpdateManyWithoutGroupItemNestedInput>;
  children?: InputMaybe<GroupItemUpdateManyWithoutParentNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<GroupItemUpdateOneWithoutChildrenNestedInput>;
  tags?: InputMaybe<TagUpdateManyWithoutGroupItemNestedInput>;
};

export type GroupItemUpdateWithoutParentInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitUpdateManyWithoutGroupItemNestedInput>;
  OutputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutGroupItemNestedInput>;
  children?: InputMaybe<GroupItemUpdateManyWithoutParentNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagUpdateManyWithoutGroupItemNestedInput>;
};

export type GroupItemUpsertWithWhereUniqueWithoutParentInput = {
  create: GroupItemCreateWithoutParentInput;
  update: GroupItemUpdateWithoutParentInput;
  where: GroupItemWhereUniqueInput;
};

export type GroupItemUpsertWithoutChildrenInput = {
  create: GroupItemCreateWithoutChildrenInput;
  update: GroupItemUpdateWithoutChildrenInput;
  where?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemUpsertWithoutOrganisationalUnitInput = {
  create: GroupItemCreateWithoutOrganisationalUnitInput;
  update: GroupItemUpdateWithoutOrganisationalUnitInput;
  where?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemUpsertWithoutOutputDesignsInput = {
  create: GroupItemCreateWithoutOutputDesignsInput;
  update: GroupItemUpdateWithoutOutputDesignsInput;
  where?: InputMaybe<GroupItemWhereInput>;
};

export type GroupItemWhereInput = {
  AND?: InputMaybe<Array<GroupItemWhereInput>>;
  NOT?: InputMaybe<Array<GroupItemWhereInput>>;
  OR?: InputMaybe<Array<GroupItemWhereInput>>;
  OrganisationalUnit?: InputMaybe<OrganisationalUnitListRelationFilter>;
  OutputDesigns?: InputMaybe<OutputDesignListRelationFilter>;
  children?: InputMaybe<GroupItemListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  parent?: InputMaybe<GroupItemNullableRelationFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  tags?: InputMaybe<TagListRelationFilter>;
};

export type GroupItemWhereUniqueInput = {
  AND?: InputMaybe<Array<GroupItemWhereInput>>;
  NOT?: InputMaybe<Array<GroupItemWhereInput>>;
  OR?: InputMaybe<Array<GroupItemWhereInput>>;
  OrganisationalUnit?: InputMaybe<OrganisationalUnitListRelationFilter>;
  OutputDesigns?: InputMaybe<OutputDesignListRelationFilter>;
  children?: InputMaybe<GroupItemListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  entityType?: InputMaybe<EnumGroupedEntityTypeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  parent?: InputMaybe<GroupItemNullableRelationFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  tags?: InputMaybe<TagListRelationFilter>;
};

export enum GroupedEntityType {
  Assumption = 'Assumption',
  ClientReport = 'ClientReport',
  Disbursement = 'Disbursement',
  Exclusion = 'Exclusion',
  MatterTemplate = 'MatterTemplate',
  ProposalOutput = 'ProposalOutput'
}

export type GroupedLegalFeeResult = {
  __typename?: 'GroupedLegalFeeResult';
  matterId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  total: LegalFee;
};

export type GroupedResult = {
  __typename?: 'GroupedResult';
  matterId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type GroupsResultMixedUnits = {
  __typename?: 'GroupsResultMixedUnits';
  items: Array<TotalWithGroupsResultMixedUnits>;
};

export type HeaderInput = {
  headerImage: Scalars['Upload']['input'];
  outputDesignId: Scalars['Float']['input'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntegrationRecordCountQueryResult = {
  __typename?: 'IntegrationRecordCountQueryResult';
  clients: Scalars['Float']['output'];
  currencies: Scalars['Float']['output'];
  externalMatters: Scalars['Float']['output'];
  feeEarnerLevels: Scalars['Float']['output'];
  feeEarners: Scalars['Float']['output'];
  matterInvoices: Scalars['Float']['output'];
  matterPermissions: Scalars['Float']['output'];
  officeLocations: Scalars['Float']['output'];
  organisationalUnits: Scalars['Float']['output'];
  rates: Scalars['Float']['output'];
  timeEntries: Scalars['Float']['output'];
  users: Scalars['Float']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  date: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  externalMatterId: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  status: Maybe<InvoiceStatusEnum>;
  totalFeeNet: Scalars['Float']['output'];
};

export enum InvoiceStatus {
  Outstanding = 'Outstanding',
  Paid = 'Paid'
}

export enum InvoiceStatusEnum {
  Outstanding = 'Outstanding',
  Paid = 'Paid'
}

export type LegalFee = {
  __typename?: 'LegalFee';
  assignedResources: Array<AssignedResource>;
  fixedLegalFeeAdminCharge: PriceAdminCharge;
  fixedLegalFeeDiscount: PriceDiscount;
  fixedLegalFeeTax: Tax;
  fixedLegalFeeTotal: Price;
  legalFeeAdminCharge: PriceOrPriceRangeAdminCharge;
  legalFeeDiscount: PriceOrPriceRangeDiscount;
  legalFeeLineItems: Array<LegalFeeLineItem>;
  legalFeeTax: TaxOrTaxRange;
  legalFeeTotal: PriceOrPriceRange;
  legalFeeTotalBeforeVisibleUplifts: PriceOrPriceRange;
  legalFeeUplifts: Array<PriceOrPriceRangeUplift>;
  technologyChargeLineItems: Array<TechnologyChargeLineItem>;
  upliftsTotal: PriceOrPriceRange;
};

export type LegalFeeLineItem = {
  __typename?: 'LegalFeeLineItem';
  fee: PriceOrPriceRange;
  order: Scalars['Float']['output'];
  tasks: Array<TaskItem>;
  title: Scalars['String']['output'];
};

export type LegalFeeLineItemInput = {
  fee?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  tasks?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LegalFeeUpliftInput = {
  fee?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type LegalFeeUpliftLineItem = {
  __typename?: 'LegalFeeUpliftLineItem';
  fee: PriceOrPriceRange;
  order: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
};

export type LibraryAssumption = {
  __typename?: 'LibraryAssumption';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  createdById: Maybe<Scalars['Int']['output']>;
  default: Maybe<Scalars['Boolean']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  mandatory: Maybe<Scalars['Boolean']['output']>;
  organisationalUnits: Maybe<Array<OrganisationalUnit>>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type LibraryAssumptionCreateInput = {
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutFromLibraryAssumptionInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryAssumptionsInput>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutLibraryAssumptionsInput>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryAssumptionCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryAssumptionCreateManyCreatedByInputEnvelope = {
  data: Array<LibraryAssumptionCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryAssumptionCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryAssumptionCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryAssumptionCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryAssumptionCreateManyCreatedByInputEnvelope>;
};

export type LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput = {
  connect?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryAssumptionCreateOrConnectWithoutOrganisationalUnitsInput>>;
  create?: InputMaybe<Array<LibraryAssumptionCreateWithoutOrganisationalUnitsInput>>;
};

export type LibraryAssumptionCreateNestedOneWithoutAssumptionsInput = {
  connect?: InputMaybe<LibraryAssumptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryAssumptionCreateOrConnectWithoutAssumptionsInput>;
  create?: InputMaybe<LibraryAssumptionCreateWithoutAssumptionsInput>;
};

export type LibraryAssumptionCreateOrConnectWithoutAssumptionsInput = {
  create: LibraryAssumptionCreateWithoutAssumptionsInput;
  where: LibraryAssumptionWhereUniqueInput;
};

export type LibraryAssumptionCreateOrConnectWithoutCreatedByInput = {
  create: LibraryAssumptionCreateWithoutCreatedByInput;
  where: LibraryAssumptionWhereUniqueInput;
};

export type LibraryAssumptionCreateOrConnectWithoutOrganisationalUnitsInput = {
  create: LibraryAssumptionCreateWithoutOrganisationalUnitsInput;
  where: LibraryAssumptionWhereUniqueInput;
};

export type LibraryAssumptionCreateWithoutAssumptionsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryAssumptionsInput>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutLibraryAssumptionsInput>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryAssumptionCreateWithoutCreatedByInput = {
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutFromLibraryAssumptionInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutLibraryAssumptionsInput>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryAssumptionCreateWithoutOrganisationalUnitsInput = {
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutFromLibraryAssumptionInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryAssumptionsInput>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryAssumptionListRelationFilter = {
  every?: InputMaybe<LibraryAssumptionWhereInput>;
  none?: InputMaybe<LibraryAssumptionWhereInput>;
  some?: InputMaybe<LibraryAssumptionWhereInput>;
};

export type LibraryAssumptionNullableRelationFilter = {
  is?: InputMaybe<LibraryAssumptionWhereInput>;
  isNot?: InputMaybe<LibraryAssumptionWhereInput>;
};

export type LibraryAssumptionScalarWhereInput = {
  AND?: InputMaybe<Array<LibraryAssumptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<LibraryAssumptionScalarWhereInput>>;
  OR?: InputMaybe<Array<LibraryAssumptionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryAssumptionUpdate = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  firmWide?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text: Scalars['String']['input'];
};

export type LibraryAssumptionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryAssumptionUpdateManyWithWhereWithoutCreatedByInput = {
  data: LibraryAssumptionUpdateManyMutationInput;
  where: LibraryAssumptionScalarWhereInput;
};

export type LibraryAssumptionUpdateManyWithWhereWithoutOrganisationalUnitsInput = {
  data: LibraryAssumptionUpdateManyMutationInput;
  where: LibraryAssumptionScalarWhereInput;
};

export type LibraryAssumptionUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryAssumptionCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryAssumptionCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryAssumptionCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LibraryAssumptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  set?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  update?: InputMaybe<Array<LibraryAssumptionUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<LibraryAssumptionUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<LibraryAssumptionUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput = {
  connect?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryAssumptionCreateOrConnectWithoutOrganisationalUnitsInput>>;
  create?: InputMaybe<Array<LibraryAssumptionCreateWithoutOrganisationalUnitsInput>>;
  delete?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LibraryAssumptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  set?: InputMaybe<Array<LibraryAssumptionWhereUniqueInput>>;
  update?: InputMaybe<Array<LibraryAssumptionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput>>;
  updateMany?: InputMaybe<Array<LibraryAssumptionUpdateManyWithWhereWithoutOrganisationalUnitsInput>>;
  upsert?: InputMaybe<Array<LibraryAssumptionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput>>;
};

export type LibraryAssumptionUpdateOneWithoutAssumptionsNestedInput = {
  connect?: InputMaybe<LibraryAssumptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryAssumptionCreateOrConnectWithoutAssumptionsInput>;
  create?: InputMaybe<LibraryAssumptionCreateWithoutAssumptionsInput>;
  delete?: InputMaybe<LibraryAssumptionWhereInput>;
  disconnect?: InputMaybe<LibraryAssumptionWhereInput>;
  update?: InputMaybe<LibraryAssumptionUpdateToOneWithWhereWithoutAssumptionsInput>;
  upsert?: InputMaybe<LibraryAssumptionUpsertWithoutAssumptionsInput>;
};

export type LibraryAssumptionUpdateToOneWithWhereWithoutAssumptionsInput = {
  data: LibraryAssumptionUpdateWithoutAssumptionsInput;
  where?: InputMaybe<LibraryAssumptionWhereInput>;
};

export type LibraryAssumptionUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: LibraryAssumptionUpdateWithoutCreatedByInput;
  where: LibraryAssumptionWhereUniqueInput;
};

export type LibraryAssumptionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput = {
  data: LibraryAssumptionUpdateWithoutOrganisationalUnitsInput;
  where: LibraryAssumptionWhereUniqueInput;
};

export type LibraryAssumptionUpdateWithoutAssumptionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedLibraryAssumptionsNestedInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  organisationalUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutLibraryAssumptionsNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryAssumptionUpdateWithoutCreatedByInput = {
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutFromLibraryAssumptionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  organisationalUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutLibraryAssumptionsNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryAssumptionUpdateWithoutOrganisationalUnitsInput = {
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutFromLibraryAssumptionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedLibraryAssumptionsNestedInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryAssumptionUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: LibraryAssumptionCreateWithoutCreatedByInput;
  update: LibraryAssumptionUpdateWithoutCreatedByInput;
  where: LibraryAssumptionWhereUniqueInput;
};

export type LibraryAssumptionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput = {
  create: LibraryAssumptionCreateWithoutOrganisationalUnitsInput;
  update: LibraryAssumptionUpdateWithoutOrganisationalUnitsInput;
  where: LibraryAssumptionWhereUniqueInput;
};

export type LibraryAssumptionUpsertWithoutAssumptionsInput = {
  create: LibraryAssumptionCreateWithoutAssumptionsInput;
  update: LibraryAssumptionUpdateWithoutAssumptionsInput;
  where?: InputMaybe<LibraryAssumptionWhereInput>;
};

export type LibraryAssumptionWhereInput = {
  AND?: InputMaybe<Array<LibraryAssumptionWhereInput>>;
  NOT?: InputMaybe<Array<LibraryAssumptionWhereInput>>;
  OR?: InputMaybe<Array<LibraryAssumptionWhereInput>>;
  assumptions?: InputMaybe<AssumptionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  organisationalUnits?: InputMaybe<OrganisationalUnitListRelationFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryAssumptionWhereUniqueInput = {
  AND?: InputMaybe<Array<LibraryAssumptionWhereInput>>;
  NOT?: InputMaybe<Array<LibraryAssumptionWhereInput>>;
  OR?: InputMaybe<Array<LibraryAssumptionWhereInput>>;
  assumptions?: InputMaybe<AssumptionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  organisationalUnits?: InputMaybe<OrganisationalUnitListRelationFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryDisbursement = {
  __typename?: 'LibraryDisbursement';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  createdById: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  vatStatus: TaxLabelStatus;
};

export type LibraryDisbursementCreate = {
  amount: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  vatStatus: Scalars['String']['input'];
};

export type LibraryDisbursementCreateManyCreatedByInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vatStatus: TaxLabelStatus;
};

export type LibraryDisbursementCreateManyCreatedByInputEnvelope = {
  data: Array<LibraryDisbursementCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryDisbursementCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<LibraryDisbursementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryDisbursementCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryDisbursementCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryDisbursementCreateManyCreatedByInputEnvelope>;
};

export type LibraryDisbursementCreateOrConnectWithoutCreatedByInput = {
  create: LibraryDisbursementCreateWithoutCreatedByInput;
  where: LibraryDisbursementWhereUniqueInput;
};

export type LibraryDisbursementCreateWithoutCreatedByInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vatStatus: TaxLabelStatus;
};

export type LibraryDisbursementListRelationFilter = {
  every?: InputMaybe<LibraryDisbursementWhereInput>;
  none?: InputMaybe<LibraryDisbursementWhereInput>;
  some?: InputMaybe<LibraryDisbursementWhereInput>;
};

export type LibraryDisbursementScalarWhereInput = {
  AND?: InputMaybe<Array<LibraryDisbursementScalarWhereInput>>;
  NOT?: InputMaybe<Array<LibraryDisbursementScalarWhereInput>>;
  OR?: InputMaybe<Array<LibraryDisbursementScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFilter>;
};

export type LibraryDisbursementUpdate = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  vatStatus?: InputMaybe<Scalars['String']['input']>;
};

export type LibraryDisbursementUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFieldUpdateOperationsInput>;
};

export type LibraryDisbursementUpdateManyWithWhereWithoutCreatedByInput = {
  data: LibraryDisbursementUpdateManyMutationInput;
  where: LibraryDisbursementScalarWhereInput;
};

export type LibraryDisbursementUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<LibraryDisbursementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryDisbursementCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryDisbursementCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryDisbursementCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<LibraryDisbursementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LibraryDisbursementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LibraryDisbursementWhereUniqueInput>>;
  set?: InputMaybe<Array<LibraryDisbursementWhereUniqueInput>>;
  update?: InputMaybe<Array<LibraryDisbursementUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<LibraryDisbursementUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<LibraryDisbursementUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type LibraryDisbursementUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: LibraryDisbursementUpdateWithoutCreatedByInput;
  where: LibraryDisbursementWhereUniqueInput;
};

export type LibraryDisbursementUpdateWithoutCreatedByInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFieldUpdateOperationsInput>;
};

export type LibraryDisbursementUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: LibraryDisbursementCreateWithoutCreatedByInput;
  update: LibraryDisbursementUpdateWithoutCreatedByInput;
  where: LibraryDisbursementWhereUniqueInput;
};

export type LibraryDisbursementWhereInput = {
  AND?: InputMaybe<Array<LibraryDisbursementWhereInput>>;
  NOT?: InputMaybe<Array<LibraryDisbursementWhereInput>>;
  OR?: InputMaybe<Array<LibraryDisbursementWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFilter>;
};

export type LibraryDisbursementWhereUniqueInput = {
  AND?: InputMaybe<Array<LibraryDisbursementWhereInput>>;
  NOT?: InputMaybe<Array<LibraryDisbursementWhereInput>>;
  OR?: InputMaybe<Array<LibraryDisbursementWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vatStatus?: InputMaybe<EnumTaxLabelStatusFilter>;
};

export type LibraryExclusion = {
  __typename?: 'LibraryExclusion';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  createdById: Maybe<Scalars['Int']['output']>;
  default: Maybe<Scalars['Boolean']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  mandatory: Maybe<Scalars['Boolean']['output']>;
  organisationalUnits: Maybe<Array<OrganisationalUnit>>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type LibraryExclusionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryExclusionsInput>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutFromLibraryExclusionInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutLibraryExclusionsInput>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryExclusionCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryExclusionCreateManyCreatedByInputEnvelope = {
  data: Array<LibraryExclusionCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryExclusionCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryExclusionCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryExclusionCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryExclusionCreateManyCreatedByInputEnvelope>;
};

export type LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput = {
  connect?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryExclusionCreateOrConnectWithoutOrganisationalUnitsInput>>;
  create?: InputMaybe<Array<LibraryExclusionCreateWithoutOrganisationalUnitsInput>>;
};

export type LibraryExclusionCreateNestedOneWithoutExclusionsInput = {
  connect?: InputMaybe<LibraryExclusionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryExclusionCreateOrConnectWithoutExclusionsInput>;
  create?: InputMaybe<LibraryExclusionCreateWithoutExclusionsInput>;
};

export type LibraryExclusionCreateOrConnectWithoutCreatedByInput = {
  create: LibraryExclusionCreateWithoutCreatedByInput;
  where: LibraryExclusionWhereUniqueInput;
};

export type LibraryExclusionCreateOrConnectWithoutExclusionsInput = {
  create: LibraryExclusionCreateWithoutExclusionsInput;
  where: LibraryExclusionWhereUniqueInput;
};

export type LibraryExclusionCreateOrConnectWithoutOrganisationalUnitsInput = {
  create: LibraryExclusionCreateWithoutOrganisationalUnitsInput;
  where: LibraryExclusionWhereUniqueInput;
};

export type LibraryExclusionCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutFromLibraryExclusionInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutLibraryExclusionsInput>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryExclusionCreateWithoutExclusionsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryExclusionsInput>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutLibraryExclusionsInput>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryExclusionCreateWithoutOrganisationalUnitsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryExclusionsInput>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutFromLibraryExclusionInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryExclusionListRelationFilter = {
  every?: InputMaybe<LibraryExclusionWhereInput>;
  none?: InputMaybe<LibraryExclusionWhereInput>;
  some?: InputMaybe<LibraryExclusionWhereInput>;
};

export type LibraryExclusionNullableRelationFilter = {
  is?: InputMaybe<LibraryExclusionWhereInput>;
  isNot?: InputMaybe<LibraryExclusionWhereInput>;
};

export type LibraryExclusionScalarWhereInput = {
  AND?: InputMaybe<Array<LibraryExclusionScalarWhereInput>>;
  NOT?: InputMaybe<Array<LibraryExclusionScalarWhereInput>>;
  OR?: InputMaybe<Array<LibraryExclusionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryExclusionUpdate = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  firmWide?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  organisationalUnitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text: Scalars['String']['input'];
};

export type LibraryExclusionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryExclusionUpdateManyWithWhereWithoutCreatedByInput = {
  data: LibraryExclusionUpdateManyMutationInput;
  where: LibraryExclusionScalarWhereInput;
};

export type LibraryExclusionUpdateManyWithWhereWithoutOrganisationalUnitsInput = {
  data: LibraryExclusionUpdateManyMutationInput;
  where: LibraryExclusionScalarWhereInput;
};

export type LibraryExclusionUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryExclusionCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryExclusionCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryExclusionCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LibraryExclusionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  set?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  update?: InputMaybe<Array<LibraryExclusionUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<LibraryExclusionUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<LibraryExclusionUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput = {
  connect?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryExclusionCreateOrConnectWithoutOrganisationalUnitsInput>>;
  create?: InputMaybe<Array<LibraryExclusionCreateWithoutOrganisationalUnitsInput>>;
  delete?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LibraryExclusionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  set?: InputMaybe<Array<LibraryExclusionWhereUniqueInput>>;
  update?: InputMaybe<Array<LibraryExclusionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput>>;
  updateMany?: InputMaybe<Array<LibraryExclusionUpdateManyWithWhereWithoutOrganisationalUnitsInput>>;
  upsert?: InputMaybe<Array<LibraryExclusionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput>>;
};

export type LibraryExclusionUpdateOneWithoutExclusionsNestedInput = {
  connect?: InputMaybe<LibraryExclusionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryExclusionCreateOrConnectWithoutExclusionsInput>;
  create?: InputMaybe<LibraryExclusionCreateWithoutExclusionsInput>;
  delete?: InputMaybe<LibraryExclusionWhereInput>;
  disconnect?: InputMaybe<LibraryExclusionWhereInput>;
  update?: InputMaybe<LibraryExclusionUpdateToOneWithWhereWithoutExclusionsInput>;
  upsert?: InputMaybe<LibraryExclusionUpsertWithoutExclusionsInput>;
};

export type LibraryExclusionUpdateToOneWithWhereWithoutExclusionsInput = {
  data: LibraryExclusionUpdateWithoutExclusionsInput;
  where?: InputMaybe<LibraryExclusionWhereInput>;
};

export type LibraryExclusionUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: LibraryExclusionUpdateWithoutCreatedByInput;
  where: LibraryExclusionWhereUniqueInput;
};

export type LibraryExclusionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput = {
  data: LibraryExclusionUpdateWithoutOrganisationalUnitsInput;
  where: LibraryExclusionWhereUniqueInput;
};

export type LibraryExclusionUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutFromLibraryExclusionNestedInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  organisationalUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutLibraryExclusionsNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryExclusionUpdateWithoutExclusionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedLibraryExclusionsNestedInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  organisationalUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutLibraryExclusionsNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryExclusionUpdateWithoutOrganisationalUnitsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedLibraryExclusionsNestedInput>;
  default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutFromLibraryExclusionNestedInput>;
  mandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryExclusionUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: LibraryExclusionCreateWithoutCreatedByInput;
  update: LibraryExclusionUpdateWithoutCreatedByInput;
  where: LibraryExclusionWhereUniqueInput;
};

export type LibraryExclusionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput = {
  create: LibraryExclusionCreateWithoutOrganisationalUnitsInput;
  update: LibraryExclusionUpdateWithoutOrganisationalUnitsInput;
  where: LibraryExclusionWhereUniqueInput;
};

export type LibraryExclusionUpsertWithoutExclusionsInput = {
  create: LibraryExclusionCreateWithoutExclusionsInput;
  update: LibraryExclusionUpdateWithoutExclusionsInput;
  where?: InputMaybe<LibraryExclusionWhereInput>;
};

export type LibraryExclusionWhereInput = {
  AND?: InputMaybe<Array<LibraryExclusionWhereInput>>;
  NOT?: InputMaybe<Array<LibraryExclusionWhereInput>>;
  OR?: InputMaybe<Array<LibraryExclusionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  exclusions?: InputMaybe<ExclusionListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  organisationalUnits?: InputMaybe<OrganisationalUnitListRelationFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryExclusionWhereUniqueInput = {
  AND?: InputMaybe<Array<LibraryExclusionWhereInput>>;
  NOT?: InputMaybe<Array<LibraryExclusionWhereInput>>;
  OR?: InputMaybe<Array<LibraryExclusionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  default?: InputMaybe<BoolNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  exclusions?: InputMaybe<ExclusionListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<BoolNullableFilter>;
  organisationalUnits?: InputMaybe<OrganisationalUnitListRelationFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryTechnology = {
  __typename?: 'LibraryTechnology';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  createdById: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  technologyRates: Array<TechnologyRates>;
  technologyUnit: TechnologyUnit;
  technologyUnitId: Scalars['Int']['output'];
  type: TechnologyChargeType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type LibraryTechnologyCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryTechnologiesInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutLibraryTechnologyInput>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutLibraryTechnologyInput>;
  technologyUnit: TechnologyUnitCreateNestedOneWithoutLibraryTechnologyInput;
  type: TechnologyChargeType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryTechnologyCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  technologyUnitId: Scalars['Int']['input'];
  type: TechnologyChargeType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryTechnologyCreateManyCreatedByInputEnvelope = {
  data: Array<LibraryTechnologyCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryTechnologyCreateManyTechnologyUnitInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  type: TechnologyChargeType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryTechnologyCreateManyTechnologyUnitInputEnvelope = {
  data: Array<LibraryTechnologyCreateManyTechnologyUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryTechnologyCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryTechnologyCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryTechnologyCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryTechnologyCreateManyCreatedByInputEnvelope>;
};

export type LibraryTechnologyCreateNestedManyWithoutTechnologyUnitInput = {
  connect?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryTechnologyCreateOrConnectWithoutTechnologyUnitInput>>;
  create?: InputMaybe<Array<LibraryTechnologyCreateWithoutTechnologyUnitInput>>;
  createMany?: InputMaybe<LibraryTechnologyCreateManyTechnologyUnitInputEnvelope>;
};

export type LibraryTechnologyCreateNestedOneWithoutTechnologyChargesInput = {
  connect?: InputMaybe<LibraryTechnologyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryTechnologyCreateOrConnectWithoutTechnologyChargesInput>;
  create?: InputMaybe<LibraryTechnologyCreateWithoutTechnologyChargesInput>;
};

export type LibraryTechnologyCreateNestedOneWithoutTechnologyRatesInput = {
  connect?: InputMaybe<LibraryTechnologyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryTechnologyCreateOrConnectWithoutTechnologyRatesInput>;
  create?: InputMaybe<LibraryTechnologyCreateWithoutTechnologyRatesInput>;
};

export type LibraryTechnologyCreateOrConnectWithoutCreatedByInput = {
  create: LibraryTechnologyCreateWithoutCreatedByInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyCreateOrConnectWithoutTechnologyChargesInput = {
  create: LibraryTechnologyCreateWithoutTechnologyChargesInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyCreateOrConnectWithoutTechnologyRatesInput = {
  create: LibraryTechnologyCreateWithoutTechnologyRatesInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyCreateOrConnectWithoutTechnologyUnitInput = {
  create: LibraryTechnologyCreateWithoutTechnologyUnitInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutLibraryTechnologyInput>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutLibraryTechnologyInput>;
  technologyUnit: TechnologyUnitCreateNestedOneWithoutLibraryTechnologyInput;
  type: TechnologyChargeType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryTechnologyCreateWithoutTechnologyChargesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryTechnologiesInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutLibraryTechnologyInput>;
  technologyUnit: TechnologyUnitCreateNestedOneWithoutLibraryTechnologyInput;
  type: TechnologyChargeType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryTechnologyCreateWithoutTechnologyRatesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryTechnologiesInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutLibraryTechnologyInput>;
  technologyUnit: TechnologyUnitCreateNestedOneWithoutLibraryTechnologyInput;
  type: TechnologyChargeType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryTechnologyCreateWithoutTechnologyUnitInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedLibraryTechnologiesInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutLibraryTechnologyInput>;
  technologyRates?: InputMaybe<TechnologyRatesCreateNestedManyWithoutLibraryTechnologyInput>;
  type: TechnologyChargeType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LibraryTechnologyListRelationFilter = {
  every?: InputMaybe<LibraryTechnologyWhereInput>;
  none?: InputMaybe<LibraryTechnologyWhereInput>;
  some?: InputMaybe<LibraryTechnologyWhereInput>;
};

export type LibraryTechnologyRelationFilter = {
  is?: InputMaybe<LibraryTechnologyWhereInput>;
  isNot?: InputMaybe<LibraryTechnologyWhereInput>;
};

export type LibraryTechnologyScalarWhereInput = {
  AND?: InputMaybe<Array<LibraryTechnologyScalarWhereInput>>;
  NOT?: InputMaybe<Array<LibraryTechnologyScalarWhereInput>>;
  OR?: InputMaybe<Array<LibraryTechnologyScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  technologyUnitId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumTechnologyChargeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryTechnologyUpdate = {
  baseAmount?: InputMaybe<Scalars['Float']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  technologyUnitId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TechnologyChargeType>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type LibraryTechnologyUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryTechnologyUpdateManyWithWhereWithoutCreatedByInput = {
  data: LibraryTechnologyUpdateManyMutationInput;
  where: LibraryTechnologyScalarWhereInput;
};

export type LibraryTechnologyUpdateManyWithWhereWithoutTechnologyUnitInput = {
  data: LibraryTechnologyUpdateManyMutationInput;
  where: LibraryTechnologyScalarWhereInput;
};

export type LibraryTechnologyUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryTechnologyCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<LibraryTechnologyCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<LibraryTechnologyCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LibraryTechnologyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  set?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  update?: InputMaybe<Array<LibraryTechnologyUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<LibraryTechnologyUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<LibraryTechnologyUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type LibraryTechnologyUpdateManyWithoutTechnologyUnitNestedInput = {
  connect?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LibraryTechnologyCreateOrConnectWithoutTechnologyUnitInput>>;
  create?: InputMaybe<Array<LibraryTechnologyCreateWithoutTechnologyUnitInput>>;
  createMany?: InputMaybe<LibraryTechnologyCreateManyTechnologyUnitInputEnvelope>;
  delete?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LibraryTechnologyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  set?: InputMaybe<Array<LibraryTechnologyWhereUniqueInput>>;
  update?: InputMaybe<Array<LibraryTechnologyUpdateWithWhereUniqueWithoutTechnologyUnitInput>>;
  updateMany?: InputMaybe<Array<LibraryTechnologyUpdateManyWithWhereWithoutTechnologyUnitInput>>;
  upsert?: InputMaybe<Array<LibraryTechnologyUpsertWithWhereUniqueWithoutTechnologyUnitInput>>;
};

export type LibraryTechnologyUpdateOneRequiredWithoutTechnologyChargesNestedInput = {
  connect?: InputMaybe<LibraryTechnologyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryTechnologyCreateOrConnectWithoutTechnologyChargesInput>;
  create?: InputMaybe<LibraryTechnologyCreateWithoutTechnologyChargesInput>;
  update?: InputMaybe<LibraryTechnologyUpdateToOneWithWhereWithoutTechnologyChargesInput>;
  upsert?: InputMaybe<LibraryTechnologyUpsertWithoutTechnologyChargesInput>;
};

export type LibraryTechnologyUpdateOneRequiredWithoutTechnologyRatesNestedInput = {
  connect?: InputMaybe<LibraryTechnologyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryTechnologyCreateOrConnectWithoutTechnologyRatesInput>;
  create?: InputMaybe<LibraryTechnologyCreateWithoutTechnologyRatesInput>;
  update?: InputMaybe<LibraryTechnologyUpdateToOneWithWhereWithoutTechnologyRatesInput>;
  upsert?: InputMaybe<LibraryTechnologyUpsertWithoutTechnologyRatesInput>;
};

export type LibraryTechnologyUpdateToOneWithWhereWithoutTechnologyChargesInput = {
  data: LibraryTechnologyUpdateWithoutTechnologyChargesInput;
  where?: InputMaybe<LibraryTechnologyWhereInput>;
};

export type LibraryTechnologyUpdateToOneWithWhereWithoutTechnologyRatesInput = {
  data: LibraryTechnologyUpdateWithoutTechnologyRatesInput;
  where?: InputMaybe<LibraryTechnologyWhereInput>;
};

export type LibraryTechnologyUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: LibraryTechnologyUpdateWithoutCreatedByInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyUpdateWithWhereUniqueWithoutTechnologyUnitInput = {
  data: LibraryTechnologyUpdateWithoutTechnologyUnitInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutLibraryTechnologyNestedInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutLibraryTechnologyNestedInput>;
  technologyUnit?: InputMaybe<TechnologyUnitUpdateOneRequiredWithoutLibraryTechnologyNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryTechnologyUpdateWithoutTechnologyChargesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedLibraryTechnologiesNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutLibraryTechnologyNestedInput>;
  technologyUnit?: InputMaybe<TechnologyUnitUpdateOneRequiredWithoutLibraryTechnologyNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryTechnologyUpdateWithoutTechnologyRatesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedLibraryTechnologiesNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutLibraryTechnologyNestedInput>;
  technologyUnit?: InputMaybe<TechnologyUnitUpdateOneRequiredWithoutLibraryTechnologyNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryTechnologyUpdateWithoutTechnologyUnitInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedLibraryTechnologiesNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutLibraryTechnologyNestedInput>;
  technologyRates?: InputMaybe<TechnologyRatesUpdateManyWithoutLibraryTechnologyNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LibraryTechnologyUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: LibraryTechnologyCreateWithoutCreatedByInput;
  update: LibraryTechnologyUpdateWithoutCreatedByInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyUpsertWithWhereUniqueWithoutTechnologyUnitInput = {
  create: LibraryTechnologyCreateWithoutTechnologyUnitInput;
  update: LibraryTechnologyUpdateWithoutTechnologyUnitInput;
  where: LibraryTechnologyWhereUniqueInput;
};

export type LibraryTechnologyUpsertWithoutTechnologyChargesInput = {
  create: LibraryTechnologyCreateWithoutTechnologyChargesInput;
  update: LibraryTechnologyUpdateWithoutTechnologyChargesInput;
  where?: InputMaybe<LibraryTechnologyWhereInput>;
};

export type LibraryTechnologyUpsertWithoutTechnologyRatesInput = {
  create: LibraryTechnologyCreateWithoutTechnologyRatesInput;
  update: LibraryTechnologyUpdateWithoutTechnologyRatesInput;
  where?: InputMaybe<LibraryTechnologyWhereInput>;
};

export type LibraryTechnologyWhereInput = {
  AND?: InputMaybe<Array<LibraryTechnologyWhereInput>>;
  NOT?: InputMaybe<Array<LibraryTechnologyWhereInput>>;
  OR?: InputMaybe<Array<LibraryTechnologyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  technologyCharges?: InputMaybe<TechnologyChargeListRelationFilter>;
  technologyRates?: InputMaybe<TechnologyRatesListRelationFilter>;
  technologyUnit?: InputMaybe<TechnologyUnitRelationFilter>;
  technologyUnitId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumTechnologyChargeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryTechnologyWhereUniqueInput = {
  AND?: InputMaybe<Array<LibraryTechnologyWhereInput>>;
  NOT?: InputMaybe<Array<LibraryTechnologyWhereInput>>;
  OR?: InputMaybe<Array<LibraryTechnologyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  technologyCharges?: InputMaybe<TechnologyChargeListRelationFilter>;
  technologyRates?: InputMaybe<TechnologyRatesListRelationFilter>;
  technologyUnit?: InputMaybe<TechnologyUnitRelationFilter>;
  technologyUnitId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumTechnologyChargeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LibraryUplift = {
  __typename?: 'LibraryUplift';
  group: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type LibraryUpliftCreateNestedOneWithoutUpliftsInput = {
  connect?: InputMaybe<LibraryUpliftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryUpliftCreateOrConnectWithoutUpliftsInput>;
  create?: InputMaybe<LibraryUpliftCreateWithoutUpliftsInput>;
};

export type LibraryUpliftCreateOrConnectWithoutUpliftsInput = {
  create: LibraryUpliftCreateWithoutUpliftsInput;
  where: LibraryUpliftWhereUniqueInput;
};

export type LibraryUpliftCreateWithoutUpliftsInput = {
  group: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type LibraryUpliftNullableRelationFilter = {
  is?: InputMaybe<LibraryUpliftWhereInput>;
  isNot?: InputMaybe<LibraryUpliftWhereInput>;
};

export type LibraryUpliftUpdateOneWithoutUpliftsNestedInput = {
  connect?: InputMaybe<LibraryUpliftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LibraryUpliftCreateOrConnectWithoutUpliftsInput>;
  create?: InputMaybe<LibraryUpliftCreateWithoutUpliftsInput>;
  delete?: InputMaybe<LibraryUpliftWhereInput>;
  disconnect?: InputMaybe<LibraryUpliftWhereInput>;
  update?: InputMaybe<LibraryUpliftUpdateToOneWithWhereWithoutUpliftsInput>;
  upsert?: InputMaybe<LibraryUpliftUpsertWithoutUpliftsInput>;
};

export type LibraryUpliftUpdateToOneWithWhereWithoutUpliftsInput = {
  data: LibraryUpliftUpdateWithoutUpliftsInput;
  where?: InputMaybe<LibraryUpliftWhereInput>;
};

export type LibraryUpliftUpdateWithoutUpliftsInput = {
  group?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LibraryUpliftUpsertWithoutUpliftsInput = {
  create: LibraryUpliftCreateWithoutUpliftsInput;
  update: LibraryUpliftUpdateWithoutUpliftsInput;
  where?: InputMaybe<LibraryUpliftWhereInput>;
};

export type LibraryUpliftWhereInput = {
  AND?: InputMaybe<Array<LibraryUpliftWhereInput>>;
  NOT?: InputMaybe<Array<LibraryUpliftWhereInput>>;
  OR?: InputMaybe<Array<LibraryUpliftWhereInput>>;
  group?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  reason?: InputMaybe<StringFilter>;
  uplifts?: InputMaybe<UpliftListRelationFilter>;
};

export type LibraryUpliftWhereUniqueInput = {
  AND?: InputMaybe<Array<LibraryUpliftWhereInput>>;
  NOT?: InputMaybe<Array<LibraryUpliftWhereInput>>;
  OR?: InputMaybe<Array<LibraryUpliftWhereInput>>;
  group?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<StringFilter>;
  uplifts?: InputMaybe<UpliftListRelationFilter>;
};

export type LinkingLogCreateManyExternalMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  forceOpenModal: Scalars['Boolean']['input'];
  gap: Scalars['Float']['input'];
  highConfidenceMatch: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  rankPosition: Scalars['Int']['input'];
  relevanceScore: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type LinkingLogCreateManyExternalMatterInputEnvelope = {
  data: Array<LinkingLogCreateManyExternalMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkingLogCreateManyMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalMatterId: Scalars['Int']['input'];
  forceOpenModal: Scalars['Boolean']['input'];
  gap: Scalars['Float']['input'];
  highConfidenceMatch: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  rankPosition: Scalars['Int']['input'];
  relevanceScore: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type LinkingLogCreateManyMatterInputEnvelope = {
  data: Array<LinkingLogCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkingLogCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalMatterId: Scalars['Int']['input'];
  forceOpenModal: Scalars['Boolean']['input'];
  gap: Scalars['Float']['input'];
  highConfidenceMatch: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  rankPosition: Scalars['Int']['input'];
  relevanceScore: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LinkingLogCreateManyUserInputEnvelope = {
  data: Array<LinkingLogCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkingLogCreateNestedManyWithoutExternalMatterInput = {
  connect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LinkingLogCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<LinkingLogCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<LinkingLogCreateManyExternalMatterInputEnvelope>;
};

export type LinkingLogCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LinkingLogCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<LinkingLogCreateWithoutMatterInput>>;
  createMany?: InputMaybe<LinkingLogCreateManyMatterInputEnvelope>;
};

export type LinkingLogCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LinkingLogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LinkingLogCreateWithoutUserInput>>;
  createMany?: InputMaybe<LinkingLogCreateManyUserInputEnvelope>;
};

export type LinkingLogCreateOrConnectWithoutExternalMatterInput = {
  create: LinkingLogCreateWithoutExternalMatterInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogCreateOrConnectWithoutMatterInput = {
  create: LinkingLogCreateWithoutMatterInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogCreateOrConnectWithoutUserInput = {
  create: LinkingLogCreateWithoutUserInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogCreateWithoutExternalMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  forceOpenModal: Scalars['Boolean']['input'];
  gap: Scalars['Float']['input'];
  highConfidenceMatch: Scalars['Boolean']['input'];
  matter: MatterCreateNestedOneWithoutLinkingLogsInput;
  rankPosition: Scalars['Int']['input'];
  relevanceScore: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutLinkingLogsInput;
};

export type LinkingLogCreateWithoutMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalMatter: ExternalMatterCreateNestedOneWithoutLinkingLogsInput;
  forceOpenModal: Scalars['Boolean']['input'];
  gap: Scalars['Float']['input'];
  highConfidenceMatch: Scalars['Boolean']['input'];
  rankPosition: Scalars['Int']['input'];
  relevanceScore: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutLinkingLogsInput;
};

export type LinkingLogCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalMatter: ExternalMatterCreateNestedOneWithoutLinkingLogsInput;
  forceOpenModal: Scalars['Boolean']['input'];
  gap: Scalars['Float']['input'];
  highConfidenceMatch: Scalars['Boolean']['input'];
  matter: MatterCreateNestedOneWithoutLinkingLogsInput;
  rankPosition: Scalars['Int']['input'];
  relevanceScore: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LinkingLogListRelationFilter = {
  every?: InputMaybe<LinkingLogWhereInput>;
  none?: InputMaybe<LinkingLogWhereInput>;
  some?: InputMaybe<LinkingLogWhereInput>;
};

export type LinkingLogScalarWhereInput = {
  AND?: InputMaybe<Array<LinkingLogScalarWhereInput>>;
  NOT?: InputMaybe<Array<LinkingLogScalarWhereInput>>;
  OR?: InputMaybe<Array<LinkingLogScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  forceOpenModal?: InputMaybe<BoolFilter>;
  gap?: InputMaybe<FloatFilter>;
  highConfidenceMatch?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  rankPosition?: InputMaybe<IntFilter>;
  relevanceScore?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type LinkingLogUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forceOpenModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gap?: InputMaybe<FloatFieldUpdateOperationsInput>;
  highConfidenceMatch?: InputMaybe<BoolFieldUpdateOperationsInput>;
  rankPosition?: InputMaybe<IntFieldUpdateOperationsInput>;
  relevanceScore?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LinkingLogUpdateManyWithWhereWithoutExternalMatterInput = {
  data: LinkingLogUpdateManyMutationInput;
  where: LinkingLogScalarWhereInput;
};

export type LinkingLogUpdateManyWithWhereWithoutMatterInput = {
  data: LinkingLogUpdateManyMutationInput;
  where: LinkingLogScalarWhereInput;
};

export type LinkingLogUpdateManyWithWhereWithoutUserInput = {
  data: LinkingLogUpdateManyMutationInput;
  where: LinkingLogScalarWhereInput;
};

export type LinkingLogUpdateManyWithoutExternalMatterNestedInput = {
  connect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LinkingLogCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<LinkingLogCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<LinkingLogCreateManyExternalMatterInputEnvelope>;
  delete?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LinkingLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  set?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  update?: InputMaybe<Array<LinkingLogUpdateWithWhereUniqueWithoutExternalMatterInput>>;
  updateMany?: InputMaybe<Array<LinkingLogUpdateManyWithWhereWithoutExternalMatterInput>>;
  upsert?: InputMaybe<Array<LinkingLogUpsertWithWhereUniqueWithoutExternalMatterInput>>;
};

export type LinkingLogUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LinkingLogCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<LinkingLogCreateWithoutMatterInput>>;
  createMany?: InputMaybe<LinkingLogCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LinkingLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  set?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  update?: InputMaybe<Array<LinkingLogUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<LinkingLogUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<LinkingLogUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type LinkingLogUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LinkingLogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LinkingLogCreateWithoutUserInput>>;
  createMany?: InputMaybe<LinkingLogCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LinkingLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  set?: InputMaybe<Array<LinkingLogWhereUniqueInput>>;
  update?: InputMaybe<Array<LinkingLogUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<LinkingLogUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<LinkingLogUpsertWithWhereUniqueWithoutUserInput>>;
};

export type LinkingLogUpdateWithWhereUniqueWithoutExternalMatterInput = {
  data: LinkingLogUpdateWithoutExternalMatterInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogUpdateWithWhereUniqueWithoutMatterInput = {
  data: LinkingLogUpdateWithoutMatterInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogUpdateWithWhereUniqueWithoutUserInput = {
  data: LinkingLogUpdateWithoutUserInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogUpdateWithoutExternalMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forceOpenModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gap?: InputMaybe<FloatFieldUpdateOperationsInput>;
  highConfidenceMatch?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutLinkingLogsNestedInput>;
  rankPosition?: InputMaybe<IntFieldUpdateOperationsInput>;
  relevanceScore?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutLinkingLogsNestedInput>;
};

export type LinkingLogUpdateWithoutMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutLinkingLogsNestedInput>;
  forceOpenModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gap?: InputMaybe<FloatFieldUpdateOperationsInput>;
  highConfidenceMatch?: InputMaybe<BoolFieldUpdateOperationsInput>;
  rankPosition?: InputMaybe<IntFieldUpdateOperationsInput>;
  relevanceScore?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutLinkingLogsNestedInput>;
};

export type LinkingLogUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutLinkingLogsNestedInput>;
  forceOpenModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gap?: InputMaybe<FloatFieldUpdateOperationsInput>;
  highConfidenceMatch?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutLinkingLogsNestedInput>;
  rankPosition?: InputMaybe<IntFieldUpdateOperationsInput>;
  relevanceScore?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LinkingLogUpsertWithWhereUniqueWithoutExternalMatterInput = {
  create: LinkingLogCreateWithoutExternalMatterInput;
  update: LinkingLogUpdateWithoutExternalMatterInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogUpsertWithWhereUniqueWithoutMatterInput = {
  create: LinkingLogCreateWithoutMatterInput;
  update: LinkingLogUpdateWithoutMatterInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogUpsertWithWhereUniqueWithoutUserInput = {
  create: LinkingLogCreateWithoutUserInput;
  update: LinkingLogUpdateWithoutUserInput;
  where: LinkingLogWhereUniqueInput;
};

export type LinkingLogWhereInput = {
  AND?: InputMaybe<Array<LinkingLogWhereInput>>;
  NOT?: InputMaybe<Array<LinkingLogWhereInput>>;
  OR?: InputMaybe<Array<LinkingLogWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalMatter?: InputMaybe<ExternalMatterRelationFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  forceOpenModal?: InputMaybe<BoolFilter>;
  gap?: InputMaybe<FloatFilter>;
  highConfidenceMatch?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  rankPosition?: InputMaybe<IntFilter>;
  relevanceScore?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type LinkingLogWhereUniqueInput = {
  AND?: InputMaybe<Array<LinkingLogWhereInput>>;
  NOT?: InputMaybe<Array<LinkingLogWhereInput>>;
  OR?: InputMaybe<Array<LinkingLogWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalMatter?: InputMaybe<ExternalMatterRelationFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  forceOpenModal?: InputMaybe<BoolFilter>;
  gap?: InputMaybe<FloatFilter>;
  highConfidenceMatch?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  rankPosition?: InputMaybe<IntFilter>;
  relevanceScore?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type LogoutResult = {
  __typename?: 'LogoutResult';
  success: Scalars['Boolean']['output'];
};

export type Matter = {
  __typename?: 'Matter';
  agreedPrice: Maybe<Scalars['Float']['output']>;
  aiGeneratedMatterSummary: Maybe<Scalars['String']['output']>;
  autoClosed: Maybe<Scalars['Boolean']['output']>;
  brand: Maybe<Brand>;
  brandId: Maybe<Scalars['Int']['output']>;
  client: Maybe<Client>;
  clientId: Maybe<Scalars['Int']['output']>;
  clientReportOutputId: Maybe<Scalars['Int']['output']>;
  clientReportOutputPartId: Maybe<Scalars['Int']['output']>;
  completionPercentage: Maybe<Scalars['Float']['output']>;
  confidential: Maybe<Scalars['Boolean']['output']>;
  createFromHistoricalId: Maybe<Scalars['Int']['output']>;
  createFromTemplateId: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  createdById: Scalars['Int']['output'];
  createdFromPms: Maybe<Scalars['Boolean']['output']>;
  currency: Currency;
  currencyId: Maybe<Scalars['Int']['output']>;
  deadlineDate: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  deletedById: Maybe<Scalars['Int']['output']>;
  disbursements: Maybe<Array<Disbursement>>;
  discounts: Maybe<Array<Discount>>;
  externalMatter: Maybe<ExternalMatter>;
  externalMatterId: Maybe<Scalars['Int']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  feeCharged: Maybe<Scalars['Float']['output']>;
  feeRiskCappedFeeInclude: Maybe<Scalars['Boolean']['output']>;
  feeRiskInclude: Maybe<Scalars['Boolean']['output']>;
  ganttInclude: Maybe<Scalars['Boolean']['output']>;
  gpmDangerThreshold: GpmDangerThresholdResult;
  hasTimeEntries: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  includeBillingChartInReport: Maybe<Scalars['Boolean']['output']>;
  includeCostProjectionInReport: Maybe<Scalars['Boolean']['output']>;
  includeFeeEarnersInProposalOutput: Maybe<Scalars['Boolean']['output']>;
  includeRatesInProposalOutput: Maybe<Scalars['Boolean']['output']>;
  includeTasksInProposalOutput: Maybe<Scalars['Boolean']['output']>;
  isFavourite: Scalars['Boolean']['output'];
  leadFeeEarner: Maybe<FeeEarner>;
  leadFeeEarnerId: Maybe<Scalars['Int']['output']>;
  matterEmbeddingId: Maybe<Scalars['String']['output']>;
  matterType: MatterType;
  officeLocation: Maybe<OfficeLocation>;
  officeLocationId: Maybe<Scalars['Int']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  organisationalUnit: Maybe<OrganisationalUnit>;
  organisationalUnitId: Maybe<Scalars['Int']['output']>;
  parent: Maybe<ParentMatter>;
  parentMatterId: Maybe<Scalars['Int']['output']>;
  parentMatterPhaseId: Maybe<Scalars['Int']['output']>;
  phases: Maybe<Array<Phase>>;
  pinnedMatters: Maybe<Array<Matter>>;
  priceOptions: Maybe<PriceOptions>;
  priceOptionsId: Maybe<Scalars['Int']['output']>;
  priceRangeId: Maybe<Scalars['Int']['output']>;
  pricingLevel: PricingLevel;
  pricingTarget: Maybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId: Maybe<Scalars['Int']['output']>;
  proposalOutputId: Maybe<Scalars['Int']['output']>;
  reference: Scalars['String']['output'];
  startDate: Maybe<Scalars['DateTimeISO']['output']>;
  status: MatterStatus;
  taxStatus: TaxStatus;
  teamMemberships: Maybe<Array<TeamMembership>>;
  technologyCharges: Maybe<Array<TechnologyCharge>>;
  template: Scalars['Boolean']['output'];
  templateGpmThreshold: Maybe<Scalars['Int']['output']>;
  templateType: Maybe<TemplateType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  uplifts: Maybe<Array<Uplift>>;
  waiveAdminCharge: Maybe<Scalars['Boolean']['output']>;
  waiveAdminChargeReason: Maybe<Scalars['String']['output']>;
  work: Maybe<Array<Work>>;
};

export type MatterCompletionLog = {
  __typename?: 'MatterCompletionLog';
  completionPercentage: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  createdByUserId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  matterId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MatterCompletionLogCreateManyCreatedByUserInput = {
  completionPercentage: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterCompletionLogCreateManyCreatedByUserInputEnvelope = {
  data: Array<MatterCompletionLogCreateManyCreatedByUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCompletionLogCreateManyMatterInput = {
  completionPercentage: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUserId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterCompletionLogCreateManyMatterInputEnvelope = {
  data: Array<MatterCompletionLogCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput = {
  connect?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCompletionLogCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<MatterCompletionLogCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<MatterCompletionLogCreateManyCreatedByUserInputEnvelope>;
};

export type MatterCompletionLogCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCompletionLogCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<MatterCompletionLogCreateWithoutMatterInput>>;
  createMany?: InputMaybe<MatterCompletionLogCreateManyMatterInputEnvelope>;
};

export type MatterCompletionLogCreateOrConnectWithoutCreatedByUserInput = {
  create: MatterCompletionLogCreateWithoutCreatedByUserInput;
  where: MatterCompletionLogWhereUniqueInput;
};

export type MatterCompletionLogCreateOrConnectWithoutMatterInput = {
  create: MatterCompletionLogCreateWithoutMatterInput;
  where: MatterCompletionLogWhereUniqueInput;
};

export type MatterCompletionLogCreateWithoutCreatedByUserInput = {
  completionPercentage: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matter: MatterCreateNestedOneWithoutCompletionLogsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterCompletionLogCreateWithoutMatterInput = {
  completionPercentage: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdByUser: UserCreateNestedOneWithoutCreatedMatterCompletionLogsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterCompletionLogListRelationFilter = {
  every?: InputMaybe<MatterCompletionLogWhereInput>;
  none?: InputMaybe<MatterCompletionLogWhereInput>;
  some?: InputMaybe<MatterCompletionLogWhereInput>;
};

export type MatterCompletionLogScalarWhereInput = {
  AND?: InputMaybe<Array<MatterCompletionLogScalarWhereInput>>;
  NOT?: InputMaybe<Array<MatterCompletionLogScalarWhereInput>>;
  OR?: InputMaybe<Array<MatterCompletionLogScalarWhereInput>>;
  completionPercentage?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByUserId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterCompletionLogUpdateManyMutationInput = {
  completionPercentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterCompletionLogUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: MatterCompletionLogUpdateManyMutationInput;
  where: MatterCompletionLogScalarWhereInput;
};

export type MatterCompletionLogUpdateManyWithWhereWithoutMatterInput = {
  data: MatterCompletionLogUpdateManyMutationInput;
  where: MatterCompletionLogScalarWhereInput;
};

export type MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCompletionLogCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<MatterCompletionLogCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<MatterCompletionLogCreateManyCreatedByUserInputEnvelope>;
  delete?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterCompletionLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterCompletionLogUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: InputMaybe<Array<MatterCompletionLogUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: InputMaybe<Array<MatterCompletionLogUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type MatterCompletionLogUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCompletionLogCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<MatterCompletionLogCreateWithoutMatterInput>>;
  createMany?: InputMaybe<MatterCompletionLogCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterCompletionLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterCompletionLogWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterCompletionLogUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<MatterCompletionLogUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<MatterCompletionLogUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type MatterCompletionLogUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: MatterCompletionLogUpdateWithoutCreatedByUserInput;
  where: MatterCompletionLogWhereUniqueInput;
};

export type MatterCompletionLogUpdateWithWhereUniqueWithoutMatterInput = {
  data: MatterCompletionLogUpdateWithoutMatterInput;
  where: MatterCompletionLogWhereUniqueInput;
};

export type MatterCompletionLogUpdateWithoutCreatedByUserInput = {
  completionPercentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutCompletionLogsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterCompletionLogUpdateWithoutMatterInput = {
  completionPercentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdByUser?: InputMaybe<UserUpdateOneRequiredWithoutCreatedMatterCompletionLogsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterCompletionLogUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: MatterCompletionLogCreateWithoutCreatedByUserInput;
  update: MatterCompletionLogUpdateWithoutCreatedByUserInput;
  where: MatterCompletionLogWhereUniqueInput;
};

export type MatterCompletionLogUpsertWithWhereUniqueWithoutMatterInput = {
  create: MatterCompletionLogCreateWithoutMatterInput;
  update: MatterCompletionLogUpdateWithoutMatterInput;
  where: MatterCompletionLogWhereUniqueInput;
};

export type MatterCompletionLogWhereInput = {
  AND?: InputMaybe<Array<MatterCompletionLogWhereInput>>;
  NOT?: InputMaybe<Array<MatterCompletionLogWhereInput>>;
  OR?: InputMaybe<Array<MatterCompletionLogWhereInput>>;
  completionPercentage?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByUser?: InputMaybe<UserRelationFilter>;
  createdByUserId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterCompletionLogWhereUniqueInput = {
  AND?: InputMaybe<Array<MatterCompletionLogWhereInput>>;
  NOT?: InputMaybe<Array<MatterCompletionLogWhereInput>>;
  OR?: InputMaybe<Array<MatterCompletionLogWhereInput>>;
  completionPercentage?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByUser?: InputMaybe<UserRelationFilter>;
  createdByUserId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterCreateInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateManyBrandInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyBrandInputEnvelope = {
  data: Array<MatterCreateManyBrandInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyClientInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyClientInputEnvelope = {
  data: Array<MatterCreateManyClientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyClientReportOutputPartInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyClientReportOutputPartInputEnvelope = {
  data: Array<MatterCreateManyClientReportOutputPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyCreatedByInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyCreatedByInputEnvelope = {
  data: Array<MatterCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyCurrencyInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyCurrencyInputEnvelope = {
  data: Array<MatterCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyDeletedByInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyDeletedByInputEnvelope = {
  data: Array<MatterCreateManyDeletedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyFeeEarnerInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyFeeEarnerInputEnvelope = {
  data: Array<MatterCreateManyFeeEarnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyOfficeLocationInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyOfficeLocationInputEnvelope = {
  data: Array<MatterCreateManyOfficeLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyOrganisationalUnitInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyOrganisationalUnitInputEnvelope = {
  data: Array<MatterCreateManyOrganisationalUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyParentInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyParentInputEnvelope = {
  data: Array<MatterCreateManyParentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyParentMatterPhaseInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOuputPartId?: InputMaybe<Scalars['Int']['input']>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyParentMatterPhaseInputEnvelope = {
  data: Array<MatterCreateManyParentMatterPhaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateManyProposalOuputPartInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPartId?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<MatterType>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterPhaseId?: InputMaybe<Scalars['Int']['input']>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<Scalars['Int']['input']>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterCreateManyProposalOuputPartInputEnvelope = {
  data: Array<MatterCreateManyProposalOuputPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterCreateNestedManyWithoutBrandInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutBrandInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutBrandInput>>;
  createMany?: InputMaybe<MatterCreateManyBrandInputEnvelope>;
};

export type MatterCreateNestedManyWithoutClientInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutClientInput>>;
  createMany?: InputMaybe<MatterCreateManyClientInputEnvelope>;
};

export type MatterCreateNestedManyWithoutClientReportOutputPartInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutClientReportOutputPartInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutClientReportOutputPartInput>>;
  createMany?: InputMaybe<MatterCreateManyClientReportOutputPartInputEnvelope>;
};

export type MatterCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<MatterCreateManyCreatedByInputEnvelope>;
};

export type MatterCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<MatterCreateManyCurrencyInputEnvelope>;
};

export type MatterCreateNestedManyWithoutDeletedByInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutDeletedByInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutDeletedByInput>>;
  createMany?: InputMaybe<MatterCreateManyDeletedByInputEnvelope>;
};

export type MatterCreateNestedManyWithoutFavouritedByInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutFavouritedByInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutFavouritedByInput>>;
};

export type MatterCreateNestedManyWithoutFeeEarnerInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<MatterCreateManyFeeEarnerInputEnvelope>;
};

export type MatterCreateNestedManyWithoutOfficeLocationInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutOfficeLocationInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutOfficeLocationInput>>;
  createMany?: InputMaybe<MatterCreateManyOfficeLocationInputEnvelope>;
};

export type MatterCreateNestedManyWithoutOrganisationalUnitInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<MatterCreateManyOrganisationalUnitInputEnvelope>;
};

export type MatterCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutParentInput>>;
  createMany?: InputMaybe<MatterCreateManyParentInputEnvelope>;
};

export type MatterCreateNestedManyWithoutParentMatterPhaseInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutParentMatterPhaseInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutParentMatterPhaseInput>>;
  createMany?: InputMaybe<MatterCreateManyParentMatterPhaseInputEnvelope>;
};

export type MatterCreateNestedManyWithoutPinnedMattersInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutPinnedMattersInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutPinnedMattersInput>>;
};

export type MatterCreateNestedManyWithoutPinnedToInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutPinnedToInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutPinnedToInput>>;
};

export type MatterCreateNestedManyWithoutProposalOuputPartInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutProposalOuputPartInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutProposalOuputPartInput>>;
  createMany?: InputMaybe<MatterCreateManyProposalOuputPartInputEnvelope>;
};

export type MatterCreateNestedOneWithoutAssumptionsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutAssumptionsInput>;
  create?: InputMaybe<MatterCreateWithoutAssumptionsInput>;
};

export type MatterCreateNestedOneWithoutClientReportOutputInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutClientReportOutputInput>;
  create?: InputMaybe<MatterCreateWithoutClientReportOutputInput>;
};

export type MatterCreateNestedOneWithoutCollaboratorsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutCollaboratorsInput>;
  create?: InputMaybe<MatterCreateWithoutCollaboratorsInput>;
};

export type MatterCreateNestedOneWithoutCompletionLogsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutCompletionLogsInput>;
  create?: InputMaybe<MatterCreateWithoutCompletionLogsInput>;
};

export type MatterCreateNestedOneWithoutDisbursementsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutDisbursementsInput>;
  create?: InputMaybe<MatterCreateWithoutDisbursementsInput>;
};

export type MatterCreateNestedOneWithoutDiscountsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutDiscountsInput>;
  create?: InputMaybe<MatterCreateWithoutDiscountsInput>;
};

export type MatterCreateNestedOneWithoutExclusionsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutExclusionsInput>;
  create?: InputMaybe<MatterCreateWithoutExclusionsInput>;
};

export type MatterCreateNestedOneWithoutExternalMatterInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutExternalMatterInput>;
  create?: InputMaybe<MatterCreateWithoutExternalMatterInput>;
};

export type MatterCreateNestedOneWithoutLinkingLogsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutLinkingLogsInput>;
  create?: InputMaybe<MatterCreateWithoutLinkingLogsInput>;
};

export type MatterCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<MatterCreateWithoutNotificationsInput>;
};

export type MatterCreateNestedOneWithoutPhasesInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutPhasesInput>;
  create?: InputMaybe<MatterCreateWithoutPhasesInput>;
};

export type MatterCreateNestedOneWithoutPriceOptionsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutPriceOptionsInput>;
  create?: InputMaybe<MatterCreateWithoutPriceOptionsInput>;
};

export type MatterCreateNestedOneWithoutProposalOuputInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutProposalOuputInput>;
  create?: InputMaybe<MatterCreateWithoutProposalOuputInput>;
};

export type MatterCreateNestedOneWithoutTeamMembershipsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutTeamMembershipsInput>;
  create?: InputMaybe<MatterCreateWithoutTeamMembershipsInput>;
};

export type MatterCreateNestedOneWithoutTechnologyChargesInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutTechnologyChargesInput>;
  create?: InputMaybe<MatterCreateWithoutTechnologyChargesInput>;
};

export type MatterCreateNestedOneWithoutTriggeredNotificationRulesInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutTriggeredNotificationRulesInput>;
  create?: InputMaybe<MatterCreateWithoutTriggeredNotificationRulesInput>;
};

export type MatterCreateNestedOneWithoutUpliftsInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutUpliftsInput>;
  create?: InputMaybe<MatterCreateWithoutUpliftsInput>;
};

export type MatterCreateNestedOneWithoutWorkInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<MatterCreateWithoutWorkInput>;
};

export type MatterCreateOrConnectWithoutAssumptionsInput = {
  create: MatterCreateWithoutAssumptionsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutBrandInput = {
  create: MatterCreateWithoutBrandInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutClientInput = {
  create: MatterCreateWithoutClientInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutClientReportOutputInput = {
  create: MatterCreateWithoutClientReportOutputInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutClientReportOutputPartInput = {
  create: MatterCreateWithoutClientReportOutputPartInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutCollaboratorsInput = {
  create: MatterCreateWithoutCollaboratorsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutCompletionLogsInput = {
  create: MatterCreateWithoutCompletionLogsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutCreatedByInput = {
  create: MatterCreateWithoutCreatedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutCurrencyInput = {
  create: MatterCreateWithoutCurrencyInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutDeletedByInput = {
  create: MatterCreateWithoutDeletedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutDisbursementsInput = {
  create: MatterCreateWithoutDisbursementsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutDiscountsInput = {
  create: MatterCreateWithoutDiscountsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutExclusionsInput = {
  create: MatterCreateWithoutExclusionsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutExternalMatterInput = {
  create: MatterCreateWithoutExternalMatterInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutFavouritedByInput = {
  create: MatterCreateWithoutFavouritedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutFeeEarnerInput = {
  create: MatterCreateWithoutFeeEarnerInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutLinkingLogsInput = {
  create: MatterCreateWithoutLinkingLogsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutNotificationsInput = {
  create: MatterCreateWithoutNotificationsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutOfficeLocationInput = {
  create: MatterCreateWithoutOfficeLocationInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutOrganisationalUnitInput = {
  create: MatterCreateWithoutOrganisationalUnitInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutParentInput = {
  create: MatterCreateWithoutParentInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutParentMatterPhaseInput = {
  create: MatterCreateWithoutParentMatterPhaseInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutPhasesInput = {
  create: MatterCreateWithoutPhasesInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutPinnedMattersInput = {
  create: MatterCreateWithoutPinnedMattersInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutPinnedToInput = {
  create: MatterCreateWithoutPinnedToInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutPriceOptionsInput = {
  create: MatterCreateWithoutPriceOptionsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutProposalOuputInput = {
  create: MatterCreateWithoutProposalOuputInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutProposalOuputPartInput = {
  create: MatterCreateWithoutProposalOuputPartInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutTeamMembershipsInput = {
  create: MatterCreateWithoutTeamMembershipsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutTechnologyChargesInput = {
  create: MatterCreateWithoutTechnologyChargesInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutTriggeredNotificationRulesInput = {
  create: MatterCreateWithoutTriggeredNotificationRulesInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutUpliftsInput = {
  create: MatterCreateWithoutUpliftsInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateOrConnectWithoutWorkInput = {
  create: MatterCreateWithoutWorkInput;
  where: MatterWhereUniqueInput;
};

export type MatterCreateWithoutAssumptionsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutBrandInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutClientInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutClientReportOutputInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutClientReportOutputPartInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutCollaboratorsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutCompletionLogsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutCreatedByInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutCurrencyInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutDeletedByInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutDisbursementsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutDiscountsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutExclusionsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutExternalMatterInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutFavouritedByInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutFeeEarnerInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutLinkingLogsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutNotificationsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutOfficeLocationInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutOrganisationalUnitInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutParentInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutParentMatterPhaseInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutPhasesInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutPinnedMattersInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutPinnedToInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutPriceOptionsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutProposalOuputInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutProposalOuputPartInput = {
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutTeamMembershipsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutTechnologyChargesInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutTriggeredNotificationRulesInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutUpliftsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutMatterInput>;
};

export type MatterCreateWithoutWorkInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedOneWithoutMatterInput>;
  agreedPrice?: InputMaybe<Scalars['Float']['input']>;
  agreedPriceRange?: InputMaybe<PriceRangeCreateNestedOneWithoutMattersInput>;
  aiGeneratedMatterSummary?: InputMaybe<Scalars['String']['input']>;
  assumptions?: InputMaybe<AssumptionCreateNestedManyWithoutMatterInput>;
  autoClosed?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandCreateNestedOneWithoutMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutMattersInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputCreateNestedOneWithoutMatterInput>;
  clientReportOutputId?: InputMaybe<Scalars['Int']['input']>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedOneWithoutMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutMatterInput>;
  completionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutMatterInput>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createFromHistoricalId?: InputMaybe<Scalars['Int']['input']>;
  createFromTemplateId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdFromPms?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutMatterInput>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedMattersInput>;
  disbursements?: InputMaybe<DisbursementCreateNestedManyWithoutMatterInput>;
  discounts?: InputMaybe<DiscountCreateNestedManyWithoutMatterInput>;
  exclusions?: InputMaybe<ExclusionCreateNestedManyWithoutMatterInput>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutMatterInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  favouritedBy?: InputMaybe<UserCreateNestedManyWithoutFavouriteMattersInput>;
  feeCharged?: InputMaybe<Scalars['Float']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutMattersInput>;
  feeRiskCappedFeeInclude?: InputMaybe<Scalars['Boolean']['input']>;
  feeRiskInclude?: InputMaybe<Scalars['Boolean']['input']>;
  ganttInclude?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeBillingChartInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionInReport?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutMatterInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingCreateNestedOneWithoutMatterInput>;
  matterType?: InputMaybe<MatterType>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutMatterInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutMattersInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutMattersInput>;
  parent?: InputMaybe<ParentMatterCreateNestedOneWithoutMattersInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseCreateNestedOneWithoutMattersInput>;
  phases?: InputMaybe<PhaseCreateNestedManyWithoutMatterInput>;
  pinnedMatters?: InputMaybe<MatterCreateNestedManyWithoutPinnedToInput>;
  pinnedTo?: InputMaybe<MatterCreateNestedManyWithoutPinnedMattersInput>;
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutMatterInput>;
  pricingLevel: PricingLevel;
  pricingTarget?: InputMaybe<PricingTarget>;
  pricingType: PricingType;
  proposalOptions?: InputMaybe<MatterProposalOptionsCreateNestedOneWithoutMatterInput>;
  proposalOuput?: InputMaybe<ProposalOutputCreateNestedOneWithoutMatterInput>;
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<MatterStatus>;
  taxStatus?: InputMaybe<TaxStatus>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutMatterInput>;
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutMatterInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  templateGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<TemplateType>;
  title: Scalars['String']['input'];
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutMatterInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  uplifts?: InputMaybe<UpliftCreateNestedManyWithoutMatterInput>;
  waiveAdminCharge?: InputMaybe<Scalars['Boolean']['input']>;
  waiveAdminChargeReason?: InputMaybe<Scalars['String']['input']>;
};

export type MatterEmbeddingCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<MatterEmbeddingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterEmbeddingCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<MatterEmbeddingCreateWithoutMatterInput>;
};

export type MatterEmbeddingCreateOrConnectWithoutMatterInput = {
  create: MatterEmbeddingCreateWithoutMatterInput;
  where: MatterEmbeddingWhereUniqueInput;
};

export type MatterEmbeddingCreateWithoutMatterInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterEmbeddingNullableRelationFilter = {
  is?: InputMaybe<MatterEmbeddingWhereInput>;
  isNot?: InputMaybe<MatterEmbeddingWhereInput>;
};

export type MatterEmbeddingUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<MatterEmbeddingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterEmbeddingCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<MatterEmbeddingCreateWithoutMatterInput>;
  delete?: InputMaybe<MatterEmbeddingWhereInput>;
  disconnect?: InputMaybe<MatterEmbeddingWhereInput>;
  update?: InputMaybe<MatterEmbeddingUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<MatterEmbeddingUpsertWithoutMatterInput>;
};

export type MatterEmbeddingUpdateToOneWithWhereWithoutMatterInput = {
  data: MatterEmbeddingUpdateWithoutMatterInput;
  where?: InputMaybe<MatterEmbeddingWhereInput>;
};

export type MatterEmbeddingUpdateWithoutMatterInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterEmbeddingUpsertWithoutMatterInput = {
  create: MatterEmbeddingCreateWithoutMatterInput;
  update: MatterEmbeddingUpdateWithoutMatterInput;
  where?: InputMaybe<MatterEmbeddingWhereInput>;
};

export type MatterEmbeddingWhereInput = {
  AND?: InputMaybe<Array<MatterEmbeddingWhereInput>>;
  NOT?: InputMaybe<Array<MatterEmbeddingWhereInput>>;
  OR?: InputMaybe<Array<MatterEmbeddingWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterEmbeddingWhereUniqueInput = {
  AND?: InputMaybe<Array<MatterEmbeddingWhereInput>>;
  NOT?: InputMaybe<Array<MatterEmbeddingWhereInput>>;
  OR?: InputMaybe<Array<MatterEmbeddingWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterExternalMattersResult = {
  __typename?: 'MatterExternalMattersResult';
  externalMatters: Array<RelevantExternalMatterResult>;
  matterId: Scalars['Int']['output'];
};

export type MatterInvoiceCreateManyCurrencyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId: Scalars['Int']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  status: InvoiceStatus;
  totalDisbursementGross: Scalars['Float']['input'];
  totalDisbursementNet: Scalars['Float']['input'];
  totalFeeGross: Scalars['Float']['input'];
  totalFeeNet: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterInvoiceCreateManyCurrencyInputEnvelope = {
  data: Array<MatterInvoiceCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterInvoiceCreateManyExternalMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  status: InvoiceStatus;
  totalDisbursementGross: Scalars['Float']['input'];
  totalDisbursementNet: Scalars['Float']['input'];
  totalFeeGross: Scalars['Float']['input'];
  totalFeeNet: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterInvoiceCreateManyExternalMatterInputEnvelope = {
  data: Array<MatterInvoiceCreateManyExternalMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterInvoiceCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterInvoiceCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<MatterInvoiceCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<MatterInvoiceCreateManyCurrencyInputEnvelope>;
};

export type MatterInvoiceCreateNestedManyWithoutExternalMatterInput = {
  connect?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterInvoiceCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<MatterInvoiceCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<MatterInvoiceCreateManyExternalMatterInputEnvelope>;
};

export type MatterInvoiceCreateNestedOneWithoutTimeEntryInput = {
  connect?: InputMaybe<MatterInvoiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterInvoiceCreateOrConnectWithoutTimeEntryInput>;
  create?: InputMaybe<MatterInvoiceCreateWithoutTimeEntryInput>;
};

export type MatterInvoiceCreateOrConnectWithoutCurrencyInput = {
  create: MatterInvoiceCreateWithoutCurrencyInput;
  where: MatterInvoiceWhereUniqueInput;
};

export type MatterInvoiceCreateOrConnectWithoutExternalMatterInput = {
  create: MatterInvoiceCreateWithoutExternalMatterInput;
  where: MatterInvoiceWhereUniqueInput;
};

export type MatterInvoiceCreateOrConnectWithoutTimeEntryInput = {
  create: MatterInvoiceCreateWithoutTimeEntryInput;
  where: MatterInvoiceWhereUniqueInput;
};

export type MatterInvoiceCreateWithoutCurrencyInput = {
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutMatterInvoiceInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter: ExternalMatterCreateNestedOneWithoutMatterInvoicesInput;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status: InvoiceStatus;
  totalDisbursementGross: Scalars['Float']['input'];
  totalDisbursementNet: Scalars['Float']['input'];
  totalFeeGross: Scalars['Float']['input'];
  totalFeeNet: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterInvoiceCreateWithoutExternalMatterInput = {
  TimeEntry?: InputMaybe<TimeEntryCreateNestedManyWithoutMatterInvoiceInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency: CurrencyCreateNestedOneWithoutMatterInvoiceInput;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status: InvoiceStatus;
  totalDisbursementGross: Scalars['Float']['input'];
  totalDisbursementNet: Scalars['Float']['input'];
  totalFeeGross: Scalars['Float']['input'];
  totalFeeNet: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterInvoiceCreateWithoutTimeEntryInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency: CurrencyCreateNestedOneWithoutMatterInvoiceInput;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter: ExternalMatterCreateNestedOneWithoutMatterInvoicesInput;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status: InvoiceStatus;
  totalDisbursementGross: Scalars['Float']['input'];
  totalDisbursementNet: Scalars['Float']['input'];
  totalFeeGross: Scalars['Float']['input'];
  totalFeeNet: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterInvoiceListRelationFilter = {
  every?: InputMaybe<MatterInvoiceWhereInput>;
  none?: InputMaybe<MatterInvoiceWhereInput>;
  some?: InputMaybe<MatterInvoiceWhereInput>;
};

export type MatterInvoiceNullableRelationFilter = {
  is?: InputMaybe<MatterInvoiceWhereInput>;
  isNot?: InputMaybe<MatterInvoiceWhereInput>;
};

export type MatterInvoiceScalarWhereInput = {
  AND?: InputMaybe<Array<MatterInvoiceScalarWhereInput>>;
  NOT?: InputMaybe<Array<MatterInvoiceScalarWhereInput>>;
  OR?: InputMaybe<Array<MatterInvoiceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumInvoiceStatusFilter>;
  totalDisbursementGross?: InputMaybe<FloatFilter>;
  totalDisbursementNet?: InputMaybe<FloatFilter>;
  totalFeeGross?: InputMaybe<FloatFilter>;
  totalFeeNet?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterInvoiceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumInvoiceStatusFieldUpdateOperationsInput>;
  totalDisbursementGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalDisbursementNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterInvoiceUpdateManyWithWhereWithoutCurrencyInput = {
  data: MatterInvoiceUpdateManyMutationInput;
  where: MatterInvoiceScalarWhereInput;
};

export type MatterInvoiceUpdateManyWithWhereWithoutExternalMatterInput = {
  data: MatterInvoiceUpdateManyMutationInput;
  where: MatterInvoiceScalarWhereInput;
};

export type MatterInvoiceUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterInvoiceCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<MatterInvoiceCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<MatterInvoiceCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterInvoiceUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<MatterInvoiceUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<MatterInvoiceUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type MatterInvoiceUpdateManyWithoutExternalMatterNestedInput = {
  connect?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterInvoiceCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<MatterInvoiceCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<MatterInvoiceCreateManyExternalMatterInputEnvelope>;
  delete?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterInvoiceUpdateWithWhereUniqueWithoutExternalMatterInput>>;
  updateMany?: InputMaybe<Array<MatterInvoiceUpdateManyWithWhereWithoutExternalMatterInput>>;
  upsert?: InputMaybe<Array<MatterInvoiceUpsertWithWhereUniqueWithoutExternalMatterInput>>;
};

export type MatterInvoiceUpdateOneWithoutTimeEntryNestedInput = {
  connect?: InputMaybe<MatterInvoiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterInvoiceCreateOrConnectWithoutTimeEntryInput>;
  create?: InputMaybe<MatterInvoiceCreateWithoutTimeEntryInput>;
  delete?: InputMaybe<MatterInvoiceWhereInput>;
  disconnect?: InputMaybe<MatterInvoiceWhereInput>;
  update?: InputMaybe<MatterInvoiceUpdateToOneWithWhereWithoutTimeEntryInput>;
  upsert?: InputMaybe<MatterInvoiceUpsertWithoutTimeEntryInput>;
};

export type MatterInvoiceUpdateToOneWithWhereWithoutTimeEntryInput = {
  data: MatterInvoiceUpdateWithoutTimeEntryInput;
  where?: InputMaybe<MatterInvoiceWhereInput>;
};

export type MatterInvoiceUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: MatterInvoiceUpdateWithoutCurrencyInput;
  where: MatterInvoiceWhereUniqueInput;
};

export type MatterInvoiceUpdateWithWhereUniqueWithoutExternalMatterInput = {
  data: MatterInvoiceUpdateWithoutExternalMatterInput;
  where: MatterInvoiceWhereUniqueInput;
};

export type MatterInvoiceUpdateWithoutCurrencyInput = {
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutMatterInvoiceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutMatterInvoicesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumInvoiceStatusFieldUpdateOperationsInput>;
  totalDisbursementGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalDisbursementNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterInvoiceUpdateWithoutExternalMatterInput = {
  TimeEntry?: InputMaybe<TimeEntryUpdateManyWithoutMatterInvoiceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutMatterInvoiceNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumInvoiceStatusFieldUpdateOperationsInput>;
  totalDisbursementGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalDisbursementNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterInvoiceUpdateWithoutTimeEntryInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutMatterInvoiceNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutMatterInvoicesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumInvoiceStatusFieldUpdateOperationsInput>;
  totalDisbursementGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalDisbursementNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeGross?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalFeeNet?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterInvoiceUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: MatterInvoiceCreateWithoutCurrencyInput;
  update: MatterInvoiceUpdateWithoutCurrencyInput;
  where: MatterInvoiceWhereUniqueInput;
};

export type MatterInvoiceUpsertWithWhereUniqueWithoutExternalMatterInput = {
  create: MatterInvoiceCreateWithoutExternalMatterInput;
  update: MatterInvoiceUpdateWithoutExternalMatterInput;
  where: MatterInvoiceWhereUniqueInput;
};

export type MatterInvoiceUpsertWithoutTimeEntryInput = {
  create: MatterInvoiceCreateWithoutTimeEntryInput;
  update: MatterInvoiceUpdateWithoutTimeEntryInput;
  where?: InputMaybe<MatterInvoiceWhereInput>;
};

export type MatterInvoiceWhereInput = {
  AND?: InputMaybe<Array<MatterInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<MatterInvoiceWhereInput>>;
  OR?: InputMaybe<Array<MatterInvoiceWhereInput>>;
  TimeEntry?: InputMaybe<TimeEntryListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatter?: InputMaybe<ExternalMatterRelationFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumInvoiceStatusFilter>;
  totalDisbursementGross?: InputMaybe<FloatFilter>;
  totalDisbursementNet?: InputMaybe<FloatFilter>;
  totalFeeGross?: InputMaybe<FloatFilter>;
  totalFeeNet?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterInvoiceWhereUniqueInput = {
  AND?: InputMaybe<Array<MatterInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<MatterInvoiceWhereInput>>;
  OR?: InputMaybe<Array<MatterInvoiceWhereInput>>;
  TimeEntry?: InputMaybe<TimeEntryListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterRelationFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<EnumInvoiceStatusFilter>;
  totalDisbursementGross?: InputMaybe<FloatFilter>;
  totalDisbursementNet?: InputMaybe<FloatFilter>;
  totalFeeGross?: InputMaybe<FloatFilter>;
  totalFeeNet?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MatterListRelationFilter = {
  every?: InputMaybe<MatterWhereInput>;
  none?: InputMaybe<MatterWhereInput>;
  some?: InputMaybe<MatterWhereInput>;
};

export type MatterNullableRelationFilter = {
  is?: InputMaybe<MatterWhereInput>;
  isNot?: InputMaybe<MatterWhereInput>;
};

export type MatterPage = {
  __typename?: 'MatterPage';
  count: Scalars['Int']['output'];
  matters: Array<BaseMatterResult>;
};

export type MatterPermissionCreateManyMatterInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type MatterPermissionCreateManyMatterInputEnvelope = {
  data: Array<MatterPermissionCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterPermissionCreateManyUserInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterPermissionCreateManyUserInputEnvelope = {
  data: Array<MatterPermissionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterPermissionCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterPermissionCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<MatterPermissionCreateWithoutMatterInput>>;
  createMany?: InputMaybe<MatterPermissionCreateManyMatterInputEnvelope>;
};

export type MatterPermissionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterPermissionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MatterPermissionCreateWithoutUserInput>>;
  createMany?: InputMaybe<MatterPermissionCreateManyUserInputEnvelope>;
};

export type MatterPermissionCreateOrConnectWithoutMatterInput = {
  create: MatterPermissionCreateWithoutMatterInput;
  where: MatterPermissionWhereUniqueInput;
};

export type MatterPermissionCreateOrConnectWithoutUserInput = {
  create: MatterPermissionCreateWithoutUserInput;
  where: MatterPermissionWhereUniqueInput;
};

export type MatterPermissionCreateWithoutMatterInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMatterPermissionsInput;
};

export type MatterPermissionCreateWithoutUserInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matter: ExternalMatterCreateNestedOneWithoutMatterPermissionsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MatterPermissionListRelationFilter = {
  every?: InputMaybe<MatterPermissionWhereInput>;
  none?: InputMaybe<MatterPermissionWhereInput>;
  some?: InputMaybe<MatterPermissionWhereInput>;
};

export type MatterPermissionScalarWhereInput = {
  AND?: InputMaybe<Array<MatterPermissionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MatterPermissionScalarWhereInput>>;
  OR?: InputMaybe<Array<MatterPermissionScalarWhereInput>>;
  access?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type MatterPermissionUpdateManyMutationInput = {
  access?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterPermissionUpdateManyWithWhereWithoutMatterInput = {
  data: MatterPermissionUpdateManyMutationInput;
  where: MatterPermissionScalarWhereInput;
};

export type MatterPermissionUpdateManyWithWhereWithoutUserInput = {
  data: MatterPermissionUpdateManyMutationInput;
  where: MatterPermissionScalarWhereInput;
};

export type MatterPermissionUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterPermissionCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<MatterPermissionCreateWithoutMatterInput>>;
  createMany?: InputMaybe<MatterPermissionCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterPermissionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterPermissionUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<MatterPermissionUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<MatterPermissionUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type MatterPermissionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterPermissionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MatterPermissionCreateWithoutUserInput>>;
  createMany?: InputMaybe<MatterPermissionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterPermissionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterPermissionWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterPermissionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<MatterPermissionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<MatterPermissionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type MatterPermissionUpdateWithWhereUniqueWithoutMatterInput = {
  data: MatterPermissionUpdateWithoutMatterInput;
  where: MatterPermissionWhereUniqueInput;
};

export type MatterPermissionUpdateWithWhereUniqueWithoutUserInput = {
  data: MatterPermissionUpdateWithoutUserInput;
  where: MatterPermissionWhereUniqueInput;
};

export type MatterPermissionUpdateWithoutMatterInput = {
  access?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMatterPermissionsNestedInput>;
};

export type MatterPermissionUpdateWithoutUserInput = {
  access?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutMatterPermissionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MatterPermissionUpsertWithWhereUniqueWithoutMatterInput = {
  create: MatterPermissionCreateWithoutMatterInput;
  update: MatterPermissionUpdateWithoutMatterInput;
  where: MatterPermissionWhereUniqueInput;
};

export type MatterPermissionUpsertWithWhereUniqueWithoutUserInput = {
  create: MatterPermissionCreateWithoutUserInput;
  update: MatterPermissionUpdateWithoutUserInput;
  where: MatterPermissionWhereUniqueInput;
};

export type MatterPermissionWhereInput = {
  AND?: InputMaybe<Array<MatterPermissionWhereInput>>;
  NOT?: InputMaybe<Array<MatterPermissionWhereInput>>;
  OR?: InputMaybe<Array<MatterPermissionWhereInput>>;
  access?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<ExternalMatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type MatterPermissionWhereUniqueInput = {
  AND?: InputMaybe<Array<MatterPermissionWhereInput>>;
  NOT?: InputMaybe<Array<MatterPermissionWhereInput>>;
  OR?: InputMaybe<Array<MatterPermissionWhereInput>>;
  access?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<ExternalMatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type MatterProposalOptionsCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<MatterProposalOptionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterProposalOptionsCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<MatterProposalOptionsCreateWithoutMatterInput>;
};

export type MatterProposalOptionsCreateOrConnectWithoutMatterInput = {
  create: MatterProposalOptionsCreateWithoutMatterInput;
  where: MatterProposalOptionsWhereUniqueInput;
};

export type MatterProposalOptionsCreateWithoutMatterInput = {
  includeDisbursements?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatterProposalOptionsNullableRelationFilter = {
  is?: InputMaybe<MatterProposalOptionsWhereInput>;
  isNot?: InputMaybe<MatterProposalOptionsWhereInput>;
};

export type MatterProposalOptionsUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<MatterProposalOptionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterProposalOptionsCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<MatterProposalOptionsCreateWithoutMatterInput>;
  delete?: InputMaybe<MatterProposalOptionsWhereInput>;
  disconnect?: InputMaybe<MatterProposalOptionsWhereInput>;
  update?: InputMaybe<MatterProposalOptionsUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<MatterProposalOptionsUpsertWithoutMatterInput>;
};

export type MatterProposalOptionsUpdateToOneWithWhereWithoutMatterInput = {
  data: MatterProposalOptionsUpdateWithoutMatterInput;
  where?: InputMaybe<MatterProposalOptionsWhereInput>;
};

export type MatterProposalOptionsUpdateWithoutMatterInput = {
  includeDisbursements?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type MatterProposalOptionsUpsertWithoutMatterInput = {
  create: MatterProposalOptionsCreateWithoutMatterInput;
  update: MatterProposalOptionsUpdateWithoutMatterInput;
  where?: InputMaybe<MatterProposalOptionsWhereInput>;
};

export type MatterProposalOptionsWhereInput = {
  AND?: InputMaybe<Array<MatterProposalOptionsWhereInput>>;
  NOT?: InputMaybe<Array<MatterProposalOptionsWhereInput>>;
  OR?: InputMaybe<Array<MatterProposalOptionsWhereInput>>;
  id?: InputMaybe<IntFilter>;
  includeDisbursements?: InputMaybe<BoolFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
};

export type MatterProposalOptionsWhereUniqueInput = {
  AND?: InputMaybe<Array<MatterProposalOptionsWhereInput>>;
  NOT?: InputMaybe<Array<MatterProposalOptionsWhereInput>>;
  OR?: InputMaybe<Array<MatterProposalOptionsWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeDisbursements?: InputMaybe<BoolFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
};

export type MatterRelationFilter = {
  is?: InputMaybe<MatterWhereInput>;
  isNot?: InputMaybe<MatterWhereInput>;
};

export type MatterResult = {
  __typename?: 'MatterResult';
  matters: Array<Matter>;
  total: Scalars['Int']['output'];
};

export type MatterScalarWhereInput = {
  AND?: InputMaybe<Array<MatterScalarWhereInput>>;
  NOT?: InputMaybe<Array<MatterScalarWhereInput>>;
  OR?: InputMaybe<Array<MatterScalarWhereInput>>;
  agreedPrice?: InputMaybe<FloatNullableFilter>;
  aiGeneratedMatterSummary?: InputMaybe<StringNullableFilter>;
  autoClosed?: InputMaybe<BoolNullableFilter>;
  brandId?: InputMaybe<IntNullableFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  clientReportOutputId?: InputMaybe<IntNullableFilter>;
  clientReportOutputPartId?: InputMaybe<IntNullableFilter>;
  completionPercentage?: InputMaybe<FloatNullableFilter>;
  confidential?: InputMaybe<BoolNullableFilter>;
  createFromHistoricalId?: InputMaybe<IntNullableFilter>;
  createFromTemplateId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntFilter>;
  createdFromPms?: InputMaybe<BoolNullableFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedById?: InputMaybe<IntNullableFilter>;
  externalMatterId?: InputMaybe<IntNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  feeCharged?: InputMaybe<FloatNullableFilter>;
  feeRiskCappedFeeInclude?: InputMaybe<BoolNullableFilter>;
  feeRiskInclude?: InputMaybe<BoolNullableFilter>;
  ganttInclude?: InputMaybe<BoolNullableFilter>;
  hasTimeEntries?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeBillingChartInReport?: InputMaybe<BoolNullableFilter>;
  includeCostProjectionInReport?: InputMaybe<BoolNullableFilter>;
  includeFeeEarnersInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeRatesInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolNullableFilter>;
  leadFeeEarnerId?: InputMaybe<IntNullableFilter>;
  matterEmbeddingId?: InputMaybe<StringNullableFilter>;
  matterType?: InputMaybe<EnumMatterTypeFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  order?: InputMaybe<IntNullableFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  parentMatterPhaseId?: InputMaybe<IntNullableFilter>;
  priceOptionsId?: InputMaybe<IntNullableFilter>;
  priceRangeId?: InputMaybe<IntNullableFilter>;
  pricingLevel?: InputMaybe<EnumPricingLevelFilter>;
  pricingTarget?: InputMaybe<EnumPricingTargetNullableFilter>;
  pricingType?: InputMaybe<EnumPricingTypeFilter>;
  proposalOuputPartId?: InputMaybe<IntNullableFilter>;
  proposalOutputId?: InputMaybe<IntNullableFilter>;
  reference?: InputMaybe<UuidFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumMatterStatusFilter>;
  taxStatus?: InputMaybe<EnumTaxStatusFilter>;
  template?: InputMaybe<BoolFilter>;
  templateGpmThreshold?: InputMaybe<IntNullableFilter>;
  templateType?: InputMaybe<EnumTemplateTypeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  waiveAdminCharge?: InputMaybe<BoolNullableFilter>;
  waiveAdminChargeReason?: InputMaybe<StringNullableFilter>;
};

export enum MatterStatus {
  ClientReview = 'ClientReview',
  Closed = 'Closed',
  Draft = 'Draft',
  Live = 'Live',
  Lost = 'Lost'
}

export enum MatterStatusEnum {
  ClientReview = 'ClientReview',
  Closed = 'Closed',
  Draft = 'Draft',
  Live = 'Live',
  Lost = 'Lost'
}

export enum MatterType {
  MultiDisciplinary = 'MultiDisciplinary',
  Standard = 'Standard'
}

export type MatterUpdateInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateManyMutationInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MatterUpdateManyWithWhereWithoutBrandInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutClientInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutClientReportOutputPartInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutCreatedByInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutCurrencyInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutDeletedByInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutFavouritedByInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutFeeEarnerInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutOfficeLocationInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutOrganisationalUnitInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutParentInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutParentMatterPhaseInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutPinnedMattersInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutPinnedToInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithWhereWithoutProposalOuputPartInput = {
  data: MatterUpdateManyMutationInput;
  where: MatterScalarWhereInput;
};

export type MatterUpdateManyWithoutBrandNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutBrandInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutBrandInput>>;
  createMany?: InputMaybe<MatterCreateManyBrandInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutBrandInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutBrandInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutBrandInput>>;
};

export type MatterUpdateManyWithoutClientNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutClientInput>>;
  createMany?: InputMaybe<MatterCreateManyClientInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutClientInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutClientInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutClientInput>>;
};

export type MatterUpdateManyWithoutClientReportOutputPartNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutClientReportOutputPartInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutClientReportOutputPartInput>>;
  createMany?: InputMaybe<MatterCreateManyClientReportOutputPartInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutClientReportOutputPartInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutClientReportOutputPartInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutClientReportOutputPartInput>>;
};

export type MatterUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<MatterCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type MatterUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<MatterCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type MatterUpdateManyWithoutDeletedByNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutDeletedByInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutDeletedByInput>>;
  createMany?: InputMaybe<MatterCreateManyDeletedByInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutDeletedByInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutDeletedByInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutDeletedByInput>>;
};

export type MatterUpdateManyWithoutFavouritedByNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutFavouritedByInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutFavouritedByInput>>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutFavouritedByInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutFavouritedByInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutFavouritedByInput>>;
};

export type MatterUpdateManyWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<MatterCreateManyFeeEarnerInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutFeeEarnerInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutFeeEarnerInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutFeeEarnerInput>>;
};

export type MatterUpdateManyWithoutOfficeLocationNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutOfficeLocationInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutOfficeLocationInput>>;
  createMany?: InputMaybe<MatterCreateManyOfficeLocationInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutOfficeLocationInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutOfficeLocationInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutOfficeLocationInput>>;
};

export type MatterUpdateManyWithoutOrganisationalUnitNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<MatterCreateManyOrganisationalUnitInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutOrganisationalUnitInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput>>;
};

export type MatterUpdateManyWithoutParentMatterPhaseNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutParentMatterPhaseInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutParentMatterPhaseInput>>;
  createMany?: InputMaybe<MatterCreateManyParentMatterPhaseInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutParentMatterPhaseInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutParentMatterPhaseInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutParentMatterPhaseInput>>;
};

export type MatterUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutParentInput>>;
  createMany?: InputMaybe<MatterCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutParentInput>>;
};

export type MatterUpdateManyWithoutPinnedMattersNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutPinnedMattersInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutPinnedMattersInput>>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutPinnedMattersInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutPinnedMattersInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutPinnedMattersInput>>;
};

export type MatterUpdateManyWithoutPinnedToNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutPinnedToInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutPinnedToInput>>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutPinnedToInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutPinnedToInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutPinnedToInput>>;
};

export type MatterUpdateManyWithoutProposalOuputPartNestedInput = {
  connect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MatterCreateOrConnectWithoutProposalOuputPartInput>>;
  create?: InputMaybe<Array<MatterCreateWithoutProposalOuputPartInput>>;
  createMany?: InputMaybe<MatterCreateManyProposalOuputPartInputEnvelope>;
  delete?: InputMaybe<Array<MatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MatterWhereUniqueInput>>;
  set?: InputMaybe<Array<MatterWhereUniqueInput>>;
  update?: InputMaybe<Array<MatterUpdateWithWhereUniqueWithoutProposalOuputPartInput>>;
  updateMany?: InputMaybe<Array<MatterUpdateManyWithWhereWithoutProposalOuputPartInput>>;
  upsert?: InputMaybe<Array<MatterUpsertWithWhereUniqueWithoutProposalOuputPartInput>>;
};

export type MatterUpdateOneRequiredWithoutAssumptionsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutAssumptionsInput>;
  create?: InputMaybe<MatterCreateWithoutAssumptionsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutAssumptionsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutAssumptionsInput>;
};

export type MatterUpdateOneRequiredWithoutClientReportOutputNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutClientReportOutputInput>;
  create?: InputMaybe<MatterCreateWithoutClientReportOutputInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutClientReportOutputInput>;
  upsert?: InputMaybe<MatterUpsertWithoutClientReportOutputInput>;
};

export type MatterUpdateOneRequiredWithoutCompletionLogsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutCompletionLogsInput>;
  create?: InputMaybe<MatterCreateWithoutCompletionLogsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutCompletionLogsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutCompletionLogsInput>;
};

export type MatterUpdateOneRequiredWithoutDisbursementsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutDisbursementsInput>;
  create?: InputMaybe<MatterCreateWithoutDisbursementsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutDisbursementsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutDisbursementsInput>;
};

export type MatterUpdateOneRequiredWithoutDiscountsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutDiscountsInput>;
  create?: InputMaybe<MatterCreateWithoutDiscountsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutDiscountsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutDiscountsInput>;
};

export type MatterUpdateOneRequiredWithoutExclusionsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutExclusionsInput>;
  create?: InputMaybe<MatterCreateWithoutExclusionsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutExclusionsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutExclusionsInput>;
};

export type MatterUpdateOneRequiredWithoutLinkingLogsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutLinkingLogsInput>;
  create?: InputMaybe<MatterCreateWithoutLinkingLogsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutLinkingLogsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutLinkingLogsInput>;
};

export type MatterUpdateOneRequiredWithoutPhasesNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutPhasesInput>;
  create?: InputMaybe<MatterCreateWithoutPhasesInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutPhasesInput>;
  upsert?: InputMaybe<MatterUpsertWithoutPhasesInput>;
};

export type MatterUpdateOneRequiredWithoutProposalOuputNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutProposalOuputInput>;
  create?: InputMaybe<MatterCreateWithoutProposalOuputInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutProposalOuputInput>;
  upsert?: InputMaybe<MatterUpsertWithoutProposalOuputInput>;
};

export type MatterUpdateOneRequiredWithoutTeamMembershipsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutTeamMembershipsInput>;
  create?: InputMaybe<MatterCreateWithoutTeamMembershipsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutTeamMembershipsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutTeamMembershipsInput>;
};

export type MatterUpdateOneRequiredWithoutTechnologyChargesNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutTechnologyChargesInput>;
  create?: InputMaybe<MatterCreateWithoutTechnologyChargesInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutTechnologyChargesInput>;
  upsert?: InputMaybe<MatterUpsertWithoutTechnologyChargesInput>;
};

export type MatterUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutTriggeredNotificationRulesInput>;
  create?: InputMaybe<MatterCreateWithoutTriggeredNotificationRulesInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutTriggeredNotificationRulesInput>;
  upsert?: InputMaybe<MatterUpsertWithoutTriggeredNotificationRulesInput>;
};

export type MatterUpdateOneRequiredWithoutUpliftsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutUpliftsInput>;
  create?: InputMaybe<MatterCreateWithoutUpliftsInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutUpliftsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutUpliftsInput>;
};

export type MatterUpdateOneWithoutCollaboratorsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutCollaboratorsInput>;
  create?: InputMaybe<MatterCreateWithoutCollaboratorsInput>;
  delete?: InputMaybe<MatterWhereInput>;
  disconnect?: InputMaybe<MatterWhereInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutCollaboratorsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutCollaboratorsInput>;
};

export type MatterUpdateOneWithoutExternalMatterNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutExternalMatterInput>;
  create?: InputMaybe<MatterCreateWithoutExternalMatterInput>;
  delete?: InputMaybe<MatterWhereInput>;
  disconnect?: InputMaybe<MatterWhereInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutExternalMatterInput>;
  upsert?: InputMaybe<MatterUpsertWithoutExternalMatterInput>;
};

export type MatterUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<MatterCreateWithoutNotificationsInput>;
  delete?: InputMaybe<MatterWhereInput>;
  disconnect?: InputMaybe<MatterWhereInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutNotificationsInput>;
};

export type MatterUpdateOneWithoutPriceOptionsNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutPriceOptionsInput>;
  create?: InputMaybe<MatterCreateWithoutPriceOptionsInput>;
  delete?: InputMaybe<MatterWhereInput>;
  disconnect?: InputMaybe<MatterWhereInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutPriceOptionsInput>;
  upsert?: InputMaybe<MatterUpsertWithoutPriceOptionsInput>;
};

export type MatterUpdateOneWithoutWorkNestedInput = {
  connect?: InputMaybe<MatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MatterCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<MatterCreateWithoutWorkInput>;
  delete?: InputMaybe<MatterWhereInput>;
  disconnect?: InputMaybe<MatterWhereInput>;
  update?: InputMaybe<MatterUpdateToOneWithWhereWithoutWorkInput>;
  upsert?: InputMaybe<MatterUpsertWithoutWorkInput>;
};

export type MatterUpdateToOneWithWhereWithoutAssumptionsInput = {
  data: MatterUpdateWithoutAssumptionsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutClientReportOutputInput = {
  data: MatterUpdateWithoutClientReportOutputInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutCollaboratorsInput = {
  data: MatterUpdateWithoutCollaboratorsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutCompletionLogsInput = {
  data: MatterUpdateWithoutCompletionLogsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutDisbursementsInput = {
  data: MatterUpdateWithoutDisbursementsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutDiscountsInput = {
  data: MatterUpdateWithoutDiscountsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutExclusionsInput = {
  data: MatterUpdateWithoutExclusionsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutExternalMatterInput = {
  data: MatterUpdateWithoutExternalMatterInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutLinkingLogsInput = {
  data: MatterUpdateWithoutLinkingLogsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutNotificationsInput = {
  data: MatterUpdateWithoutNotificationsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutPhasesInput = {
  data: MatterUpdateWithoutPhasesInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutPriceOptionsInput = {
  data: MatterUpdateWithoutPriceOptionsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutProposalOuputInput = {
  data: MatterUpdateWithoutProposalOuputInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutTeamMembershipsInput = {
  data: MatterUpdateWithoutTeamMembershipsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutTechnologyChargesInput = {
  data: MatterUpdateWithoutTechnologyChargesInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutTriggeredNotificationRulesInput = {
  data: MatterUpdateWithoutTriggeredNotificationRulesInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutUpliftsInput = {
  data: MatterUpdateWithoutUpliftsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateToOneWithWhereWithoutWorkInput = {
  data: MatterUpdateWithoutWorkInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpdateWithWhereUniqueWithoutBrandInput = {
  data: MatterUpdateWithoutBrandInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutClientInput = {
  data: MatterUpdateWithoutClientInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutClientReportOutputPartInput = {
  data: MatterUpdateWithoutClientReportOutputPartInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: MatterUpdateWithoutCreatedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: MatterUpdateWithoutCurrencyInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutDeletedByInput = {
  data: MatterUpdateWithoutDeletedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutFavouritedByInput = {
  data: MatterUpdateWithoutFavouritedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutFeeEarnerInput = {
  data: MatterUpdateWithoutFeeEarnerInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutOfficeLocationInput = {
  data: MatterUpdateWithoutOfficeLocationInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput = {
  data: MatterUpdateWithoutOrganisationalUnitInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutParentInput = {
  data: MatterUpdateWithoutParentInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutParentMatterPhaseInput = {
  data: MatterUpdateWithoutParentMatterPhaseInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutPinnedMattersInput = {
  data: MatterUpdateWithoutPinnedMattersInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutPinnedToInput = {
  data: MatterUpdateWithoutPinnedToInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithWhereUniqueWithoutProposalOuputPartInput = {
  data: MatterUpdateWithoutProposalOuputPartInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpdateWithoutAssumptionsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutBrandInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutClientInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutClientReportOutputInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutClientReportOutputPartInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutCollaboratorsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutCompletionLogsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutCreatedByInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutCurrencyInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutDeletedByInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutDisbursementsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutDiscountsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutExclusionsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutExternalMatterInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutFavouritedByInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutFeeEarnerInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutLinkingLogsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutNotificationsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutOfficeLocationInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutOrganisationalUnitInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutParentInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutParentMatterPhaseInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutPhasesInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutPinnedMattersInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutPinnedToInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutPriceOptionsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutProposalOuputInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutProposalOuputPartInput = {
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutTeamMembershipsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutTechnologyChargesInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutTriggeredNotificationRulesInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutUpliftsInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutMatterNestedInput>;
};

export type MatterUpdateWithoutWorkInput = {
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateOneWithoutMatterNestedInput>;
  agreedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  agreedPriceRange?: InputMaybe<PriceRangeUpdateOneWithoutMattersNestedInput>;
  aiGeneratedMatterSummary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assumptions?: InputMaybe<AssumptionUpdateManyWithoutMatterNestedInput>;
  autoClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  brand?: InputMaybe<BrandUpdateOneWithoutMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutMattersNestedInput>;
  clientReportOutput?: InputMaybe<ClientReportOutputUpdateOneWithoutMatterNestedInput>;
  clientReportOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateOneWithoutMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutMatterNestedInput>;
  completionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutMatterNestedInput>;
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  confidential?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createFromHistoricalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createFromTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFromPms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutMatterNestedInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedMattersNestedInput>;
  disbursements?: InputMaybe<DisbursementUpdateManyWithoutMatterNestedInput>;
  discounts?: InputMaybe<DiscountUpdateManyWithoutMatterNestedInput>;
  exclusions?: InputMaybe<ExclusionUpdateManyWithoutMatterNestedInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutMatterNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favouritedBy?: InputMaybe<UserUpdateManyWithoutFavouriteMattersNestedInput>;
  feeCharged?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutMattersNestedInput>;
  feeRiskCappedFeeInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeRiskInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ganttInclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasTimeEntries?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeBillingChartInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeCostProjectionInReport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutMatterNestedInput>;
  matterEmbedding?: InputMaybe<MatterEmbeddingUpdateOneWithoutMatterNestedInput>;
  matterType?: InputMaybe<EnumMatterTypeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutMatterNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutMattersNestedInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutMattersNestedInput>;
  parent?: InputMaybe<ParentMatterUpdateOneWithoutMattersNestedInput>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseUpdateOneWithoutMattersNestedInput>;
  phases?: InputMaybe<PhaseUpdateManyWithoutMatterNestedInput>;
  pinnedMatters?: InputMaybe<MatterUpdateManyWithoutPinnedToNestedInput>;
  pinnedTo?: InputMaybe<MatterUpdateManyWithoutPinnedMattersNestedInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutMatterNestedInput>;
  pricingLevel?: InputMaybe<EnumPricingLevelFieldUpdateOperationsInput>;
  pricingTarget?: InputMaybe<NullableEnumPricingTargetFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  proposalOptions?: InputMaybe<MatterProposalOptionsUpdateOneWithoutMatterNestedInput>;
  proposalOuput?: InputMaybe<ProposalOutputUpdateOneWithoutMatterNestedInput>;
  proposalOutputId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  taxStatus?: InputMaybe<EnumTaxStatusFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutMatterNestedInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutMatterNestedInput>;
  template?: InputMaybe<BoolFieldUpdateOperationsInput>;
  templateGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  templateType?: InputMaybe<NullableEnumTemplateTypeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersUpdateManyWithoutMatterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uplifts?: InputMaybe<UpliftUpdateManyWithoutMatterNestedInput>;
  waiveAdminCharge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  waiveAdminChargeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MatterUpsertWithWhereUniqueWithoutBrandInput = {
  create: MatterCreateWithoutBrandInput;
  update: MatterUpdateWithoutBrandInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutClientInput = {
  create: MatterCreateWithoutClientInput;
  update: MatterUpdateWithoutClientInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutClientReportOutputPartInput = {
  create: MatterCreateWithoutClientReportOutputPartInput;
  update: MatterUpdateWithoutClientReportOutputPartInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: MatterCreateWithoutCreatedByInput;
  update: MatterUpdateWithoutCreatedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: MatterCreateWithoutCurrencyInput;
  update: MatterUpdateWithoutCurrencyInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutDeletedByInput = {
  create: MatterCreateWithoutDeletedByInput;
  update: MatterUpdateWithoutDeletedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutFavouritedByInput = {
  create: MatterCreateWithoutFavouritedByInput;
  update: MatterUpdateWithoutFavouritedByInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutFeeEarnerInput = {
  create: MatterCreateWithoutFeeEarnerInput;
  update: MatterUpdateWithoutFeeEarnerInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutOfficeLocationInput = {
  create: MatterCreateWithoutOfficeLocationInput;
  update: MatterUpdateWithoutOfficeLocationInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput = {
  create: MatterCreateWithoutOrganisationalUnitInput;
  update: MatterUpdateWithoutOrganisationalUnitInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutParentInput = {
  create: MatterCreateWithoutParentInput;
  update: MatterUpdateWithoutParentInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutParentMatterPhaseInput = {
  create: MatterCreateWithoutParentMatterPhaseInput;
  update: MatterUpdateWithoutParentMatterPhaseInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutPinnedMattersInput = {
  create: MatterCreateWithoutPinnedMattersInput;
  update: MatterUpdateWithoutPinnedMattersInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutPinnedToInput = {
  create: MatterCreateWithoutPinnedToInput;
  update: MatterUpdateWithoutPinnedToInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithWhereUniqueWithoutProposalOuputPartInput = {
  create: MatterCreateWithoutProposalOuputPartInput;
  update: MatterUpdateWithoutProposalOuputPartInput;
  where: MatterWhereUniqueInput;
};

export type MatterUpsertWithoutAssumptionsInput = {
  create: MatterCreateWithoutAssumptionsInput;
  update: MatterUpdateWithoutAssumptionsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutClientReportOutputInput = {
  create: MatterCreateWithoutClientReportOutputInput;
  update: MatterUpdateWithoutClientReportOutputInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutCollaboratorsInput = {
  create: MatterCreateWithoutCollaboratorsInput;
  update: MatterUpdateWithoutCollaboratorsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutCompletionLogsInput = {
  create: MatterCreateWithoutCompletionLogsInput;
  update: MatterUpdateWithoutCompletionLogsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutDisbursementsInput = {
  create: MatterCreateWithoutDisbursementsInput;
  update: MatterUpdateWithoutDisbursementsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutDiscountsInput = {
  create: MatterCreateWithoutDiscountsInput;
  update: MatterUpdateWithoutDiscountsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutExclusionsInput = {
  create: MatterCreateWithoutExclusionsInput;
  update: MatterUpdateWithoutExclusionsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutExternalMatterInput = {
  create: MatterCreateWithoutExternalMatterInput;
  update: MatterUpdateWithoutExternalMatterInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutLinkingLogsInput = {
  create: MatterCreateWithoutLinkingLogsInput;
  update: MatterUpdateWithoutLinkingLogsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutNotificationsInput = {
  create: MatterCreateWithoutNotificationsInput;
  update: MatterUpdateWithoutNotificationsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutPhasesInput = {
  create: MatterCreateWithoutPhasesInput;
  update: MatterUpdateWithoutPhasesInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutPriceOptionsInput = {
  create: MatterCreateWithoutPriceOptionsInput;
  update: MatterUpdateWithoutPriceOptionsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutProposalOuputInput = {
  create: MatterCreateWithoutProposalOuputInput;
  update: MatterUpdateWithoutProposalOuputInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutTeamMembershipsInput = {
  create: MatterCreateWithoutTeamMembershipsInput;
  update: MatterUpdateWithoutTeamMembershipsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutTechnologyChargesInput = {
  create: MatterCreateWithoutTechnologyChargesInput;
  update: MatterUpdateWithoutTechnologyChargesInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutTriggeredNotificationRulesInput = {
  create: MatterCreateWithoutTriggeredNotificationRulesInput;
  update: MatterUpdateWithoutTriggeredNotificationRulesInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutUpliftsInput = {
  create: MatterCreateWithoutUpliftsInput;
  update: MatterUpdateWithoutUpliftsInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterUpsertWithoutWorkInput = {
  create: MatterCreateWithoutWorkInput;
  update: MatterUpdateWithoutWorkInput;
  where?: InputMaybe<MatterWhereInput>;
};

export type MatterWhereInput = {
  AND?: InputMaybe<Array<MatterWhereInput>>;
  NOT?: InputMaybe<Array<MatterWhereInput>>;
  OR?: InputMaybe<Array<MatterWhereInput>>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartNullableRelationFilter>;
  agreedPrice?: InputMaybe<FloatNullableFilter>;
  agreedPriceRange?: InputMaybe<PriceRangeNullableRelationFilter>;
  aiGeneratedMatterSummary?: InputMaybe<StringNullableFilter>;
  assumptions?: InputMaybe<AssumptionListRelationFilter>;
  autoClosed?: InputMaybe<BoolNullableFilter>;
  brand?: InputMaybe<BrandNullableRelationFilter>;
  brandId?: InputMaybe<IntNullableFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  clientReportOutput?: InputMaybe<ClientReportOutputNullableRelationFilter>;
  clientReportOutputId?: InputMaybe<IntNullableFilter>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartNullableRelationFilter>;
  clientReportOutputPartId?: InputMaybe<IntNullableFilter>;
  collaborators?: InputMaybe<CollaboratorListRelationFilter>;
  completionLogs?: InputMaybe<MatterCompletionLogListRelationFilter>;
  completionPercentage?: InputMaybe<FloatNullableFilter>;
  confidential?: InputMaybe<BoolNullableFilter>;
  createFromHistoricalId?: InputMaybe<IntNullableFilter>;
  createFromTemplateId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntFilter>;
  createdFromPms?: InputMaybe<BoolNullableFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<UserNullableRelationFilter>;
  deletedById?: InputMaybe<IntNullableFilter>;
  disbursements?: InputMaybe<DisbursementListRelationFilter>;
  discounts?: InputMaybe<DiscountListRelationFilter>;
  exclusions?: InputMaybe<ExclusionListRelationFilter>;
  externalMatter?: InputMaybe<ExternalMatterNullableRelationFilter>;
  externalMatterId?: InputMaybe<IntNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  favouritedBy?: InputMaybe<UserListRelationFilter>;
  feeCharged?: InputMaybe<FloatNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeRiskCappedFeeInclude?: InputMaybe<BoolNullableFilter>;
  feeRiskInclude?: InputMaybe<BoolNullableFilter>;
  ganttInclude?: InputMaybe<BoolNullableFilter>;
  hasTimeEntries?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeBillingChartInReport?: InputMaybe<BoolNullableFilter>;
  includeCostProjectionInReport?: InputMaybe<BoolNullableFilter>;
  includeFeeEarnersInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeRatesInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolNullableFilter>;
  leadFeeEarnerId?: InputMaybe<IntNullableFilter>;
  linkingLogs?: InputMaybe<LinkingLogListRelationFilter>;
  matterEmbedding?: InputMaybe<MatterEmbeddingNullableRelationFilter>;
  matterEmbeddingId?: InputMaybe<StringNullableFilter>;
  matterType?: InputMaybe<EnumMatterTypeFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  officeLocation?: InputMaybe<OfficeLocationNullableRelationFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  order?: InputMaybe<IntNullableFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  parent?: InputMaybe<ParentMatterNullableRelationFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseNullableRelationFilter>;
  parentMatterPhaseId?: InputMaybe<IntNullableFilter>;
  phases?: InputMaybe<PhaseListRelationFilter>;
  pinnedMatters?: InputMaybe<MatterListRelationFilter>;
  pinnedTo?: InputMaybe<MatterListRelationFilter>;
  priceOptions?: InputMaybe<PriceOptionsNullableRelationFilter>;
  priceOptionsId?: InputMaybe<IntNullableFilter>;
  priceRangeId?: InputMaybe<IntNullableFilter>;
  pricingLevel?: InputMaybe<EnumPricingLevelFilter>;
  pricingTarget?: InputMaybe<EnumPricingTargetNullableFilter>;
  pricingType?: InputMaybe<EnumPricingTypeFilter>;
  proposalOptions?: InputMaybe<MatterProposalOptionsNullableRelationFilter>;
  proposalOuput?: InputMaybe<ProposalOutputNullableRelationFilter>;
  proposalOuputPartId?: InputMaybe<IntNullableFilter>;
  proposalOutputId?: InputMaybe<IntNullableFilter>;
  reference?: InputMaybe<UuidFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumMatterStatusFilter>;
  taxStatus?: InputMaybe<EnumTaxStatusFilter>;
  teamMemberships?: InputMaybe<TeamMembershipListRelationFilter>;
  technologyCharges?: InputMaybe<TechnologyChargeListRelationFilter>;
  template?: InputMaybe<BoolFilter>;
  templateGpmThreshold?: InputMaybe<IntNullableFilter>;
  templateType?: InputMaybe<EnumTemplateTypeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uplifts?: InputMaybe<UpliftListRelationFilter>;
  waiveAdminCharge?: InputMaybe<BoolNullableFilter>;
  waiveAdminChargeReason?: InputMaybe<StringNullableFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type MatterWhereUniqueInput = {
  AND?: InputMaybe<Array<MatterWhereInput>>;
  NOT?: InputMaybe<Array<MatterWhereInput>>;
  OR?: InputMaybe<Array<MatterWhereInput>>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartNullableRelationFilter>;
  agreedPrice?: InputMaybe<FloatNullableFilter>;
  agreedPriceRange?: InputMaybe<PriceRangeNullableRelationFilter>;
  aiGeneratedMatterSummary?: InputMaybe<StringNullableFilter>;
  assumptions?: InputMaybe<AssumptionListRelationFilter>;
  autoClosed?: InputMaybe<BoolNullableFilter>;
  brand?: InputMaybe<BrandNullableRelationFilter>;
  brandId?: InputMaybe<IntNullableFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  clientReportOutput?: InputMaybe<ClientReportOutputNullableRelationFilter>;
  clientReportOutputId?: InputMaybe<IntNullableFilter>;
  clientReportOutputPart?: InputMaybe<ClientReportOutputPartNullableRelationFilter>;
  clientReportOutputPartId?: InputMaybe<IntNullableFilter>;
  collaborators?: InputMaybe<CollaboratorListRelationFilter>;
  completionLogs?: InputMaybe<MatterCompletionLogListRelationFilter>;
  completionPercentage?: InputMaybe<FloatNullableFilter>;
  confidential?: InputMaybe<BoolNullableFilter>;
  createFromHistoricalId?: InputMaybe<IntNullableFilter>;
  createFromTemplateId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntFilter>;
  createdFromPms?: InputMaybe<BoolNullableFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<UserNullableRelationFilter>;
  deletedById?: InputMaybe<IntNullableFilter>;
  disbursements?: InputMaybe<DisbursementListRelationFilter>;
  discounts?: InputMaybe<DiscountListRelationFilter>;
  exclusions?: InputMaybe<ExclusionListRelationFilter>;
  externalMatter?: InputMaybe<ExternalMatterNullableRelationFilter>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  favouritedBy?: InputMaybe<UserListRelationFilter>;
  feeCharged?: InputMaybe<FloatNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeRiskCappedFeeInclude?: InputMaybe<BoolNullableFilter>;
  feeRiskInclude?: InputMaybe<BoolNullableFilter>;
  ganttInclude?: InputMaybe<BoolNullableFilter>;
  hasTimeEntries?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBillingChartInReport?: InputMaybe<BoolNullableFilter>;
  includeCostProjectionInReport?: InputMaybe<BoolNullableFilter>;
  includeFeeEarnersInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeRatesInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolNullableFilter>;
  leadFeeEarnerId?: InputMaybe<IntNullableFilter>;
  linkingLogs?: InputMaybe<LinkingLogListRelationFilter>;
  matterEmbedding?: InputMaybe<MatterEmbeddingNullableRelationFilter>;
  matterEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  matterType?: InputMaybe<EnumMatterTypeFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  officeLocation?: InputMaybe<OfficeLocationNullableRelationFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  order?: InputMaybe<IntNullableFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  parent?: InputMaybe<ParentMatterNullableRelationFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  parentMatterPhase?: InputMaybe<ParentMatterPhaseNullableRelationFilter>;
  parentMatterPhaseId?: InputMaybe<IntNullableFilter>;
  phases?: InputMaybe<PhaseListRelationFilter>;
  pinnedMatters?: InputMaybe<MatterListRelationFilter>;
  pinnedTo?: InputMaybe<MatterListRelationFilter>;
  priceOptions?: InputMaybe<PriceOptionsNullableRelationFilter>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeId?: InputMaybe<IntNullableFilter>;
  pricingLevel?: InputMaybe<EnumPricingLevelFilter>;
  pricingTarget?: InputMaybe<EnumPricingTargetNullableFilter>;
  pricingType?: InputMaybe<EnumPricingTypeFilter>;
  proposalOptions?: InputMaybe<MatterProposalOptionsNullableRelationFilter>;
  proposalOuput?: InputMaybe<ProposalOutputNullableRelationFilter>;
  proposalOuputPartId?: InputMaybe<IntNullableFilter>;
  proposalOutputId?: InputMaybe<IntNullableFilter>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumMatterStatusFilter>;
  taxStatus?: InputMaybe<EnumTaxStatusFilter>;
  teamMemberships?: InputMaybe<TeamMembershipListRelationFilter>;
  technologyCharges?: InputMaybe<TechnologyChargeListRelationFilter>;
  template?: InputMaybe<BoolFilter>;
  templateGpmThreshold?: InputMaybe<IntNullableFilter>;
  templateType?: InputMaybe<EnumTemplateTypeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleMattersListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uplifts?: InputMaybe<UpliftListRelationFilter>;
  waiveAdminCharge?: InputMaybe<BoolNullableFilter>;
  waiveAdminChargeReason?: InputMaybe<StringNullableFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type MattersByAreaPerformance = {
  __typename?: 'MattersByAreaPerformance';
  count: Scalars['Float']['output'];
  organisationalUnitName: Scalars['String']['output'];
};

export type MattersStatusPerformance = {
  __typename?: 'MattersStatusPerformance';
  count: Scalars['Float']['output'];
  status: MatterStatusEnum;
};

export type MergeTag = {
  __typename?: 'MergeTag';
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MetaData = {
  __typename?: 'MetaData';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignWorksToPhase: Array<Work>;
  bedrockStartStreamingClarifyingQuestions: StartStreamingResponse;
  bedrockStartStreamingMatterSummary: StartStreamingResponse;
  cloneDesign: OutputDesign;
  copyLibraryPhase: CopyLibraryPhaseResult;
  copyMatterPhases: CopyMatterPhasesResult;
  copyPricing: Matter;
  copyResourcing: Matter;
  copyScope: Matter;
  createAndAddDisbursement: Disbursement;
  createAndAddDiscount: Discount;
  createAndAddPhase: Phase;
  createAndAddPhases: Array<Phase>;
  createAndAddTask: Task;
  createAndAddTasks: Array<Task>;
  createAndAddTechnologyCharge: TechnologyCharge;
  createAndAddUplift: Uplift;
  createAndAddWork: Array<Work>;
  createAssumptions: Array<Assumption>;
  createBrand: Brand;
  createClient: Client;
  createDesign: OutputDesign;
  createDynamicTag: DynamicTag;
  createExclusions: Array<Exclusion>;
  createExternalMatter: ExternalMatter;
  createFileDataImport: DataImportResult;
  createGroupItem: GroupItem;
  createLibraryAssumption: LibraryAssumption;
  createLibraryDisbursement: LibraryDisbursement;
  createLibraryExclusion: LibraryExclusion;
  createLibraryTechnology: LibraryTechnology;
  createManyTechnologyRates: CreateManyTechnologyRatesResult;
  createMatter: Matter;
  createMatterTemplate: Matter;
  createNotificationRule: NotificationRule;
  createOrUpdateMatterCompletionLog: MatterCompletionLog;
  createParentMatter: ParentMatter;
  createRate: RateResult;
  createTaxonomy: Taxonomy;
  createTechnologyRates: TechnologyRates;
  createTechnologyUnit: TechnologyUnit;
  deleteAllNotifications: DeleteAllNotificationsResult;
  deleteAssumptions: DeleteAssumptionsResult;
  deleteBrand: DeleteBrandResult;
  deleteDesign: Scalars['Boolean']['output'];
  deleteDisbursement: DeleteDisbursementResult;
  deleteDiscount: DeleteDiscountResult;
  deleteDynamicTag: DynamicTag;
  deleteExclusions: DeleteExclusionsResult;
  deleteNotification: DeleteNotificationResult;
  deleteNotificationRule: DeleteNotificationRuleResult;
  deleteNotificationRules: DeleteNotificationRulesResult;
  deletePdfOption: OutputDesign;
  deletePhase: DeletePhaseResult;
  deletePhases: DeletePhasesResult;
  deleteTask: DeleteTaskResult;
  deleteTasks: DeleteTasksResult;
  deleteTechnologyCharge: DeleteTechnologyChargeResult;
  deleteTechnologyUnit: TechnologyUnit;
  deleteUplift: DeleteUpliftResult;
  deleteWork: DeleteWorkResult;
  linkMattersToParentMatter: ParentMatter;
  logout: LogoutResult;
  quickLinkMatter: Matter;
  replaceTeamMember: Matter;
  resetExistingProposals: Scalars['Boolean']['output'];
  testDesign: TestDesignOutput;
  toggleFavourite: Matter;
  toggleIncludeInProposal: ParentMatterPhase;
  updateActiveNotificationRules: UpdateNotificationRulesResult;
  updateAssumption: Assumption;
  updateAssumptions: Array<Assumption>;
  updateBrand: Brand;
  updateClient: Client;
  updateClientReportHtml: Scalars['Boolean']['output'];
  updateClientReportOptions: ClientReportOptionsUpdateResult;
  updateDesigns: Array<OutputDesign>;
  updateDisbursement: Disbursement;
  updateDisbursements: Array<Disbursement>;
  updateDiscount: Discount;
  updateDiscounts: Array<Discount>;
  updateDynamicTag: DynamicTag;
  updateExclusion: Exclusion;
  updateExclusions: Array<Exclusion>;
  updateExternalMatter: ExternalMatter;
  updateFeeEarnerLevels: Array<FeeEarnerLevel>;
  updateGroupItem: GroupItem;
  updateLastLoginAt: User;
  updateLibraryAssumptions: UpdateLibraryAssumptionsResult;
  updateLibraryDisbursements: Array<LibraryDisbursement>;
  updateLibraryExclusions: UpdateLibraryExclusionsResult;
  updateLibraryTechnologies: Array<LibraryTechnology>;
  updateManyMatterTemplate: Array<Matter>;
  updateManyTechnologyRates: UpdateManyTechnologyRatesResult;
  updateManyWork: Array<Work>;
  updateMatter: Matter;
  updateMatterCollaborators: Array<Collaborator>;
  updateMatterTemplate: Matter;
  updateNotificationRule: NotificationRule;
  updateOfficeLocationsByCountry: Array<OfficeLocation>;
  updateOrganisationalUnit: OrganisationalUnit;
  updateOrganisationalUnits: Array<OrganisationalUnit>;
  updateParentMatter: ParentMatter;
  updateParentMatterCollaborators: Array<Collaborator>;
  updatePhase: Phase;
  updatePhases: Array<Phase>;
  updateProposalHtml: Scalars['Boolean']['output'];
  updateProposalOfficeAndOrganisationalUnit: Scalars['Boolean']['output'];
  updateProposalOptions: ProposalOptionsUpdateResult;
  updateQuickUpdateShownAt: User;
  updateSettings: Settings;
  updateTask: Task;
  updateTasks: Array<Task>;
  updateTaxonomy: Taxonomy;
  updateTeamMembers: Matter;
  updateTechnologyCharge: TechnologyCharge;
  updateTechnologyCharges: Array<TechnologyCharge>;
  updateTechnologyRates: TechnologyRates;
  updateTechnologyUnits: Array<TechnologyUnit>;
  updateUplift: Uplift;
  updateUplifts: Array<Uplift>;
  updateUserSettings: UserSettings;
  updateWork: Work;
  uploadFooterImage: Scalars['Boolean']['output'];
  uploadHeaderImage: Scalars['Boolean']['output'];
  uploadPDFAttachment: Scalars['Boolean']['output'];
};


export type MutationAssignWorksToPhaseArgs = {
  data: Array<WorkCreateInput>;
};


export type MutationBedrockStartStreamingClarifyingQuestionsArgs = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  matterTitle: Scalars['String']['input'];
};


export type MutationBedrockStartStreamingMatterSummaryArgs = {
  input: GenerateSummaryInput;
};


export type MutationCloneDesignArgs = {
  id: Scalars['Float']['input'];
};


export type MutationCopyLibraryPhaseArgs = {
  matterId: Scalars['Float']['input'];
  phaseId: Scalars['Float']['input'];
};


export type MutationCopyMatterPhasesArgs = {
  copiedMatterId: Scalars['Float']['input'];
  targetMatterId: Scalars['Float']['input'];
};


export type MutationCopyPricingArgs = {
  copyResourcing: Scalars['Boolean']['input'];
  copyScope: Scalars['Boolean']['input'];
  pricingMatterId: Scalars['Int']['input'];
  rateReplacements: Array<RateReplacement>;
  targetMatterId: Scalars['Int']['input'];
};


export type MutationCopyResourcingArgs = {
  rateReplacements: Array<RateReplacement>;
  resourcingMatterId: Scalars['Int']['input'];
  targetMatterId: Scalars['Int']['input'];
};


export type MutationCopyScopeArgs = {
  scopeMatterId: Scalars['Int']['input'];
  targetMatterId: Scalars['Int']['input'];
};


export type MutationCreateAndAddDisbursementArgs = {
  data: DisbursementCreateInput;
};


export type MutationCreateAndAddDiscountArgs = {
  data: DiscountCreateInput;
  matterId: Scalars['Float']['input'];
};


export type MutationCreateAndAddPhaseArgs = {
  data: PhaseCreateInput;
  matterId: Scalars['Float']['input'];
};


export type MutationCreateAndAddPhasesArgs = {
  data: Array<PhaseCreateInput>;
  matterId: Scalars['Float']['input'];
};


export type MutationCreateAndAddTaskArgs = {
  data: TaskCreateInput;
  phaseId: Scalars['Float']['input'];
};


export type MutationCreateAndAddTasksArgs = {
  data: Array<TaskCreateInput>;
  phaseId: Scalars['Float']['input'];
};


export type MutationCreateAndAddTechnologyChargeArgs = {
  data: TechnologyChargeCreateInput;
};


export type MutationCreateAndAddUpliftArgs = {
  data: UpliftCreateInput;
  matterId: Scalars['Float']['input'];
};


export type MutationCreateAndAddWorkArgs = {
  data: WorkCreateInput;
};


export type MutationCreateAssumptionsArgs = {
  input: Array<AssumptionCreateInput>;
};


export type MutationCreateBrandArgs = {
  data: BrandInput;
};


export type MutationCreateClientArgs = {
  data: ClientCreateInput;
};


export type MutationCreateDesignArgs = {
  data: OutputDesignCreateInput;
};


export type MutationCreateDynamicTagArgs = {
  createInput: DynamicTagCreateInput;
};


export type MutationCreateExclusionsArgs = {
  input: Array<ExclusionCreateInput>;
};


export type MutationCreateExternalMatterArgs = {
  data: ExternalMatterCreateInput;
};


export type MutationCreateFileDataImportArgs = {
  type: VpdDataImportType;
  upload: Scalars['Upload']['input'];
};


export type MutationCreateGroupItemArgs = {
  createInput: CreateGroupItem;
};


export type MutationCreateLibraryAssumptionArgs = {
  data: LibraryAssumptionCreateInput;
};


export type MutationCreateLibraryDisbursementArgs = {
  data: LibraryDisbursementCreate;
};


export type MutationCreateLibraryExclusionArgs = {
  data: LibraryExclusionCreateInput;
};


export type MutationCreateLibraryTechnologyArgs = {
  data: LibraryTechnologyCreateInput;
};


export type MutationCreateManyTechnologyRatesArgs = {
  data: CreateManyTechnologyRatesInput;
};


export type MutationCreateMatterArgs = {
  createFromOptions: InputMaybe<CreateFromOptions>;
  data: MatterCreateInput;
  parentId: InputMaybe<Scalars['Int']['input']>;
  parentPhaseId: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateMatterTemplateArgs = {
  cloneTemplateId: InputMaybe<Scalars['Float']['input']>;
  data: MatterCreateInput;
};


export type MutationCreateNotificationRuleArgs = {
  data: NotificationRuleCreateInput;
};


export type MutationCreateOrUpdateMatterCompletionLogArgs = {
  completionPercentage: Scalars['Float']['input'];
  matterId: Scalars['Float']['input'];
};


export type MutationCreateParentMatterArgs = {
  clientId: Scalars['Int']['input'];
  createInput: Scalars['String']['input'];
  phases: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateRateArgs = {
  data: RateCreateInput;
};


export type MutationCreateTaxonomyArgs = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationCreateTechnologyRatesArgs = {
  data: TechnologyRatesCreateInput;
};


export type MutationCreateTechnologyUnitArgs = {
  data: TechnologyUnitCreateInput;
};


export type MutationDeleteAssumptionsArgs = {
  assumptionIds: Array<Scalars['Int']['input']>;
};


export type MutationDeleteBrandArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteDesignArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteDisbursementArgs = {
  disbursementId: Scalars['Float']['input'];
};


export type MutationDeleteDiscountArgs = {
  discountId: Scalars['Float']['input'];
};


export type MutationDeleteDynamicTagArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteExclusionsArgs = {
  input: Array<Scalars['Int']['input']>;
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['Float']['input'];
};


export type MutationDeleteNotificationRuleArgs = {
  notificationRuleId: Scalars['Float']['input'];
};


export type MutationDeleteNotificationRulesArgs = {
  notificationRuleIds: Array<Scalars['Float']['input']>;
};


export type MutationDeletePdfOptionArgs = {
  option: Scalars['String']['input'];
  outputDesignId: Scalars['Float']['input'];
};


export type MutationDeletePhaseArgs = {
  phaseId: Scalars['Float']['input'];
};


export type MutationDeletePhasesArgs = {
  phaseIds: Array<Scalars['Int']['input']>;
};


export type MutationDeleteTaskArgs = {
  taskId: Scalars['Float']['input'];
};


export type MutationDeleteTasksArgs = {
  phaseId: Scalars['Float']['input'];
};


export type MutationDeleteTechnologyChargeArgs = {
  technologyChargeId: Scalars['Float']['input'];
};


export type MutationDeleteTechnologyUnitArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUpliftArgs = {
  upliftId: Scalars['Float']['input'];
};


export type MutationDeleteWorkArgs = {
  workId: Scalars['Float']['input'];
};


export type MutationLinkMattersToParentMatterArgs = {
  id: Scalars['Int']['input'];
  matterIds: Array<Scalars['Int']['input']>;
};


export type MutationQuickLinkMatterArgs = {
  input: QuickLinkMatterInput;
};


export type MutationReplaceTeamMemberArgs = {
  matterId: Scalars['Int']['input'];
  teamMemberToAdd: TeamMembershipIds;
  teamMemberToRemove: TeamMembershipIds;
};


export type MutationTestDesignArgs = {
  input: TestDesignInput;
};


export type MutationToggleFavouriteArgs = {
  favourite: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationToggleIncludeInProposalArgs = {
  id: Scalars['Float']['input'];
  include: Scalars['Boolean']['input'];
};


export type MutationUpdateActiveNotificationRulesArgs = {
  data: UpdateActiveNotificationRulesInput;
};


export type MutationUpdateAssumptionArgs = {
  input: Array<UpdateManyAssumptionsInput>;
};


export type MutationUpdateAssumptionsArgs = {
  input: Array<UpdateManyAssumptionsInput>;
};


export type MutationUpdateBrandArgs = {
  data: UpdateBrandInput;
};


export type MutationUpdateClientArgs = {
  data: ClientUpdateInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateClientReportHtmlArgs = {
  update: UpdateClientReportOutputInput;
};


export type MutationUpdateClientReportOptionsArgs = {
  updateOptions: UpdateClientReportOptionsInput;
};


export type MutationUpdateDesignsArgs = {
  data: Array<UpdateDesignsInput>;
  designType: Scalars['String']['input'];
};


export type MutationUpdateDisbursementArgs = {
  disbursement: UpdateDisbursementInput;
};


export type MutationUpdateDisbursementsArgs = {
  data: Array<DisburmentUpdate>;
};


export type MutationUpdateDiscountArgs = {
  data: DiscountUpdateInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateDiscountsArgs = {
  data: Array<UpdateDiscountsInput>;
};


export type MutationUpdateDynamicTagArgs = {
  id: Scalars['Int']['input'];
  update: DynamicTagUpdateInput;
};


export type MutationUpdateExclusionArgs = {
  id: Scalars['Float']['input'];
  input: ExclusionUpdateInput;
};


export type MutationUpdateExclusionsArgs = {
  input: Array<UpdateManyExclusionsInput>;
};


export type MutationUpdateExternalMatterArgs = {
  data: ExternalMatterCreateInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateFeeEarnerLevelsArgs = {
  input: Array<UpdateManyFeeEarnerLevelsInput>;
};


export type MutationUpdateGroupItemArgs = {
  id: Scalars['Float']['input'];
  updateInput: GroupItemUpdateInput;
};


export type MutationUpdateLibraryAssumptionsArgs = {
  data: Array<LibraryAssumptionUpdate>;
};


export type MutationUpdateLibraryDisbursementsArgs = {
  data: Array<LibraryDisbursementUpdate>;
};


export type MutationUpdateLibraryExclusionsArgs = {
  data: Array<LibraryExclusionUpdate>;
};


export type MutationUpdateLibraryTechnologiesArgs = {
  data: Array<UpdateLibraryTechnologyInput>;
};


export type MutationUpdateManyMatterTemplateArgs = {
  input: Array<UpdateManyTemplatesInput>;
};


export type MutationUpdateManyTechnologyRatesArgs = {
  data: UpdateManyTechnologyRatesInput;
};


export type MutationUpdateManyWorkArgs = {
  data: Array<UpdateManyWorkInput>;
};


export type MutationUpdateMatterArgs = {
  data: MatterUpdateInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateMatterCollaboratorsArgs = {
  data: UpdateMatterCollaboratorsInput;
};


export type MutationUpdateMatterTemplateArgs = {
  data: MatterUpdateInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateNotificationRuleArgs = {
  data: UpdateNotificationRulesInput;
};


export type MutationUpdateOfficeLocationsByCountryArgs = {
  input: OfficeLocationsUpdateInput;
};


export type MutationUpdateOrganisationalUnitArgs = {
  id: Scalars['Int']['input'];
  input: OrganisationalUnitUpdateInput;
};


export type MutationUpdateOrganisationalUnitsArgs = {
  input: Array<UpdateManyOrganisationalUnitsInput>;
};


export type MutationUpdateParentMatterArgs = {
  id: Scalars['Int']['input'];
  updateInput: ParentMatterUpdateInput;
};


export type MutationUpdateParentMatterCollaboratorsArgs = {
  data: UpdateMatterCollaboratorsInput;
};


export type MutationUpdatePhaseArgs = {
  data: PhaseUpdateInput;
  matterId: Scalars['Int']['input'];
  phaseId: Scalars['Int']['input'];
};


export type MutationUpdatePhasesArgs = {
  data: Array<UpdatePhasesInput>;
  matterId: Scalars['Int']['input'];
};


export type MutationUpdateProposalHtmlArgs = {
  update: UpdateProposalOutputInput;
};


export type MutationUpdateProposalOfficeAndOrganisationalUnitArgs = {
  designTemplateId: Scalars['Float']['input'];
  matterId: Scalars['Float']['input'];
  selectedOfficeId: Scalars['Float']['input'];
  selectedOrganisationalUnitId: Scalars['Float']['input'];
};


export type MutationUpdateProposalOptionsArgs = {
  updateOptions: UpdateProposalOptionsInput;
};


export type MutationUpdateSettingsArgs = {
  data: SettingsUpdateInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateTaskArgs = {
  data: TaskUpdateInput;
  taskId: Scalars['Float']['input'];
};


export type MutationUpdateTasksArgs = {
  data: Array<UpdateTaskInput>;
};


export type MutationUpdateTaxonomyArgs = {
  id: Scalars['Float']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationUpdateTeamMembersArgs = {
  matterId: Scalars['Float']['input'];
  teamMembersToAdd: Array<TeamMembershipIds>;
  teamMembersToRemove: Array<TeamMembershipIds>;
};


export type MutationUpdateTechnologyChargeArgs = {
  technologyCharge: UpdateTechnologyChargeInput;
};


export type MutationUpdateTechnologyChargesArgs = {
  data: Array<UpdateTechnologyChargeInput>;
};


export type MutationUpdateTechnologyRatesArgs = {
  data: UpdateTechnologyRatesInput;
};


export type MutationUpdateTechnologyUnitsArgs = {
  data: Array<UpdateTechnologyUnitInput>;
};


export type MutationUpdateUpliftArgs = {
  data: UpliftUpdateInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateUpliftsArgs = {
  data: Array<UpdateManyUpliftsInput>;
};


export type MutationUpdateUserSettingsArgs = {
  data: UserSettingsUpdateInput;
};


export type MutationUpdateWorkArgs = {
  data: WorkUpdateInput;
  workId: Scalars['Float']['input'];
};


export type MutationUploadFooterImageArgs = {
  footerInput: FooterInput;
};


export type MutationUploadHeaderImageArgs = {
  headerInput: HeaderInput;
};


export type MutationUploadPdfAttachmentArgs = {
  pdfAttachment: PdfAttachment;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedEnumDiscountTypeFilter = {
  equals?: InputMaybe<DiscountType>;
  in?: InputMaybe<Array<DiscountType>>;
  not?: InputMaybe<NestedEnumDiscountTypeFilter>;
  notIn?: InputMaybe<Array<DiscountType>>;
};

export type NestedEnumDynamicTagConditionAndOrNullableFilter = {
  equals?: InputMaybe<DynamicTagConditionAndOr>;
  in?: InputMaybe<Array<DynamicTagConditionAndOr>>;
  not?: InputMaybe<NestedEnumDynamicTagConditionAndOrNullableFilter>;
  notIn?: InputMaybe<Array<DynamicTagConditionAndOr>>;
};

export type NestedEnumDynamicTagContentTypeFilter = {
  equals?: InputMaybe<DynamicTagContentType>;
  in?: InputMaybe<Array<DynamicTagContentType>>;
  not?: InputMaybe<NestedEnumDynamicTagContentTypeFilter>;
  notIn?: InputMaybe<Array<DynamicTagContentType>>;
};

export type NestedEnumExternalMatterStatusFilter = {
  equals?: InputMaybe<ExternalMatterStatus>;
  in?: InputMaybe<Array<ExternalMatterStatus>>;
  not?: InputMaybe<NestedEnumExternalMatterStatusFilter>;
  notIn?: InputMaybe<Array<ExternalMatterStatus>>;
};

export type NestedEnumExternalMatterTaxStatusFilter = {
  equals?: InputMaybe<ExternalMatterTaxStatus>;
  in?: InputMaybe<Array<ExternalMatterTaxStatus>>;
  not?: InputMaybe<NestedEnumExternalMatterTaxStatusFilter>;
  notIn?: InputMaybe<Array<ExternalMatterTaxStatus>>;
};

export type NestedEnumGroupedEntityTypeFilter = {
  equals?: InputMaybe<GroupedEntityType>;
  in?: InputMaybe<Array<GroupedEntityType>>;
  not?: InputMaybe<NestedEnumGroupedEntityTypeFilter>;
  notIn?: InputMaybe<Array<GroupedEntityType>>;
};

export type NestedEnumInvoiceStatusFilter = {
  equals?: InputMaybe<InvoiceStatus>;
  in?: InputMaybe<Array<InvoiceStatus>>;
  not?: InputMaybe<NestedEnumInvoiceStatusFilter>;
  notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type NestedEnumMatterStatusFilter = {
  equals?: InputMaybe<MatterStatus>;
  in?: InputMaybe<Array<MatterStatus>>;
  not?: InputMaybe<NestedEnumMatterStatusFilter>;
  notIn?: InputMaybe<Array<MatterStatus>>;
};

export type NestedEnumMatterTypeFilter = {
  equals?: InputMaybe<MatterType>;
  in?: InputMaybe<Array<MatterType>>;
  not?: InputMaybe<NestedEnumMatterTypeFilter>;
  notIn?: InputMaybe<Array<MatterType>>;
};

export type NestedEnumNotificationTypeFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type NestedEnumOutputDesignTypeFilter = {
  equals?: InputMaybe<OutputDesignType>;
  in?: InputMaybe<Array<OutputDesignType>>;
  not?: InputMaybe<NestedEnumOutputDesignTypeFilter>;
  notIn?: InputMaybe<Array<OutputDesignType>>;
};

export type NestedEnumPricingLevelFilter = {
  equals?: InputMaybe<PricingLevel>;
  in?: InputMaybe<Array<PricingLevel>>;
  not?: InputMaybe<NestedEnumPricingLevelFilter>;
  notIn?: InputMaybe<Array<PricingLevel>>;
};

export type NestedEnumPricingTargetNullableFilter = {
  equals?: InputMaybe<PricingTarget>;
  in?: InputMaybe<Array<PricingTarget>>;
  not?: InputMaybe<NestedEnumPricingTargetNullableFilter>;
  notIn?: InputMaybe<Array<PricingTarget>>;
};

export type NestedEnumPricingTypeFilter = {
  equals?: InputMaybe<PricingType>;
  in?: InputMaybe<Array<PricingType>>;
  not?: InputMaybe<NestedEnumPricingTypeFilter>;
  notIn?: InputMaybe<Array<PricingType>>;
};

export type NestedEnumTaxLabelFilter = {
  equals?: InputMaybe<TaxLabel>;
  in?: InputMaybe<Array<TaxLabel>>;
  not?: InputMaybe<NestedEnumTaxLabelFilter>;
  notIn?: InputMaybe<Array<TaxLabel>>;
};

export type NestedEnumTaxLabelNullableFilter = {
  equals?: InputMaybe<TaxLabel>;
  in?: InputMaybe<Array<TaxLabel>>;
  not?: InputMaybe<NestedEnumTaxLabelNullableFilter>;
  notIn?: InputMaybe<Array<TaxLabel>>;
};

export type NestedEnumTaxLabelStatusFilter = {
  equals?: InputMaybe<TaxLabelStatus>;
  in?: InputMaybe<Array<TaxLabelStatus>>;
  not?: InputMaybe<NestedEnumTaxLabelStatusFilter>;
  notIn?: InputMaybe<Array<TaxLabelStatus>>;
};

export type NestedEnumTaxStatusFilter = {
  equals?: InputMaybe<TaxStatus>;
  in?: InputMaybe<Array<TaxStatus>>;
  not?: InputMaybe<NestedEnumTaxStatusFilter>;
  notIn?: InputMaybe<Array<TaxStatus>>;
};

export type NestedEnumTechnologyChargeTypeFilter = {
  equals?: InputMaybe<TechnologyChargeType>;
  in?: InputMaybe<Array<TechnologyChargeType>>;
  not?: InputMaybe<NestedEnumTechnologyChargeTypeFilter>;
  notIn?: InputMaybe<Array<TechnologyChargeType>>;
};

export type NestedEnumTemplateTypeNullableFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeNullableFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type NestedEnumUpliftTypeFilter = {
  equals?: InputMaybe<UpliftType>;
  in?: InputMaybe<Array<UpliftType>>;
  not?: InputMaybe<NestedEnumUpliftTypeFilter>;
  notIn?: InputMaybe<Array<UpliftType>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Notification = {
  __typename?: 'Notification';
  archived: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isParent: Scalars['Boolean']['output'];
  matterId: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  notificationRuleId: Maybe<Scalars['Int']['output']>;
  parentMatterId: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: NotificationType;
  userId: Scalars['Int']['output'];
};

export type NotificationCreateManyMatterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationRuleId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type: NotificationType;
  userId: Scalars['Int']['input'];
};

export type NotificationCreateManyMatterInputEnvelope = {
  data: Array<NotificationCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyNotificationRuleInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type: NotificationType;
  userId: Scalars['Int']['input'];
};

export type NotificationCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyParentMatterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationRuleId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type: NotificationType;
  userId: Scalars['Int']['input'];
};

export type NotificationCreateManyParentMatterInputEnvelope = {
  data: Array<NotificationCreateManyParentMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyUserInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationRuleId?: InputMaybe<Scalars['Int']['input']>;
  parentMatterId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type: NotificationType;
};

export type NotificationCreateManyUserInputEnvelope = {
  data: Array<NotificationCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutMatterInput>>;
  createMany?: InputMaybe<NotificationCreateManyMatterInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutParentMatterInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutParentMatterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutParentMatterInput>>;
  createMany?: InputMaybe<NotificationCreateManyParentMatterInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
};

export type NotificationCreateOrConnectWithoutMatterInput = {
  create: NotificationCreateWithoutMatterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationCreateWithoutNotificationRuleInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutParentMatterInput = {
  create: NotificationCreateWithoutParentMatterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutUserInput = {
  create: NotificationCreateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateWithoutMatterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationRule?: InputMaybe<NotificationRuleCreateNestedOneWithoutNotificationsInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedOneWithoutNotificationsInput>;
  title: Scalars['String']['input'];
  type: NotificationType;
  user: UserCreateNestedOneWithoutNotificationsInput;
};

export type NotificationCreateWithoutNotificationRuleInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutNotificationsInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedOneWithoutNotificationsInput>;
  title: Scalars['String']['input'];
  type: NotificationType;
  user: UserCreateNestedOneWithoutNotificationsInput;
};

export type NotificationCreateWithoutParentMatterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutNotificationsInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationRule?: InputMaybe<NotificationRuleCreateNestedOneWithoutNotificationsInput>;
  title: Scalars['String']['input'];
  type: NotificationType;
  user: UserCreateNestedOneWithoutNotificationsInput;
};

export type NotificationCreateWithoutUserInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutNotificationsInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationRule?: InputMaybe<NotificationRuleCreateNestedOneWithoutNotificationsInput>;
  parentMatter?: InputMaybe<ParentMatterCreateNestedOneWithoutNotificationsInput>;
  title: Scalars['String']['input'];
  type: NotificationType;
};

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationResult = {
  __typename?: 'NotificationResult';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isParent: Scalars['Boolean']['output'];
  matterId: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  parentMatterId: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: NotificationType;
};

export type NotificationRule = {
  __typename?: 'NotificationRule';
  accruedBudgetThreshold: Maybe<Scalars['Float']['output']>;
  accruedTimeThreshold: Maybe<Scalars['Float']['output']>;
  active: Scalars['Boolean']['output'];
  activeGpmThreshold: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  createdById: Maybe<Scalars['Int']['output']>;
  currency: Maybe<Currency>;
  currencyId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifyFeeEarnerLevels: Maybe<Array<FeeEarnerLevel>>;
  notifyOrganisationalUnits: Maybe<Array<OrganisationalUnit>>;
  notifyUsers: Maybe<Array<User>>;
  proposalFeeThreshold: Maybe<Scalars['Float']['output']>;
  proposalGpmThreshold: Maybe<Scalars['Int']['output']>;
  thresholdBooleanType: Scalars['Boolean']['output'];
  thresholdFilter: Maybe<Scalars['Float']['output']>;
  triggerBooleanType: Scalars['Boolean']['output'];
  triggerClients: Maybe<Array<Client>>;
  triggerFeeEarnerLevels: Maybe<Array<FeeEarnerLevel>>;
  triggerMatters: Maybe<Array<Matter>>;
  triggerOrganisationalUnits: Maybe<Array<OrganisationalUnit>>;
  triggerUsers: Maybe<Array<User>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type NotificationRuleClientsCreateManyClientInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleClientsCreateManyClientInputEnvelope = {
  data: Array<NotificationRuleClientsCreateManyClientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleClientsCreateManyNotificationRuleInput = {
  clientId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleClientsCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleClientsCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleClientsCreateNestedManyWithoutClientInput = {
  connect?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleClientsCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<NotificationRuleClientsCreateWithoutClientInput>>;
  createMany?: InputMaybe<NotificationRuleClientsCreateManyClientInputEnvelope>;
};

export type NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleClientsCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleClientsCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleClientsCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleClientsCreateOrConnectWithoutClientInput = {
  create: NotificationRuleClientsCreateWithoutClientInput;
  where: NotificationRuleClientsWhereUniqueInput;
};

export type NotificationRuleClientsCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleClientsCreateWithoutNotificationRuleInput;
  where: NotificationRuleClientsWhereUniqueInput;
};

export type NotificationRuleClientsCreateWithoutClientInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerClientsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleClientsCreateWithoutNotificationRuleInput = {
  Client: ClientCreateNestedOneWithoutNotificationRuleInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleClientsListRelationFilter = {
  every?: InputMaybe<NotificationRuleClientsWhereInput>;
  none?: InputMaybe<NotificationRuleClientsWhereInput>;
  some?: InputMaybe<NotificationRuleClientsWhereInput>;
};

export type NotificationRuleClientsScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleClientsScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleClientsScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleClientsScalarWhereInput>>;
  clientId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleClientsUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleClientsUpdateManyWithWhereWithoutClientInput = {
  data: NotificationRuleClientsUpdateManyMutationInput;
  where: NotificationRuleClientsScalarWhereInput;
};

export type NotificationRuleClientsUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleClientsUpdateManyMutationInput;
  where: NotificationRuleClientsScalarWhereInput;
};

export type NotificationRuleClientsUpdateManyWithoutClientNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleClientsCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<NotificationRuleClientsCreateWithoutClientInput>>;
  createMany?: InputMaybe<NotificationRuleClientsCreateManyClientInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleClientsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleClientsUpdateWithWhereUniqueWithoutClientInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleClientsUpdateManyWithWhereWithoutClientInput>>;
  upsert?: InputMaybe<Array<NotificationRuleClientsUpsertWithWhereUniqueWithoutClientInput>>;
};

export type NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleClientsCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleClientsCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleClientsCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleClientsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleClientsWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleClientsUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleClientsUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleClientsUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleClientsUpdateWithWhereUniqueWithoutClientInput = {
  data: NotificationRuleClientsUpdateWithoutClientInput;
  where: NotificationRuleClientsWhereUniqueInput;
};

export type NotificationRuleClientsUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleClientsUpdateWithoutNotificationRuleInput;
  where: NotificationRuleClientsWhereUniqueInput;
};

export type NotificationRuleClientsUpdateWithoutClientInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutTriggerClientsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleClientsUpdateWithoutNotificationRuleInput = {
  Client?: InputMaybe<ClientUpdateOneRequiredWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleClientsUpsertWithWhereUniqueWithoutClientInput = {
  create: NotificationRuleClientsCreateWithoutClientInput;
  update: NotificationRuleClientsUpdateWithoutClientInput;
  where: NotificationRuleClientsWhereUniqueInput;
};

export type NotificationRuleClientsUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleClientsCreateWithoutNotificationRuleInput;
  update: NotificationRuleClientsUpdateWithoutNotificationRuleInput;
  where: NotificationRuleClientsWhereUniqueInput;
};

export type NotificationRuleClientsWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleClientsWhereInput>>;
  Client?: InputMaybe<ClientRelationFilter>;
  NOT?: InputMaybe<Array<NotificationRuleClientsWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleClientsWhereInput>>;
  clientId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleClientsWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleClientsWhereInput>>;
  Client?: InputMaybe<ClientRelationFilter>;
  NOT?: InputMaybe<Array<NotificationRuleClientsWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleClientsWhereInput>>;
  clientId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleCreateInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateManyCreatedByInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateManyCreatedByInputEnvelope = {
  data: Array<NotificationRuleCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleCreateManyCurrencyInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateManyCurrencyInputEnvelope = {
  data: Array<NotificationRuleCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<NotificationRuleCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<NotificationRuleCreateManyCreatedByInputEnvelope>;
};

export type NotificationRuleCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<NotificationRuleCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<NotificationRuleCreateManyCurrencyInputEnvelope>;
};

export type NotificationRuleCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotificationsInput>;
};

export type NotificationRuleCreateNestedOneWithoutNotifyFeeEarnerLevelsInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotifyFeeEarnerLevelsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput>;
};

export type NotificationRuleCreateNestedOneWithoutNotifyOrganisationalUnitsInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotifyOrganisationalUnitsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotifyOrganisationalUnitsInput>;
};

export type NotificationRuleCreateNestedOneWithoutNotifyUsersInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotifyUsersInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotifyUsersInput>;
};

export type NotificationRuleCreateNestedOneWithoutTriggerClientsInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerClientsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerClientsInput>;
};

export type NotificationRuleCreateNestedOneWithoutTriggerFeeEarnerLevelsInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerFeeEarnerLevelsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput>;
};

export type NotificationRuleCreateNestedOneWithoutTriggerMattersInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerMattersInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerMattersInput>;
};

export type NotificationRuleCreateNestedOneWithoutTriggerOrganisationalUnitsInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerOrganisationalUnitsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput>;
};

export type NotificationRuleCreateNestedOneWithoutTriggerUsersInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerUsersInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerUsersInput>;
};

export type NotificationRuleCreateOrConnectWithoutCreatedByInput = {
  create: NotificationRuleCreateWithoutCreatedByInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutCurrencyInput = {
  create: NotificationRuleCreateWithoutCurrencyInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutNotificationsInput = {
  create: NotificationRuleCreateWithoutNotificationsInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutNotifyFeeEarnerLevelsInput = {
  create: NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutNotifyOrganisationalUnitsInput = {
  create: NotificationRuleCreateWithoutNotifyOrganisationalUnitsInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutNotifyUsersInput = {
  create: NotificationRuleCreateWithoutNotifyUsersInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutTriggerClientsInput = {
  create: NotificationRuleCreateWithoutTriggerClientsInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutTriggerFeeEarnerLevelsInput = {
  create: NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutTriggerMattersInput = {
  create: NotificationRuleCreateWithoutTriggerMattersInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutTriggerOrganisationalUnitsInput = {
  create: NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateOrConnectWithoutTriggerUsersInput = {
  create: NotificationRuleCreateWithoutTriggerUsersInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleCreateWithoutCreatedByInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutCurrencyInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutNotificationsInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutNotifyOrganisationalUnitsInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutNotifyUsersInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutTriggerClientsInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutTriggerMattersInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleCreateWithoutTriggerUsersInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutNotificationRulesInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutNotificationRuleInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutNotificationRuleInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Int']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInputEnvelope = {
  data: Array<NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInput = {
  feeEarnerLevelId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInputEnvelope>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutFeeEarnerLevelInput = {
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput;
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput;
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutNotifyFeeEarnerLevelsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput = {
  feeEarnerLevel: FeeEarnerLevelCreateNestedOneWithoutNotifyNotificationRulesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelNotifyListRelationFilter = {
  every?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyWhereInput>;
  none?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyWhereInput>;
  some?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyWhereInput>;
};

export type NotificationRuleFeeEarnerLevelNotifyScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyScalarWhereInput>>;
  feeEarnerLevelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutFeeEarnerLevelInput = {
  data: NotificationRuleFeeEarnerLevelNotifyUpdateManyMutationInput;
  where: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleFeeEarnerLevelNotifyUpdateManyMutationInput;
  where: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutFeeEarnerLevelInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutFeeEarnerLevelInput>>;
  upsert?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutFeeEarnerLevelInput>>;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutFeeEarnerLevelInput = {
  data: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutFeeEarnerLevelInput;
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutNotificationRuleInput;
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateWithoutFeeEarnerLevelInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutNotifyFeeEarnerLevelsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleFeeEarnerLevelNotifyUpdateWithoutNotificationRuleInput = {
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneRequiredWithoutNotifyNotificationRulesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutFeeEarnerLevelInput = {
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput;
  update: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutFeeEarnerLevelInput;
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput;
  update: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutNotificationRuleInput;
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelNotifyWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereInput>>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleFeeEarnerLevelNotifyWhereInput>>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInputEnvelope = {
  data: Array<NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInput = {
  feeEarnerLevelId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInputEnvelope>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutFeeEarnerLevelInput = {
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput;
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput;
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerFeeEarnerLevelsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput = {
  feeEarnerLevel: FeeEarnerLevelCreateNestedOneWithoutTriggeredNotificationRulesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleFeeEarnerLevelTriggerListRelationFilter = {
  every?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerWhereInput>;
  none?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerWhereInput>;
  some?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerWhereInput>;
};

export type NotificationRuleFeeEarnerLevelTriggerScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerScalarWhereInput>>;
  feeEarnerLevelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutFeeEarnerLevelInput = {
  data: NotificationRuleFeeEarnerLevelTriggerUpdateManyMutationInput;
  where: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleFeeEarnerLevelTriggerUpdateManyMutationInput;
  where: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutFeeEarnerLevelInput>>;
  upsert?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput>>;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput = {
  data: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutFeeEarnerLevelInput;
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutNotificationRuleInput;
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateWithoutFeeEarnerLevelInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutTriggerFeeEarnerLevelsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleFeeEarnerLevelTriggerUpdateWithoutNotificationRuleInput = {
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput = {
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput;
  update: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutFeeEarnerLevelInput;
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput;
  update: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutNotificationRuleInput;
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
};

export type NotificationRuleFeeEarnerLevelTriggerWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereInput>>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleFeeEarnerLevelTriggerWhereInput>>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleListRelationFilter = {
  every?: InputMaybe<NotificationRuleWhereInput>;
  none?: InputMaybe<NotificationRuleWhereInput>;
  some?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleMattersCreateManyMatterInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleMattersCreateManyMatterInputEnvelope = {
  data: Array<NotificationRuleMattersCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleMattersCreateManyNotificationRuleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleMattersCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleMattersCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleMattersCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleMattersCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<NotificationRuleMattersCreateWithoutMatterInput>>;
  createMany?: InputMaybe<NotificationRuleMattersCreateManyMatterInputEnvelope>;
};

export type NotificationRuleMattersCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleMattersCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleMattersCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleMattersCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleMattersCreateOrConnectWithoutMatterInput = {
  create: NotificationRuleMattersCreateWithoutMatterInput;
  where: NotificationRuleMattersWhereUniqueInput;
};

export type NotificationRuleMattersCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleMattersCreateWithoutNotificationRuleInput;
  where: NotificationRuleMattersWhereUniqueInput;
};

export type NotificationRuleMattersCreateWithoutMatterInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerMattersInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleMattersCreateWithoutNotificationRuleInput = {
  matter: MatterCreateNestedOneWithoutTriggeredNotificationRulesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleMattersListRelationFilter = {
  every?: InputMaybe<NotificationRuleMattersWhereInput>;
  none?: InputMaybe<NotificationRuleMattersWhereInput>;
  some?: InputMaybe<NotificationRuleMattersWhereInput>;
};

export type NotificationRuleMattersScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleMattersScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleMattersScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleMattersScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleMattersUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleMattersUpdateManyWithWhereWithoutMatterInput = {
  data: NotificationRuleMattersUpdateManyMutationInput;
  where: NotificationRuleMattersScalarWhereInput;
};

export type NotificationRuleMattersUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleMattersUpdateManyMutationInput;
  where: NotificationRuleMattersScalarWhereInput;
};

export type NotificationRuleMattersUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleMattersCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<NotificationRuleMattersCreateWithoutMatterInput>>;
  createMany?: InputMaybe<NotificationRuleMattersCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleMattersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleMattersUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleMattersUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<NotificationRuleMattersUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleMattersCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleMattersCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleMattersCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleMattersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleMattersWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleMattersUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleMattersUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleMattersUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleMattersUpdateWithWhereUniqueWithoutMatterInput = {
  data: NotificationRuleMattersUpdateWithoutMatterInput;
  where: NotificationRuleMattersWhereUniqueInput;
};

export type NotificationRuleMattersUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleMattersUpdateWithoutNotificationRuleInput;
  where: NotificationRuleMattersWhereUniqueInput;
};

export type NotificationRuleMattersUpdateWithoutMatterInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutTriggerMattersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleMattersUpdateWithoutNotificationRuleInput = {
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleMattersUpsertWithWhereUniqueWithoutMatterInput = {
  create: NotificationRuleMattersCreateWithoutMatterInput;
  update: NotificationRuleMattersUpdateWithoutMatterInput;
  where: NotificationRuleMattersWhereUniqueInput;
};

export type NotificationRuleMattersUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleMattersCreateWithoutNotificationRuleInput;
  update: NotificationRuleMattersUpdateWithoutNotificationRuleInput;
  where: NotificationRuleMattersWhereUniqueInput;
};

export type NotificationRuleMattersWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleMattersWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleMattersWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleMattersWhereInput>>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleMattersWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleMattersWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleMattersWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleMattersWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleNullableRelationFilter = {
  is?: InputMaybe<NotificationRuleWhereInput>;
  isNot?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInputEnvelope = {
  data: Array<NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInputEnvelope>;
};

export type NotificationRuleOrganisationalUnitsCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput;
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsCreateOrConnectWithoutOrganisationalUnitInput = {
  create: NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput;
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput = {
  OrganisationalUnit: OrganisationalUnitCreateNestedOneWithoutTriggeredNotificationRulesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerOrganisationalUnitsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsListRelationFilter = {
  every?: InputMaybe<NotificationRuleOrganisationalUnitsWhereInput>;
  none?: InputMaybe<NotificationRuleOrganisationalUnitsWhereInput>;
  some?: InputMaybe<NotificationRuleOrganisationalUnitsWhereInput>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateManyNotificationRuleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleOrganisationalUnitsNotifyCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateManyOrganisationalUnitInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateManyOrganisationalUnitInputEnvelope = {
  data: Array<NotificationRuleOrganisationalUnitsNotifyCreateManyOrganisationalUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateManyOrganisationalUnitInputEnvelope>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleOrganisationalUnitsNotifyCreateWithoutNotificationRuleInput;
  where: NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateOrConnectWithoutOrganisationalUnitInput = {
  create: NotificationRuleOrganisationalUnitsNotifyCreateWithoutOrganisationalUnitInput;
  where: NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateWithoutNotificationRuleInput = {
  OrganisationalUnit: OrganisationalUnitCreateNestedOneWithoutNotifyNotificationRulesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsNotifyCreateWithoutOrganisationalUnitInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutNotifyOrganisationalUnitsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleOrganisationalUnitsNotifyListRelationFilter = {
  every?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyWhereInput>;
  none?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyWhereInput>;
  some?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyWhereInput>;
};

export type NotificationRuleOrganisationalUnitsNotifyScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  organisationalUnitId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleOrganisationalUnitsNotifyUpdateManyMutationInput;
  where: NotificationRuleOrganisationalUnitsNotifyScalarWhereInput;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateManyWithWhereWithoutOrganisationalUnitInput = {
  data: NotificationRuleOrganisationalUnitsNotifyUpdateManyMutationInput;
  where: NotificationRuleOrganisationalUnitsNotifyScalarWhereInput;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateManyOrganisationalUnitInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyUpdateWithWhereUniqueWithoutOrganisationalUnitInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithWhereWithoutOrganisationalUnitInput>>;
  upsert?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyUpsertWithWhereUniqueWithoutOrganisationalUnitInput>>;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleOrganisationalUnitsNotifyUpdateWithoutNotificationRuleInput;
  where: NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateWithWhereUniqueWithoutOrganisationalUnitInput = {
  data: NotificationRuleOrganisationalUnitsNotifyUpdateWithoutOrganisationalUnitInput;
  where: NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateWithoutNotificationRuleInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneRequiredWithoutNotifyNotificationRulesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleOrganisationalUnitsNotifyUpdateWithoutOrganisationalUnitInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutNotifyOrganisationalUnitsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleOrganisationalUnitsNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleOrganisationalUnitsNotifyCreateWithoutNotificationRuleInput;
  update: NotificationRuleOrganisationalUnitsNotifyUpdateWithoutNotificationRuleInput;
  where: NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsNotifyUpsertWithWhereUniqueWithoutOrganisationalUnitInput = {
  create: NotificationRuleOrganisationalUnitsNotifyCreateWithoutOrganisationalUnitInput;
  update: NotificationRuleOrganisationalUnitsNotifyUpdateWithoutOrganisationalUnitInput;
  where: NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsNotifyWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereInput>>;
  OrganisationalUnit?: InputMaybe<OrganisationalUnitRelationFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  organisationalUnitId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleOrganisationalUnitsNotifyWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleOrganisationalUnitsNotifyWhereInput>>;
  OrganisationalUnit?: InputMaybe<OrganisationalUnitRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  organisationalUnitId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleOrganisationalUnitsScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleOrganisationalUnitsScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleOrganisationalUnitsScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleOrganisationalUnitsScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  organisationalUnitId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleOrganisationalUnitsUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleOrganisationalUnitsUpdateManyMutationInput;
  where: NotificationRuleOrganisationalUnitsScalarWhereInput;
};

export type NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutOrganisationalUnitInput = {
  data: NotificationRuleOrganisationalUnitsUpdateManyMutationInput;
  where: NotificationRuleOrganisationalUnitsScalarWhereInput;
};

export type NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutOrganisationalUnitInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutOrganisationalUnitInput>>;
  upsert?: InputMaybe<Array<NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutOrganisationalUnitInput>>;
};

export type NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleOrganisationalUnitsUpdateWithoutNotificationRuleInput;
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutOrganisationalUnitInput = {
  data: NotificationRuleOrganisationalUnitsUpdateWithoutOrganisationalUnitInput;
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsUpdateWithoutNotificationRuleInput = {
  OrganisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleOrganisationalUnitsUpdateWithoutOrganisationalUnitInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutTriggerOrganisationalUnitsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput;
  update: NotificationRuleOrganisationalUnitsUpdateWithoutNotificationRuleInput;
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutOrganisationalUnitInput = {
  create: NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput;
  update: NotificationRuleOrganisationalUnitsUpdateWithoutOrganisationalUnitInput;
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
};

export type NotificationRuleOrganisationalUnitsWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereInput>>;
  OrganisationalUnit?: InputMaybe<OrganisationalUnitRelationFilter>;
  id?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  organisationalUnitId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleOrganisationalUnitsWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleOrganisationalUnitsWhereInput>>;
  OrganisationalUnit?: InputMaybe<OrganisationalUnitRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  organisationalUnitId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleRelationFilter = {
  is?: InputMaybe<NotificationRuleWhereInput>;
  isNot?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleScalarWhereInput>>;
  accruedBudgetThreshold?: InputMaybe<FloatNullableFilter>;
  accruedTimeThreshold?: InputMaybe<FloatNullableFilter>;
  active?: InputMaybe<BoolFilter>;
  activeGpmThreshold?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  proposalFeeThreshold?: InputMaybe<FloatNullableFilter>;
  proposalGpmThreshold?: InputMaybe<IntNullableFilter>;
  thresholdBooleanType?: InputMaybe<BoolFilter>;
  thresholdFilter?: InputMaybe<FloatNullableFilter>;
  triggerBooleanType?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleUpdateManyMutationInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateManyWithWhereWithoutCreatedByInput = {
  data: NotificationRuleUpdateManyMutationInput;
  where: NotificationRuleScalarWhereInput;
};

export type NotificationRuleUpdateManyWithWhereWithoutCurrencyInput = {
  data: NotificationRuleUpdateManyMutationInput;
  where: NotificationRuleScalarWhereInput;
};

export type NotificationRuleUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<NotificationRuleCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<NotificationRuleCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<NotificationRuleUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type NotificationRuleUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<NotificationRuleCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<NotificationRuleCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<NotificationRuleUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type NotificationRuleUpdateOneRequiredWithoutNotifyFeeEarnerLevelsNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotifyFeeEarnerLevelsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutNotifyFeeEarnerLevelsInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutNotifyFeeEarnerLevelsInput>;
};

export type NotificationRuleUpdateOneRequiredWithoutNotifyOrganisationalUnitsNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotifyOrganisationalUnitsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotifyOrganisationalUnitsInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutNotifyOrganisationalUnitsInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutNotifyOrganisationalUnitsInput>;
};

export type NotificationRuleUpdateOneRequiredWithoutNotifyUsersNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotifyUsersInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotifyUsersInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutNotifyUsersInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutNotifyUsersInput>;
};

export type NotificationRuleUpdateOneRequiredWithoutTriggerClientsNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerClientsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerClientsInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutTriggerClientsInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutTriggerClientsInput>;
};

export type NotificationRuleUpdateOneRequiredWithoutTriggerFeeEarnerLevelsNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerFeeEarnerLevelsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutTriggerFeeEarnerLevelsInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutTriggerFeeEarnerLevelsInput>;
};

export type NotificationRuleUpdateOneRequiredWithoutTriggerMattersNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerMattersInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerMattersInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutTriggerMattersInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutTriggerMattersInput>;
};

export type NotificationRuleUpdateOneRequiredWithoutTriggerOrganisationalUnitsNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerOrganisationalUnitsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutTriggerOrganisationalUnitsInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutTriggerOrganisationalUnitsInput>;
};

export type NotificationRuleUpdateOneRequiredWithoutTriggerUsersNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutTriggerUsersInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutTriggerUsersInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutTriggerUsersInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutTriggerUsersInput>;
};

export type NotificationRuleUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<NotificationRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationRuleCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<NotificationRuleCreateWithoutNotificationsInput>;
  delete?: InputMaybe<NotificationRuleWhereInput>;
  disconnect?: InputMaybe<NotificationRuleWhereInput>;
  update?: InputMaybe<NotificationRuleUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<NotificationRuleUpsertWithoutNotificationsInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutNotificationsInput = {
  data: NotificationRuleUpdateWithoutNotificationsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutNotifyFeeEarnerLevelsInput = {
  data: NotificationRuleUpdateWithoutNotifyFeeEarnerLevelsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutNotifyOrganisationalUnitsInput = {
  data: NotificationRuleUpdateWithoutNotifyOrganisationalUnitsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutNotifyUsersInput = {
  data: NotificationRuleUpdateWithoutNotifyUsersInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutTriggerClientsInput = {
  data: NotificationRuleUpdateWithoutTriggerClientsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutTriggerFeeEarnerLevelsInput = {
  data: NotificationRuleUpdateWithoutTriggerFeeEarnerLevelsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutTriggerMattersInput = {
  data: NotificationRuleUpdateWithoutTriggerMattersInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutTriggerOrganisationalUnitsInput = {
  data: NotificationRuleUpdateWithoutTriggerOrganisationalUnitsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateToOneWithWhereWithoutTriggerUsersInput = {
  data: NotificationRuleUpdateWithoutTriggerUsersInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: NotificationRuleUpdateWithoutCreatedByInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: NotificationRuleUpdateWithoutCurrencyInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleUpdateWithoutCreatedByInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutCurrencyInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutNotificationsInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutNotifyFeeEarnerLevelsInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutNotifyOrganisationalUnitsInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutNotifyUsersInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutTriggerClientsInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutTriggerFeeEarnerLevelsInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutTriggerMattersInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutTriggerOrganisationalUnitsInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpdateWithoutTriggerUsersInput = {
  accruedBudgetThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  accruedTimeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutNotificationRulesNestedInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutNotificationRuleNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutNotificationRuleNestedInput>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput>;
  proposalFeeThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  proposalGpmThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  thresholdBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  thresholdFilter?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  triggerBooleanType?: InputMaybe<BoolFieldUpdateOperationsInput>;
  triggerClients?: InputMaybe<NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput>;
  triggerMatters?: InputMaybe<NotificationRuleMattersUpdateManyWithoutNotificationRuleNestedInput>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: NotificationRuleCreateWithoutCreatedByInput;
  update: NotificationRuleUpdateWithoutCreatedByInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: NotificationRuleCreateWithoutCurrencyInput;
  update: NotificationRuleUpdateWithoutCurrencyInput;
  where: NotificationRuleWhereUniqueInput;
};

export type NotificationRuleUpsertWithoutNotificationsInput = {
  create: NotificationRuleCreateWithoutNotificationsInput;
  update: NotificationRuleUpdateWithoutNotificationsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutNotifyFeeEarnerLevelsInput = {
  create: NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput;
  update: NotificationRuleUpdateWithoutNotifyFeeEarnerLevelsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutNotifyOrganisationalUnitsInput = {
  create: NotificationRuleCreateWithoutNotifyOrganisationalUnitsInput;
  update: NotificationRuleUpdateWithoutNotifyOrganisationalUnitsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutNotifyUsersInput = {
  create: NotificationRuleCreateWithoutNotifyUsersInput;
  update: NotificationRuleUpdateWithoutNotifyUsersInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutTriggerClientsInput = {
  create: NotificationRuleCreateWithoutTriggerClientsInput;
  update: NotificationRuleUpdateWithoutTriggerClientsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutTriggerFeeEarnerLevelsInput = {
  create: NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput;
  update: NotificationRuleUpdateWithoutTriggerFeeEarnerLevelsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutTriggerMattersInput = {
  create: NotificationRuleCreateWithoutTriggerMattersInput;
  update: NotificationRuleUpdateWithoutTriggerMattersInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutTriggerOrganisationalUnitsInput = {
  create: NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput;
  update: NotificationRuleUpdateWithoutTriggerOrganisationalUnitsInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUpsertWithoutTriggerUsersInput = {
  create: NotificationRuleCreateWithoutTriggerUsersInput;
  update: NotificationRuleUpdateWithoutTriggerUsersInput;
  where?: InputMaybe<NotificationRuleWhereInput>;
};

export type NotificationRuleUserNotifyCreateManyNotificationRuleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type NotificationRuleUserNotifyCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleUserNotifyCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleUserNotifyCreateManyUserInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleUserNotifyCreateManyUserInputEnvelope = {
  data: Array<NotificationRuleUserNotifyCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserNotifyCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleUserNotifyCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleUserNotifyCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleUserNotifyCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserNotifyCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationRuleUserNotifyCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationRuleUserNotifyCreateManyUserInputEnvelope>;
};

export type NotificationRuleUserNotifyCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleUserNotifyCreateWithoutNotificationRuleInput;
  where: NotificationRuleUserNotifyWhereUniqueInput;
};

export type NotificationRuleUserNotifyCreateOrConnectWithoutUserInput = {
  create: NotificationRuleUserNotifyCreateWithoutUserInput;
  where: NotificationRuleUserNotifyWhereUniqueInput;
};

export type NotificationRuleUserNotifyCreateWithoutNotificationRuleInput = {
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutNotifyRulesInput;
};

export type NotificationRuleUserNotifyCreateWithoutUserInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutNotifyUsersInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleUserNotifyListRelationFilter = {
  every?: InputMaybe<NotificationRuleUserNotifyWhereInput>;
  none?: InputMaybe<NotificationRuleUserNotifyWhereInput>;
  some?: InputMaybe<NotificationRuleUserNotifyWhereInput>;
};

export type NotificationRuleUserNotifyScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleUserNotifyScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleUserNotifyScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleUserNotifyScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NotificationRuleUserNotifyUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUserNotifyUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleUserNotifyUpdateManyMutationInput;
  where: NotificationRuleUserNotifyScalarWhereInput;
};

export type NotificationRuleUserNotifyUpdateManyWithWhereWithoutUserInput = {
  data: NotificationRuleUserNotifyUpdateManyMutationInput;
  where: NotificationRuleUserNotifyScalarWhereInput;
};

export type NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserNotifyCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleUserNotifyCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleUserNotifyCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleUserNotifyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleUserNotifyUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserNotifyCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationRuleUserNotifyCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationRuleUserNotifyCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleUserNotifyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleUserNotifyWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleUserNotifyUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutUserInput>>;
};

export type NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleUserNotifyUpdateWithoutNotificationRuleInput;
  where: NotificationRuleUserNotifyWhereUniqueInput;
};

export type NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutUserInput = {
  data: NotificationRuleUserNotifyUpdateWithoutUserInput;
  where: NotificationRuleUserNotifyWhereUniqueInput;
};

export type NotificationRuleUserNotifyUpdateWithoutNotificationRuleInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotifyRulesNestedInput>;
};

export type NotificationRuleUserNotifyUpdateWithoutUserInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutNotifyUsersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleUserNotifyCreateWithoutNotificationRuleInput;
  update: NotificationRuleUserNotifyUpdateWithoutNotificationRuleInput;
  where: NotificationRuleUserNotifyWhereUniqueInput;
};

export type NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutUserInput = {
  create: NotificationRuleUserNotifyCreateWithoutUserInput;
  update: NotificationRuleUserNotifyUpdateWithoutUserInput;
  where: NotificationRuleUserNotifyWhereUniqueInput;
};

export type NotificationRuleUserNotifyWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleUserNotifyWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleUserNotifyWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleUserNotifyWhereInput>>;
  id?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NotificationRuleUserNotifyWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleUserNotifyWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleUserNotifyWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleUserNotifyWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NotificationRuleUserTriggerCreateManyNotificationRuleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type NotificationRuleUserTriggerCreateManyNotificationRuleInputEnvelope = {
  data: Array<NotificationRuleUserTriggerCreateManyNotificationRuleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleUserTriggerCreateManyUserInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRuleId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleUserTriggerCreateManyUserInputEnvelope = {
  data: Array<NotificationRuleUserTriggerCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput = {
  connect?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserTriggerCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleUserTriggerCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleUserTriggerCreateManyNotificationRuleInputEnvelope>;
};

export type NotificationRuleUserTriggerCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserTriggerCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationRuleUserTriggerCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationRuleUserTriggerCreateManyUserInputEnvelope>;
};

export type NotificationRuleUserTriggerCreateOrConnectWithoutNotificationRuleInput = {
  create: NotificationRuleUserTriggerCreateWithoutNotificationRuleInput;
  where: NotificationRuleUserTriggerWhereUniqueInput;
};

export type NotificationRuleUserTriggerCreateOrConnectWithoutUserInput = {
  create: NotificationRuleUserTriggerCreateWithoutUserInput;
  where: NotificationRuleUserTriggerWhereUniqueInput;
};

export type NotificationRuleUserTriggerCreateWithoutNotificationRuleInput = {
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutTriggeredRulesInput;
};

export type NotificationRuleUserTriggerCreateWithoutUserInput = {
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerUsersInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NotificationRuleUserTriggerListRelationFilter = {
  every?: InputMaybe<NotificationRuleUserTriggerWhereInput>;
  none?: InputMaybe<NotificationRuleUserTriggerWhereInput>;
  some?: InputMaybe<NotificationRuleUserTriggerWhereInput>;
};

export type NotificationRuleUserTriggerScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleUserTriggerScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleUserTriggerScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleUserTriggerScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NotificationRuleUserTriggerUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUserTriggerUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationRuleUserTriggerUpdateManyMutationInput;
  where: NotificationRuleUserTriggerScalarWhereInput;
};

export type NotificationRuleUserTriggerUpdateManyWithWhereWithoutUserInput = {
  data: NotificationRuleUserTriggerUpdateManyMutationInput;
  where: NotificationRuleUserTriggerScalarWhereInput;
};

export type NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserTriggerCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationRuleUserTriggerCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationRuleUserTriggerCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleUserTriggerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleUserTriggerUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationRuleUserTriggerCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationRuleUserTriggerCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationRuleUserTriggerCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationRuleUserTriggerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationRuleUserTriggerWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<NotificationRuleUserTriggerUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutUserInput>>;
};

export type NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationRuleUserTriggerUpdateWithoutNotificationRuleInput;
  where: NotificationRuleUserTriggerWhereUniqueInput;
};

export type NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutUserInput = {
  data: NotificationRuleUserTriggerUpdateWithoutUserInput;
  where: NotificationRuleUserTriggerWhereUniqueInput;
};

export type NotificationRuleUserTriggerUpdateWithoutNotificationRuleInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutTriggeredRulesNestedInput>;
};

export type NotificationRuleUserTriggerUpdateWithoutUserInput = {
  notificationRule?: InputMaybe<NotificationRuleUpdateOneRequiredWithoutTriggerUsersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationRuleUserTriggerCreateWithoutNotificationRuleInput;
  update: NotificationRuleUserTriggerUpdateWithoutNotificationRuleInput;
  where: NotificationRuleUserTriggerWhereUniqueInput;
};

export type NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutUserInput = {
  create: NotificationRuleUserTriggerCreateWithoutUserInput;
  update: NotificationRuleUserTriggerUpdateWithoutUserInput;
  where: NotificationRuleUserTriggerWhereUniqueInput;
};

export type NotificationRuleUserTriggerWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleUserTriggerWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleUserTriggerWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleUserTriggerWhereInput>>;
  id?: InputMaybe<IntFilter>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NotificationRuleUserTriggerWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleUserTriggerWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleUserTriggerWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleUserTriggerWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notificationRule?: InputMaybe<NotificationRuleRelationFilter>;
  notificationRuleId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NotificationRuleWhereInput = {
  AND?: InputMaybe<Array<NotificationRuleWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleWhereInput>>;
  accruedBudgetThreshold?: InputMaybe<FloatNullableFilter>;
  accruedTimeThreshold?: InputMaybe<FloatNullableFilter>;
  active?: InputMaybe<BoolFilter>;
  activeGpmThreshold?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyListRelationFilter>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyListRelationFilter>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyListRelationFilter>;
  proposalFeeThreshold?: InputMaybe<FloatNullableFilter>;
  proposalGpmThreshold?: InputMaybe<IntNullableFilter>;
  thresholdBooleanType?: InputMaybe<BoolFilter>;
  thresholdFilter?: InputMaybe<FloatNullableFilter>;
  triggerBooleanType?: InputMaybe<BoolFilter>;
  triggerClients?: InputMaybe<NotificationRuleClientsListRelationFilter>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerListRelationFilter>;
  triggerMatters?: InputMaybe<NotificationRuleMattersListRelationFilter>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsListRelationFilter>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationRuleWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationRuleWhereInput>>;
  NOT?: InputMaybe<Array<NotificationRuleWhereInput>>;
  OR?: InputMaybe<Array<NotificationRuleWhereInput>>;
  accruedBudgetThreshold?: InputMaybe<FloatNullableFilter>;
  accruedTimeThreshold?: InputMaybe<FloatNullableFilter>;
  active?: InputMaybe<BoolFilter>;
  activeGpmThreshold?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  notifyFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelNotifyListRelationFilter>;
  notifyOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyListRelationFilter>;
  notifyUsers?: InputMaybe<NotificationRuleUserNotifyListRelationFilter>;
  proposalFeeThreshold?: InputMaybe<FloatNullableFilter>;
  proposalGpmThreshold?: InputMaybe<IntNullableFilter>;
  thresholdBooleanType?: InputMaybe<BoolFilter>;
  thresholdFilter?: InputMaybe<FloatNullableFilter>;
  triggerBooleanType?: InputMaybe<BoolFilter>;
  triggerClients?: InputMaybe<NotificationRuleClientsListRelationFilter>;
  triggerFeeEarnerLevels?: InputMaybe<NotificationRuleFeeEarnerLevelTriggerListRelationFilter>;
  triggerMatters?: InputMaybe<NotificationRuleMattersListRelationFilter>;
  triggerOrganisationalUnits?: InputMaybe<NotificationRuleOrganisationalUnitsListRelationFilter>;
  triggerUsers?: InputMaybe<NotificationRuleUserTriggerListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereInput>>;
  archived?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isParent?: InputMaybe<BoolFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  notificationRuleId?: InputMaybe<IntNullableFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationTypeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export enum NotificationType {
  Alert = 'Alert',
  Standard = 'Standard'
}

export type NotificationUpdateManyMutationInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationTypeFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyWithWhereWithoutMatterInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutNotificationRuleInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutParentMatterInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutUserInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutMatterInput>>;
  createMany?: InputMaybe<NotificationCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type NotificationUpdateManyWithoutNotificationRuleNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutNotificationRuleInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutNotificationRuleInput>>;
  createMany?: InputMaybe<NotificationCreateManyNotificationRuleInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutNotificationRuleInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutNotificationRuleInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutNotificationRuleInput>>;
};

export type NotificationUpdateManyWithoutParentMatterNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutParentMatterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutParentMatterInput>>;
  createMany?: InputMaybe<NotificationCreateManyParentMatterInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutParentMatterInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutParentMatterInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutParentMatterInput>>;
};

export type NotificationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type NotificationUpdateWithWhereUniqueWithoutMatterInput = {
  data: NotificationUpdateWithoutMatterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutNotificationRuleInput = {
  data: NotificationUpdateWithoutNotificationRuleInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutParentMatterInput = {
  data: NotificationUpdateWithoutParentMatterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutUserInput = {
  data: NotificationUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithoutMatterInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleUpdateOneWithoutNotificationsNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateOneWithoutNotificationsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationTypeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationsNestedInput>;
};

export type NotificationUpdateWithoutNotificationRuleInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutNotificationsNestedInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateOneWithoutNotificationsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationTypeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationsNestedInput>;
};

export type NotificationUpdateWithoutParentMatterInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutNotificationsNestedInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleUpdateOneWithoutNotificationsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationTypeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutNotificationsNestedInput>;
};

export type NotificationUpdateWithoutUserInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutNotificationsNestedInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationRule?: InputMaybe<NotificationRuleUpdateOneWithoutNotificationsNestedInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateOneWithoutNotificationsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationTypeFieldUpdateOperationsInput>;
};

export type NotificationUpsertWithWhereUniqueWithoutMatterInput = {
  create: NotificationCreateWithoutMatterInput;
  update: NotificationUpdateWithoutMatterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutNotificationRuleInput = {
  create: NotificationCreateWithoutNotificationRuleInput;
  update: NotificationUpdateWithoutNotificationRuleInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutParentMatterInput = {
  create: NotificationCreateWithoutParentMatterInput;
  update: NotificationUpdateWithoutParentMatterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutUserInput = {
  create: NotificationCreateWithoutUserInput;
  update: NotificationUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  archived?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isParent?: InputMaybe<BoolFilter>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  notificationRule?: InputMaybe<NotificationRuleNullableRelationFilter>;
  notificationRuleId?: InputMaybe<IntNullableFilter>;
  parentMatter?: InputMaybe<ParentMatterNullableRelationFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationTypeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  archived?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isParent?: InputMaybe<BoolFilter>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  notificationRule?: InputMaybe<NotificationRuleNullableRelationFilter>;
  notificationRuleId?: InputMaybe<IntNullableFilter>;
  parentMatter?: InputMaybe<ParentMatterNullableRelationFilter>;
  parentMatterId?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationTypeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NullableEnumDynamicTagConditionAndOrFieldUpdateOperationsInput = {
  set?: InputMaybe<DynamicTagConditionAndOr>;
};

export type NullableEnumPricingTargetFieldUpdateOperationsInput = {
  set?: InputMaybe<PricingTarget>;
};

export type NullableEnumTaxLabelFieldUpdateOperationsInput = {
  set?: InputMaybe<TaxLabel>;
};

export type NullableEnumTemplateTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TemplateType>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type OfficeLocation = {
  __typename?: 'OfficeLocation';
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  taxLabel: Maybe<TaxLabel>;
  taxLevelPercent: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OfficeLocationCreateNestedOneWithoutFeeEarnersInput = {
  connect?: InputMaybe<OfficeLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OfficeLocationCreateOrConnectWithoutFeeEarnersInput>;
  create?: InputMaybe<OfficeLocationCreateWithoutFeeEarnersInput>;
};

export type OfficeLocationCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<OfficeLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OfficeLocationCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<OfficeLocationCreateWithoutMattersInput>;
};

export type OfficeLocationCreateNestedOneWithoutRatesInput = {
  connect?: InputMaybe<OfficeLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OfficeLocationCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<OfficeLocationCreateWithoutRatesInput>;
};

export type OfficeLocationCreateOrConnectWithoutFeeEarnersInput = {
  create: OfficeLocationCreateWithoutFeeEarnersInput;
  where: OfficeLocationWhereUniqueInput;
};

export type OfficeLocationCreateOrConnectWithoutMattersInput = {
  create: OfficeLocationCreateWithoutMattersInput;
  where: OfficeLocationWhereUniqueInput;
};

export type OfficeLocationCreateOrConnectWithoutRatesInput = {
  create: OfficeLocationCreateWithoutRatesInput;
  where: OfficeLocationWhereUniqueInput;
};

export type OfficeLocationCreateWithoutFeeEarnersInput = {
  countryCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOfficeLocationInput>;
  name: Scalars['String']['input'];
  rates?: InputMaybe<RateCreateNestedManyWithoutOfficeLocationInput>;
  taxLabel?: InputMaybe<TaxLabel>;
  taxLevelPercent?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OfficeLocationCreateWithoutMattersInput = {
  countryCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOfficeLocationInput>;
  name: Scalars['String']['input'];
  rates?: InputMaybe<RateCreateNestedManyWithoutOfficeLocationInput>;
  taxLabel?: InputMaybe<TaxLabel>;
  taxLevelPercent?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OfficeLocationCreateWithoutRatesInput = {
  countryCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOfficeLocationInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOfficeLocationInput>;
  name: Scalars['String']['input'];
  taxLabel?: InputMaybe<TaxLabel>;
  taxLevelPercent?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OfficeLocationNullableRelationFilter = {
  is?: InputMaybe<OfficeLocationWhereInput>;
  isNot?: InputMaybe<OfficeLocationWhereInput>;
};

export type OfficeLocationUpdateOneWithoutFeeEarnersNestedInput = {
  connect?: InputMaybe<OfficeLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OfficeLocationCreateOrConnectWithoutFeeEarnersInput>;
  create?: InputMaybe<OfficeLocationCreateWithoutFeeEarnersInput>;
  delete?: InputMaybe<OfficeLocationWhereInput>;
  disconnect?: InputMaybe<OfficeLocationWhereInput>;
  update?: InputMaybe<OfficeLocationUpdateToOneWithWhereWithoutFeeEarnersInput>;
  upsert?: InputMaybe<OfficeLocationUpsertWithoutFeeEarnersInput>;
};

export type OfficeLocationUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<OfficeLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OfficeLocationCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<OfficeLocationCreateWithoutMattersInput>;
  delete?: InputMaybe<OfficeLocationWhereInput>;
  disconnect?: InputMaybe<OfficeLocationWhereInput>;
  update?: InputMaybe<OfficeLocationUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<OfficeLocationUpsertWithoutMattersInput>;
};

export type OfficeLocationUpdateOneWithoutRatesNestedInput = {
  connect?: InputMaybe<OfficeLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OfficeLocationCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<OfficeLocationCreateWithoutRatesInput>;
  delete?: InputMaybe<OfficeLocationWhereInput>;
  disconnect?: InputMaybe<OfficeLocationWhereInput>;
  update?: InputMaybe<OfficeLocationUpdateToOneWithWhereWithoutRatesInput>;
  upsert?: InputMaybe<OfficeLocationUpsertWithoutRatesInput>;
};

export type OfficeLocationUpdateToOneWithWhereWithoutFeeEarnersInput = {
  data: OfficeLocationUpdateWithoutFeeEarnersInput;
  where?: InputMaybe<OfficeLocationWhereInput>;
};

export type OfficeLocationUpdateToOneWithWhereWithoutMattersInput = {
  data: OfficeLocationUpdateWithoutMattersInput;
  where?: InputMaybe<OfficeLocationWhereInput>;
};

export type OfficeLocationUpdateToOneWithWhereWithoutRatesInput = {
  data: OfficeLocationUpdateWithoutRatesInput;
  where?: InputMaybe<OfficeLocationWhereInput>;
};

export type OfficeLocationUpdateWithoutFeeEarnersInput = {
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOfficeLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOfficeLocationNestedInput>;
  taxLabel?: InputMaybe<NullableEnumTaxLabelFieldUpdateOperationsInput>;
  taxLevelPercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OfficeLocationUpdateWithoutMattersInput = {
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOfficeLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOfficeLocationNestedInput>;
  taxLabel?: InputMaybe<NullableEnumTaxLabelFieldUpdateOperationsInput>;
  taxLevelPercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OfficeLocationUpdateWithoutRatesInput = {
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOfficeLocationNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOfficeLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  taxLabel?: InputMaybe<NullableEnumTaxLabelFieldUpdateOperationsInput>;
  taxLevelPercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OfficeLocationUpsertWithoutFeeEarnersInput = {
  create: OfficeLocationCreateWithoutFeeEarnersInput;
  update: OfficeLocationUpdateWithoutFeeEarnersInput;
  where?: InputMaybe<OfficeLocationWhereInput>;
};

export type OfficeLocationUpsertWithoutMattersInput = {
  create: OfficeLocationCreateWithoutMattersInput;
  update: OfficeLocationUpdateWithoutMattersInput;
  where?: InputMaybe<OfficeLocationWhereInput>;
};

export type OfficeLocationUpsertWithoutRatesInput = {
  create: OfficeLocationCreateWithoutRatesInput;
  update: OfficeLocationUpdateWithoutRatesInput;
  where?: InputMaybe<OfficeLocationWhereInput>;
};

export type OfficeLocationWhereInput = {
  AND?: InputMaybe<Array<OfficeLocationWhereInput>>;
  NOT?: InputMaybe<Array<OfficeLocationWhereInput>>;
  OR?: InputMaybe<Array<OfficeLocationWhereInput>>;
  countryCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarners?: InputMaybe<FeeEarnerListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  taxLabel?: InputMaybe<EnumTaxLabelNullableFilter>;
  taxLevelPercent?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OfficeLocationWhereUniqueInput = {
  AND?: InputMaybe<Array<OfficeLocationWhereInput>>;
  NOT?: InputMaybe<Array<OfficeLocationWhereInput>>;
  OR?: InputMaybe<Array<OfficeLocationWhereInput>>;
  countryCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarners?: InputMaybe<FeeEarnerListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  rates?: InputMaybe<RateListRelationFilter>;
  taxLabel?: InputMaybe<EnumTaxLabelNullableFilter>;
  taxLevelPercent?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OfficeLocationsUpdateInput = {
  countryCode: Scalars['String']['input'];
  taxLabel?: InputMaybe<TaxLabel>;
  taxLevelPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganisationalUnit = {
  __typename?: 'OrganisationalUnit';
  children: Maybe<Array<OrganisationalUnit>>;
  createdAt: Scalars['DateTimeISO']['output'];
  defaultDesignId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  gpmDangerThreshold: Maybe<Scalars['Int']['output']>;
  gpmWarningThreshold: Maybe<Scalars['Int']['output']>;
  groupItemId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parent: Maybe<OrganisationalUnit>;
  parentId: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganisationalUnitCreateManyDefaultOutputDesignInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  groupItemId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateManyDefaultOutputDesignInputEnvelope = {
  data: Array<OrganisationalUnitCreateManyDefaultOutputDesignInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganisationalUnitCreateManyGroupItemInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultDesignId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateManyGroupItemInputEnvelope = {
  data: Array<OrganisationalUnitCreateManyGroupItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganisationalUnitCreateManyParentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultDesignId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  groupItemId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateManyParentInputEnvelope = {
  data: Array<OrganisationalUnitCreateManyParentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganisationalUnitCreateNestedManyWithoutDefaultOutputDesignInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutDefaultOutputDesignInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutDefaultOutputDesignInput>>;
  createMany?: InputMaybe<OrganisationalUnitCreateManyDefaultOutputDesignInputEnvelope>;
};

export type OrganisationalUnitCreateNestedManyWithoutGroupItemInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutGroupItemInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutGroupItemInput>>;
  createMany?: InputMaybe<OrganisationalUnitCreateManyGroupItemInputEnvelope>;
};

export type OrganisationalUnitCreateNestedManyWithoutLibraryAssumptionsInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutLibraryAssumptionsInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutLibraryAssumptionsInput>>;
};

export type OrganisationalUnitCreateNestedManyWithoutLibraryExclusionsInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutLibraryExclusionsInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutLibraryExclusionsInput>>;
};

export type OrganisationalUnitCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutParentInput>>;
  createMany?: InputMaybe<OrganisationalUnitCreateManyParentInputEnvelope>;
};

export type OrganisationalUnitCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutChildrenInput>;
};

export type OrganisationalUnitCreateNestedOneWithoutExternalMattersInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutExternalMattersInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutExternalMattersInput>;
};

export type OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutFeeEarnersInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutFeeEarnersInput>;
};

export type OrganisationalUnitCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutMattersInput>;
};

export type OrganisationalUnitCreateNestedOneWithoutNotifyNotificationRulesInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutNotifyNotificationRulesInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutNotifyNotificationRulesInput>;
};

export type OrganisationalUnitCreateNestedOneWithoutRatesInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutRatesInput>;
};

export type OrganisationalUnitCreateNestedOneWithoutTriggeredNotificationRulesInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutTriggeredNotificationRulesInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput>;
};

export type OrganisationalUnitCreateOrConnectWithoutChildrenInput = {
  create: OrganisationalUnitCreateWithoutChildrenInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutDefaultOutputDesignInput = {
  create: OrganisationalUnitCreateWithoutDefaultOutputDesignInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutExternalMattersInput = {
  create: OrganisationalUnitCreateWithoutExternalMattersInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutFeeEarnersInput = {
  create: OrganisationalUnitCreateWithoutFeeEarnersInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutGroupItemInput = {
  create: OrganisationalUnitCreateWithoutGroupItemInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutLibraryAssumptionsInput = {
  create: OrganisationalUnitCreateWithoutLibraryAssumptionsInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutLibraryExclusionsInput = {
  create: OrganisationalUnitCreateWithoutLibraryExclusionsInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutMattersInput = {
  create: OrganisationalUnitCreateWithoutMattersInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutNotifyNotificationRulesInput = {
  create: OrganisationalUnitCreateWithoutNotifyNotificationRulesInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutParentInput = {
  create: OrganisationalUnitCreateWithoutParentInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutRatesInput = {
  create: OrganisationalUnitCreateWithoutRatesInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateOrConnectWithoutTriggeredNotificationRulesInput = {
  create: OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitCreateWithoutChildrenInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutDefaultOutputDesignInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutExternalMattersInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutFeeEarnersInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutGroupItemInput = {
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutLibraryAssumptionsInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutLibraryExclusionsInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutMattersInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutNotifyNotificationRulesInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutParentInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutRatesInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput = {
  GroupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOrganisationalUnitInput>;
  children?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  defaultOutputDesign?: InputMaybe<OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarners?: InputMaybe<FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput>;
  gpmDangerThreshold?: InputMaybe<Scalars['Int']['input']>;
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutOrganisationalUnitInput>;
  name: Scalars['String']['input'];
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyCreateNestedManyWithoutOrganisationalUnitInput>;
  order: Scalars['Int']['input'];
  parent?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutChildrenInput>;
  rates?: InputMaybe<RateCreateNestedManyWithoutOrganisationalUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganisationalUnitListRelationFilter = {
  every?: InputMaybe<OrganisationalUnitWhereInput>;
  none?: InputMaybe<OrganisationalUnitWhereInput>;
  some?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitNullableRelationFilter = {
  is?: InputMaybe<OrganisationalUnitWhereInput>;
  isNot?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitRelationFilter = {
  is?: InputMaybe<OrganisationalUnitWhereInput>;
  isNot?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitScalarWhereInput = {
  AND?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  OR?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultDesignId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  gpmDangerThreshold?: InputMaybe<IntNullableFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrganisationalUnitUpdateInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateManyWithWhereWithoutDefaultOutputDesignInput = {
  data: OrganisationalUnitUpdateManyMutationInput;
  where: OrganisationalUnitScalarWhereInput;
};

export type OrganisationalUnitUpdateManyWithWhereWithoutGroupItemInput = {
  data: OrganisationalUnitUpdateManyMutationInput;
  where: OrganisationalUnitScalarWhereInput;
};

export type OrganisationalUnitUpdateManyWithWhereWithoutLibraryAssumptionsInput = {
  data: OrganisationalUnitUpdateManyMutationInput;
  where: OrganisationalUnitScalarWhereInput;
};

export type OrganisationalUnitUpdateManyWithWhereWithoutLibraryExclusionsInput = {
  data: OrganisationalUnitUpdateManyMutationInput;
  where: OrganisationalUnitScalarWhereInput;
};

export type OrganisationalUnitUpdateManyWithWhereWithoutParentInput = {
  data: OrganisationalUnitUpdateManyMutationInput;
  where: OrganisationalUnitScalarWhereInput;
};

export type OrganisationalUnitUpdateManyWithoutDefaultOutputDesignNestedInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutDefaultOutputDesignInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutDefaultOutputDesignInput>>;
  createMany?: InputMaybe<OrganisationalUnitCreateManyDefaultOutputDesignInputEnvelope>;
  delete?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganisationalUnitUpdateWithWhereUniqueWithoutDefaultOutputDesignInput>>;
  updateMany?: InputMaybe<Array<OrganisationalUnitUpdateManyWithWhereWithoutDefaultOutputDesignInput>>;
  upsert?: InputMaybe<Array<OrganisationalUnitUpsertWithWhereUniqueWithoutDefaultOutputDesignInput>>;
};

export type OrganisationalUnitUpdateManyWithoutGroupItemNestedInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutGroupItemInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutGroupItemInput>>;
  createMany?: InputMaybe<OrganisationalUnitCreateManyGroupItemInputEnvelope>;
  delete?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganisationalUnitUpdateWithWhereUniqueWithoutGroupItemInput>>;
  updateMany?: InputMaybe<Array<OrganisationalUnitUpdateManyWithWhereWithoutGroupItemInput>>;
  upsert?: InputMaybe<Array<OrganisationalUnitUpsertWithWhereUniqueWithoutGroupItemInput>>;
};

export type OrganisationalUnitUpdateManyWithoutLibraryAssumptionsNestedInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutLibraryAssumptionsInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutLibraryAssumptionsInput>>;
  delete?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganisationalUnitUpdateWithWhereUniqueWithoutLibraryAssumptionsInput>>;
  updateMany?: InputMaybe<Array<OrganisationalUnitUpdateManyWithWhereWithoutLibraryAssumptionsInput>>;
  upsert?: InputMaybe<Array<OrganisationalUnitUpsertWithWhereUniqueWithoutLibraryAssumptionsInput>>;
};

export type OrganisationalUnitUpdateManyWithoutLibraryExclusionsNestedInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutLibraryExclusionsInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutLibraryExclusionsInput>>;
  delete?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganisationalUnitUpdateWithWhereUniqueWithoutLibraryExclusionsInput>>;
  updateMany?: InputMaybe<Array<OrganisationalUnitUpdateManyWithWhereWithoutLibraryExclusionsInput>>;
  upsert?: InputMaybe<Array<OrganisationalUnitUpsertWithWhereUniqueWithoutLibraryExclusionsInput>>;
};

export type OrganisationalUnitUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganisationalUnitCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<OrganisationalUnitCreateWithoutParentInput>>;
  createMany?: InputMaybe<OrganisationalUnitCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganisationalUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganisationalUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganisationalUnitUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<OrganisationalUnitUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<OrganisationalUnitUpsertWithWhereUniqueWithoutParentInput>>;
};

export type OrganisationalUnitUpdateOneRequiredWithoutNotifyNotificationRulesNestedInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutNotifyNotificationRulesInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutNotifyNotificationRulesInput>;
  update?: InputMaybe<OrganisationalUnitUpdateToOneWithWhereWithoutNotifyNotificationRulesInput>;
  upsert?: InputMaybe<OrganisationalUnitUpsertWithoutNotifyNotificationRulesInput>;
};

export type OrganisationalUnitUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutTriggeredNotificationRulesInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput>;
  update?: InputMaybe<OrganisationalUnitUpdateToOneWithWhereWithoutTriggeredNotificationRulesInput>;
  upsert?: InputMaybe<OrganisationalUnitUpsertWithoutTriggeredNotificationRulesInput>;
};

export type OrganisationalUnitUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutChildrenInput>;
  delete?: InputMaybe<OrganisationalUnitWhereInput>;
  disconnect?: InputMaybe<OrganisationalUnitWhereInput>;
  update?: InputMaybe<OrganisationalUnitUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<OrganisationalUnitUpsertWithoutChildrenInput>;
};

export type OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutExternalMattersInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutExternalMattersInput>;
  delete?: InputMaybe<OrganisationalUnitWhereInput>;
  disconnect?: InputMaybe<OrganisationalUnitWhereInput>;
  update?: InputMaybe<OrganisationalUnitUpdateToOneWithWhereWithoutExternalMattersInput>;
  upsert?: InputMaybe<OrganisationalUnitUpsertWithoutExternalMattersInput>;
};

export type OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutFeeEarnersInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutFeeEarnersInput>;
  delete?: InputMaybe<OrganisationalUnitWhereInput>;
  disconnect?: InputMaybe<OrganisationalUnitWhereInput>;
  update?: InputMaybe<OrganisationalUnitUpdateToOneWithWhereWithoutFeeEarnersInput>;
  upsert?: InputMaybe<OrganisationalUnitUpsertWithoutFeeEarnersInput>;
};

export type OrganisationalUnitUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutMattersInput>;
  delete?: InputMaybe<OrganisationalUnitWhereInput>;
  disconnect?: InputMaybe<OrganisationalUnitWhereInput>;
  update?: InputMaybe<OrganisationalUnitUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<OrganisationalUnitUpsertWithoutMattersInput>;
};

export type OrganisationalUnitUpdateOneWithoutRatesNestedInput = {
  connect?: InputMaybe<OrganisationalUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganisationalUnitCreateOrConnectWithoutRatesInput>;
  create?: InputMaybe<OrganisationalUnitCreateWithoutRatesInput>;
  delete?: InputMaybe<OrganisationalUnitWhereInput>;
  disconnect?: InputMaybe<OrganisationalUnitWhereInput>;
  update?: InputMaybe<OrganisationalUnitUpdateToOneWithWhereWithoutRatesInput>;
  upsert?: InputMaybe<OrganisationalUnitUpsertWithoutRatesInput>;
};

export type OrganisationalUnitUpdateToOneWithWhereWithoutChildrenInput = {
  data: OrganisationalUnitUpdateWithoutChildrenInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpdateToOneWithWhereWithoutExternalMattersInput = {
  data: OrganisationalUnitUpdateWithoutExternalMattersInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpdateToOneWithWhereWithoutFeeEarnersInput = {
  data: OrganisationalUnitUpdateWithoutFeeEarnersInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpdateToOneWithWhereWithoutMattersInput = {
  data: OrganisationalUnitUpdateWithoutMattersInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpdateToOneWithWhereWithoutNotifyNotificationRulesInput = {
  data: OrganisationalUnitUpdateWithoutNotifyNotificationRulesInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpdateToOneWithWhereWithoutRatesInput = {
  data: OrganisationalUnitUpdateWithoutRatesInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpdateToOneWithWhereWithoutTriggeredNotificationRulesInput = {
  data: OrganisationalUnitUpdateWithoutTriggeredNotificationRulesInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpdateWithWhereUniqueWithoutDefaultOutputDesignInput = {
  data: OrganisationalUnitUpdateWithoutDefaultOutputDesignInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpdateWithWhereUniqueWithoutGroupItemInput = {
  data: OrganisationalUnitUpdateWithoutGroupItemInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpdateWithWhereUniqueWithoutLibraryAssumptionsInput = {
  data: OrganisationalUnitUpdateWithoutLibraryAssumptionsInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpdateWithWhereUniqueWithoutLibraryExclusionsInput = {
  data: OrganisationalUnitUpdateWithoutLibraryExclusionsInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpdateWithWhereUniqueWithoutParentInput = {
  data: OrganisationalUnitUpdateWithoutParentInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpdateWithoutChildrenInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutDefaultOutputDesignInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutExternalMattersInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutFeeEarnersInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutGroupItemInput = {
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutLibraryAssumptionsInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutLibraryExclusionsInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutMattersInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutNotifyNotificationRulesInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutParentInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutRatesInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpdateWithoutTriggeredNotificationRulesInput = {
  GroupItem?: InputMaybe<GroupItemUpdateOneWithoutOrganisationalUnitNestedInput>;
  children?: InputMaybe<OrganisationalUnitUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultOutputDesign?: InputMaybe<OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatters?: InputMaybe<ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarners?: InputMaybe<FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput>;
  gpmDangerThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  libraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutOrganisationalUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyUpdateManyWithoutOrganisationalUnitNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<OrganisationalUnitUpdateOneWithoutChildrenNestedInput>;
  rates?: InputMaybe<RateUpdateManyWithoutOrganisationalUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganisationalUnitUpsertWithWhereUniqueWithoutDefaultOutputDesignInput = {
  create: OrganisationalUnitCreateWithoutDefaultOutputDesignInput;
  update: OrganisationalUnitUpdateWithoutDefaultOutputDesignInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpsertWithWhereUniqueWithoutGroupItemInput = {
  create: OrganisationalUnitCreateWithoutGroupItemInput;
  update: OrganisationalUnitUpdateWithoutGroupItemInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpsertWithWhereUniqueWithoutLibraryAssumptionsInput = {
  create: OrganisationalUnitCreateWithoutLibraryAssumptionsInput;
  update: OrganisationalUnitUpdateWithoutLibraryAssumptionsInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpsertWithWhereUniqueWithoutLibraryExclusionsInput = {
  create: OrganisationalUnitCreateWithoutLibraryExclusionsInput;
  update: OrganisationalUnitUpdateWithoutLibraryExclusionsInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpsertWithWhereUniqueWithoutParentInput = {
  create: OrganisationalUnitCreateWithoutParentInput;
  update: OrganisationalUnitUpdateWithoutParentInput;
  where: OrganisationalUnitWhereUniqueInput;
};

export type OrganisationalUnitUpsertWithoutChildrenInput = {
  create: OrganisationalUnitCreateWithoutChildrenInput;
  update: OrganisationalUnitUpdateWithoutChildrenInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpsertWithoutExternalMattersInput = {
  create: OrganisationalUnitCreateWithoutExternalMattersInput;
  update: OrganisationalUnitUpdateWithoutExternalMattersInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpsertWithoutFeeEarnersInput = {
  create: OrganisationalUnitCreateWithoutFeeEarnersInput;
  update: OrganisationalUnitUpdateWithoutFeeEarnersInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpsertWithoutMattersInput = {
  create: OrganisationalUnitCreateWithoutMattersInput;
  update: OrganisationalUnitUpdateWithoutMattersInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpsertWithoutNotifyNotificationRulesInput = {
  create: OrganisationalUnitCreateWithoutNotifyNotificationRulesInput;
  update: OrganisationalUnitUpdateWithoutNotifyNotificationRulesInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpsertWithoutRatesInput = {
  create: OrganisationalUnitCreateWithoutRatesInput;
  update: OrganisationalUnitUpdateWithoutRatesInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitUpsertWithoutTriggeredNotificationRulesInput = {
  create: OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput;
  update: OrganisationalUnitUpdateWithoutTriggeredNotificationRulesInput;
  where?: InputMaybe<OrganisationalUnitWhereInput>;
};

export type OrganisationalUnitWhereInput = {
  AND?: InputMaybe<Array<OrganisationalUnitWhereInput>>;
  GroupItem?: InputMaybe<GroupItemNullableRelationFilter>;
  NOT?: InputMaybe<Array<OrganisationalUnitWhereInput>>;
  OR?: InputMaybe<Array<OrganisationalUnitWhereInput>>;
  children?: InputMaybe<OrganisationalUnitListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultDesignId?: InputMaybe<IntNullableFilter>;
  defaultOutputDesign?: InputMaybe<OutputDesignNullableRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatters?: InputMaybe<ExternalMatterListRelationFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarners?: InputMaybe<FeeEarnerListRelationFilter>;
  gpmDangerThreshold?: InputMaybe<IntNullableFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionListRelationFilter>;
  libraryExclusions?: InputMaybe<LibraryExclusionListRelationFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  parent?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrganisationalUnitWhereUniqueInput = {
  AND?: InputMaybe<Array<OrganisationalUnitWhereInput>>;
  GroupItem?: InputMaybe<GroupItemNullableRelationFilter>;
  NOT?: InputMaybe<Array<OrganisationalUnitWhereInput>>;
  OR?: InputMaybe<Array<OrganisationalUnitWhereInput>>;
  children?: InputMaybe<OrganisationalUnitListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultDesignId?: InputMaybe<IntNullableFilter>;
  defaultOutputDesign?: InputMaybe<OutputDesignNullableRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatters?: InputMaybe<ExternalMatterListRelationFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarners?: InputMaybe<FeeEarnerListRelationFilter>;
  gpmDangerThreshold?: InputMaybe<IntNullableFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryAssumptions?: InputMaybe<LibraryAssumptionListRelationFilter>;
  libraryExclusions?: InputMaybe<LibraryExclusionListRelationFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  notifyNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsNotifyListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  parent?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  rates?: InputMaybe<RateListRelationFilter>;
  triggeredNotificationRules?: InputMaybe<NotificationRuleOrganisationalUnitsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OutputDesign = {
  __typename?: 'OutputDesign';
  active: Scalars['Boolean']['output'];
  contentAfterUrl: Maybe<Scalars['String']['output']>;
  contentBeforeUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdByUserId: Scalars['Int']['output'];
  default: Scalars['Boolean']['output'];
  defaultForOrgUnits: Maybe<Array<OrganisationalUnit>>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  description: Maybe<Scalars['String']['output']>;
  footerImageUrl: Maybe<Scalars['String']['output']>;
  groupItemId: Maybe<Scalars['Int']['output']>;
  groupItems: Maybe<Array<GroupItem>>;
  headerImageUrl: Maybe<Scalars['String']['output']>;
  htmlContent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  removeTemplateMargin: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: OutputDesignType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OutputDesignCreateInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutDesignTemplateInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutDesignTemplateInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutDefaultOutputDesignInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOutputDesignsInput>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignCreateManyCreatedByUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupItemId?: InputMaybe<Scalars['Int']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignCreateManyCreatedByUserInputEnvelope = {
  data: Array<OutputDesignCreateManyCreatedByUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OutputDesignCreateManyGroupItemInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignCreateManyGroupItemInputEnvelope = {
  data: Array<OutputDesignCreateManyGroupItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OutputDesignCreateNestedManyWithoutCreatedByUserInput = {
  connect?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OutputDesignCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<OutputDesignCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<OutputDesignCreateManyCreatedByUserInputEnvelope>;
};

export type OutputDesignCreateNestedManyWithoutGroupItemInput = {
  connect?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OutputDesignCreateOrConnectWithoutGroupItemInput>>;
  create?: InputMaybe<Array<OutputDesignCreateWithoutGroupItemInput>>;
  createMany?: InputMaybe<OutputDesignCreateManyGroupItemInputEnvelope>;
};

export type OutputDesignCreateNestedOneWithoutClientReportOutputInput = {
  connect?: InputMaybe<OutputDesignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OutputDesignCreateOrConnectWithoutClientReportOutputInput>;
  create?: InputMaybe<OutputDesignCreateWithoutClientReportOutputInput>;
};

export type OutputDesignCreateNestedOneWithoutDefaultForOrgUnitsInput = {
  connect?: InputMaybe<OutputDesignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OutputDesignCreateOrConnectWithoutDefaultForOrgUnitsInput>;
  create?: InputMaybe<OutputDesignCreateWithoutDefaultForOrgUnitsInput>;
};

export type OutputDesignCreateNestedOneWithoutProposalOutputInput = {
  connect?: InputMaybe<OutputDesignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OutputDesignCreateOrConnectWithoutProposalOutputInput>;
  create?: InputMaybe<OutputDesignCreateWithoutProposalOutputInput>;
};

export type OutputDesignCreateOrConnectWithoutClientReportOutputInput = {
  create: OutputDesignCreateWithoutClientReportOutputInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignCreateOrConnectWithoutCreatedByUserInput = {
  create: OutputDesignCreateWithoutCreatedByUserInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignCreateOrConnectWithoutDefaultForOrgUnitsInput = {
  create: OutputDesignCreateWithoutDefaultForOrgUnitsInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignCreateOrConnectWithoutGroupItemInput = {
  create: OutputDesignCreateWithoutGroupItemInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignCreateOrConnectWithoutProposalOutputInput = {
  create: OutputDesignCreateWithoutProposalOutputInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignCreateWithoutClientReportOutputInput = {
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutDesignTemplateInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutDefaultOutputDesignInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOutputDesignsInput>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignCreateWithoutCreatedByUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutDesignTemplateInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutDesignTemplateInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutDefaultOutputDesignInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOutputDesignsInput>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignCreateWithoutDefaultForOrgUnitsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutDesignTemplateInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutDesignTemplateInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOutputDesignsInput>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignCreateWithoutGroupItemInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutDesignTemplateInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutDesignTemplateInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutDefaultOutputDesignInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignCreateWithoutProposalOutputInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutDesignTemplateInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentAfterUrl?: InputMaybe<Scalars['String']['input']>;
  contentBeforeUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitCreateNestedManyWithoutDefaultOutputDesignInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footerImageUrl?: InputMaybe<Scalars['String']['input']>;
  groupItem?: InputMaybe<GroupItemCreateNestedOneWithoutOutputDesignsInput>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  removeTemplateMargin?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OutputDesignType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OutputDesignListRelationFilter = {
  every?: InputMaybe<OutputDesignWhereInput>;
  none?: InputMaybe<OutputDesignWhereInput>;
  some?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignNullableRelationFilter = {
  is?: InputMaybe<OutputDesignWhereInput>;
  isNot?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignRelationFilter = {
  is?: InputMaybe<OutputDesignWhereInput>;
  isNot?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignScalarWhereInput = {
  AND?: InputMaybe<Array<OutputDesignScalarWhereInput>>;
  NOT?: InputMaybe<Array<OutputDesignScalarWhereInput>>;
  OR?: InputMaybe<Array<OutputDesignScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  contentAfterUrl?: InputMaybe<StringNullableFilter>;
  contentBeforeUrl?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  footerImageUrl?: InputMaybe<StringNullableFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  headerImageUrl?: InputMaybe<StringNullableFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  removeTemplateMargin?: InputMaybe<BoolFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumOutputDesignTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum OutputDesignType {
  ClientReport = 'ClientReport',
  Proposal = 'Proposal',
  TextBlock = 'TextBlock'
}

export type OutputDesignUpdateInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutDesignTemplateNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutDesignTemplateNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contentAfterUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentBeforeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutDefaultOutputDesignNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  footerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupItem?: InputMaybe<GroupItemUpdateOneWithoutOutputDesignsNestedInput>;
  headerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  removeTemplateMargin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOutputDesignTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OutputDesignUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contentAfterUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentBeforeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  footerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  headerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  removeTemplateMargin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOutputDesignTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OutputDesignUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: OutputDesignUpdateManyMutationInput;
  where: OutputDesignScalarWhereInput;
};

export type OutputDesignUpdateManyWithWhereWithoutGroupItemInput = {
  data: OutputDesignUpdateManyMutationInput;
  where: OutputDesignScalarWhereInput;
};

export type OutputDesignUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OutputDesignCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<OutputDesignCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<OutputDesignCreateManyCreatedByUserInputEnvelope>;
  delete?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OutputDesignScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  set?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  update?: InputMaybe<Array<OutputDesignUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: InputMaybe<Array<OutputDesignUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: InputMaybe<Array<OutputDesignUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type OutputDesignUpdateManyWithoutGroupItemNestedInput = {
  connect?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OutputDesignCreateOrConnectWithoutGroupItemInput>>;
  create?: InputMaybe<Array<OutputDesignCreateWithoutGroupItemInput>>;
  createMany?: InputMaybe<OutputDesignCreateManyGroupItemInputEnvelope>;
  delete?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OutputDesignScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  set?: InputMaybe<Array<OutputDesignWhereUniqueInput>>;
  update?: InputMaybe<Array<OutputDesignUpdateWithWhereUniqueWithoutGroupItemInput>>;
  updateMany?: InputMaybe<Array<OutputDesignUpdateManyWithWhereWithoutGroupItemInput>>;
  upsert?: InputMaybe<Array<OutputDesignUpsertWithWhereUniqueWithoutGroupItemInput>>;
};

export type OutputDesignUpdateOneRequiredWithoutClientReportOutputNestedInput = {
  connect?: InputMaybe<OutputDesignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OutputDesignCreateOrConnectWithoutClientReportOutputInput>;
  create?: InputMaybe<OutputDesignCreateWithoutClientReportOutputInput>;
  update?: InputMaybe<OutputDesignUpdateToOneWithWhereWithoutClientReportOutputInput>;
  upsert?: InputMaybe<OutputDesignUpsertWithoutClientReportOutputInput>;
};

export type OutputDesignUpdateOneRequiredWithoutProposalOutputNestedInput = {
  connect?: InputMaybe<OutputDesignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OutputDesignCreateOrConnectWithoutProposalOutputInput>;
  create?: InputMaybe<OutputDesignCreateWithoutProposalOutputInput>;
  update?: InputMaybe<OutputDesignUpdateToOneWithWhereWithoutProposalOutputInput>;
  upsert?: InputMaybe<OutputDesignUpsertWithoutProposalOutputInput>;
};

export type OutputDesignUpdateOneWithoutDefaultForOrgUnitsNestedInput = {
  connect?: InputMaybe<OutputDesignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OutputDesignCreateOrConnectWithoutDefaultForOrgUnitsInput>;
  create?: InputMaybe<OutputDesignCreateWithoutDefaultForOrgUnitsInput>;
  delete?: InputMaybe<OutputDesignWhereInput>;
  disconnect?: InputMaybe<OutputDesignWhereInput>;
  update?: InputMaybe<OutputDesignUpdateToOneWithWhereWithoutDefaultForOrgUnitsInput>;
  upsert?: InputMaybe<OutputDesignUpsertWithoutDefaultForOrgUnitsInput>;
};

export type OutputDesignUpdateToOneWithWhereWithoutClientReportOutputInput = {
  data: OutputDesignUpdateWithoutClientReportOutputInput;
  where?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignUpdateToOneWithWhereWithoutDefaultForOrgUnitsInput = {
  data: OutputDesignUpdateWithoutDefaultForOrgUnitsInput;
  where?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignUpdateToOneWithWhereWithoutProposalOutputInput = {
  data: OutputDesignUpdateWithoutProposalOutputInput;
  where?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: OutputDesignUpdateWithoutCreatedByUserInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignUpdateWithWhereUniqueWithoutGroupItemInput = {
  data: OutputDesignUpdateWithoutGroupItemInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignUpdateWithoutClientReportOutputInput = {
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutDesignTemplateNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contentAfterUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentBeforeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutDefaultOutputDesignNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  footerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupItem?: InputMaybe<GroupItemUpdateOneWithoutOutputDesignsNestedInput>;
  headerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  removeTemplateMargin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOutputDesignTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OutputDesignUpdateWithoutCreatedByUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutDesignTemplateNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutDesignTemplateNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contentAfterUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentBeforeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutDefaultOutputDesignNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  footerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupItem?: InputMaybe<GroupItemUpdateOneWithoutOutputDesignsNestedInput>;
  headerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  removeTemplateMargin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOutputDesignTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OutputDesignUpdateWithoutDefaultForOrgUnitsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutDesignTemplateNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutDesignTemplateNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contentAfterUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentBeforeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  footerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupItem?: InputMaybe<GroupItemUpdateOneWithoutOutputDesignsNestedInput>;
  headerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  removeTemplateMargin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOutputDesignTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OutputDesignUpdateWithoutGroupItemInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutDesignTemplateNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutDesignTemplateNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contentAfterUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentBeforeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutDefaultOutputDesignNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  footerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  headerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  removeTemplateMargin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOutputDesignTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OutputDesignUpdateWithoutProposalOutputInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutDesignTemplateNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contentAfterUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentBeforeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  default?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitUpdateManyWithoutDefaultOutputDesignNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  footerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupItem?: InputMaybe<GroupItemUpdateOneWithoutOutputDesignsNestedInput>;
  headerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  removeTemplateMargin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOutputDesignTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OutputDesignUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: OutputDesignCreateWithoutCreatedByUserInput;
  update: OutputDesignUpdateWithoutCreatedByUserInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignUpsertWithWhereUniqueWithoutGroupItemInput = {
  create: OutputDesignCreateWithoutGroupItemInput;
  update: OutputDesignUpdateWithoutGroupItemInput;
  where: OutputDesignWhereUniqueInput;
};

export type OutputDesignUpsertWithoutClientReportOutputInput = {
  create: OutputDesignCreateWithoutClientReportOutputInput;
  update: OutputDesignUpdateWithoutClientReportOutputInput;
  where?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignUpsertWithoutDefaultForOrgUnitsInput = {
  create: OutputDesignCreateWithoutDefaultForOrgUnitsInput;
  update: OutputDesignUpdateWithoutDefaultForOrgUnitsInput;
  where?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignUpsertWithoutProposalOutputInput = {
  create: OutputDesignCreateWithoutProposalOutputInput;
  update: OutputDesignUpdateWithoutProposalOutputInput;
  where?: InputMaybe<OutputDesignWhereInput>;
};

export type OutputDesignWhereInput = {
  AND?: InputMaybe<Array<OutputDesignWhereInput>>;
  ClientReportOutput?: InputMaybe<ClientReportOutputListRelationFilter>;
  NOT?: InputMaybe<Array<OutputDesignWhereInput>>;
  OR?: InputMaybe<Array<OutputDesignWhereInput>>;
  ProposalOutput?: InputMaybe<ProposalOutputListRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  contentAfterUrl?: InputMaybe<StringNullableFilter>;
  contentBeforeUrl?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolFilter>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  footerImageUrl?: InputMaybe<StringNullableFilter>;
  groupItem?: InputMaybe<GroupItemNullableRelationFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  headerImageUrl?: InputMaybe<StringNullableFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  removeTemplateMargin?: InputMaybe<BoolFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumOutputDesignTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OutputDesignWhereUniqueInput = {
  AND?: InputMaybe<Array<OutputDesignWhereInput>>;
  ClientReportOutput?: InputMaybe<ClientReportOutputListRelationFilter>;
  NOT?: InputMaybe<Array<OutputDesignWhereInput>>;
  OR?: InputMaybe<Array<OutputDesignWhereInput>>;
  ProposalOutput?: InputMaybe<ProposalOutputListRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  contentAfterUrl?: InputMaybe<StringNullableFilter>;
  contentBeforeUrl?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  default?: InputMaybe<BoolFilter>;
  defaultForOrgUnits?: InputMaybe<OrganisationalUnitListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  footerImageUrl?: InputMaybe<StringNullableFilter>;
  groupItem?: InputMaybe<GroupItemNullableRelationFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  headerImageUrl?: InputMaybe<StringNullableFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  removeTemplateMargin?: InputMaybe<BoolFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumOutputDesignTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PdfAttachment = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  outputDesignId: Scalars['Float']['input'];
  pdfAttachment: Scalars['Upload']['input'];
};

export type PdfOptions = {
  __typename?: 'PDFOptions';
  contentAfterName: Maybe<Scalars['String']['output']>;
  contentBeforeName: Maybe<Scalars['String']['output']>;
  footerImageName: Maybe<Scalars['String']['output']>;
  headerImageName: Maybe<Scalars['String']['output']>;
};

export type PaginatedDataImportRecords = {
  __typename?: 'PaginatedDataImportRecords';
  items: Array<DataImportRecord>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedMatterTemplates = {
  __typename?: 'PaginatedMatterTemplates';
  items: Array<Matter>;
  total: Scalars['Int']['output'];
};

export type ParentMatter = {
  __typename?: 'ParentMatter';
  brandId: Maybe<Scalars['Int']['output']>;
  client: Client;
  clientId: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdById: Scalars['Int']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  deletedById: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  includeFeeEarnersInProposalOutput: Maybe<Scalars['Boolean']['output']>;
  includeRatesInProposalOutput: Maybe<Scalars['Boolean']['output']>;
  includeTasksInProposalOutput: Maybe<Scalars['Boolean']['output']>;
  matters: Array<Matter>;
  phases: Array<ParentMatterPhase>;
  reference: Scalars['String']['output'];
  status: MatterStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  upliftsDiscountsDisbursements: AllItemsResult;
};

export type ParentMatterCreateManyBrandInput = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateManyBrandInputEnvelope = {
  data: Array<ParentMatterCreateManyBrandInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParentMatterCreateManyClientInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateManyClientInputEnvelope = {
  data: Array<ParentMatterCreateManyClientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParentMatterCreateManyCreatedByInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedById?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateManyCreatedByInputEnvelope = {
  data: Array<ParentMatterCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParentMatterCreateManyDeletedByInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateManyDeletedByInputEnvelope = {
  data: Array<ParentMatterCreateManyDeletedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParentMatterCreateNestedManyWithoutBrandInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutBrandInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutBrandInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyBrandInputEnvelope>;
};

export type ParentMatterCreateNestedManyWithoutClientInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutClientInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyClientInputEnvelope>;
};

export type ParentMatterCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyCreatedByInputEnvelope>;
};

export type ParentMatterCreateNestedManyWithoutDeletedByInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutDeletedByInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutDeletedByInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyDeletedByInputEnvelope>;
};

export type ParentMatterCreateNestedOneWithoutCollaboratorsInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutCollaboratorsInput>;
  create?: InputMaybe<ParentMatterCreateWithoutCollaboratorsInput>;
};

export type ParentMatterCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<ParentMatterCreateWithoutMattersInput>;
};

export type ParentMatterCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<ParentMatterCreateWithoutNotificationsInput>;
};

export type ParentMatterCreateNestedOneWithoutPhasesInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutPhasesInput>;
  create?: InputMaybe<ParentMatterCreateWithoutPhasesInput>;
};

export type ParentMatterCreateOrConnectWithoutBrandInput = {
  create: ParentMatterCreateWithoutBrandInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateOrConnectWithoutClientInput = {
  create: ParentMatterCreateWithoutClientInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateOrConnectWithoutCollaboratorsInput = {
  create: ParentMatterCreateWithoutCollaboratorsInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateOrConnectWithoutCreatedByInput = {
  create: ParentMatterCreateWithoutCreatedByInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateOrConnectWithoutDeletedByInput = {
  create: ParentMatterCreateWithoutDeletedByInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateOrConnectWithoutMattersInput = {
  create: ParentMatterCreateWithoutMattersInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateOrConnectWithoutNotificationsInput = {
  create: ParentMatterCreateWithoutNotificationsInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateOrConnectWithoutPhasesInput = {
  create: ParentMatterCreateWithoutPhasesInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterCreateWithoutBrandInput = {
  client?: InputMaybe<ClientCreateNestedOneWithoutParentMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedParentMattersInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutParentMatterInput>;
  phases?: InputMaybe<ParentMatterPhaseCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateWithoutClientInput = {
  brand?: InputMaybe<BrandCreateNestedOneWithoutParentMattersInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedParentMattersInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutParentMatterInput>;
  phases?: InputMaybe<ParentMatterPhaseCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateWithoutCollaboratorsInput = {
  brand?: InputMaybe<BrandCreateNestedOneWithoutParentMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedParentMattersInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutParentMatterInput>;
  phases?: InputMaybe<ParentMatterPhaseCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateWithoutCreatedByInput = {
  brand?: InputMaybe<BrandCreateNestedOneWithoutParentMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutParentMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedParentMattersInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutParentMatterInput>;
  phases?: InputMaybe<ParentMatterPhaseCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateWithoutDeletedByInput = {
  brand?: InputMaybe<BrandCreateNestedOneWithoutParentMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutParentMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutParentMatterInput>;
  phases?: InputMaybe<ParentMatterPhaseCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateWithoutMattersInput = {
  brand?: InputMaybe<BrandCreateNestedOneWithoutParentMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutParentMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedParentMattersInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutParentMatterInput>;
  phases?: InputMaybe<ParentMatterPhaseCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateWithoutNotificationsInput = {
  brand?: InputMaybe<BrandCreateNestedOneWithoutParentMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutParentMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedParentMattersInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentInput>;
  phases?: InputMaybe<ParentMatterPhaseCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterCreateWithoutPhasesInput = {
  brand?: InputMaybe<BrandCreateNestedOneWithoutParentMattersInput>;
  client?: InputMaybe<ClientCreateNestedOneWithoutParentMatterInput>;
  collaborators?: InputMaybe<CollaboratorCreateNestedManyWithoutParentMatterInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedBy?: InputMaybe<UserCreateNestedOneWithoutDeletedParentMattersInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeRatesInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutParentMatterInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MatterStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterListRelationFilter = {
  every?: InputMaybe<ParentMatterWhereInput>;
  none?: InputMaybe<ParentMatterWhereInput>;
  some?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterNullableRelationFilter = {
  is?: InputMaybe<ParentMatterWhereInput>;
  isNot?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterPhase = {
  __typename?: 'ParentMatterPhase';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  includeInProposalOutput: Maybe<Scalars['Boolean']['output']>;
  matters: Array<Matter>;
  order: Scalars['Int']['output'];
  parentMatterId: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ParentMatterPhaseCreateManyParentMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterPhaseCreateManyParentMatterInputEnvelope = {
  data: Array<ParentMatterPhaseCreateManyParentMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParentMatterPhaseCreateNestedManyWithoutParentMatterInput = {
  connect?: InputMaybe<Array<ParentMatterPhaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterPhaseCreateOrConnectWithoutParentMatterInput>>;
  create?: InputMaybe<Array<ParentMatterPhaseCreateWithoutParentMatterInput>>;
  createMany?: InputMaybe<ParentMatterPhaseCreateManyParentMatterInputEnvelope>;
};

export type ParentMatterPhaseCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<ParentMatterPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterPhaseCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<ParentMatterPhaseCreateWithoutMattersInput>;
};

export type ParentMatterPhaseCreateOrConnectWithoutMattersInput = {
  create: ParentMatterPhaseCreateWithoutMattersInput;
  where: ParentMatterPhaseWhereUniqueInput;
};

export type ParentMatterPhaseCreateOrConnectWithoutParentMatterInput = {
  create: ParentMatterPhaseCreateWithoutParentMatterInput;
  where: ParentMatterPhaseWhereUniqueInput;
};

export type ParentMatterPhaseCreateWithoutMattersInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  includeInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  parentMatter: ParentMatterCreateNestedOneWithoutPhasesInput;
  reference?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterPhaseCreateWithoutParentMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  includeInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutParentMatterPhaseInput>;
  order: Scalars['Int']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ParentMatterPhaseListRelationFilter = {
  every?: InputMaybe<ParentMatterPhaseWhereInput>;
  none?: InputMaybe<ParentMatterPhaseWhereInput>;
  some?: InputMaybe<ParentMatterPhaseWhereInput>;
};

export type ParentMatterPhaseNullableRelationFilter = {
  is?: InputMaybe<ParentMatterPhaseWhereInput>;
  isNot?: InputMaybe<ParentMatterPhaseWhereInput>;
};

export type ParentMatterPhaseScalarWhereInput = {
  AND?: InputMaybe<Array<ParentMatterPhaseScalarWhereInput>>;
  NOT?: InputMaybe<Array<ParentMatterPhaseScalarWhereInput>>;
  OR?: InputMaybe<Array<ParentMatterPhaseScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeInProposalOutput?: InputMaybe<BoolNullableFilter>;
  order?: InputMaybe<IntFilter>;
  parentMatterId?: InputMaybe<IntFilter>;
  reference?: InputMaybe<UuidFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParentMatterPhaseUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterPhaseUpdateManyWithWhereWithoutParentMatterInput = {
  data: ParentMatterPhaseUpdateManyMutationInput;
  where: ParentMatterPhaseScalarWhereInput;
};

export type ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput = {
  connect?: InputMaybe<Array<ParentMatterPhaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterPhaseCreateOrConnectWithoutParentMatterInput>>;
  create?: InputMaybe<Array<ParentMatterPhaseCreateWithoutParentMatterInput>>;
  createMany?: InputMaybe<ParentMatterPhaseCreateManyParentMatterInputEnvelope>;
  delete?: InputMaybe<Array<ParentMatterPhaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ParentMatterPhaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ParentMatterPhaseWhereUniqueInput>>;
  set?: InputMaybe<Array<ParentMatterPhaseWhereUniqueInput>>;
  update?: InputMaybe<Array<ParentMatterPhaseUpdateWithWhereUniqueWithoutParentMatterInput>>;
  updateMany?: InputMaybe<Array<ParentMatterPhaseUpdateManyWithWhereWithoutParentMatterInput>>;
  upsert?: InputMaybe<Array<ParentMatterPhaseUpsertWithWhereUniqueWithoutParentMatterInput>>;
};

export type ParentMatterPhaseUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<ParentMatterPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterPhaseCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<ParentMatterPhaseCreateWithoutMattersInput>;
  delete?: InputMaybe<ParentMatterPhaseWhereInput>;
  disconnect?: InputMaybe<ParentMatterPhaseWhereInput>;
  update?: InputMaybe<ParentMatterPhaseUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<ParentMatterPhaseUpsertWithoutMattersInput>;
};

export type ParentMatterPhaseUpdateToOneWithWhereWithoutMattersInput = {
  data: ParentMatterPhaseUpdateWithoutMattersInput;
  where?: InputMaybe<ParentMatterPhaseWhereInput>;
};

export type ParentMatterPhaseUpdateWithWhereUniqueWithoutParentMatterInput = {
  data: ParentMatterPhaseUpdateWithoutParentMatterInput;
  where: ParentMatterPhaseWhereUniqueInput;
};

export type ParentMatterPhaseUpdateWithoutMattersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentMatter?: InputMaybe<ParentMatterUpdateOneRequiredWithoutPhasesNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterPhaseUpdateWithoutParentMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentMatterPhaseNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterPhaseUpsertWithWhereUniqueWithoutParentMatterInput = {
  create: ParentMatterPhaseCreateWithoutParentMatterInput;
  update: ParentMatterPhaseUpdateWithoutParentMatterInput;
  where: ParentMatterPhaseWhereUniqueInput;
};

export type ParentMatterPhaseUpsertWithoutMattersInput = {
  create: ParentMatterPhaseCreateWithoutMattersInput;
  update: ParentMatterPhaseUpdateWithoutMattersInput;
  where?: InputMaybe<ParentMatterPhaseWhereInput>;
};

export type ParentMatterPhaseWhereInput = {
  AND?: InputMaybe<Array<ParentMatterPhaseWhereInput>>;
  NOT?: InputMaybe<Array<ParentMatterPhaseWhereInput>>;
  OR?: InputMaybe<Array<ParentMatterPhaseWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeInProposalOutput?: InputMaybe<BoolNullableFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  parentMatter?: InputMaybe<ParentMatterRelationFilter>;
  parentMatterId?: InputMaybe<IntFilter>;
  reference?: InputMaybe<UuidFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParentMatterPhaseWhereUniqueInput = {
  AND?: InputMaybe<Array<ParentMatterPhaseWhereInput>>;
  NOT?: InputMaybe<Array<ParentMatterPhaseWhereInput>>;
  OR?: InputMaybe<Array<ParentMatterPhaseWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeInProposalOutput?: InputMaybe<BoolNullableFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  parentMatter?: InputMaybe<ParentMatterRelationFilter>;
  parentMatterId?: InputMaybe<IntFilter>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParentMatterRelationFilter = {
  is?: InputMaybe<ParentMatterWhereInput>;
  isNot?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterScalarWhereInput = {
  AND?: InputMaybe<Array<ParentMatterScalarWhereInput>>;
  NOT?: InputMaybe<Array<ParentMatterScalarWhereInput>>;
  OR?: InputMaybe<Array<ParentMatterScalarWhereInput>>;
  brandId?: InputMaybe<IntNullableFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedById?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeFeeEarnersInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeRatesInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumMatterStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParentMatterUpdateInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateManyWithWhereWithoutBrandInput = {
  data: ParentMatterUpdateManyMutationInput;
  where: ParentMatterScalarWhereInput;
};

export type ParentMatterUpdateManyWithWhereWithoutClientInput = {
  data: ParentMatterUpdateManyMutationInput;
  where: ParentMatterScalarWhereInput;
};

export type ParentMatterUpdateManyWithWhereWithoutCreatedByInput = {
  data: ParentMatterUpdateManyMutationInput;
  where: ParentMatterScalarWhereInput;
};

export type ParentMatterUpdateManyWithWhereWithoutDeletedByInput = {
  data: ParentMatterUpdateManyMutationInput;
  where: ParentMatterScalarWhereInput;
};

export type ParentMatterUpdateManyWithoutBrandNestedInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutBrandInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutBrandInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyBrandInputEnvelope>;
  delete?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ParentMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ParentMatterUpdateWithWhereUniqueWithoutBrandInput>>;
  updateMany?: InputMaybe<Array<ParentMatterUpdateManyWithWhereWithoutBrandInput>>;
  upsert?: InputMaybe<Array<ParentMatterUpsertWithWhereUniqueWithoutBrandInput>>;
};

export type ParentMatterUpdateManyWithoutClientNestedInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutClientInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyClientInputEnvelope>;
  delete?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ParentMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ParentMatterUpdateWithWhereUniqueWithoutClientInput>>;
  updateMany?: InputMaybe<Array<ParentMatterUpdateManyWithWhereWithoutClientInput>>;
  upsert?: InputMaybe<Array<ParentMatterUpsertWithWhereUniqueWithoutClientInput>>;
};

export type ParentMatterUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ParentMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ParentMatterUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<ParentMatterUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<ParentMatterUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type ParentMatterUpdateManyWithoutDeletedByNestedInput = {
  connect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParentMatterCreateOrConnectWithoutDeletedByInput>>;
  create?: InputMaybe<Array<ParentMatterCreateWithoutDeletedByInput>>;
  createMany?: InputMaybe<ParentMatterCreateManyDeletedByInputEnvelope>;
  delete?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ParentMatterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  set?: InputMaybe<Array<ParentMatterWhereUniqueInput>>;
  update?: InputMaybe<Array<ParentMatterUpdateWithWhereUniqueWithoutDeletedByInput>>;
  updateMany?: InputMaybe<Array<ParentMatterUpdateManyWithWhereWithoutDeletedByInput>>;
  upsert?: InputMaybe<Array<ParentMatterUpsertWithWhereUniqueWithoutDeletedByInput>>;
};

export type ParentMatterUpdateOneRequiredWithoutPhasesNestedInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutPhasesInput>;
  create?: InputMaybe<ParentMatterCreateWithoutPhasesInput>;
  update?: InputMaybe<ParentMatterUpdateToOneWithWhereWithoutPhasesInput>;
  upsert?: InputMaybe<ParentMatterUpsertWithoutPhasesInput>;
};

export type ParentMatterUpdateOneWithoutCollaboratorsNestedInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutCollaboratorsInput>;
  create?: InputMaybe<ParentMatterCreateWithoutCollaboratorsInput>;
  delete?: InputMaybe<ParentMatterWhereInput>;
  disconnect?: InputMaybe<ParentMatterWhereInput>;
  update?: InputMaybe<ParentMatterUpdateToOneWithWhereWithoutCollaboratorsInput>;
  upsert?: InputMaybe<ParentMatterUpsertWithoutCollaboratorsInput>;
};

export type ParentMatterUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<ParentMatterCreateWithoutMattersInput>;
  delete?: InputMaybe<ParentMatterWhereInput>;
  disconnect?: InputMaybe<ParentMatterWhereInput>;
  update?: InputMaybe<ParentMatterUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<ParentMatterUpsertWithoutMattersInput>;
};

export type ParentMatterUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<ParentMatterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ParentMatterCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<ParentMatterCreateWithoutNotificationsInput>;
  delete?: InputMaybe<ParentMatterWhereInput>;
  disconnect?: InputMaybe<ParentMatterWhereInput>;
  update?: InputMaybe<ParentMatterUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<ParentMatterUpsertWithoutNotificationsInput>;
};

export type ParentMatterUpdateToOneWithWhereWithoutCollaboratorsInput = {
  data: ParentMatterUpdateWithoutCollaboratorsInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterUpdateToOneWithWhereWithoutMattersInput = {
  data: ParentMatterUpdateWithoutMattersInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterUpdateToOneWithWhereWithoutNotificationsInput = {
  data: ParentMatterUpdateWithoutNotificationsInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterUpdateToOneWithWhereWithoutPhasesInput = {
  data: ParentMatterUpdateWithoutPhasesInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterUpdateWithWhereUniqueWithoutBrandInput = {
  data: ParentMatterUpdateWithoutBrandInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpdateWithWhereUniqueWithoutClientInput = {
  data: ParentMatterUpdateWithoutClientInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: ParentMatterUpdateWithoutCreatedByInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpdateWithWhereUniqueWithoutDeletedByInput = {
  data: ParentMatterUpdateWithoutDeletedByInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpdateWithoutBrandInput = {
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateWithoutClientInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateWithoutCollaboratorsInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateWithoutCreatedByInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateWithoutDeletedByInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateWithoutMattersInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateWithoutNotificationsInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  phases?: InputMaybe<ParentMatterPhaseUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpdateWithoutPhasesInput = {
  brand?: InputMaybe<BrandUpdateOneWithoutParentMattersNestedInput>;
  client?: InputMaybe<ClientUpdateOneWithoutParentMatterNestedInput>;
  collaborators?: InputMaybe<CollaboratorUpdateManyWithoutParentMatterNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<UserUpdateOneWithoutDeletedParentMattersNestedInput>;
  includeFeeEarnersInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeRatesInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  includeTasksInProposalOutput?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutParentNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutParentMatterNestedInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMatterStatusFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParentMatterUpsertWithWhereUniqueWithoutBrandInput = {
  create: ParentMatterCreateWithoutBrandInput;
  update: ParentMatterUpdateWithoutBrandInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpsertWithWhereUniqueWithoutClientInput = {
  create: ParentMatterCreateWithoutClientInput;
  update: ParentMatterUpdateWithoutClientInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: ParentMatterCreateWithoutCreatedByInput;
  update: ParentMatterUpdateWithoutCreatedByInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpsertWithWhereUniqueWithoutDeletedByInput = {
  create: ParentMatterCreateWithoutDeletedByInput;
  update: ParentMatterUpdateWithoutDeletedByInput;
  where: ParentMatterWhereUniqueInput;
};

export type ParentMatterUpsertWithoutCollaboratorsInput = {
  create: ParentMatterCreateWithoutCollaboratorsInput;
  update: ParentMatterUpdateWithoutCollaboratorsInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterUpsertWithoutMattersInput = {
  create: ParentMatterCreateWithoutMattersInput;
  update: ParentMatterUpdateWithoutMattersInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterUpsertWithoutNotificationsInput = {
  create: ParentMatterCreateWithoutNotificationsInput;
  update: ParentMatterUpdateWithoutNotificationsInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterUpsertWithoutPhasesInput = {
  create: ParentMatterCreateWithoutPhasesInput;
  update: ParentMatterUpdateWithoutPhasesInput;
  where?: InputMaybe<ParentMatterWhereInput>;
};

export type ParentMatterWhereInput = {
  AND?: InputMaybe<Array<ParentMatterWhereInput>>;
  NOT?: InputMaybe<Array<ParentMatterWhereInput>>;
  OR?: InputMaybe<Array<ParentMatterWhereInput>>;
  brand?: InputMaybe<BrandNullableRelationFilter>;
  brandId?: InputMaybe<IntNullableFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  collaborators?: InputMaybe<CollaboratorListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<UserNullableRelationFilter>;
  deletedById?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeFeeEarnersInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeRatesInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolNullableFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  phases?: InputMaybe<ParentMatterPhaseListRelationFilter>;
  reference?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumMatterStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParentMatterWhereUniqueInput = {
  AND?: InputMaybe<Array<ParentMatterWhereInput>>;
  NOT?: InputMaybe<Array<ParentMatterWhereInput>>;
  OR?: InputMaybe<Array<ParentMatterWhereInput>>;
  brand?: InputMaybe<BrandNullableRelationFilter>;
  brandId?: InputMaybe<IntNullableFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  collaborators?: InputMaybe<CollaboratorListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<UserNullableRelationFilter>;
  deletedById?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeFeeEarnersInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeRatesInProposalOutput?: InputMaybe<BoolNullableFilter>;
  includeTasksInProposalOutput?: InputMaybe<BoolNullableFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  phases?: InputMaybe<ParentMatterPhaseListRelationFilter>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumMatterStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParentProposalResult = {
  __typename?: 'ParentProposalResult';
  collated: Proposal;
  items: Array<Proposal>;
};

export type PercentageRange = {
  __typename?: 'PercentageRange';
  lower: Scalars['Float']['output'];
  upper: Scalars['Float']['output'];
};

export type PerformanceResult = {
  __typename?: 'PerformanceResult';
  mattersPerArea: Array<MattersByAreaPerformance>;
  mattersStatus: Array<MattersStatusPerformance>;
};

export type Phase = {
  __typename?: 'Phase';
  autoFocus: Maybe<Scalars['Boolean']['output']>;
  completionPercentage: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deadlineDate: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  html: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  markedComplete: Scalars['Boolean']['output'];
  matterId: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  priceOptions: Maybe<PriceOptions>;
  priceOptionsId: Maybe<Scalars['Int']['output']>;
  startDate: Maybe<Scalars['DateTimeISO']['output']>;
  tasks: Maybe<Array<Task>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  work: Maybe<Array<Work>>;
};

export type PhaseAndTasks = {
  __typename?: 'PhaseAndTasks';
  phaseTitle: Scalars['String']['output'];
  tasks: Array<Scalars['String']['output']>;
};

export type PhaseCreateInput = {
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  order: Scalars['Int']['input'];
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutPhaseInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tasks?: InputMaybe<TaskCreateNestedManyWithoutPhaseInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutPhaseInput>;
};

export type PhaseCreateManyMatterInput = {
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PhaseCreateManyMatterInputEnvelope = {
  data: Array<PhaseCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhaseCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<PhaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PhaseCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<PhaseCreateWithoutMatterInput>>;
  createMany?: InputMaybe<PhaseCreateManyMatterInputEnvelope>;
};

export type PhaseCreateNestedOneWithoutPriceOptionsInput = {
  connect?: InputMaybe<PhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PhaseCreateOrConnectWithoutPriceOptionsInput>;
  create?: InputMaybe<PhaseCreateWithoutPriceOptionsInput>;
};

export type PhaseCreateNestedOneWithoutTasksInput = {
  connect?: InputMaybe<PhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PhaseCreateOrConnectWithoutTasksInput>;
  create?: InputMaybe<PhaseCreateWithoutTasksInput>;
};

export type PhaseCreateNestedOneWithoutWorkInput = {
  connect?: InputMaybe<PhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PhaseCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<PhaseCreateWithoutWorkInput>;
};

export type PhaseCreateOrConnectWithoutMatterInput = {
  create: PhaseCreateWithoutMatterInput;
  where: PhaseWhereUniqueInput;
};

export type PhaseCreateOrConnectWithoutPriceOptionsInput = {
  create: PhaseCreateWithoutPriceOptionsInput;
  where: PhaseWhereUniqueInput;
};

export type PhaseCreateOrConnectWithoutTasksInput = {
  create: PhaseCreateWithoutTasksInput;
  where: PhaseWhereUniqueInput;
};

export type PhaseCreateOrConnectWithoutWorkInput = {
  create: PhaseCreateWithoutWorkInput;
  where: PhaseWhereUniqueInput;
};

export type PhaseCreateWithoutMatterInput = {
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutPhaseInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tasks?: InputMaybe<TaskCreateNestedManyWithoutPhaseInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutPhaseInput>;
};

export type PhaseCreateWithoutPriceOptionsInput = {
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  order: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tasks?: InputMaybe<TaskCreateNestedManyWithoutPhaseInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutPhaseInput>;
};

export type PhaseCreateWithoutTasksInput = {
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  order: Scalars['Int']['input'];
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutPhaseInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutPhaseInput>;
};

export type PhaseCreateWithoutWorkInput = {
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  order: Scalars['Int']['input'];
  priceOptions?: InputMaybe<PriceOptionsCreateNestedOneWithoutPhaseInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tasks?: InputMaybe<TaskCreateNestedManyWithoutPhaseInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PhaseListRelationFilter = {
  every?: InputMaybe<PhaseWhereInput>;
  none?: InputMaybe<PhaseWhereInput>;
  some?: InputMaybe<PhaseWhereInput>;
};

export type PhaseNullableRelationFilter = {
  is?: InputMaybe<PhaseWhereInput>;
  isNot?: InputMaybe<PhaseWhereInput>;
};

export type PhaseRelationFilter = {
  is?: InputMaybe<PhaseWhereInput>;
  isNot?: InputMaybe<PhaseWhereInput>;
};

export type PhaseScalarWhereInput = {
  AND?: InputMaybe<Array<PhaseScalarWhereInput>>;
  NOT?: InputMaybe<Array<PhaseScalarWhereInput>>;
  OR?: InputMaybe<Array<PhaseScalarWhereInput>>;
  completionPercentage?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  html?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  markedComplete?: InputMaybe<BoolFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  priceOptionsId?: InputMaybe<IntNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PhaseUpdateInput = {
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutPhasesNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutPhaseNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tasks?: InputMaybe<TaskUpdateManyWithoutPhaseNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutPhaseNestedInput>;
};

export type PhaseUpdateManyMutationInput = {
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PhaseUpdateManyWithWhereWithoutMatterInput = {
  data: PhaseUpdateManyMutationInput;
  where: PhaseScalarWhereInput;
};

export type PhaseUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<PhaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PhaseCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<PhaseCreateWithoutMatterInput>>;
  createMany?: InputMaybe<PhaseCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<PhaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PhaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PhaseWhereUniqueInput>>;
  set?: InputMaybe<Array<PhaseWhereUniqueInput>>;
  update?: InputMaybe<Array<PhaseUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<PhaseUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<PhaseUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type PhaseUpdateOneRequiredWithoutTasksNestedInput = {
  connect?: InputMaybe<PhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PhaseCreateOrConnectWithoutTasksInput>;
  create?: InputMaybe<PhaseCreateWithoutTasksInput>;
  update?: InputMaybe<PhaseUpdateToOneWithWhereWithoutTasksInput>;
  upsert?: InputMaybe<PhaseUpsertWithoutTasksInput>;
};

export type PhaseUpdateOneWithoutPriceOptionsNestedInput = {
  connect?: InputMaybe<PhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PhaseCreateOrConnectWithoutPriceOptionsInput>;
  create?: InputMaybe<PhaseCreateWithoutPriceOptionsInput>;
  delete?: InputMaybe<PhaseWhereInput>;
  disconnect?: InputMaybe<PhaseWhereInput>;
  update?: InputMaybe<PhaseUpdateToOneWithWhereWithoutPriceOptionsInput>;
  upsert?: InputMaybe<PhaseUpsertWithoutPriceOptionsInput>;
};

export type PhaseUpdateOneWithoutWorkNestedInput = {
  connect?: InputMaybe<PhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PhaseCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<PhaseCreateWithoutWorkInput>;
  delete?: InputMaybe<PhaseWhereInput>;
  disconnect?: InputMaybe<PhaseWhereInput>;
  update?: InputMaybe<PhaseUpdateToOneWithWhereWithoutWorkInput>;
  upsert?: InputMaybe<PhaseUpsertWithoutWorkInput>;
};

export type PhaseUpdateToOneWithWhereWithoutPriceOptionsInput = {
  data: PhaseUpdateWithoutPriceOptionsInput;
  where?: InputMaybe<PhaseWhereInput>;
};

export type PhaseUpdateToOneWithWhereWithoutTasksInput = {
  data: PhaseUpdateWithoutTasksInput;
  where?: InputMaybe<PhaseWhereInput>;
};

export type PhaseUpdateToOneWithWhereWithoutWorkInput = {
  data: PhaseUpdateWithoutWorkInput;
  where?: InputMaybe<PhaseWhereInput>;
};

export type PhaseUpdateWithWhereUniqueWithoutMatterInput = {
  data: PhaseUpdateWithoutMatterInput;
  where: PhaseWhereUniqueInput;
};

export type PhaseUpdateWithoutMatterInput = {
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutPhaseNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tasks?: InputMaybe<TaskUpdateManyWithoutPhaseNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutPhaseNestedInput>;
};

export type PhaseUpdateWithoutPriceOptionsInput = {
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutPhasesNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tasks?: InputMaybe<TaskUpdateManyWithoutPhaseNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutPhaseNestedInput>;
};

export type PhaseUpdateWithoutTasksInput = {
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutPhasesNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutPhaseNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutPhaseNestedInput>;
};

export type PhaseUpdateWithoutWorkInput = {
  completionPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutPhasesNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  priceOptions?: InputMaybe<PriceOptionsUpdateOneWithoutPhaseNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tasks?: InputMaybe<TaskUpdateManyWithoutPhaseNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PhaseUpsertWithWhereUniqueWithoutMatterInput = {
  create: PhaseCreateWithoutMatterInput;
  update: PhaseUpdateWithoutMatterInput;
  where: PhaseWhereUniqueInput;
};

export type PhaseUpsertWithoutPriceOptionsInput = {
  create: PhaseCreateWithoutPriceOptionsInput;
  update: PhaseUpdateWithoutPriceOptionsInput;
  where?: InputMaybe<PhaseWhereInput>;
};

export type PhaseUpsertWithoutTasksInput = {
  create: PhaseCreateWithoutTasksInput;
  update: PhaseUpdateWithoutTasksInput;
  where?: InputMaybe<PhaseWhereInput>;
};

export type PhaseUpsertWithoutWorkInput = {
  create: PhaseCreateWithoutWorkInput;
  update: PhaseUpdateWithoutWorkInput;
  where?: InputMaybe<PhaseWhereInput>;
};

export type PhaseWhereInput = {
  AND?: InputMaybe<Array<PhaseWhereInput>>;
  NOT?: InputMaybe<Array<PhaseWhereInput>>;
  OR?: InputMaybe<Array<PhaseWhereInput>>;
  completionPercentage?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  html?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  markedComplete?: InputMaybe<BoolFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  priceOptions?: InputMaybe<PriceOptionsNullableRelationFilter>;
  priceOptionsId?: InputMaybe<IntNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  tasks?: InputMaybe<TaskListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type PhaseWhereUniqueInput = {
  AND?: InputMaybe<Array<PhaseWhereInput>>;
  NOT?: InputMaybe<Array<PhaseWhereInput>>;
  OR?: InputMaybe<Array<PhaseWhereInput>>;
  completionPercentage?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  html?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markedComplete?: InputMaybe<BoolFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  priceOptions?: InputMaybe<PriceOptionsNullableRelationFilter>;
  priceOptionsId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  tasks?: InputMaybe<TaskListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type PracticeArea = {
  __typename?: 'PracticeArea';
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type PracticeAreaChoice = {
  __typename?: 'PracticeAreaChoice';
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<PracticeAreaParent>;
};

export type PracticeAreaOptionsResult = {
  __typename?: 'PracticeAreaOptionsResult';
  organisationalUnits: Array<PracticeAreaChoice>;
};

export type PracticeAreaParent = {
  __typename?: 'PracticeAreaParent';
  id: Scalars['Float']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
};

export type PriceAdminCharge = {
  __typename?: 'PriceAdminCharge';
  adminChargeAmount: Scalars['Float']['output'];
  adminChargeRate: Scalars['Float']['output'];
  adminChargedAmount: Scalars['Float']['output'];
};

export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  discountAmount: Scalars['Float']['output'];
  discountRate: Scalars['Float']['output'];
  discountedAmount: Scalars['Float']['output'];
};

export type PriceOptions = {
  __typename?: 'PriceOptions';
  cappedChosen: Maybe<Scalars['Float']['output']>;
  cappedGpm: Maybe<Scalars['Int']['output']>;
  cappedSuggested: Maybe<Scalars['Float']['output']>;
  estimatedChosen: Maybe<Scalars['Float']['output']>;
  estimatedGpm: Maybe<Scalars['Int']['output']>;
  estimatedRangeChosenLower: Maybe<Scalars['Float']['output']>;
  estimatedRangeChosenUpper: Maybe<Scalars['Float']['output']>;
  estimatedRangeGpm: Maybe<Scalars['Int']['output']>;
  estimatedRangeSuggestedLower: Maybe<Scalars['Float']['output']>;
  estimatedRangeSuggestedUpper: Maybe<Scalars['Float']['output']>;
  estimatedSuggested: Maybe<Scalars['Float']['output']>;
  feeRiskLower: Maybe<Scalars['Int']['output']>;
  feeRiskUpper: Maybe<Scalars['Int']['output']>;
  fixedChosen: Maybe<Scalars['Float']['output']>;
  fixedGpm: Maybe<Scalars['Int']['output']>;
  fixedSuggested: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  topDownFeeTarget: Maybe<Scalars['Float']['output']>;
  topDownHoursTarget: Maybe<Scalars['Float']['output']>;
  topDownRateDiscount: Maybe<Scalars['Float']['output']>;
};

export type PriceOptionsCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<PriceOptionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceOptionsCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<PriceOptionsCreateWithoutMatterInput>;
};

export type PriceOptionsCreateNestedOneWithoutPhaseInput = {
  connect?: InputMaybe<PriceOptionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceOptionsCreateOrConnectWithoutPhaseInput>;
  create?: InputMaybe<PriceOptionsCreateWithoutPhaseInput>;
};

export type PriceOptionsCreateOrConnectWithoutMatterInput = {
  create: PriceOptionsCreateWithoutMatterInput;
  where: PriceOptionsWhereUniqueInput;
};

export type PriceOptionsCreateOrConnectWithoutPhaseInput = {
  create: PriceOptionsCreateWithoutPhaseInput;
  where: PriceOptionsWhereUniqueInput;
};

export type PriceOptionsCreateWithoutMatterInput = {
  cappedChosen?: InputMaybe<Scalars['Float']['input']>;
  cappedGpm?: InputMaybe<Scalars['Int']['input']>;
  cappedSuggested?: InputMaybe<Scalars['Float']['input']>;
  estimatedChosen?: InputMaybe<Scalars['Float']['input']>;
  estimatedGpm?: InputMaybe<Scalars['Int']['input']>;
  estimatedRangeChosenLower?: InputMaybe<Scalars['Float']['input']>;
  estimatedRangeChosenUpper?: InputMaybe<Scalars['Float']['input']>;
  estimatedRangeGpm?: InputMaybe<Scalars['Int']['input']>;
  estimatedRangeSuggestedLower?: InputMaybe<Scalars['Float']['input']>;
  estimatedRangeSuggestedUpper?: InputMaybe<Scalars['Float']['input']>;
  estimatedSuggested?: InputMaybe<Scalars['Float']['input']>;
  feeRiskLower?: InputMaybe<Scalars['Int']['input']>;
  feeRiskUpper?: InputMaybe<Scalars['Int']['input']>;
  fixedChosen?: InputMaybe<Scalars['Float']['input']>;
  fixedGpm?: InputMaybe<Scalars['Int']['input']>;
  fixedSuggested?: InputMaybe<Scalars['Float']['input']>;
  phase?: InputMaybe<PhaseCreateNestedOneWithoutPriceOptionsInput>;
  topDownFeeTarget?: InputMaybe<Scalars['Float']['input']>;
  topDownHoursTarget?: InputMaybe<Scalars['Float']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceOptionsCreateWithoutPhaseInput = {
  cappedChosen?: InputMaybe<Scalars['Float']['input']>;
  cappedGpm?: InputMaybe<Scalars['Int']['input']>;
  cappedSuggested?: InputMaybe<Scalars['Float']['input']>;
  estimatedChosen?: InputMaybe<Scalars['Float']['input']>;
  estimatedGpm?: InputMaybe<Scalars['Int']['input']>;
  estimatedRangeChosenLower?: InputMaybe<Scalars['Float']['input']>;
  estimatedRangeChosenUpper?: InputMaybe<Scalars['Float']['input']>;
  estimatedRangeGpm?: InputMaybe<Scalars['Int']['input']>;
  estimatedRangeSuggestedLower?: InputMaybe<Scalars['Float']['input']>;
  estimatedRangeSuggestedUpper?: InputMaybe<Scalars['Float']['input']>;
  estimatedSuggested?: InputMaybe<Scalars['Float']['input']>;
  feeRiskLower?: InputMaybe<Scalars['Int']['input']>;
  feeRiskUpper?: InputMaybe<Scalars['Int']['input']>;
  fixedChosen?: InputMaybe<Scalars['Float']['input']>;
  fixedGpm?: InputMaybe<Scalars['Int']['input']>;
  fixedSuggested?: InputMaybe<Scalars['Float']['input']>;
  matter?: InputMaybe<MatterCreateNestedOneWithoutPriceOptionsInput>;
  topDownFeeTarget?: InputMaybe<Scalars['Float']['input']>;
  topDownHoursTarget?: InputMaybe<Scalars['Float']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceOptionsNullableRelationFilter = {
  is?: InputMaybe<PriceOptionsWhereInput>;
  isNot?: InputMaybe<PriceOptionsWhereInput>;
};

export type PriceOptionsUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<PriceOptionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceOptionsCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<PriceOptionsCreateWithoutMatterInput>;
  delete?: InputMaybe<PriceOptionsWhereInput>;
  disconnect?: InputMaybe<PriceOptionsWhereInput>;
  update?: InputMaybe<PriceOptionsUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<PriceOptionsUpsertWithoutMatterInput>;
};

export type PriceOptionsUpdateOneWithoutPhaseNestedInput = {
  connect?: InputMaybe<PriceOptionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceOptionsCreateOrConnectWithoutPhaseInput>;
  create?: InputMaybe<PriceOptionsCreateWithoutPhaseInput>;
  delete?: InputMaybe<PriceOptionsWhereInput>;
  disconnect?: InputMaybe<PriceOptionsWhereInput>;
  update?: InputMaybe<PriceOptionsUpdateToOneWithWhereWithoutPhaseInput>;
  upsert?: InputMaybe<PriceOptionsUpsertWithoutPhaseInput>;
};

export type PriceOptionsUpdateToOneWithWhereWithoutMatterInput = {
  data: PriceOptionsUpdateWithoutMatterInput;
  where?: InputMaybe<PriceOptionsWhereInput>;
};

export type PriceOptionsUpdateToOneWithWhereWithoutPhaseInput = {
  data: PriceOptionsUpdateWithoutPhaseInput;
  where?: InputMaybe<PriceOptionsWhereInput>;
};

export type PriceOptionsUpdateWithoutMatterInput = {
  cappedChosen?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  cappedGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cappedSuggested?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedChosen?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  estimatedRangeChosenLower?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedRangeChosenUpper?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedRangeGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  estimatedRangeSuggestedLower?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedRangeSuggestedUpper?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedSuggested?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeRiskLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  feeRiskUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedChosen?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fixedGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedSuggested?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  phase?: InputMaybe<PhaseUpdateOneWithoutPriceOptionsNestedInput>;
  topDownFeeTarget?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  topDownHoursTarget?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type PriceOptionsUpdateWithoutPhaseInput = {
  cappedChosen?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  cappedGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cappedSuggested?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedChosen?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  estimatedRangeChosenLower?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedRangeChosenUpper?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedRangeGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  estimatedRangeSuggestedLower?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedRangeSuggestedUpper?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  estimatedSuggested?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeRiskLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  feeRiskUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedChosen?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fixedGpm?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedSuggested?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneWithoutPriceOptionsNestedInput>;
  topDownFeeTarget?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  topDownHoursTarget?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type PriceOptionsUpsertWithoutMatterInput = {
  create: PriceOptionsCreateWithoutMatterInput;
  update: PriceOptionsUpdateWithoutMatterInput;
  where?: InputMaybe<PriceOptionsWhereInput>;
};

export type PriceOptionsUpsertWithoutPhaseInput = {
  create: PriceOptionsCreateWithoutPhaseInput;
  update: PriceOptionsUpdateWithoutPhaseInput;
  where?: InputMaybe<PriceOptionsWhereInput>;
};

export type PriceOptionsWhereInput = {
  AND?: InputMaybe<Array<PriceOptionsWhereInput>>;
  NOT?: InputMaybe<Array<PriceOptionsWhereInput>>;
  OR?: InputMaybe<Array<PriceOptionsWhereInput>>;
  cappedChosen?: InputMaybe<FloatNullableFilter>;
  cappedGpm?: InputMaybe<IntNullableFilter>;
  cappedSuggested?: InputMaybe<FloatNullableFilter>;
  estimatedChosen?: InputMaybe<FloatNullableFilter>;
  estimatedGpm?: InputMaybe<IntNullableFilter>;
  estimatedRangeChosenLower?: InputMaybe<FloatNullableFilter>;
  estimatedRangeChosenUpper?: InputMaybe<FloatNullableFilter>;
  estimatedRangeGpm?: InputMaybe<IntNullableFilter>;
  estimatedRangeSuggestedLower?: InputMaybe<FloatNullableFilter>;
  estimatedRangeSuggestedUpper?: InputMaybe<FloatNullableFilter>;
  estimatedSuggested?: InputMaybe<FloatNullableFilter>;
  feeRiskLower?: InputMaybe<IntNullableFilter>;
  feeRiskUpper?: InputMaybe<IntNullableFilter>;
  fixedChosen?: InputMaybe<FloatNullableFilter>;
  fixedGpm?: InputMaybe<IntNullableFilter>;
  fixedSuggested?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  phase?: InputMaybe<PhaseNullableRelationFilter>;
  topDownFeeTarget?: InputMaybe<FloatNullableFilter>;
  topDownHoursTarget?: InputMaybe<FloatNullableFilter>;
  topDownRateDiscount?: InputMaybe<FloatNullableFilter>;
};

export type PriceOptionsWhereUniqueInput = {
  AND?: InputMaybe<Array<PriceOptionsWhereInput>>;
  NOT?: InputMaybe<Array<PriceOptionsWhereInput>>;
  OR?: InputMaybe<Array<PriceOptionsWhereInput>>;
  cappedChosen?: InputMaybe<FloatNullableFilter>;
  cappedGpm?: InputMaybe<IntNullableFilter>;
  cappedSuggested?: InputMaybe<FloatNullableFilter>;
  estimatedChosen?: InputMaybe<FloatNullableFilter>;
  estimatedGpm?: InputMaybe<IntNullableFilter>;
  estimatedRangeChosenLower?: InputMaybe<FloatNullableFilter>;
  estimatedRangeChosenUpper?: InputMaybe<FloatNullableFilter>;
  estimatedRangeGpm?: InputMaybe<IntNullableFilter>;
  estimatedRangeSuggestedLower?: InputMaybe<FloatNullableFilter>;
  estimatedRangeSuggestedUpper?: InputMaybe<FloatNullableFilter>;
  estimatedSuggested?: InputMaybe<FloatNullableFilter>;
  feeRiskLower?: InputMaybe<IntNullableFilter>;
  feeRiskUpper?: InputMaybe<IntNullableFilter>;
  fixedChosen?: InputMaybe<FloatNullableFilter>;
  fixedGpm?: InputMaybe<IntNullableFilter>;
  fixedSuggested?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterNullableRelationFilter>;
  phase?: InputMaybe<PhaseNullableRelationFilter>;
  topDownFeeTarget?: InputMaybe<FloatNullableFilter>;
  topDownHoursTarget?: InputMaybe<FloatNullableFilter>;
  topDownRateDiscount?: InputMaybe<FloatNullableFilter>;
};

export type PriceOrPriceRange = Price | PriceRange;

export type PriceOrPriceRangeAdminCharge = PriceAdminCharge | PriceRangeAdminCharge;

export type PriceOrPriceRangeDiscount = PriceDiscount | PriceRangeDiscount;

export type PriceOrPriceRangeUplift = PriceRangeUplift | PriceUplift;

export type PriceRange = {
  __typename?: 'PriceRange';
  lower: Maybe<Scalars['Float']['output']>;
  upper: Maybe<Scalars['Float']['output']>;
};

export type PriceRangeAdminCharge = {
  __typename?: 'PriceRangeAdminCharge';
  adminChargeAmountRange: PriceRange;
  adminChargeRate: Scalars['Float']['output'];
  adminChargedAmountRange: PriceRange;
};

export type PriceRangeAndSingle = {
  __typename?: 'PriceRangeAndSingle';
  lower: Maybe<Scalars['Float']['output']>;
  single: Maybe<Scalars['Float']['output']>;
  upper: Maybe<Scalars['Float']['output']>;
};

export type PriceRangeCreateNestedOneWithoutMattersInput = {
  connect?: InputMaybe<PriceRangeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceRangeCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<PriceRangeCreateWithoutMattersInput>;
};

export type PriceRangeCreateOrConnectWithoutMattersInput = {
  create: PriceRangeCreateWithoutMattersInput;
  where: PriceRangeWhereUniqueInput;
};

export type PriceRangeCreateWithoutMattersInput = {
  lower?: InputMaybe<Scalars['Float']['input']>;
  upper?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceRangeDiscount = {
  __typename?: 'PriceRangeDiscount';
  discountAmountRange: PriceRange;
  discountRateRange: PercentageRange;
  discountedAmountRange: PriceRange;
};

export type PriceRangeNullableRelationFilter = {
  is?: InputMaybe<PriceRangeWhereInput>;
  isNot?: InputMaybe<PriceRangeWhereInput>;
};

export type PriceRangeUpdateOneWithoutMattersNestedInput = {
  connect?: InputMaybe<PriceRangeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceRangeCreateOrConnectWithoutMattersInput>;
  create?: InputMaybe<PriceRangeCreateWithoutMattersInput>;
  delete?: InputMaybe<PriceRangeWhereInput>;
  disconnect?: InputMaybe<PriceRangeWhereInput>;
  update?: InputMaybe<PriceRangeUpdateToOneWithWhereWithoutMattersInput>;
  upsert?: InputMaybe<PriceRangeUpsertWithoutMattersInput>;
};

export type PriceRangeUpdateToOneWithWhereWithoutMattersInput = {
  data: PriceRangeUpdateWithoutMattersInput;
  where?: InputMaybe<PriceRangeWhereInput>;
};

export type PriceRangeUpdateWithoutMattersInput = {
  lower?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  upper?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type PriceRangeUplift = {
  __typename?: 'PriceRangeUplift';
  upliftAmountRange: PriceRange;
  upliftRateRange: PercentageRange;
  upliftedAmountRange: PriceRange;
};

export type PriceRangeUpsertWithoutMattersInput = {
  create: PriceRangeCreateWithoutMattersInput;
  update: PriceRangeUpdateWithoutMattersInput;
  where?: InputMaybe<PriceRangeWhereInput>;
};

export type PriceRangeWhereInput = {
  AND?: InputMaybe<Array<PriceRangeWhereInput>>;
  NOT?: InputMaybe<Array<PriceRangeWhereInput>>;
  OR?: InputMaybe<Array<PriceRangeWhereInput>>;
  id?: InputMaybe<IntFilter>;
  lower?: InputMaybe<FloatNullableFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  upper?: InputMaybe<FloatNullableFilter>;
};

export type PriceRangeWhereUniqueInput = {
  AND?: InputMaybe<Array<PriceRangeWhereInput>>;
  NOT?: InputMaybe<Array<PriceRangeWhereInput>>;
  OR?: InputMaybe<Array<PriceRangeWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lower?: InputMaybe<FloatNullableFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  upper?: InputMaybe<FloatNullableFilter>;
};

export type PriceUplift = {
  __typename?: 'PriceUplift';
  upliftAmount: Scalars['Float']['output'];
  upliftRate: Scalars['Float']['output'];
  upliftedAmount: Scalars['Float']['output'];
};

export enum PricingLevel {
  FeeEarner = 'FeeEarner',
  Matter = 'Matter',
  None = 'None',
  Phase = 'Phase'
}

export enum PricingLevelEnum {
  FeeEarner = 'FeeEarner',
  Matter = 'Matter',
  None = 'None',
  Phase = 'Phase'
}

export enum PricingTarget {
  Fee = 'Fee',
  Hours = 'Hours'
}

export enum PricingType {
  Capped = 'Capped',
  Estimated = 'Estimated',
  EstimatedRange = 'EstimatedRange',
  Fixed = 'Fixed',
  None = 'None',
  TopDown = 'TopDown'
}

export enum PricingTypeEnum {
  Capped = 'Capped',
  Estimated = 'Estimated',
  EstimatedRange = 'EstimatedRange',
  Fixed = 'Fixed',
  None = 'None',
  TopDown = 'TopDown'
}

export type Proposal = {
  __typename?: 'Proposal';
  assignedResources: Array<AssignedResource>;
  assumptions: Array<Scalars['String']['output']>;
  clientAddressLine1: Scalars['String']['output'];
  clientAddressLine2: Scalars['String']['output'];
  clientCity: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  clientPostcode: Scalars['String']['output'];
  clientTown: Scalars['String']['output'];
  createdByEmail: Maybe<Scalars['String']['output']>;
  createdByName: Maybe<Scalars['String']['output']>;
  disbursementLineItems: Array<DisbursementLineItem>;
  disbursementsTax: Tax;
  disbursementsTotal: Price;
  excludeTax: Scalars['Boolean']['output'];
  exclusions: Array<Scalars['String']['output']>;
  feeEarnerOfficeId: Maybe<Scalars['Int']['output']>;
  feeRiskCappedFeeInclude: Scalars['Boolean']['output'];
  feeRiskDiagram: Maybe<Scalars['String']['output']>;
  feeRiskInclude: Scalars['Boolean']['output'];
  feeRiskValid: Scalars['Boolean']['output'];
  fixedGrandTotal: Price;
  fixedLegalFeeAdminCharge: PriceAdminCharge;
  fixedLegalFeeDiscount: PriceDiscount;
  fixedLegalFeeTax: Tax;
  fixedLegalFeeTotal: Price;
  ganttAvailable: Scalars['Boolean']['output'];
  ganttChart: Maybe<Array<Scalars['String']['output']>>;
  ganttInclude: Scalars['Boolean']['output'];
  grandTotal: PriceOrPriceRange;
  id: Scalars['Float']['output'];
  includeDisbursements: Scalars['Boolean']['output'];
  includeFeeEarnersInProposalOutput: Scalars['Boolean']['output'];
  includeRatesInProposalOutput: Scalars['Boolean']['output'];
  includeTasks: Scalars['Boolean']['output'];
  leadFeeEarnerEmail: Maybe<Scalars['String']['output']>;
  leadFeeEarnerName: Maybe<Scalars['String']['output']>;
  legalFeeAdminCharge: PriceOrPriceRangeAdminCharge;
  legalFeeDiscount: PriceOrPriceRangeDiscount;
  legalFeeLineItems: Array<LegalFeeLineItem>;
  legalFeeTax: TaxOrTaxRange;
  legalFeeTotal: PriceOrPriceRange;
  legalFeeTotalBeforeVisibleUplifts: PriceOrPriceRange;
  legalFeeUplifts: Array<LegalFeeUpliftLineItem>;
  matterId: Scalars['Int']['output'];
  matterTitle: Scalars['String']['output'];
  organisationalUnitId: Maybe<Scalars['Int']['output']>;
  priceOptions: FeeRiskPriceOptions;
  pricingLevel: PricingLevelEnum;
  pricingType: PricingTypeEnum;
  status: MatterStatusEnum;
  taxLabel: TaxLabelEnum;
  taxLevelPercent: Scalars['Float']['output'];
  technologyChargeLineItems: Array<TechnologyChargeLineItem>;
  upliftsTotal: PriceOrPriceRange;
};

export type ProposalOptionsUpdateResult = {
  __typename?: 'ProposalOptionsUpdateResult';
  includeDiagram: Scalars['Boolean']['output'];
  includeDisbursements: Scalars['Boolean']['output'];
  includeTasks: Scalars['Boolean']['output'];
  showFeeEarners: Scalars['Boolean']['output'];
  showRates: Scalars['Boolean']['output'];
};

export type ProposalOuputPartCreateManyCreatedByUserInput = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  proposalOutputId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOuputPartCreateManyCreatedByUserInputEnvelope = {
  data: Array<ProposalOuputPartCreateManyCreatedByUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalOuputPartCreateManyProposalOutputInput = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOuputPartCreateManyProposalOutputInputEnvelope = {
  data: Array<ProposalOuputPartCreateManyProposalOutputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput = {
  connect?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOuputPartCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ProposalOuputPartCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ProposalOuputPartCreateManyCreatedByUserInputEnvelope>;
};

export type ProposalOuputPartCreateNestedManyWithoutProposalOutputInput = {
  connect?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOuputPartCreateOrConnectWithoutProposalOutputInput>>;
  create?: InputMaybe<Array<ProposalOuputPartCreateWithoutProposalOutputInput>>;
  createMany?: InputMaybe<ProposalOuputPartCreateManyProposalOutputInputEnvelope>;
};

export type ProposalOuputPartCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<ProposalOuputPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalOuputPartCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ProposalOuputPartCreateWithoutMatterInput>;
};

export type ProposalOuputPartCreateOrConnectWithoutCreatedByUserInput = {
  create: ProposalOuputPartCreateWithoutCreatedByUserInput;
  where: ProposalOuputPartWhereUniqueInput;
};

export type ProposalOuputPartCreateOrConnectWithoutMatterInput = {
  create: ProposalOuputPartCreateWithoutMatterInput;
  where: ProposalOuputPartWhereUniqueInput;
};

export type ProposalOuputPartCreateOrConnectWithoutProposalOutputInput = {
  create: ProposalOuputPartCreateWithoutProposalOutputInput;
  where: ProposalOuputPartWhereUniqueInput;
};

export type ProposalOuputPartCreateWithoutCreatedByUserInput = {
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedOneWithoutPartsInput>;
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matter?: InputMaybe<MatterCreateNestedManyWithoutProposalOuputPartInput>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOuputPartCreateWithoutMatterInput = {
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedOneWithoutPartsInput>;
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOuputPartCreateWithoutProposalOutputInput = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matter?: InputMaybe<MatterCreateNestedManyWithoutProposalOuputPartInput>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOuputPartListRelationFilter = {
  every?: InputMaybe<ProposalOuputPartWhereInput>;
  none?: InputMaybe<ProposalOuputPartWhereInput>;
  some?: InputMaybe<ProposalOuputPartWhereInput>;
};

export type ProposalOuputPartMatterAfterUniqueCompoundUniqueInput = {
  after: Scalars['Boolean']['input'];
  matterId: Scalars['Int']['input'];
};

export type ProposalOuputPartMatterBeforeUniqueCompoundUniqueInput = {
  before: Scalars['Boolean']['input'];
  matterId: Scalars['Int']['input'];
};

export type ProposalOuputPartNullableRelationFilter = {
  is?: InputMaybe<ProposalOuputPartWhereInput>;
  isNot?: InputMaybe<ProposalOuputPartWhereInput>;
};

export type ProposalOuputPartScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalOuputPartScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalOuputPartScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalOuputPartScalarWhereInput>>;
  after?: InputMaybe<BoolFilter>;
  before?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  proposalOutputId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProposalOuputPartUpdateManyMutationInput = {
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOuputPartUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: ProposalOuputPartUpdateManyMutationInput;
  where: ProposalOuputPartScalarWhereInput;
};

export type ProposalOuputPartUpdateManyWithWhereWithoutProposalOutputInput = {
  data: ProposalOuputPartUpdateManyMutationInput;
  where: ProposalOuputPartScalarWhereInput;
};

export type ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOuputPartCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ProposalOuputPartCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ProposalOuputPartCreateManyCreatedByUserInputEnvelope>;
  delete?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalOuputPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalOuputPartUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: InputMaybe<Array<ProposalOuputPartUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: InputMaybe<Array<ProposalOuputPartUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type ProposalOuputPartUpdateManyWithoutProposalOutputNestedInput = {
  connect?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOuputPartCreateOrConnectWithoutProposalOutputInput>>;
  create?: InputMaybe<Array<ProposalOuputPartCreateWithoutProposalOutputInput>>;
  createMany?: InputMaybe<ProposalOuputPartCreateManyProposalOutputInputEnvelope>;
  delete?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalOuputPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalOuputPartWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalOuputPartUpdateWithWhereUniqueWithoutProposalOutputInput>>;
  updateMany?: InputMaybe<Array<ProposalOuputPartUpdateManyWithWhereWithoutProposalOutputInput>>;
  upsert?: InputMaybe<Array<ProposalOuputPartUpsertWithWhereUniqueWithoutProposalOutputInput>>;
};

export type ProposalOuputPartUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<ProposalOuputPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalOuputPartCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ProposalOuputPartCreateWithoutMatterInput>;
  delete?: InputMaybe<ProposalOuputPartWhereInput>;
  disconnect?: InputMaybe<ProposalOuputPartWhereInput>;
  update?: InputMaybe<ProposalOuputPartUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<ProposalOuputPartUpsertWithoutMatterInput>;
};

export type ProposalOuputPartUpdateToOneWithWhereWithoutMatterInput = {
  data: ProposalOuputPartUpdateWithoutMatterInput;
  where?: InputMaybe<ProposalOuputPartWhereInput>;
};

export type ProposalOuputPartUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: ProposalOuputPartUpdateWithoutCreatedByUserInput;
  where: ProposalOuputPartWhereUniqueInput;
};

export type ProposalOuputPartUpdateWithWhereUniqueWithoutProposalOutputInput = {
  data: ProposalOuputPartUpdateWithoutProposalOutputInput;
  where: ProposalOuputPartWhereUniqueInput;
};

export type ProposalOuputPartUpdateWithoutCreatedByUserInput = {
  ProposalOutput?: InputMaybe<ProposalOutputUpdateOneWithoutPartsNestedInput>;
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateManyWithoutProposalOuputPartNestedInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOuputPartUpdateWithoutMatterInput = {
  ProposalOutput?: InputMaybe<ProposalOutputUpdateOneWithoutPartsNestedInput>;
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOuputPartUpdateWithoutProposalOutputInput = {
  after?: InputMaybe<BoolFieldUpdateOperationsInput>;
  before?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateManyWithoutProposalOuputPartNestedInput>;
  matterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOuputPartUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: ProposalOuputPartCreateWithoutCreatedByUserInput;
  update: ProposalOuputPartUpdateWithoutCreatedByUserInput;
  where: ProposalOuputPartWhereUniqueInput;
};

export type ProposalOuputPartUpsertWithWhereUniqueWithoutProposalOutputInput = {
  create: ProposalOuputPartCreateWithoutProposalOutputInput;
  update: ProposalOuputPartUpdateWithoutProposalOutputInput;
  where: ProposalOuputPartWhereUniqueInput;
};

export type ProposalOuputPartUpsertWithoutMatterInput = {
  create: ProposalOuputPartCreateWithoutMatterInput;
  update: ProposalOuputPartUpdateWithoutMatterInput;
  where?: InputMaybe<ProposalOuputPartWhereInput>;
};

export type ProposalOuputPartWhereInput = {
  AND?: InputMaybe<Array<ProposalOuputPartWhereInput>>;
  NOT?: InputMaybe<Array<ProposalOuputPartWhereInput>>;
  OR?: InputMaybe<Array<ProposalOuputPartWhereInput>>;
  ProposalOutput?: InputMaybe<ProposalOutputNullableRelationFilter>;
  after?: InputMaybe<BoolFilter>;
  before?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterListRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  proposalOutputId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProposalOuputPartWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalOuputPartWhereInput>>;
  MatterAfterUnique?: InputMaybe<ProposalOuputPartMatterAfterUniqueCompoundUniqueInput>;
  MatterBeforeUnique?: InputMaybe<ProposalOuputPartMatterBeforeUniqueCompoundUniqueInput>;
  NOT?: InputMaybe<Array<ProposalOuputPartWhereInput>>;
  OR?: InputMaybe<Array<ProposalOuputPartWhereInput>>;
  ProposalOutput?: InputMaybe<ProposalOutputNullableRelationFilter>;
  after?: InputMaybe<BoolFilter>;
  before?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterListRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  proposalOutputId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProposalOutputCreateManyCreatedByUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplateId: Scalars['Int']['input'];
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  selectedOfficeId?: InputMaybe<Scalars['Int']['input']>;
  selectedOrganisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOutputCreateManyCreatedByUserInputEnvelope = {
  data: Array<ProposalOutputCreateManyCreatedByUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalOutputCreateManyDesignTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  selectedOfficeId?: InputMaybe<Scalars['Int']['input']>;
  selectedOrganisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOutputCreateManyDesignTemplateInputEnvelope = {
  data: Array<ProposalOutputCreateManyDesignTemplateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalOutputCreateNestedManyWithoutCreatedByUserInput = {
  connect?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOutputCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ProposalOutputCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ProposalOutputCreateManyCreatedByUserInputEnvelope>;
};

export type ProposalOutputCreateNestedManyWithoutDesignTemplateInput = {
  connect?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOutputCreateOrConnectWithoutDesignTemplateInput>>;
  create?: InputMaybe<Array<ProposalOutputCreateWithoutDesignTemplateInput>>;
  createMany?: InputMaybe<ProposalOutputCreateManyDesignTemplateInputEnvelope>;
};

export type ProposalOutputCreateNestedOneWithoutMatterInput = {
  connect?: InputMaybe<ProposalOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalOutputCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ProposalOutputCreateWithoutMatterInput>;
};

export type ProposalOutputCreateNestedOneWithoutPartsInput = {
  connect?: InputMaybe<ProposalOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalOutputCreateOrConnectWithoutPartsInput>;
  create?: InputMaybe<ProposalOutputCreateWithoutPartsInput>;
};

export type ProposalOutputCreateOrConnectWithoutCreatedByUserInput = {
  create: ProposalOutputCreateWithoutCreatedByUserInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputCreateOrConnectWithoutDesignTemplateInput = {
  create: ProposalOutputCreateWithoutDesignTemplateInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputCreateOrConnectWithoutMatterInput = {
  create: ProposalOutputCreateWithoutMatterInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputCreateOrConnectWithoutPartsInput = {
  create: ProposalOutputCreateWithoutPartsInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputCreateWithoutCreatedByUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplate: OutputDesignCreateNestedOneWithoutProposalOutputInput;
  htmlContent: Scalars['String']['input'];
  matter: MatterCreateNestedOneWithoutProposalOuputInput;
  parts?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutProposalOutputInput>;
  selectedOfficeId?: InputMaybe<Scalars['Int']['input']>;
  selectedOrganisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOutputCreateWithoutDesignTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  htmlContent: Scalars['String']['input'];
  matter: MatterCreateNestedOneWithoutProposalOuputInput;
  parts?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutProposalOutputInput>;
  selectedOfficeId?: InputMaybe<Scalars['Int']['input']>;
  selectedOrganisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOutputCreateWithoutMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplate: OutputDesignCreateNestedOneWithoutProposalOutputInput;
  htmlContent: Scalars['String']['input'];
  parts?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutProposalOutputInput>;
  selectedOfficeId?: InputMaybe<Scalars['Int']['input']>;
  selectedOrganisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOutputCreateWithoutPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  designTemplate: OutputDesignCreateNestedOneWithoutProposalOutputInput;
  htmlContent: Scalars['String']['input'];
  matter: MatterCreateNestedOneWithoutProposalOuputInput;
  selectedOfficeId?: InputMaybe<Scalars['Int']['input']>;
  selectedOrganisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProposalOutputListRelationFilter = {
  every?: InputMaybe<ProposalOutputWhereInput>;
  none?: InputMaybe<ProposalOutputWhereInput>;
  some?: InputMaybe<ProposalOutputWhereInput>;
};

export type ProposalOutputNullableRelationFilter = {
  is?: InputMaybe<ProposalOutputWhereInput>;
  isNot?: InputMaybe<ProposalOutputWhereInput>;
};

export type ProposalOutputScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalOutputScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalOutputScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalOutputScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designTemplateId?: InputMaybe<IntFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  selectedOfficeId?: InputMaybe<IntNullableFilter>;
  selectedOrganisationalUnitId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProposalOutputUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedOfficeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selectedOrganisationalUnitId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOutputUpdateManyWithWhereWithoutCreatedByUserInput = {
  data: ProposalOutputUpdateManyMutationInput;
  where: ProposalOutputScalarWhereInput;
};

export type ProposalOutputUpdateManyWithWhereWithoutDesignTemplateInput = {
  data: ProposalOutputUpdateManyMutationInput;
  where: ProposalOutputScalarWhereInput;
};

export type ProposalOutputUpdateManyWithoutCreatedByUserNestedInput = {
  connect?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOutputCreateOrConnectWithoutCreatedByUserInput>>;
  create?: InputMaybe<Array<ProposalOutputCreateWithoutCreatedByUserInput>>;
  createMany?: InputMaybe<ProposalOutputCreateManyCreatedByUserInputEnvelope>;
  delete?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalOutputUpdateWithWhereUniqueWithoutCreatedByUserInput>>;
  updateMany?: InputMaybe<Array<ProposalOutputUpdateManyWithWhereWithoutCreatedByUserInput>>;
  upsert?: InputMaybe<Array<ProposalOutputUpsertWithWhereUniqueWithoutCreatedByUserInput>>;
};

export type ProposalOutputUpdateManyWithoutDesignTemplateNestedInput = {
  connect?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalOutputCreateOrConnectWithoutDesignTemplateInput>>;
  create?: InputMaybe<Array<ProposalOutputCreateWithoutDesignTemplateInput>>;
  createMany?: InputMaybe<ProposalOutputCreateManyDesignTemplateInputEnvelope>;
  delete?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalOutputUpdateWithWhereUniqueWithoutDesignTemplateInput>>;
  updateMany?: InputMaybe<Array<ProposalOutputUpdateManyWithWhereWithoutDesignTemplateInput>>;
  upsert?: InputMaybe<Array<ProposalOutputUpsertWithWhereUniqueWithoutDesignTemplateInput>>;
};

export type ProposalOutputUpdateOneWithoutMatterNestedInput = {
  connect?: InputMaybe<ProposalOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalOutputCreateOrConnectWithoutMatterInput>;
  create?: InputMaybe<ProposalOutputCreateWithoutMatterInput>;
  delete?: InputMaybe<ProposalOutputWhereInput>;
  disconnect?: InputMaybe<ProposalOutputWhereInput>;
  update?: InputMaybe<ProposalOutputUpdateToOneWithWhereWithoutMatterInput>;
  upsert?: InputMaybe<ProposalOutputUpsertWithoutMatterInput>;
};

export type ProposalOutputUpdateOneWithoutPartsNestedInput = {
  connect?: InputMaybe<ProposalOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalOutputCreateOrConnectWithoutPartsInput>;
  create?: InputMaybe<ProposalOutputCreateWithoutPartsInput>;
  delete?: InputMaybe<ProposalOutputWhereInput>;
  disconnect?: InputMaybe<ProposalOutputWhereInput>;
  update?: InputMaybe<ProposalOutputUpdateToOneWithWhereWithoutPartsInput>;
  upsert?: InputMaybe<ProposalOutputUpsertWithoutPartsInput>;
};

export type ProposalOutputUpdateToOneWithWhereWithoutMatterInput = {
  data: ProposalOutputUpdateWithoutMatterInput;
  where?: InputMaybe<ProposalOutputWhereInput>;
};

export type ProposalOutputUpdateToOneWithWhereWithoutPartsInput = {
  data: ProposalOutputUpdateWithoutPartsInput;
  where?: InputMaybe<ProposalOutputWhereInput>;
};

export type ProposalOutputUpdateWithWhereUniqueWithoutCreatedByUserInput = {
  data: ProposalOutputUpdateWithoutCreatedByUserInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputUpdateWithWhereUniqueWithoutDesignTemplateInput = {
  data: ProposalOutputUpdateWithoutDesignTemplateInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputUpdateWithoutCreatedByUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  designTemplate?: InputMaybe<OutputDesignUpdateOneRequiredWithoutProposalOutputNestedInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutProposalOuputNestedInput>;
  parts?: InputMaybe<ProposalOuputPartUpdateManyWithoutProposalOutputNestedInput>;
  selectedOfficeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selectedOrganisationalUnitId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOutputUpdateWithoutDesignTemplateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutProposalOuputNestedInput>;
  parts?: InputMaybe<ProposalOuputPartUpdateManyWithoutProposalOutputNestedInput>;
  selectedOfficeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selectedOrganisationalUnitId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOutputUpdateWithoutMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  designTemplate?: InputMaybe<OutputDesignUpdateOneRequiredWithoutProposalOutputNestedInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  parts?: InputMaybe<ProposalOuputPartUpdateManyWithoutProposalOutputNestedInput>;
  selectedOfficeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selectedOrganisationalUnitId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOutputUpdateWithoutPartsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  designTemplate?: InputMaybe<OutputDesignUpdateOneRequiredWithoutProposalOutputNestedInput>;
  htmlContent?: InputMaybe<StringFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutProposalOuputNestedInput>;
  selectedOfficeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selectedOrganisationalUnitId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalOutputUpsertWithWhereUniqueWithoutCreatedByUserInput = {
  create: ProposalOutputCreateWithoutCreatedByUserInput;
  update: ProposalOutputUpdateWithoutCreatedByUserInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputUpsertWithWhereUniqueWithoutDesignTemplateInput = {
  create: ProposalOutputCreateWithoutDesignTemplateInput;
  update: ProposalOutputUpdateWithoutDesignTemplateInput;
  where: ProposalOutputWhereUniqueInput;
};

export type ProposalOutputUpsertWithoutMatterInput = {
  create: ProposalOutputCreateWithoutMatterInput;
  update: ProposalOutputUpdateWithoutMatterInput;
  where?: InputMaybe<ProposalOutputWhereInput>;
};

export type ProposalOutputUpsertWithoutPartsInput = {
  create: ProposalOutputCreateWithoutPartsInput;
  update: ProposalOutputUpdateWithoutPartsInput;
  where?: InputMaybe<ProposalOutputWhereInput>;
};

export type ProposalOutputWhereInput = {
  AND?: InputMaybe<Array<ProposalOutputWhereInput>>;
  NOT?: InputMaybe<Array<ProposalOutputWhereInput>>;
  OR?: InputMaybe<Array<ProposalOutputWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designTemplate?: InputMaybe<OutputDesignRelationFilter>;
  designTemplateId?: InputMaybe<IntFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  parts?: InputMaybe<ProposalOuputPartListRelationFilter>;
  selectedOfficeId?: InputMaybe<IntNullableFilter>;
  selectedOrganisationalUnitId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProposalOutputWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalOutputWhereInput>>;
  NOT?: InputMaybe<Array<ProposalOutputWhereInput>>;
  OR?: InputMaybe<Array<ProposalOutputWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designTemplate?: InputMaybe<OutputDesignRelationFilter>;
  designTemplateId?: InputMaybe<IntFilter>;
  htmlContent?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  parts?: InputMaybe<ProposalOuputPartListRelationFilter>;
  selectedOfficeId?: InputMaybe<IntNullableFilter>;
  selectedOrganisationalUnitId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProposalResult = {
  __typename?: 'ProposalResult';
  html: Scalars['String']['output'];
  outputTemplateId: Scalars['Int']['output'];
  outputTemplateName: Scalars['String']['output'];
  proposal: Proposal;
  selectedOfficeId: Maybe<Scalars['Int']['output']>;
  selectedOrganisationalUnitId: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allClients: ClientResult;
  allFeeEarners: Array<FeeEarner>;
  allUsers: Array<User>;
  bedrockCheckMatterTitleIsDescriptive: Scalars['Boolean']['output'];
  bedrockGetPhasesAndTasks: Maybe<Array<PhaseAndTasks>>;
  bedrockGetTasksForPhase: Maybe<Tasks>;
  bedrockRoiAnalyseAndRecommend: Maybe<AnalysisAndRecommendations>;
  bedrockSuggestAssumptions: Maybe<ChosenAndSuggested>;
  bedrockSuggestExclusions: Maybe<ChosenAndSuggested>;
  bedrockSuggestPracticeAreas: PracticeAreaOptionsResult;
  byId: Currency;
  clientReportByMatterId: ClientReportResult;
  countNotifyUsers: Scalars['Int']['output'];
  createdOrUpdatedMatter: Array<Matter>;
  currencies: Array<Currency>;
  currentPdfOptions: PdfOptions;
  currentUser: Maybe<CurrentUser>;
  currentUserFeeEarnerData: Maybe<CurrentUserDataResult>;
  dataImportRecordsQuery: PaginatedDataImportRecords;
  dataImportSchema: DataImportSchemaDefinition;
  dynamicTag: Maybe<DynamicTag>;
  dynamicTags: Array<DynamicTag>;
  exchangeRateByCode: Scalars['Float']['output'];
  existingDynamicTagImages: Array<ExistingDynamicTagImages>;
  feeEarnerLevels: FeeEarnerLevelsResult;
  feeEarnersByLevel: Array<FeeEarner>;
  filterUsers: UserPage;
  filteredClients: ClientResult;
  filteredDesigns: Maybe<Array<OutputDesign>>;
  filteredExternalMatters: FilteredExternalMattersResult;
  filteredExternalMattersCountWithAmount: ExternalMatterUnlinkedSummary;
  filteredMatters: MatterPage;
  findAccruedFees: AccruedFeesForUser;
  findAccruedFeesForMatter: AccruedFee;
  findAccruedFeesForUser: AccruedFeesForUser;
  findAllBrands: Array<Brand>;
  findAllExternalMatters: Array<ExternalMatter>;
  findAllLibraryUplifts: Array<LibraryUplift>;
  findAllMatters: Array<Matter>;
  findCumulativeAccruedFeesForExternalMatter: Array<CumulativeAccruedFee>;
  findCumulativeAccruedFeesForMatter: Array<CumulativeAccruedFee>;
  findDesign: Maybe<OutputDesign>;
  findExternalMatter: ExternalMatter;
  findLatestSettings: Maybe<Settings>;
  findMatter: Matter;
  findMatterCompletionLogs: Array<MatterCompletionLog>;
  findParentMatter: Maybe<ParentMatter>;
  findRelevantExternalMatters: RelevantExternalMattersWithAccruedFees;
  findRelevantMatters: RelevantMattersWithAccruedFees;
  findSimilarExternalMattersForMatters: SimilarExternalMattersForMattersResult;
  findSimilarMatters: Array<Matter>;
  generateParentProposal: ParentProposalResult;
  generateProposal: Proposal;
  generateWorkplan: Workplan;
  getAllPerformance: PerformanceResult;
  getBrand: Maybe<Brand>;
  getClientReportMergeTagFields: Maybe<Array<MergeTag>>;
  getClientsByIds: Array<Client>;
  getDefaultBrand: Maybe<Brand>;
  getPhase: Maybe<Phase>;
  getPhases: Array<Phase>;
  getProposalMergeTagFields: Maybe<Array<MergeTag>>;
  getRates: Array<RateResult>;
  getTaxInfoForMatter: Maybe<TaxInfo>;
  getTextBlocks: Array<TextBlock>;
  getTopDownRates: Array<RateGroup>;
  getUserSettings: UserSettings;
  groupItem: Maybe<GroupItem>;
  groupItems: Array<GroupItem>;
  hasInvoices: Scalars['Boolean']['output'];
  integrationRecordCountQuery: IntegrationRecordCountQueryResult;
  libraryAssumptions: Array<LibraryAssumption>;
  libraryDisbursements: Array<LibraryDisbursement>;
  libraryExclusions: Maybe<Array<LibraryExclusion>>;
  libraryTechnologies: Array<LibraryTechnology>;
  matterAssumptions: Array<Assumption>;
  matterCollaborators: Array<Collaborator>;
  matterExclusions: Array<Exclusion>;
  matterSpecificRates: Maybe<Array<RateResult>>;
  matterTemplate: Matter;
  matterTemplates: PaginatedMatterTemplates;
  notificationRules: Array<NotificationRule>;
  notifications: Array<Notification>;
  officeLocations: Array<OfficeLocation>;
  organisationalUnits: Array<OrganisationalUnit>;
  parentCollaborators: Array<Collaborator>;
  parentMatterProposal: Proposal;
  proposalByMatterId: ProposalResult;
  roiQuery: RoiQueryResult;
  tags: Array<Tag>;
  taxonomy: Array<Taxonomy>;
  technologyUnits: Array<TechnologyUnit>;
  textFilteredMatters: MatterResult;
  usageReportQuery: UsageReportQueryResult;
};


export type QueryAllClientsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBedrockCheckMatterTitleIsDescriptiveArgs = {
  matterTitle: Scalars['String']['input'];
};


export type QueryBedrockGetPhasesAndTasksArgs = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  customPrompt: InputMaybe<Scalars['String']['input']>;
  matterId: Scalars['Float']['input'];
  refineMode: InputMaybe<Scalars['Boolean']['input']>;
  useLibraryData: Scalars['Boolean']['input'];
};


export type QueryBedrockGetTasksForPhaseArgs = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  customPrompt: InputMaybe<Scalars['String']['input']>;
  matterId: Scalars['Float']['input'];
  phaseId: Scalars['Float']['input'];
  refineMode: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBedrockRoiAnalyseAndRecommendArgs = {
  roiData: RoiAnalysisInput;
};


export type QueryBedrockSuggestAssumptionsArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryBedrockSuggestExclusionsArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryBedrockSuggestPracticeAreasArgs = {
  matterTitle: Scalars['String']['input'];
  practiceAreaName: InputMaybe<Scalars['String']['input']>;
};


export type QueryByIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryClientReportByMatterIdArgs = {
  costProjectionSvgString: Scalars['String']['input'];
  matterId: Scalars['Float']['input'];
};


export type QueryCountNotifyUsersArgs = {
  organisationalUnitIds: Array<Scalars['Int']['input']>;
  roleIds: Array<Scalars['Int']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};


export type QueryCurrentPdfOptionsArgs = {
  outputDesignId: Scalars['Float']['input'];
};


export type QueryDataImportRecordsQueryArgs = {
  input: DataImportRecordsInput;
};


export type QueryDataImportSchemaArgs = {
  type: VpdDataImportType;
};


export type QueryDynamicTagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFeeEarnersByLevelArgs = {
  feeEarnerLevelId: Scalars['Int']['input'];
};


export type QueryFilterUsersArgs = {
  filter: UserFilterInput;
  includeLoggedInUserFirst: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  restrictedClientId: InputMaybe<Scalars['Int']['input']>;
  restrictedExternalMatterId: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFilteredClientsArgs = {
  filter: FilterArg;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFilteredDesignsArgs = {
  filter: OutputDesignWhereInput;
};


export type QueryFilteredExternalMattersArgs = {
  input: FilteredExternalMattersInput;
};


export type QueryFilteredMattersArgs = {
  input: FilteredMattersInput;
};


export type QueryFindAccruedFeesArgs = {
  filter: AccruedFeePagination;
};


export type QueryFindAccruedFeesForMatterArgs = {
  id: Scalars['Float']['input'];
};


export type QueryFindAccruedFeesForUserArgs = {
  filter: AccruedFeeForUserPagination;
};


export type QueryFindCumulativeAccruedFeesForExternalMatterArgs = {
  externalMatterId: Scalars['Float']['input'];
};


export type QueryFindCumulativeAccruedFeesForMatterArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryFindDesignArgs = {
  id: Scalars['Float']['input'];
};


export type QueryFindExternalMatterArgs = {
  id: Scalars['Float']['input'];
};


export type QueryFindMatterArgs = {
  id: Scalars['Float']['input'];
};


export type QueryFindMatterCompletionLogsArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryFindParentMatterArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFindRelevantExternalMattersArgs = {
  additionalSearchText: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  distanceThreshold: InputMaybe<Scalars['Float']['input']>;
  fetchAccruedFees: InputMaybe<Scalars['Boolean']['input']>;
  filter: InputMaybe<RelevantExternalMattersFilter>;
  maxResults: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  unlinkedOnly: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindRelevantMattersArgs = {
  additionalSearchText: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  distanceThreshold: InputMaybe<Scalars['Float']['input']>;
  fetchAccruedFees: InputMaybe<Scalars['Boolean']['input']>;
  filter: InputMaybe<RelevantMattersFilter>;
  maxResults: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<RelevantMattersOrderBy>;
  text: Scalars['String']['input'];
};


export type QueryFindSimilarExternalMattersForMattersArgs = {
  input: FindSimilarExternalMattersForMattersInput;
};


export type QueryFindSimilarMattersArgs = {
  limit?: Scalars['Int']['input'];
  matterId: Scalars['Int']['input'];
  template: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGenerateParentProposalArgs = {
  parentId: Scalars['Float']['input'];
};


export type QueryGenerateProposalArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryGenerateWorkplanArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryGetBrandArgs = {
  id: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetClientsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGetPhaseArgs = {
  phaseId: Scalars['Float']['input'];
};


export type QueryGetPhasesArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryGetRatesArgs = {
  filter: RateFilter;
};


export type QueryGetTaxInfoForMatterArgs = {
  matterId: Scalars['Int']['input'];
};


export type QueryGetTextBlocksArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryGetTopDownRatesArgs = {
  filter: RateFilter;
};


export type QueryGroupItemArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGroupItemsArgs = {
  groupedEntityType: Scalars['String']['input'];
};


export type QueryLibraryAssumptionsArgs = {
  filter: LibraryAssumptionWhereInput;
};


export type QueryLibraryDisbursementsArgs = {
  filter: LibraryDisbursementWhereInput;
};


export type QueryLibraryExclusionsArgs = {
  filter: LibraryExclusionWhereInput;
};


export type QueryMatterAssumptionsArgs = {
  input: Scalars['Float']['input'];
};


export type QueryMatterCollaboratorsArgs = {
  matterId: Scalars['Int']['input'];
};


export type QueryMatterExclusionsArgs = {
  input: Scalars['Float']['input'];
};


export type QueryMatterSpecificRatesArgs = {
  currencyCode: Scalars['String']['input'];
  matterId: Scalars['Float']['input'];
};


export type QueryMatterTemplateArgs = {
  id: Scalars['Float']['input'];
};


export type QueryMatterTemplatesArgs = {
  limit: Scalars['Float']['input'];
  offset: Scalars['Float']['input'];
  orderBy: InputMaybe<FilteredMattersOrderBy>;
  orgUnitFilter: InputMaybe<Scalars['Float']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  templateType: InputMaybe<TemplateType>;
};


export type QueryNotificationsArgs = {
  type: InputMaybe<Scalars['String']['input']>;
};


export type QueryParentCollaboratorsArgs = {
  parentMatterId: Scalars['Int']['input'];
};


export type QueryParentMatterProposalArgs = {
  parentMatterId: Scalars['Int']['input'];
};


export type QueryProposalByMatterIdArgs = {
  matterId: Scalars['Float']['input'];
};


export type QueryRoiQueryArgs = {
  input: RoiQueryInput;
};


export type QueryTextFilteredMattersArgs = {
  filter: TextFilterArg;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsageReportQueryArgs = {
  input: UsageReportQueryInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type QuestionOption = {
  __typename?: 'QuestionOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionResponse = {
  otherValues?: InputMaybe<Array<Scalars['String']['input']>>;
  questionId: Scalars['String']['input'];
  questionLabel: Scalars['String']['input'];
  selectedLabels: Array<Scalars['String']['input']>;
  selectedValues: Array<Scalars['String']['input']>;
};

export type QuickLinkMatterInput = {
  externalMatterId: Scalars['Int']['input'];
  forceOpenModal?: InputMaybe<Scalars['Boolean']['input']>;
  gap?: InputMaybe<Scalars['Float']['input']>;
  highConfidenceMatch?: InputMaybe<Scalars['Boolean']['input']>;
  matterId: Scalars['Int']['input'];
  newClientId?: InputMaybe<Scalars['Int']['input']>;
  rankPosition?: InputMaybe<Scalars['Int']['input']>;
  relevanceScore?: InputMaybe<Scalars['Float']['input']>;
  setLive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateManyClientInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateCreateManyClientInputEnvelope = {
  data: Array<RateCreateManyClientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateManyCurrencyInput = {
  amount: Scalars['Float']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateCreateManyCurrencyInputEnvelope = {
  data: Array<RateCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateManyExternalMatterInput = {
  amount: Scalars['Float']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateCreateManyExternalMatterInputEnvelope = {
  data: Array<RateCreateManyExternalMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateManyFeeEarnerInput = {
  amount: Scalars['Float']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateCreateManyFeeEarnerInputEnvelope = {
  data: Array<RateCreateManyFeeEarnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateManyFeeEarnerLevelInput = {
  amount: Scalars['Float']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateCreateManyFeeEarnerLevelInputEnvelope = {
  data: Array<RateCreateManyFeeEarnerLevelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateManyOfficeLocationInput = {
  amount: Scalars['Float']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateCreateManyOfficeLocationInputEnvelope = {
  data: Array<RateCreateManyOfficeLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateManyOrganisationalUnitInput = {
  amount: Scalars['Float']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId?: InputMaybe<Scalars['Int']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeLocationId?: InputMaybe<Scalars['Int']['input']>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateCreateManyOrganisationalUnitInputEnvelope = {
  data: Array<RateCreateManyOrganisationalUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCreateNestedManyWithoutClientInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<RateCreateWithoutClientInput>>;
  createMany?: InputMaybe<RateCreateManyClientInputEnvelope>;
};

export type RateCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<RateCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<RateCreateManyCurrencyInputEnvelope>;
};

export type RateCreateNestedManyWithoutExternalMatterInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<RateCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<RateCreateManyExternalMatterInputEnvelope>;
};

export type RateCreateNestedManyWithoutFeeEarnerInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<RateCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<RateCreateManyFeeEarnerInputEnvelope>;
};

export type RateCreateNestedManyWithoutFeeEarnerLevelInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<RateCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<RateCreateManyFeeEarnerLevelInputEnvelope>;
};

export type RateCreateNestedManyWithoutOfficeLocationInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutOfficeLocationInput>>;
  create?: InputMaybe<Array<RateCreateWithoutOfficeLocationInput>>;
  createMany?: InputMaybe<RateCreateManyOfficeLocationInputEnvelope>;
};

export type RateCreateNestedManyWithoutOrganisationalUnitInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<RateCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<RateCreateManyOrganisationalUnitInputEnvelope>;
};

export type RateCreateNestedOneWithoutTeamMembershipsInput = {
  connect?: InputMaybe<RateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RateCreateOrConnectWithoutTeamMembershipsInput>;
  create?: InputMaybe<RateCreateWithoutTeamMembershipsInput>;
};

export type RateCreateNestedOneWithoutWorkInput = {
  connect?: InputMaybe<RateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RateCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<RateCreateWithoutWorkInput>;
};

export type RateCreateOrConnectWithoutClientInput = {
  create: RateCreateWithoutClientInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutCurrencyInput = {
  create: RateCreateWithoutCurrencyInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutExternalMatterInput = {
  create: RateCreateWithoutExternalMatterInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutFeeEarnerInput = {
  create: RateCreateWithoutFeeEarnerInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutFeeEarnerLevelInput = {
  create: RateCreateWithoutFeeEarnerLevelInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutOfficeLocationInput = {
  create: RateCreateWithoutOfficeLocationInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutOrganisationalUnitInput = {
  create: RateCreateWithoutOrganisationalUnitInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutTeamMembershipsInput = {
  create: RateCreateWithoutTeamMembershipsInput;
  where: RateWhereUniqueInput;
};

export type RateCreateOrConnectWithoutWorkInput = {
  create: RateCreateWithoutWorkInput;
  where: RateWhereUniqueInput;
};

export type RateCreateWithoutClientInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutCurrencyInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutExternalMatterInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutFeeEarnerInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutFeeEarnerLevelInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutOfficeLocationInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutOrganisationalUnitInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutTeamMembershipsInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  work?: InputMaybe<WorkCreateNestedManyWithoutSelectedRateInput>;
};

export type RateCreateWithoutWorkInput = {
  amount: Scalars['Float']['input'];
  client?: InputMaybe<ClientCreateNestedOneWithoutRatesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutRateInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedReason?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterCreateNestedOneWithoutRatesInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutRatesInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutRatesInput>;
  officeLocation?: InputMaybe<OfficeLocationCreateNestedOneWithoutRatesInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitCreateNestedOneWithoutRatesInput>;
  specificMatterId?: InputMaybe<Scalars['Int']['input']>;
  teamMemberships?: InputMaybe<TeamMembershipCreateNestedManyWithoutRateInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RateFilter = {
  clientId?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  externalMatterId?: InputMaybe<Scalars['Float']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Float']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Float']['input']>;
  matterId: Scalars['Float']['input'];
  officeLocationId?: InputMaybe<Scalars['Float']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Float']['input']>;
};

export type RateGroup = {
  __typename?: 'RateGroup';
  feeEarnerLevelId: Scalars['Float']['output'];
  order: Scalars['Float']['output'];
  rates: Array<RateResult>;
};

export type RateListRelationFilter = {
  every?: InputMaybe<RateWhereInput>;
  none?: InputMaybe<RateWhereInput>;
  some?: InputMaybe<RateWhereInput>;
};

export type RateNullableRelationFilter = {
  is?: InputMaybe<RateWhereInput>;
  isNot?: InputMaybe<RateWhereInput>;
};

export type RateRelationFilter = {
  is?: InputMaybe<RateWhereInput>;
  isNot?: InputMaybe<RateWhereInput>;
};

export type RateReplacement = {
  newFeeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  newFeeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  newRateId: Scalars['Int']['input'];
  oldRateId: Scalars['Int']['input'];
};

export type RateResult = {
  __typename?: 'RateResult';
  amount: Scalars['Float']['output'];
  client: Maybe<Client>;
  clientId: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: Currency;
  currencyId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  deprecated: Scalars['Boolean']['output'];
  deprecatedReason: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalMatter: Maybe<ExternalMatter>;
  externalMatterId: Maybe<Scalars['Int']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  feeEarner: Maybe<FeeEarner>;
  feeEarnerId: Maybe<Scalars['Int']['output']>;
  feeEarnerLevel: Maybe<FeeEarnerLevel>;
  feeEarnerLevelId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isLevelRate: Maybe<Scalars['Boolean']['output']>;
  officeLocationId: Maybe<Scalars['Int']['output']>;
  organisationalUnit: Maybe<OrganisationalUnit>;
  organisationalUnitId: Maybe<Scalars['Int']['output']>;
  specificMatterId: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  work: Maybe<Array<Work>>;
};

export type RateScalarWhereInput = {
  AND?: InputMaybe<Array<RateScalarWhereInput>>;
  NOT?: InputMaybe<Array<RateScalarWhereInput>>;
  OR?: InputMaybe<Array<RateScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatterId?: InputMaybe<IntNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  specificMatterId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RateUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RateUpdateManyWithWhereWithoutClientInput = {
  data: RateUpdateManyMutationInput;
  where: RateScalarWhereInput;
};

export type RateUpdateManyWithWhereWithoutCurrencyInput = {
  data: RateUpdateManyMutationInput;
  where: RateScalarWhereInput;
};

export type RateUpdateManyWithWhereWithoutExternalMatterInput = {
  data: RateUpdateManyMutationInput;
  where: RateScalarWhereInput;
};

export type RateUpdateManyWithWhereWithoutFeeEarnerInput = {
  data: RateUpdateManyMutationInput;
  where: RateScalarWhereInput;
};

export type RateUpdateManyWithWhereWithoutFeeEarnerLevelInput = {
  data: RateUpdateManyMutationInput;
  where: RateScalarWhereInput;
};

export type RateUpdateManyWithWhereWithoutOfficeLocationInput = {
  data: RateUpdateManyMutationInput;
  where: RateScalarWhereInput;
};

export type RateUpdateManyWithWhereWithoutOrganisationalUnitInput = {
  data: RateUpdateManyMutationInput;
  where: RateScalarWhereInput;
};

export type RateUpdateManyWithoutClientNestedInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutClientInput>>;
  create?: InputMaybe<Array<RateCreateWithoutClientInput>>;
  createMany?: InputMaybe<RateCreateManyClientInputEnvelope>;
  delete?: InputMaybe<Array<RateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RateWhereUniqueInput>>;
  set?: InputMaybe<Array<RateWhereUniqueInput>>;
  update?: InputMaybe<Array<RateUpdateWithWhereUniqueWithoutClientInput>>;
  updateMany?: InputMaybe<Array<RateUpdateManyWithWhereWithoutClientInput>>;
  upsert?: InputMaybe<Array<RateUpsertWithWhereUniqueWithoutClientInput>>;
};

export type RateUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<RateCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<RateCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<RateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RateWhereUniqueInput>>;
  set?: InputMaybe<Array<RateWhereUniqueInput>>;
  update?: InputMaybe<Array<RateUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<RateUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<RateUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type RateUpdateManyWithoutExternalMatterNestedInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<RateCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<RateCreateManyExternalMatterInputEnvelope>;
  delete?: InputMaybe<Array<RateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RateWhereUniqueInput>>;
  set?: InputMaybe<Array<RateWhereUniqueInput>>;
  update?: InputMaybe<Array<RateUpdateWithWhereUniqueWithoutExternalMatterInput>>;
  updateMany?: InputMaybe<Array<RateUpdateManyWithWhereWithoutExternalMatterInput>>;
  upsert?: InputMaybe<Array<RateUpsertWithWhereUniqueWithoutExternalMatterInput>>;
};

export type RateUpdateManyWithoutFeeEarnerLevelNestedInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<RateCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<RateCreateManyFeeEarnerLevelInputEnvelope>;
  delete?: InputMaybe<Array<RateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RateWhereUniqueInput>>;
  set?: InputMaybe<Array<RateWhereUniqueInput>>;
  update?: InputMaybe<Array<RateUpdateWithWhereUniqueWithoutFeeEarnerLevelInput>>;
  updateMany?: InputMaybe<Array<RateUpdateManyWithWhereWithoutFeeEarnerLevelInput>>;
  upsert?: InputMaybe<Array<RateUpsertWithWhereUniqueWithoutFeeEarnerLevelInput>>;
};

export type RateUpdateManyWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<RateCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<RateCreateManyFeeEarnerInputEnvelope>;
  delete?: InputMaybe<Array<RateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RateWhereUniqueInput>>;
  set?: InputMaybe<Array<RateWhereUniqueInput>>;
  update?: InputMaybe<Array<RateUpdateWithWhereUniqueWithoutFeeEarnerInput>>;
  updateMany?: InputMaybe<Array<RateUpdateManyWithWhereWithoutFeeEarnerInput>>;
  upsert?: InputMaybe<Array<RateUpsertWithWhereUniqueWithoutFeeEarnerInput>>;
};

export type RateUpdateManyWithoutOfficeLocationNestedInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutOfficeLocationInput>>;
  create?: InputMaybe<Array<RateCreateWithoutOfficeLocationInput>>;
  createMany?: InputMaybe<RateCreateManyOfficeLocationInputEnvelope>;
  delete?: InputMaybe<Array<RateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RateWhereUniqueInput>>;
  set?: InputMaybe<Array<RateWhereUniqueInput>>;
  update?: InputMaybe<Array<RateUpdateWithWhereUniqueWithoutOfficeLocationInput>>;
  updateMany?: InputMaybe<Array<RateUpdateManyWithWhereWithoutOfficeLocationInput>>;
  upsert?: InputMaybe<Array<RateUpsertWithWhereUniqueWithoutOfficeLocationInput>>;
};

export type RateUpdateManyWithoutOrganisationalUnitNestedInput = {
  connect?: InputMaybe<Array<RateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RateCreateOrConnectWithoutOrganisationalUnitInput>>;
  create?: InputMaybe<Array<RateCreateWithoutOrganisationalUnitInput>>;
  createMany?: InputMaybe<RateCreateManyOrganisationalUnitInputEnvelope>;
  delete?: InputMaybe<Array<RateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RateWhereUniqueInput>>;
  set?: InputMaybe<Array<RateWhereUniqueInput>>;
  update?: InputMaybe<Array<RateUpdateWithWhereUniqueWithoutOrganisationalUnitInput>>;
  updateMany?: InputMaybe<Array<RateUpdateManyWithWhereWithoutOrganisationalUnitInput>>;
  upsert?: InputMaybe<Array<RateUpsertWithWhereUniqueWithoutOrganisationalUnitInput>>;
};

export type RateUpdateOneRequiredWithoutTeamMembershipsNestedInput = {
  connect?: InputMaybe<RateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RateCreateOrConnectWithoutTeamMembershipsInput>;
  create?: InputMaybe<RateCreateWithoutTeamMembershipsInput>;
  update?: InputMaybe<RateUpdateToOneWithWhereWithoutTeamMembershipsInput>;
  upsert?: InputMaybe<RateUpsertWithoutTeamMembershipsInput>;
};

export type RateUpdateOneWithoutWorkNestedInput = {
  connect?: InputMaybe<RateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RateCreateOrConnectWithoutWorkInput>;
  create?: InputMaybe<RateCreateWithoutWorkInput>;
  delete?: InputMaybe<RateWhereInput>;
  disconnect?: InputMaybe<RateWhereInput>;
  update?: InputMaybe<RateUpdateToOneWithWhereWithoutWorkInput>;
  upsert?: InputMaybe<RateUpsertWithoutWorkInput>;
};

export type RateUpdateToOneWithWhereWithoutTeamMembershipsInput = {
  data: RateUpdateWithoutTeamMembershipsInput;
  where?: InputMaybe<RateWhereInput>;
};

export type RateUpdateToOneWithWhereWithoutWorkInput = {
  data: RateUpdateWithoutWorkInput;
  where?: InputMaybe<RateWhereInput>;
};

export type RateUpdateWithWhereUniqueWithoutClientInput = {
  data: RateUpdateWithoutClientInput;
  where: RateWhereUniqueInput;
};

export type RateUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: RateUpdateWithoutCurrencyInput;
  where: RateWhereUniqueInput;
};

export type RateUpdateWithWhereUniqueWithoutExternalMatterInput = {
  data: RateUpdateWithoutExternalMatterInput;
  where: RateWhereUniqueInput;
};

export type RateUpdateWithWhereUniqueWithoutFeeEarnerInput = {
  data: RateUpdateWithoutFeeEarnerInput;
  where: RateWhereUniqueInput;
};

export type RateUpdateWithWhereUniqueWithoutFeeEarnerLevelInput = {
  data: RateUpdateWithoutFeeEarnerLevelInput;
  where: RateWhereUniqueInput;
};

export type RateUpdateWithWhereUniqueWithoutOfficeLocationInput = {
  data: RateUpdateWithoutOfficeLocationInput;
  where: RateWhereUniqueInput;
};

export type RateUpdateWithWhereUniqueWithoutOrganisationalUnitInput = {
  data: RateUpdateWithoutOrganisationalUnitInput;
  where: RateWhereUniqueInput;
};

export type RateUpdateWithoutClientInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutCurrencyInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutExternalMatterInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutFeeEarnerInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutFeeEarnerLevelInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutOfficeLocationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutOrganisationalUnitInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutTeamMembershipsInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  work?: InputMaybe<WorkUpdateManyWithoutSelectedRateNestedInput>;
};

export type RateUpdateWithoutWorkInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  client?: InputMaybe<ClientUpdateOneWithoutRatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutRateNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deprecated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deprecatedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneWithoutRatesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutRatesNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutRatesNestedInput>;
  officeLocation?: InputMaybe<OfficeLocationUpdateOneWithoutRatesNestedInput>;
  organisationalUnit?: InputMaybe<OrganisationalUnitUpdateOneWithoutRatesNestedInput>;
  specificMatterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  teamMemberships?: InputMaybe<TeamMembershipUpdateManyWithoutRateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RateUpsertWithWhereUniqueWithoutClientInput = {
  create: RateCreateWithoutClientInput;
  update: RateUpdateWithoutClientInput;
  where: RateWhereUniqueInput;
};

export type RateUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: RateCreateWithoutCurrencyInput;
  update: RateUpdateWithoutCurrencyInput;
  where: RateWhereUniqueInput;
};

export type RateUpsertWithWhereUniqueWithoutExternalMatterInput = {
  create: RateCreateWithoutExternalMatterInput;
  update: RateUpdateWithoutExternalMatterInput;
  where: RateWhereUniqueInput;
};

export type RateUpsertWithWhereUniqueWithoutFeeEarnerInput = {
  create: RateCreateWithoutFeeEarnerInput;
  update: RateUpdateWithoutFeeEarnerInput;
  where: RateWhereUniqueInput;
};

export type RateUpsertWithWhereUniqueWithoutFeeEarnerLevelInput = {
  create: RateCreateWithoutFeeEarnerLevelInput;
  update: RateUpdateWithoutFeeEarnerLevelInput;
  where: RateWhereUniqueInput;
};

export type RateUpsertWithWhereUniqueWithoutOfficeLocationInput = {
  create: RateCreateWithoutOfficeLocationInput;
  update: RateUpdateWithoutOfficeLocationInput;
  where: RateWhereUniqueInput;
};

export type RateUpsertWithWhereUniqueWithoutOrganisationalUnitInput = {
  create: RateCreateWithoutOrganisationalUnitInput;
  update: RateUpdateWithoutOrganisationalUnitInput;
  where: RateWhereUniqueInput;
};

export type RateUpsertWithoutTeamMembershipsInput = {
  create: RateCreateWithoutTeamMembershipsInput;
  update: RateUpdateWithoutTeamMembershipsInput;
  where?: InputMaybe<RateWhereInput>;
};

export type RateUpsertWithoutWorkInput = {
  create: RateCreateWithoutWorkInput;
  update: RateUpdateWithoutWorkInput;
  where?: InputMaybe<RateWhereInput>;
};

export type RateWhereInput = {
  AND?: InputMaybe<Array<RateWhereInput>>;
  NOT?: InputMaybe<Array<RateWhereInput>>;
  OR?: InputMaybe<Array<RateWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatter?: InputMaybe<ExternalMatterNullableRelationFilter>;
  externalMatterId?: InputMaybe<IntNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelNullableRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  officeLocation?: InputMaybe<OfficeLocationNullableRelationFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  specificMatterId?: InputMaybe<IntNullableFilter>;
  teamMemberships?: InputMaybe<TeamMembershipListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type RateWhereUniqueInput = {
  AND?: InputMaybe<Array<RateWhereInput>>;
  NOT?: InputMaybe<Array<RateWhereInput>>;
  OR?: InputMaybe<Array<RateWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  client?: InputMaybe<ClientNullableRelationFilter>;
  clientId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deprecated?: InputMaybe<BoolFilter>;
  deprecatedReason?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterNullableRelationFilter>;
  externalMatterId?: InputMaybe<IntNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelNullableRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  officeLocation?: InputMaybe<OfficeLocationNullableRelationFilter>;
  officeLocationId?: InputMaybe<IntNullableFilter>;
  organisationalUnit?: InputMaybe<OrganisationalUnitNullableRelationFilter>;
  organisationalUnitId?: InputMaybe<IntNullableFilter>;
  specificMatterId?: InputMaybe<IntNullableFilter>;
  teamMemberships?: InputMaybe<TeamMembershipListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  work?: InputMaybe<WorkListRelationFilter>;
};

export type RelevantExternalMatterResult = {
  __typename?: 'RelevantExternalMatterResult';
  agreedPrice: Maybe<Scalars['Float']['output']>;
  autoClosed: Scalars['Boolean']['output'];
  client: Maybe<Client>;
  clientId: Maybe<Scalars['Int']['output']>;
  closed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency: Maybe<Currency>;
  currencyId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  deprecated: Scalars['Boolean']['output'];
  deprecatedReason: Maybe<Scalars['String']['output']>;
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalMatterEmbeddingId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  feeCharged: Maybe<Scalars['Float']['output']>;
  hasTimeEntries: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  leadFeeEarner: Maybe<FeeEarner>;
  leadFeeEarnerId: Maybe<Scalars['Int']['output']>;
  matter: Maybe<Matter>;
  organisationalUnit: Maybe<OrganisationalUnit>;
  organisationalUnitId: Maybe<Scalars['Int']['output']>;
  relevanceScore: Maybe<Scalars['Float']['output']>;
  status: ExternalMatterStatus;
  taxStatus: ExternalMatterTaxStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type RelevantExternalMattersFilter = {
  clientId?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencyId?: InputMaybe<Array<Scalars['Int']['input']>>;
  feeEarnerId?: InputMaybe<Array<Scalars['Int']['input']>>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAtFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAtTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RelevantExternalMattersWithAccruedFees = {
  __typename?: 'RelevantExternalMattersWithAccruedFees';
  accruedFees: Array<BaseAccruedFee>;
  externalMatters: Array<RelevantExternalMatterResult>;
};

export type RelevantMatterResult = {
  __typename?: 'RelevantMatterResult';
  client: Maybe<Client>;
  collaborators: Maybe<Array<Collaborator>>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  currency: Maybe<Currency>;
  externalMatterId: Maybe<Scalars['Int']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isFavourite: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  organisationalUnit: Maybe<OrganisationalUnit>;
  priceOptions: Maybe<PriceOptions>;
  pricingLevel: PricingLevel;
  pricingTarget: Maybe<PricingTarget>;
  pricingType: PricingType;
  reference: Scalars['String']['output'];
  relevanceScore: Maybe<Scalars['Float']['output']>;
  status: MatterStatus;
  teamMemberships: Maybe<Array<TeamMembership>>;
  template: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type RelevantMattersFilter = {
  clientId?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencyId?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeMatterId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerId?: InputMaybe<Array<Scalars['Int']['input']>>;
  organisationalUnitId?: InputMaybe<Scalars['Int']['input']>;
  someTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<MatterStatus>>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAtFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAtTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RelevantMattersOrderBy = {
  actualFee?: InputMaybe<Scalars['AscDesc']['input']>;
  actualGpm?: InputMaybe<Scalars['AscDesc']['input']>;
};

export type RelevantMattersWithAccruedFees = {
  __typename?: 'RelevantMattersWithAccruedFees';
  accruedFees: Array<AccruedFee>;
  matters: Array<RelevantMatterResult>;
};

export type ResourceAndTime = {
  __typename?: 'ResourceAndTime';
  rateId: Scalars['Float']['output'];
  timeRange: TimeRangeAndSingle;
};

export enum RiskLevel {
  HighRisk = 'HighRisk',
  Issue = 'Issue',
  LowRisk = 'LowRisk',
  MediumRisk = 'MediumRisk',
  None = 'None'
}

export type RoiAnalysisInput = {
  cumulativeVpdProfitData: Array<ChartDatum>;
  externalMatterCountData: Array<ChartDatum>;
  notVpdGpmData: Array<ChartDatum>;
  notVpdRollingAgreedRateData: Array<ChartDatum>;
  notVpdRollingRecoveredRateData: Array<ChartDatum>;
  notVpdTotalChargeData: Array<ChartDatum>;
  notVpdWriteOffPercentageData: Array<ChartDatum>;
  vpdGpmData: Array<ChartDatum>;
  vpdMatterCountData: Array<ChartDatum>;
  vpdRollingAgreedRateData: Array<ChartDatum>;
  vpdRollingRecoveredRateData: Array<ChartDatum>;
  vpdTotalChargeData: Array<ChartDatum>;
  vpdWriteOffPercentageData: Array<ChartDatum>;
};

export type RoiFilter = {
  currencyId?: InputMaybe<Scalars['Float']['input']>;
  officeLocationId?: InputMaybe<Scalars['Float']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Float']['input']>;
};

export type RoiQueryInput = {
  filter?: InputMaybe<RoiFilter>;
  startEndDate?: InputMaybe<StartEndDate>;
  timeRange?: InputMaybe<TimeSeriesRange>;
};

export type RoiQueryResult = {
  __typename?: 'RoiQueryResult';
  roiTimeSeriesDataJSON: Scalars['String']['output'];
  timeIntervalsJSON: Scalars['String']['output'];
};

export type Settings = {
  __typename?: 'Settings';
  administrationCharge: Scalars['Int']['output'];
  autoCloseIntervalInDays: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency: Currency;
  currencyId: Maybe<Scalars['Int']['output']>;
  decimalTimeInput: Scalars['Boolean']['output'];
  defaultCountryCode: Maybe<Scalars['String']['output']>;
  enableAi: Scalars['Boolean']['output'];
  enablePiiFiltering: Scalars['Boolean']['output'];
  enableTechPricing: Scalars['Boolean']['output'];
  enableWordExport: Scalars['Boolean']['output'];
  gpmDangerThreshold: Scalars['Int']['output'];
  gpmWarningThreshold: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  numberOfAiSuggestionsToShow: Scalars['Int']['output'];
  organisationPmsName: Maybe<Scalars['String']['output']>;
  restrictGpmVisibility: Scalars['Boolean']['output'];
  seedDataSetsLoaded: Maybe<Scalars['Boolean']['output']>;
  showClarifyingQuestions: Scalars['Boolean']['output'];
  showGpmSlider: Scalars['Boolean']['output'];
  showLibraryAssumptionsExclusions: Scalars['Boolean']['output'];
  staleMatterWarningThresholdInDays: Scalars['Int']['output'];
  systemFont: Scalars['String']['output'];
  systemFontSize: Scalars['Int']['output'];
  taxEnabled: Scalars['Boolean']['output'];
  taxEnabledOptionDefault: Scalars['Boolean']['output'];
  taxLabel: TaxLabel;
  taxLevelPercent: Scalars['Float']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SettingsCreateManyCurrencyInput = {
  administrationCharge?: InputMaybe<Scalars['Int']['input']>;
  autoCloseIntervalInDays?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  decimalTimeInput?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCountryCode?: InputMaybe<Scalars['String']['input']>;
  enableAi?: InputMaybe<Scalars['Boolean']['input']>;
  enablePiiFiltering?: InputMaybe<Scalars['Boolean']['input']>;
  enableTechPricing?: InputMaybe<Scalars['Boolean']['input']>;
  enableWordExport?: InputMaybe<Scalars['Boolean']['input']>;
  gpmDangerThreshold: Scalars['Int']['input'];
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  numberOfAiSuggestionsToShow?: InputMaybe<Scalars['Int']['input']>;
  organisationPmsName?: InputMaybe<Scalars['String']['input']>;
  restrictGpmVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  seedDataSetsLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  showClarifyingQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  showGpmSlider?: InputMaybe<Scalars['Boolean']['input']>;
  showLibraryAssumptionsExclusions?: InputMaybe<Scalars['Boolean']['input']>;
  staleMatterWarningThresholdInDays?: InputMaybe<Scalars['Int']['input']>;
  systemFont?: InputMaybe<Scalars['String']['input']>;
  systemFontSize?: InputMaybe<Scalars['Int']['input']>;
  taxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxEnabledOptionDefault?: InputMaybe<Scalars['Boolean']['input']>;
  taxLabel?: InputMaybe<TaxLabel>;
  taxLevelPercent: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SettingsCreateManyCurrencyInputEnvelope = {
  data: Array<SettingsCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<SettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SettingsCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<SettingsCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<SettingsCreateManyCurrencyInputEnvelope>;
};

export type SettingsCreateOrConnectWithoutCurrencyInput = {
  create: SettingsCreateWithoutCurrencyInput;
  where: SettingsWhereUniqueInput;
};

export type SettingsCreateWithoutCurrencyInput = {
  administrationCharge?: InputMaybe<Scalars['Int']['input']>;
  autoCloseIntervalInDays?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  decimalTimeInput?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCountryCode?: InputMaybe<Scalars['String']['input']>;
  enableAi?: InputMaybe<Scalars['Boolean']['input']>;
  enablePiiFiltering?: InputMaybe<Scalars['Boolean']['input']>;
  enableTechPricing?: InputMaybe<Scalars['Boolean']['input']>;
  enableWordExport?: InputMaybe<Scalars['Boolean']['input']>;
  gpmDangerThreshold: Scalars['Int']['input'];
  gpmWarningThreshold?: InputMaybe<Scalars['Int']['input']>;
  numberOfAiSuggestionsToShow?: InputMaybe<Scalars['Int']['input']>;
  organisationPmsName?: InputMaybe<Scalars['String']['input']>;
  restrictGpmVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  seedDataSetsLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  showClarifyingQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  showGpmSlider?: InputMaybe<Scalars['Boolean']['input']>;
  showLibraryAssumptionsExclusions?: InputMaybe<Scalars['Boolean']['input']>;
  staleMatterWarningThresholdInDays?: InputMaybe<Scalars['Int']['input']>;
  systemFont?: InputMaybe<Scalars['String']['input']>;
  systemFontSize?: InputMaybe<Scalars['Int']['input']>;
  taxEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxEnabledOptionDefault?: InputMaybe<Scalars['Boolean']['input']>;
  taxLabel?: InputMaybe<TaxLabel>;
  taxLevelPercent: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SettingsListRelationFilter = {
  every?: InputMaybe<SettingsWhereInput>;
  none?: InputMaybe<SettingsWhereInput>;
  some?: InputMaybe<SettingsWhereInput>;
};

export type SettingsScalarWhereInput = {
  AND?: InputMaybe<Array<SettingsScalarWhereInput>>;
  NOT?: InputMaybe<Array<SettingsScalarWhereInput>>;
  OR?: InputMaybe<Array<SettingsScalarWhereInput>>;
  administrationCharge?: InputMaybe<IntFilter>;
  autoCloseIntervalInDays?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  decimalTimeInput?: InputMaybe<BoolFilter>;
  defaultCountryCode?: InputMaybe<StringNullableFilter>;
  enableAi?: InputMaybe<BoolFilter>;
  enablePiiFiltering?: InputMaybe<BoolFilter>;
  enableTechPricing?: InputMaybe<BoolFilter>;
  enableWordExport?: InputMaybe<BoolFilter>;
  gpmDangerThreshold?: InputMaybe<IntFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  numberOfAiSuggestionsToShow?: InputMaybe<IntFilter>;
  organisationPmsName?: InputMaybe<StringNullableFilter>;
  restrictGpmVisibility?: InputMaybe<BoolFilter>;
  seedDataSetsLoaded?: InputMaybe<BoolNullableFilter>;
  showClarifyingQuestions?: InputMaybe<BoolFilter>;
  showGpmSlider?: InputMaybe<BoolFilter>;
  showLibraryAssumptionsExclusions?: InputMaybe<BoolFilter>;
  staleMatterWarningThresholdInDays?: InputMaybe<IntFilter>;
  systemFont?: InputMaybe<StringFilter>;
  systemFontSize?: InputMaybe<IntFilter>;
  taxEnabled?: InputMaybe<BoolFilter>;
  taxEnabledOptionDefault?: InputMaybe<BoolFilter>;
  taxLabel?: InputMaybe<EnumTaxLabelFilter>;
  taxLevelPercent?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SettingsUpdateInput = {
  administrationCharge?: InputMaybe<IntFieldUpdateOperationsInput>;
  autoCloseIntervalInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutSettingsNestedInput>;
  decimalTimeInput?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enableAi?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enablePiiFiltering?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableTechPricing?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableWordExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<IntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  numberOfAiSuggestionsToShow?: InputMaybe<IntFieldUpdateOperationsInput>;
  organisationPmsName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  restrictGpmVisibility?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seedDataSetsLoaded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  showClarifyingQuestions?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showGpmSlider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showLibraryAssumptionsExclusions?: InputMaybe<BoolFieldUpdateOperationsInput>;
  staleMatterWarningThresholdInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  systemFont?: InputMaybe<StringFieldUpdateOperationsInput>;
  systemFontSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  taxEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  taxEnabledOptionDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  taxLabel?: InputMaybe<EnumTaxLabelFieldUpdateOperationsInput>;
  taxLevelPercent?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SettingsUpdateManyMutationInput = {
  administrationCharge?: InputMaybe<IntFieldUpdateOperationsInput>;
  autoCloseIntervalInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  decimalTimeInput?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enableAi?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enablePiiFiltering?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableTechPricing?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableWordExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<IntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  numberOfAiSuggestionsToShow?: InputMaybe<IntFieldUpdateOperationsInput>;
  organisationPmsName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  restrictGpmVisibility?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seedDataSetsLoaded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  showClarifyingQuestions?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showGpmSlider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showLibraryAssumptionsExclusions?: InputMaybe<BoolFieldUpdateOperationsInput>;
  staleMatterWarningThresholdInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  systemFont?: InputMaybe<StringFieldUpdateOperationsInput>;
  systemFontSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  taxEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  taxEnabledOptionDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  taxLabel?: InputMaybe<EnumTaxLabelFieldUpdateOperationsInput>;
  taxLevelPercent?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SettingsUpdateManyWithWhereWithoutCurrencyInput = {
  data: SettingsUpdateManyMutationInput;
  where: SettingsScalarWhereInput;
};

export type SettingsUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<SettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SettingsCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<SettingsCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<SettingsCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<SettingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SettingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SettingsWhereUniqueInput>>;
  set?: InputMaybe<Array<SettingsWhereUniqueInput>>;
  update?: InputMaybe<Array<SettingsUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<SettingsUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<SettingsUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type SettingsUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: SettingsUpdateWithoutCurrencyInput;
  where: SettingsWhereUniqueInput;
};

export type SettingsUpdateWithoutCurrencyInput = {
  administrationCharge?: InputMaybe<IntFieldUpdateOperationsInput>;
  autoCloseIntervalInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  decimalTimeInput?: InputMaybe<BoolFieldUpdateOperationsInput>;
  defaultCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enableAi?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enablePiiFiltering?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableTechPricing?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableWordExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gpmDangerThreshold?: InputMaybe<IntFieldUpdateOperationsInput>;
  gpmWarningThreshold?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  numberOfAiSuggestionsToShow?: InputMaybe<IntFieldUpdateOperationsInput>;
  organisationPmsName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  restrictGpmVisibility?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seedDataSetsLoaded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  showClarifyingQuestions?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showGpmSlider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showLibraryAssumptionsExclusions?: InputMaybe<BoolFieldUpdateOperationsInput>;
  staleMatterWarningThresholdInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  systemFont?: InputMaybe<StringFieldUpdateOperationsInput>;
  systemFontSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  taxEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  taxEnabledOptionDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  taxLabel?: InputMaybe<EnumTaxLabelFieldUpdateOperationsInput>;
  taxLevelPercent?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SettingsUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: SettingsCreateWithoutCurrencyInput;
  update: SettingsUpdateWithoutCurrencyInput;
  where: SettingsWhereUniqueInput;
};

export type SettingsWhereInput = {
  AND?: InputMaybe<Array<SettingsWhereInput>>;
  NOT?: InputMaybe<Array<SettingsWhereInput>>;
  OR?: InputMaybe<Array<SettingsWhereInput>>;
  administrationCharge?: InputMaybe<IntFilter>;
  autoCloseIntervalInDays?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  decimalTimeInput?: InputMaybe<BoolFilter>;
  defaultCountryCode?: InputMaybe<StringNullableFilter>;
  enableAi?: InputMaybe<BoolFilter>;
  enablePiiFiltering?: InputMaybe<BoolFilter>;
  enableTechPricing?: InputMaybe<BoolFilter>;
  enableWordExport?: InputMaybe<BoolFilter>;
  gpmDangerThreshold?: InputMaybe<IntFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  numberOfAiSuggestionsToShow?: InputMaybe<IntFilter>;
  organisationPmsName?: InputMaybe<StringNullableFilter>;
  restrictGpmVisibility?: InputMaybe<BoolFilter>;
  seedDataSetsLoaded?: InputMaybe<BoolNullableFilter>;
  showClarifyingQuestions?: InputMaybe<BoolFilter>;
  showGpmSlider?: InputMaybe<BoolFilter>;
  showLibraryAssumptionsExclusions?: InputMaybe<BoolFilter>;
  staleMatterWarningThresholdInDays?: InputMaybe<IntFilter>;
  systemFont?: InputMaybe<StringFilter>;
  systemFontSize?: InputMaybe<IntFilter>;
  taxEnabled?: InputMaybe<BoolFilter>;
  taxEnabledOptionDefault?: InputMaybe<BoolFilter>;
  taxLabel?: InputMaybe<EnumTaxLabelFilter>;
  taxLevelPercent?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<SettingsWhereInput>>;
  NOT?: InputMaybe<Array<SettingsWhereInput>>;
  OR?: InputMaybe<Array<SettingsWhereInput>>;
  administrationCharge?: InputMaybe<IntFilter>;
  autoCloseIntervalInDays?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  decimalTimeInput?: InputMaybe<BoolFilter>;
  defaultCountryCode?: InputMaybe<StringNullableFilter>;
  enableAi?: InputMaybe<BoolFilter>;
  enablePiiFiltering?: InputMaybe<BoolFilter>;
  enableTechPricing?: InputMaybe<BoolFilter>;
  enableWordExport?: InputMaybe<BoolFilter>;
  gpmDangerThreshold?: InputMaybe<IntFilter>;
  gpmWarningThreshold?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  numberOfAiSuggestionsToShow?: InputMaybe<IntFilter>;
  organisationPmsName?: InputMaybe<StringNullableFilter>;
  restrictGpmVisibility?: InputMaybe<BoolFilter>;
  seedDataSetsLoaded?: InputMaybe<BoolNullableFilter>;
  showClarifyingQuestions?: InputMaybe<BoolFilter>;
  showGpmSlider?: InputMaybe<BoolFilter>;
  showLibraryAssumptionsExclusions?: InputMaybe<BoolFilter>;
  staleMatterWarningThresholdInDays?: InputMaybe<IntFilter>;
  systemFont?: InputMaybe<StringFilter>;
  systemFontSize?: InputMaybe<IntFilter>;
  taxEnabled?: InputMaybe<BoolFilter>;
  taxEnabledOptionDefault?: InputMaybe<BoolFilter>;
  taxLabel?: InputMaybe<EnumTaxLabelFilter>;
  taxLevelPercent?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SimilarExternalMattersForMattersResult = {
  __typename?: 'SimilarExternalMattersForMattersResult';
  results: Array<MatterExternalMattersResult>;
};

export type StartEndDate = {
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type StartStreamingResponse = {
  __typename?: 'StartStreamingResponse';
  sessionId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StreamingClarifyingQuestionEvent = {
  __typename?: 'StreamingClarifyingQuestionEvent';
  currentQuestionIndex: Maybe<Scalars['Float']['output']>;
  error: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  question: Maybe<ClarifyingQuestion>;
  sessionId: Scalars['String']['output'];
  totalQuestions: Maybe<Scalars['Float']['output']>;
};

export type StreamingMatterSummaryEvent = {
  __typename?: 'StreamingMatterSummaryEvent';
  chunk: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  fullSummary: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdOrUpdatedMatter: Matter;
  fileDataImportCompleted: DataImportProcessedPayload;
  fileDataImportProgress: DataImportProgress;
  newNotification: NotificationResult;
  streamingClarifyingQuestions: StreamingClarifyingQuestionEvent;
  streamingMatterSummary: StreamingMatterSummaryEvent;
};


export type SubscriptionStreamingClarifyingQuestionsArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionStreamingMatterSummaryArgs = {
  sessionId: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  groupItemId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TagCreateManyGroupItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type TagCreateManyGroupItemInputEnvelope = {
  data: Array<TagCreateManyGroupItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TagCreateNestedManyWithoutGroupItemInput = {
  connect?: InputMaybe<Array<TagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TagCreateOrConnectWithoutGroupItemInput>>;
  create?: InputMaybe<Array<TagCreateWithoutGroupItemInput>>;
  createMany?: InputMaybe<TagCreateManyGroupItemInputEnvelope>;
};

export type TagCreateOrConnectWithoutGroupItemInput = {
  create: TagCreateWithoutGroupItemInput;
  where: TagWhereUniqueInput;
};

export type TagCreateWithoutGroupItemInput = {
  name: Scalars['String']['input'];
};

export type TagListRelationFilter = {
  every?: InputMaybe<TagWhereInput>;
  none?: InputMaybe<TagWhereInput>;
  some?: InputMaybe<TagWhereInput>;
};

export type TagScalarWhereInput = {
  AND?: InputMaybe<Array<TagScalarWhereInput>>;
  NOT?: InputMaybe<Array<TagScalarWhereInput>>;
  OR?: InputMaybe<Array<TagScalarWhereInput>>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TagUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TagUpdateManyWithWhereWithoutGroupItemInput = {
  data: TagUpdateManyMutationInput;
  where: TagScalarWhereInput;
};

export type TagUpdateManyWithoutGroupItemNestedInput = {
  connect?: InputMaybe<Array<TagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TagCreateOrConnectWithoutGroupItemInput>>;
  create?: InputMaybe<Array<TagCreateWithoutGroupItemInput>>;
  createMany?: InputMaybe<TagCreateManyGroupItemInputEnvelope>;
  delete?: InputMaybe<Array<TagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TagWhereUniqueInput>>;
  set?: InputMaybe<Array<TagWhereUniqueInput>>;
  update?: InputMaybe<Array<TagUpdateWithWhereUniqueWithoutGroupItemInput>>;
  updateMany?: InputMaybe<Array<TagUpdateManyWithWhereWithoutGroupItemInput>>;
  upsert?: InputMaybe<Array<TagUpsertWithWhereUniqueWithoutGroupItemInput>>;
};

export type TagUpdateWithWhereUniqueWithoutGroupItemInput = {
  data: TagUpdateWithoutGroupItemInput;
  where: TagWhereUniqueInput;
};

export type TagUpdateWithoutGroupItemInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TagUpsertWithWhereUniqueWithoutGroupItemInput = {
  create: TagCreateWithoutGroupItemInput;
  update: TagUpdateWithoutGroupItemInput;
  where: TagWhereUniqueInput;
};

export type TagWhereInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  groupItem?: InputMaybe<GroupItemNullableRelationFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TagWhereUniqueInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  groupItem?: InputMaybe<GroupItemNullableRelationFilter>;
  groupItemId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
};

export type Task = {
  __typename?: 'Task';
  createdAt: Scalars['DateTimeISO']['output'];
  deadlineDate: Maybe<Scalars['DateTimeISO']['output']>;
  html: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  markedComplete: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  phaseId: Scalars['Int']['output'];
  startDate: Maybe<Scalars['DateTimeISO']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TaskCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  phase: PhaseCreateNestedOneWithoutTasksInput;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TaskCreateManyPhaseInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TaskCreateManyPhaseInputEnvelope = {
  data: Array<TaskCreateManyPhaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskCreateNestedManyWithoutPhaseInput = {
  connect?: InputMaybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaskCreateOrConnectWithoutPhaseInput>>;
  create?: InputMaybe<Array<TaskCreateWithoutPhaseInput>>;
  createMany?: InputMaybe<TaskCreateManyPhaseInputEnvelope>;
};

export type TaskCreateOrConnectWithoutPhaseInput = {
  create: TaskCreateWithoutPhaseInput;
  where: TaskWhereUniqueInput;
};

export type TaskCreateWithoutPhaseInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TaskItem = {
  __typename?: 'TaskItem';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Float']['output'];
  order: Scalars['Float']['output'];
  phaseId: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TaskListRelationFilter = {
  every?: InputMaybe<TaskWhereInput>;
  none?: InputMaybe<TaskWhereInput>;
  some?: InputMaybe<TaskWhereInput>;
};

export type TaskScalarWhereInput = {
  AND?: InputMaybe<Array<TaskScalarWhereInput>>;
  NOT?: InputMaybe<Array<TaskScalarWhereInput>>;
  OR?: InputMaybe<Array<TaskScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  html?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  markedComplete?: InputMaybe<BoolFilter>;
  order?: InputMaybe<IntFilter>;
  phaseId?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TaskUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  phase?: InputMaybe<PhaseUpdateOneRequiredWithoutTasksNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaskUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaskUpdateManyWithWhereWithoutPhaseInput = {
  data: TaskUpdateManyMutationInput;
  where: TaskScalarWhereInput;
};

export type TaskUpdateManyWithoutPhaseNestedInput = {
  connect?: InputMaybe<Array<TaskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaskCreateOrConnectWithoutPhaseInput>>;
  create?: InputMaybe<Array<TaskCreateWithoutPhaseInput>>;
  createMany?: InputMaybe<TaskCreateManyPhaseInputEnvelope>;
  delete?: InputMaybe<Array<TaskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaskWhereUniqueInput>>;
  set?: InputMaybe<Array<TaskWhereUniqueInput>>;
  update?: InputMaybe<Array<TaskUpdateWithWhereUniqueWithoutPhaseInput>>;
  updateMany?: InputMaybe<Array<TaskUpdateManyWithWhereWithoutPhaseInput>>;
  upsert?: InputMaybe<Array<TaskUpsertWithWhereUniqueWithoutPhaseInput>>;
};

export type TaskUpdateWithWhereUniqueWithoutPhaseInput = {
  data: TaskUpdateWithoutPhaseInput;
  where: TaskWhereUniqueInput;
};

export type TaskUpdateWithoutPhaseInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  html?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  markedComplete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaskUpsertWithWhereUniqueWithoutPhaseInput = {
  create: TaskCreateWithoutPhaseInput;
  update: TaskUpdateWithoutPhaseInput;
  where: TaskWhereUniqueInput;
};

export type TaskWhereInput = {
  AND?: InputMaybe<Array<TaskWhereInput>>;
  NOT?: InputMaybe<Array<TaskWhereInput>>;
  OR?: InputMaybe<Array<TaskWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  html?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  markedComplete?: InputMaybe<BoolFilter>;
  order?: InputMaybe<IntFilter>;
  phase?: InputMaybe<PhaseRelationFilter>;
  phaseId?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TaskWhereUniqueInput = {
  AND?: InputMaybe<Array<TaskWhereInput>>;
  NOT?: InputMaybe<Array<TaskWhereInput>>;
  OR?: InputMaybe<Array<TaskWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deadlineDate?: InputMaybe<DateTimeNullableFilter>;
  html?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  markedComplete?: InputMaybe<BoolFilter>;
  order?: InputMaybe<IntFilter>;
  phase?: InputMaybe<PhaseRelationFilter>;
  phaseId?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Tasks = {
  __typename?: 'Tasks';
  tasks: Array<Scalars['String']['output']>;
};

export type Tax = {
  __typename?: 'Tax';
  taxAmount: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
  totalIncludingTax: Scalars['Float']['output'];
};

export type TaxInfo = {
  __typename?: 'TaxInfo';
  taxLabel: Maybe<TaxLabel>;
  taxLevelPercent: Maybe<Scalars['Float']['output']>;
};

export enum TaxLabel {
  Gst = 'GST',
  Vat = 'VAT'
}

export enum TaxLabelEnum {
  Gst = 'GST',
  Vat = 'VAT'
}

export enum TaxLabelStatus {
  Exclusive = 'Exclusive',
  Exempt = 'Exempt',
  Inclusive = 'Inclusive'
}

export enum TaxLabelStatusEnum {
  Exclusive = 'Exclusive',
  Exempt = 'Exempt',
  Inclusive = 'Inclusive'
}

export type TaxOrTaxRange = Tax | TaxRange;

export type TaxRange = {
  __typename?: 'TaxRange';
  taxAmountRange: PriceRange;
  taxRate: Scalars['Float']['output'];
  totalRangeIncludingTax: PriceRange;
};

export enum TaxStatus {
  ClientExempt = 'ClientExempt',
  ExternalMatterExempt = 'ExternalMatterExempt',
  MatterExempt = 'MatterExempt',
  None = 'None'
}

export type Taxonomy = {
  __typename?: 'Taxonomy';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  key: TaxonomyKey;
  updatedAt: Scalars['DateTimeISO']['output'];
  value: Scalars['String']['output'];
};

export enum TaxonomyKey {
  FeeEarner = 'FeeEarner',
  FeeEarnerLevel = 'FeeEarnerLevel',
  PracticeArea = 'PracticeArea',
  Template = 'Template'
}

export type TeamMembership = {
  __typename?: 'TeamMembership';
  feeEarner: Maybe<FeeEarner>;
  feeEarnerId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  matterId: Scalars['Int']['output'];
  rate: RateResult;
  rateId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TeamMembershipCreateManyFeeEarnerInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  rateId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TeamMembershipCreateManyFeeEarnerInputEnvelope = {
  data: Array<TeamMembershipCreateManyFeeEarnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMembershipCreateManyMatterInput = {
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rateId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TeamMembershipCreateManyMatterInputEnvelope = {
  data: Array<TeamMembershipCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMembershipCreateManyRateInput = {
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TeamMembershipCreateManyRateInputEnvelope = {
  data: Array<TeamMembershipCreateManyRateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMembershipCreateNestedManyWithoutFeeEarnerInput = {
  connect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMembershipCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<TeamMembershipCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<TeamMembershipCreateManyFeeEarnerInputEnvelope>;
};

export type TeamMembershipCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMembershipCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<TeamMembershipCreateWithoutMatterInput>>;
  createMany?: InputMaybe<TeamMembershipCreateManyMatterInputEnvelope>;
};

export type TeamMembershipCreateNestedManyWithoutRateInput = {
  connect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMembershipCreateOrConnectWithoutRateInput>>;
  create?: InputMaybe<Array<TeamMembershipCreateWithoutRateInput>>;
  createMany?: InputMaybe<TeamMembershipCreateManyRateInputEnvelope>;
};

export type TeamMembershipCreateOrConnectWithoutFeeEarnerInput = {
  create: TeamMembershipCreateWithoutFeeEarnerInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipCreateOrConnectWithoutMatterInput = {
  create: TeamMembershipCreateWithoutMatterInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipCreateOrConnectWithoutRateInput = {
  create: TeamMembershipCreateWithoutRateInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipCreateWithoutFeeEarnerInput = {
  matter: MatterCreateNestedOneWithoutTeamMembershipsInput;
  rate: RateCreateNestedOneWithoutTeamMembershipsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TeamMembershipCreateWithoutMatterInput = {
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutTeamMembershipsInput>;
  rate: RateCreateNestedOneWithoutTeamMembershipsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TeamMembershipCreateWithoutRateInput = {
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutTeamMembershipsInput>;
  matter: MatterCreateNestedOneWithoutTeamMembershipsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TeamMembershipIds = {
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  rateId: Scalars['Int']['input'];
};

export type TeamMembershipListRelationFilter = {
  every?: InputMaybe<TeamMembershipWhereInput>;
  none?: InputMaybe<TeamMembershipWhereInput>;
  some?: InputMaybe<TeamMembershipWhereInput>;
};

export type TeamMembershipScalarWhereInput = {
  AND?: InputMaybe<Array<TeamMembershipScalarWhereInput>>;
  NOT?: InputMaybe<Array<TeamMembershipScalarWhereInput>>;
  OR?: InputMaybe<Array<TeamMembershipScalarWhereInput>>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  rateId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TeamMembershipUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TeamMembershipUpdateManyWithWhereWithoutFeeEarnerInput = {
  data: TeamMembershipUpdateManyMutationInput;
  where: TeamMembershipScalarWhereInput;
};

export type TeamMembershipUpdateManyWithWhereWithoutMatterInput = {
  data: TeamMembershipUpdateManyMutationInput;
  where: TeamMembershipScalarWhereInput;
};

export type TeamMembershipUpdateManyWithWhereWithoutRateInput = {
  data: TeamMembershipUpdateManyMutationInput;
  where: TeamMembershipScalarWhereInput;
};

export type TeamMembershipUpdateManyWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMembershipCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<TeamMembershipCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<TeamMembershipCreateManyFeeEarnerInputEnvelope>;
  delete?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamMembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamMembershipUpdateWithWhereUniqueWithoutFeeEarnerInput>>;
  updateMany?: InputMaybe<Array<TeamMembershipUpdateManyWithWhereWithoutFeeEarnerInput>>;
  upsert?: InputMaybe<Array<TeamMembershipUpsertWithWhereUniqueWithoutFeeEarnerInput>>;
};

export type TeamMembershipUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMembershipCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<TeamMembershipCreateWithoutMatterInput>>;
  createMany?: InputMaybe<TeamMembershipCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamMembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamMembershipUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<TeamMembershipUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<TeamMembershipUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type TeamMembershipUpdateManyWithoutRateNestedInput = {
  connect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMembershipCreateOrConnectWithoutRateInput>>;
  create?: InputMaybe<Array<TeamMembershipCreateWithoutRateInput>>;
  createMany?: InputMaybe<TeamMembershipCreateManyRateInputEnvelope>;
  delete?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamMembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamMembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamMembershipUpdateWithWhereUniqueWithoutRateInput>>;
  updateMany?: InputMaybe<Array<TeamMembershipUpdateManyWithWhereWithoutRateInput>>;
  upsert?: InputMaybe<Array<TeamMembershipUpsertWithWhereUniqueWithoutRateInput>>;
};

export type TeamMembershipUpdateWithWhereUniqueWithoutFeeEarnerInput = {
  data: TeamMembershipUpdateWithoutFeeEarnerInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipUpdateWithWhereUniqueWithoutMatterInput = {
  data: TeamMembershipUpdateWithoutMatterInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipUpdateWithWhereUniqueWithoutRateInput = {
  data: TeamMembershipUpdateWithoutRateInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipUpdateWithoutFeeEarnerInput = {
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutTeamMembershipsNestedInput>;
  rate?: InputMaybe<RateUpdateOneRequiredWithoutTeamMembershipsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TeamMembershipUpdateWithoutMatterInput = {
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutTeamMembershipsNestedInput>;
  rate?: InputMaybe<RateUpdateOneRequiredWithoutTeamMembershipsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TeamMembershipUpdateWithoutRateInput = {
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutTeamMembershipsNestedInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutTeamMembershipsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TeamMembershipUpsertWithWhereUniqueWithoutFeeEarnerInput = {
  create: TeamMembershipCreateWithoutFeeEarnerInput;
  update: TeamMembershipUpdateWithoutFeeEarnerInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipUpsertWithWhereUniqueWithoutMatterInput = {
  create: TeamMembershipCreateWithoutMatterInput;
  update: TeamMembershipUpdateWithoutMatterInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipUpsertWithWhereUniqueWithoutRateInput = {
  create: TeamMembershipCreateWithoutRateInput;
  update: TeamMembershipUpdateWithoutRateInput;
  where: TeamMembershipWhereUniqueInput;
};

export type TeamMembershipWhereInput = {
  AND?: InputMaybe<Array<TeamMembershipWhereInput>>;
  NOT?: InputMaybe<Array<TeamMembershipWhereInput>>;
  OR?: InputMaybe<Array<TeamMembershipWhereInput>>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  rate?: InputMaybe<RateRelationFilter>;
  rateId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TeamMembershipWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamMembershipWhereInput>>;
  NOT?: InputMaybe<Array<TeamMembershipWhereInput>>;
  OR?: InputMaybe<Array<TeamMembershipWhereInput>>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  rate?: InputMaybe<RateRelationFilter>;
  rateId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TechnologyCharge = {
  __typename?: 'TechnologyCharge';
  autoFocus: Maybe<Scalars['Boolean']['output']>;
  baseAmount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currencyId: Maybe<Scalars['Int']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  fixedAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  libraryTechnology: LibraryTechnology;
  libraryTechnologyId: Scalars['Int']['output'];
  matterId: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  technologyUnit: TechnologyUnit;
  technologyUnitId: Scalars['Int']['output'];
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TechnologyChargeCreateInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutTechnologyChargeInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  libraryTechnology: LibraryTechnologyCreateNestedOneWithoutTechnologyChargesInput;
  matter: MatterCreateNestedOneWithoutTechnologyChargesInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  technologyUnit: TechnologyUnitCreateNestedOneWithoutTechnologyChargesInput;
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateManyCurrencyInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryTechnologyId: Scalars['Int']['input'];
  matterId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  technologyUnitId: Scalars['Int']['input'];
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateManyCurrencyInputEnvelope = {
  data: Array<TechnologyChargeCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyChargeCreateManyLibraryTechnologyInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  technologyUnitId: Scalars['Int']['input'];
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateManyLibraryTechnologyInputEnvelope = {
  data: Array<TechnologyChargeCreateManyLibraryTechnologyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyChargeCreateManyMatterInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryTechnologyId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  technologyUnitId: Scalars['Int']['input'];
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateManyMatterInputEnvelope = {
  data: Array<TechnologyChargeCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyChargeCreateManyTechnologyUnitInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryTechnologyId: Scalars['Int']['input'];
  matterId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateManyTechnologyUnitInputEnvelope = {
  data: Array<TechnologyChargeCreateManyTechnologyUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyChargeCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyCurrencyInputEnvelope>;
};

export type TechnologyChargeCreateNestedManyWithoutLibraryTechnologyInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutLibraryTechnologyInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutLibraryTechnologyInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyLibraryTechnologyInputEnvelope>;
};

export type TechnologyChargeCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutMatterInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyMatterInputEnvelope>;
};

export type TechnologyChargeCreateNestedManyWithoutTechnologyUnitInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutTechnologyUnitInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutTechnologyUnitInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyTechnologyUnitInputEnvelope>;
};

export type TechnologyChargeCreateOrConnectWithoutCurrencyInput = {
  create: TechnologyChargeCreateWithoutCurrencyInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeCreateOrConnectWithoutLibraryTechnologyInput = {
  create: TechnologyChargeCreateWithoutLibraryTechnologyInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeCreateOrConnectWithoutMatterInput = {
  create: TechnologyChargeCreateWithoutMatterInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeCreateOrConnectWithoutTechnologyUnitInput = {
  create: TechnologyChargeCreateWithoutTechnologyUnitInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeCreateWithoutCurrencyInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  libraryTechnology: LibraryTechnologyCreateNestedOneWithoutTechnologyChargesInput;
  matter: MatterCreateNestedOneWithoutTechnologyChargesInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  technologyUnit: TechnologyUnitCreateNestedOneWithoutTechnologyChargesInput;
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateWithoutLibraryTechnologyInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutTechnologyChargeInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  matter: MatterCreateNestedOneWithoutTechnologyChargesInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  technologyUnit: TechnologyUnitCreateNestedOneWithoutTechnologyChargesInput;
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateWithoutMatterInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutTechnologyChargeInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  libraryTechnology: LibraryTechnologyCreateNestedOneWithoutTechnologyChargesInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  technologyUnit: TechnologyUnitCreateNestedOneWithoutTechnologyChargesInput;
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeCreateWithoutTechnologyUnitInput = {
  baseAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutTechnologyChargeInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  fixedAmount: Scalars['Float']['input'];
  libraryTechnology: LibraryTechnologyCreateNestedOneWithoutTechnologyChargesInput;
  matter: MatterCreateNestedOneWithoutTechnologyChargesInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  type: TechnologyChargeType;
  unitCost: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyChargeLineItem = {
  __typename?: 'TechnologyChargeLineItem';
  baseAmount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  fee: PriceOrPriceRange;
  fixedAmount: Scalars['Float']['output'];
  isBaseChargeNonZero: Scalars['Boolean']['output'];
  isBasePlusUnits: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  technologyUnit: Scalars['Float']['output'];
  unitCost: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
};

export type TechnologyChargeListRelationFilter = {
  every?: InputMaybe<TechnologyChargeWhereInput>;
  none?: InputMaybe<TechnologyChargeWhereInput>;
  some?: InputMaybe<TechnologyChargeWhereInput>;
};

export type TechnologyChargeScalarWhereInput = {
  AND?: InputMaybe<Array<TechnologyChargeScalarWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyChargeScalarWhereInput>>;
  OR?: InputMaybe<Array<TechnologyChargeScalarWhereInput>>;
  baseAmount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  fixedAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<IntFilter>;
  libraryTechnologyId?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  percentage?: InputMaybe<FloatFilter>;
  technologyUnitId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumTechnologyChargeTypeFilter>;
  unitCost?: InputMaybe<FloatFilter>;
  units?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum TechnologyChargeType {
  BasePlusUnits = 'BasePlusUnits',
  Fixed = 'Fixed',
  Percentage = 'Percentage'
}

export type TechnologyChargeUpdateInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutTechnologyChargeNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  technologyUnit?: InputMaybe<TechnologyUnitUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  units?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyChargeUpdateManyMutationInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  units?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyChargeUpdateManyWithWhereWithoutCurrencyInput = {
  data: TechnologyChargeUpdateManyMutationInput;
  where: TechnologyChargeScalarWhereInput;
};

export type TechnologyChargeUpdateManyWithWhereWithoutLibraryTechnologyInput = {
  data: TechnologyChargeUpdateManyMutationInput;
  where: TechnologyChargeScalarWhereInput;
};

export type TechnologyChargeUpdateManyWithWhereWithoutMatterInput = {
  data: TechnologyChargeUpdateManyMutationInput;
  where: TechnologyChargeScalarWhereInput;
};

export type TechnologyChargeUpdateManyWithWhereWithoutTechnologyUnitInput = {
  data: TechnologyChargeUpdateManyMutationInput;
  where: TechnologyChargeScalarWhereInput;
};

export type TechnologyChargeUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TechnologyChargeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  set?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  update?: InputMaybe<Array<TechnologyChargeUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<TechnologyChargeUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<TechnologyChargeUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type TechnologyChargeUpdateManyWithoutLibraryTechnologyNestedInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutLibraryTechnologyInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutLibraryTechnologyInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyLibraryTechnologyInputEnvelope>;
  delete?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TechnologyChargeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  set?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  update?: InputMaybe<Array<TechnologyChargeUpdateWithWhereUniqueWithoutLibraryTechnologyInput>>;
  updateMany?: InputMaybe<Array<TechnologyChargeUpdateManyWithWhereWithoutLibraryTechnologyInput>>;
  upsert?: InputMaybe<Array<TechnologyChargeUpsertWithWhereUniqueWithoutLibraryTechnologyInput>>;
};

export type TechnologyChargeUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutMatterInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TechnologyChargeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  set?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  update?: InputMaybe<Array<TechnologyChargeUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<TechnologyChargeUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<TechnologyChargeUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type TechnologyChargeUpdateManyWithoutTechnologyUnitNestedInput = {
  connect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyChargeCreateOrConnectWithoutTechnologyUnitInput>>;
  create?: InputMaybe<Array<TechnologyChargeCreateWithoutTechnologyUnitInput>>;
  createMany?: InputMaybe<TechnologyChargeCreateManyTechnologyUnitInputEnvelope>;
  delete?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TechnologyChargeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  set?: InputMaybe<Array<TechnologyChargeWhereUniqueInput>>;
  update?: InputMaybe<Array<TechnologyChargeUpdateWithWhereUniqueWithoutTechnologyUnitInput>>;
  updateMany?: InputMaybe<Array<TechnologyChargeUpdateManyWithWhereWithoutTechnologyUnitInput>>;
  upsert?: InputMaybe<Array<TechnologyChargeUpsertWithWhereUniqueWithoutTechnologyUnitInput>>;
};

export type TechnologyChargeUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: TechnologyChargeUpdateWithoutCurrencyInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeUpdateWithWhereUniqueWithoutLibraryTechnologyInput = {
  data: TechnologyChargeUpdateWithoutLibraryTechnologyInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeUpdateWithWhereUniqueWithoutMatterInput = {
  data: TechnologyChargeUpdateWithoutMatterInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeUpdateWithWhereUniqueWithoutTechnologyUnitInput = {
  data: TechnologyChargeUpdateWithoutTechnologyUnitInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeUpdateWithoutCurrencyInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  technologyUnit?: InputMaybe<TechnologyUnitUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  units?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyChargeUpdateWithoutLibraryTechnologyInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutTechnologyChargeNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  technologyUnit?: InputMaybe<TechnologyUnitUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  units?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyChargeUpdateWithoutMatterInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutTechnologyChargeNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  technologyUnit?: InputMaybe<TechnologyUnitUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  units?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyChargeUpdateWithoutTechnologyUnitInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutTechnologyChargeNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutTechnologyChargesNestedInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTechnologyChargeTypeFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  units?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyChargeUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: TechnologyChargeCreateWithoutCurrencyInput;
  update: TechnologyChargeUpdateWithoutCurrencyInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeUpsertWithWhereUniqueWithoutLibraryTechnologyInput = {
  create: TechnologyChargeCreateWithoutLibraryTechnologyInput;
  update: TechnologyChargeUpdateWithoutLibraryTechnologyInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeUpsertWithWhereUniqueWithoutMatterInput = {
  create: TechnologyChargeCreateWithoutMatterInput;
  update: TechnologyChargeUpdateWithoutMatterInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeUpsertWithWhereUniqueWithoutTechnologyUnitInput = {
  create: TechnologyChargeCreateWithoutTechnologyUnitInput;
  update: TechnologyChargeUpdateWithoutTechnologyUnitInput;
  where: TechnologyChargeWhereUniqueInput;
};

export type TechnologyChargeWhereInput = {
  AND?: InputMaybe<Array<TechnologyChargeWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyChargeWhereInput>>;
  OR?: InputMaybe<Array<TechnologyChargeWhereInput>>;
  baseAmount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  fixedAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<IntFilter>;
  libraryTechnology?: InputMaybe<LibraryTechnologyRelationFilter>;
  libraryTechnologyId?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  percentage?: InputMaybe<FloatFilter>;
  technologyUnit?: InputMaybe<TechnologyUnitRelationFilter>;
  technologyUnitId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumTechnologyChargeTypeFilter>;
  unitCost?: InputMaybe<FloatFilter>;
  units?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TechnologyChargeWhereUniqueInput = {
  AND?: InputMaybe<Array<TechnologyChargeWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyChargeWhereInput>>;
  OR?: InputMaybe<Array<TechnologyChargeWhereInput>>;
  baseAmount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyNullableRelationFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  fixedAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryTechnology?: InputMaybe<LibraryTechnologyRelationFilter>;
  libraryTechnologyId?: InputMaybe<IntFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  percentage?: InputMaybe<FloatFilter>;
  technologyUnit?: InputMaybe<TechnologyUnitRelationFilter>;
  technologyUnitId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumTechnologyChargeTypeFilter>;
  unitCost?: InputMaybe<FloatFilter>;
  units?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TechnologyRates = {
  __typename?: 'TechnologyRates';
  baseAmount: Scalars['Float']['output'];
  currency: Currency;
  currencyId: Scalars['Int']['output'];
  fixedAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  libraryTechnologyId: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  unitCost: Scalars['Float']['output'];
};

export type TechnologyRatesCreateInput = {
  baseAmount: Scalars['Float']['input'];
  currency: CurrencyCreateNestedOneWithoutTechnologyRatesInput;
  fixedAmount: Scalars['Float']['input'];
  libraryTechnology: LibraryTechnologyCreateNestedOneWithoutTechnologyRatesInput;
  percentage: Scalars['Float']['input'];
  unitCost: Scalars['Float']['input'];
};

export type TechnologyRatesCreateManyCurrencyInput = {
  baseAmount: Scalars['Float']['input'];
  fixedAmount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryTechnologyId: Scalars['Int']['input'];
  percentage: Scalars['Float']['input'];
  unitCost: Scalars['Float']['input'];
};

export type TechnologyRatesCreateManyCurrencyInputEnvelope = {
  data: Array<TechnologyRatesCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyRatesCreateManyItemInput = {
  baseAmount?: InputMaybe<Scalars['Float']['input']>;
  currencyId: Scalars['Int']['input'];
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  libraryTechnologyId: Scalars['Int']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type TechnologyRatesCreateManyLibraryTechnologyInput = {
  baseAmount: Scalars['Float']['input'];
  currencyId: Scalars['Int']['input'];
  fixedAmount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  percentage: Scalars['Float']['input'];
  unitCost: Scalars['Float']['input'];
};

export type TechnologyRatesCreateManyLibraryTechnologyInputEnvelope = {
  data: Array<TechnologyRatesCreateManyLibraryTechnologyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyRatesCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyRatesCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<TechnologyRatesCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<TechnologyRatesCreateManyCurrencyInputEnvelope>;
};

export type TechnologyRatesCreateNestedManyWithoutLibraryTechnologyInput = {
  connect?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyRatesCreateOrConnectWithoutLibraryTechnologyInput>>;
  create?: InputMaybe<Array<TechnologyRatesCreateWithoutLibraryTechnologyInput>>;
  createMany?: InputMaybe<TechnologyRatesCreateManyLibraryTechnologyInputEnvelope>;
};

export type TechnologyRatesCreateOrConnectWithoutCurrencyInput = {
  create: TechnologyRatesCreateWithoutCurrencyInput;
  where: TechnologyRatesWhereUniqueInput;
};

export type TechnologyRatesCreateOrConnectWithoutLibraryTechnologyInput = {
  create: TechnologyRatesCreateWithoutLibraryTechnologyInput;
  where: TechnologyRatesWhereUniqueInput;
};

export type TechnologyRatesCreateWithoutCurrencyInput = {
  baseAmount: Scalars['Float']['input'];
  fixedAmount: Scalars['Float']['input'];
  libraryTechnology: LibraryTechnologyCreateNestedOneWithoutTechnologyRatesInput;
  percentage: Scalars['Float']['input'];
  unitCost: Scalars['Float']['input'];
};

export type TechnologyRatesCreateWithoutLibraryTechnologyInput = {
  baseAmount: Scalars['Float']['input'];
  currency: CurrencyCreateNestedOneWithoutTechnologyRatesInput;
  fixedAmount: Scalars['Float']['input'];
  percentage: Scalars['Float']['input'];
  unitCost: Scalars['Float']['input'];
};

export type TechnologyRatesListRelationFilter = {
  every?: InputMaybe<TechnologyRatesWhereInput>;
  none?: InputMaybe<TechnologyRatesWhereInput>;
  some?: InputMaybe<TechnologyRatesWhereInput>;
};

export type TechnologyRatesScalarWhereInput = {
  AND?: InputMaybe<Array<TechnologyRatesScalarWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyRatesScalarWhereInput>>;
  OR?: InputMaybe<Array<TechnologyRatesScalarWhereInput>>;
  baseAmount?: InputMaybe<FloatFilter>;
  currencyId?: InputMaybe<IntFilter>;
  fixedAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<IntFilter>;
  libraryTechnologyId?: InputMaybe<IntFilter>;
  percentage?: InputMaybe<FloatFilter>;
  unitCost?: InputMaybe<FloatFilter>;
};

export type TechnologyRatesUpdate = {
  baseAmount?: InputMaybe<Scalars['Float']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type TechnologyRatesUpdateManyMutationInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type TechnologyRatesUpdateManyWithWhereWithoutCurrencyInput = {
  data: TechnologyRatesUpdateManyMutationInput;
  where: TechnologyRatesScalarWhereInput;
};

export type TechnologyRatesUpdateManyWithWhereWithoutLibraryTechnologyInput = {
  data: TechnologyRatesUpdateManyMutationInput;
  where: TechnologyRatesScalarWhereInput;
};

export type TechnologyRatesUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyRatesCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<TechnologyRatesCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<TechnologyRatesCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TechnologyRatesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  set?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  update?: InputMaybe<Array<TechnologyRatesUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<TechnologyRatesUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<TechnologyRatesUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type TechnologyRatesUpdateManyWithoutLibraryTechnologyNestedInput = {
  connect?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyRatesCreateOrConnectWithoutLibraryTechnologyInput>>;
  create?: InputMaybe<Array<TechnologyRatesCreateWithoutLibraryTechnologyInput>>;
  createMany?: InputMaybe<TechnologyRatesCreateManyLibraryTechnologyInputEnvelope>;
  delete?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TechnologyRatesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  set?: InputMaybe<Array<TechnologyRatesWhereUniqueInput>>;
  update?: InputMaybe<Array<TechnologyRatesUpdateWithWhereUniqueWithoutLibraryTechnologyInput>>;
  updateMany?: InputMaybe<Array<TechnologyRatesUpdateManyWithWhereWithoutLibraryTechnologyInput>>;
  upsert?: InputMaybe<Array<TechnologyRatesUpsertWithWhereUniqueWithoutLibraryTechnologyInput>>;
};

export type TechnologyRatesUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: TechnologyRatesUpdateWithoutCurrencyInput;
  where: TechnologyRatesWhereUniqueInput;
};

export type TechnologyRatesUpdateWithWhereUniqueWithoutLibraryTechnologyInput = {
  data: TechnologyRatesUpdateWithoutLibraryTechnologyInput;
  where: TechnologyRatesWhereUniqueInput;
};

export type TechnologyRatesUpdateWithoutCurrencyInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyUpdateOneRequiredWithoutTechnologyRatesNestedInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type TechnologyRatesUpdateWithoutLibraryTechnologyInput = {
  baseAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutTechnologyRatesNestedInput>;
  fixedAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  unitCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type TechnologyRatesUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: TechnologyRatesCreateWithoutCurrencyInput;
  update: TechnologyRatesUpdateWithoutCurrencyInput;
  where: TechnologyRatesWhereUniqueInput;
};

export type TechnologyRatesUpsertWithWhereUniqueWithoutLibraryTechnologyInput = {
  create: TechnologyRatesCreateWithoutLibraryTechnologyInput;
  update: TechnologyRatesUpdateWithoutLibraryTechnologyInput;
  where: TechnologyRatesWhereUniqueInput;
};

export type TechnologyRatesWhereInput = {
  AND?: InputMaybe<Array<TechnologyRatesWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyRatesWhereInput>>;
  OR?: InputMaybe<Array<TechnologyRatesWhereInput>>;
  baseAmount?: InputMaybe<FloatFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<IntFilter>;
  fixedAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<IntFilter>;
  libraryTechnology?: InputMaybe<LibraryTechnologyRelationFilter>;
  libraryTechnologyId?: InputMaybe<IntFilter>;
  percentage?: InputMaybe<FloatFilter>;
  unitCost?: InputMaybe<FloatFilter>;
};

export type TechnologyRatesWhereUniqueInput = {
  AND?: InputMaybe<Array<TechnologyRatesWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyRatesWhereInput>>;
  OR?: InputMaybe<Array<TechnologyRatesWhereInput>>;
  baseAmount?: InputMaybe<FloatFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<IntFilter>;
  fixedAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryTechnology?: InputMaybe<LibraryTechnologyRelationFilter>;
  libraryTechnologyId?: InputMaybe<IntFilter>;
  percentage?: InputMaybe<FloatFilter>;
  unitCost?: InputMaybe<FloatFilter>;
};

export type TechnologyUnit = {
  __typename?: 'TechnologyUnit';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Maybe<User>;
  createdById: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TechnologyUnitCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedTechnologyUnitsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutTechnologyUnitInput>;
  name: Scalars['String']['input'];
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutTechnologyUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyUnitCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyUnitCreateManyCreatedByInputEnvelope = {
  data: Array<TechnologyUnitCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyUnitCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<TechnologyUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyUnitCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<TechnologyUnitCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<TechnologyUnitCreateManyCreatedByInputEnvelope>;
};

export type TechnologyUnitCreateNestedOneWithoutLibraryTechnologyInput = {
  connect?: InputMaybe<TechnologyUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TechnologyUnitCreateOrConnectWithoutLibraryTechnologyInput>;
  create?: InputMaybe<TechnologyUnitCreateWithoutLibraryTechnologyInput>;
};

export type TechnologyUnitCreateNestedOneWithoutTechnologyChargesInput = {
  connect?: InputMaybe<TechnologyUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TechnologyUnitCreateOrConnectWithoutTechnologyChargesInput>;
  create?: InputMaybe<TechnologyUnitCreateWithoutTechnologyChargesInput>;
};

export type TechnologyUnitCreateOrConnectWithoutCreatedByInput = {
  create: TechnologyUnitCreateWithoutCreatedByInput;
  where: TechnologyUnitWhereUniqueInput;
};

export type TechnologyUnitCreateOrConnectWithoutLibraryTechnologyInput = {
  create: TechnologyUnitCreateWithoutLibraryTechnologyInput;
  where: TechnologyUnitWhereUniqueInput;
};

export type TechnologyUnitCreateOrConnectWithoutTechnologyChargesInput = {
  create: TechnologyUnitCreateWithoutTechnologyChargesInput;
  where: TechnologyUnitWhereUniqueInput;
};

export type TechnologyUnitCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  libraryTechnology?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutTechnologyUnitInput>;
  name: Scalars['String']['input'];
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutTechnologyUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyUnitCreateWithoutLibraryTechnologyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedTechnologyUnitsInput>;
  name: Scalars['String']['input'];
  technologyCharges?: InputMaybe<TechnologyChargeCreateNestedManyWithoutTechnologyUnitInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyUnitCreateWithoutTechnologyChargesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedTechnologyUnitsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutTechnologyUnitInput>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TechnologyUnitListRelationFilter = {
  every?: InputMaybe<TechnologyUnitWhereInput>;
  none?: InputMaybe<TechnologyUnitWhereInput>;
  some?: InputMaybe<TechnologyUnitWhereInput>;
};

export type TechnologyUnitRelationFilter = {
  is?: InputMaybe<TechnologyUnitWhereInput>;
  isNot?: InputMaybe<TechnologyUnitWhereInput>;
};

export type TechnologyUnitScalarWhereInput = {
  AND?: InputMaybe<Array<TechnologyUnitScalarWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyUnitScalarWhereInput>>;
  OR?: InputMaybe<Array<TechnologyUnitScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TechnologyUnitUpdate = {
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TechnologyUnitUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyUnitUpdateManyWithWhereWithoutCreatedByInput = {
  data: TechnologyUnitUpdateManyMutationInput;
  where: TechnologyUnitScalarWhereInput;
};

export type TechnologyUnitUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<TechnologyUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TechnologyUnitCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<TechnologyUnitCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<TechnologyUnitCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<TechnologyUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TechnologyUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TechnologyUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<TechnologyUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<TechnologyUnitUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<TechnologyUnitUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<TechnologyUnitUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type TechnologyUnitUpdateOneRequiredWithoutLibraryTechnologyNestedInput = {
  connect?: InputMaybe<TechnologyUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TechnologyUnitCreateOrConnectWithoutLibraryTechnologyInput>;
  create?: InputMaybe<TechnologyUnitCreateWithoutLibraryTechnologyInput>;
  update?: InputMaybe<TechnologyUnitUpdateToOneWithWhereWithoutLibraryTechnologyInput>;
  upsert?: InputMaybe<TechnologyUnitUpsertWithoutLibraryTechnologyInput>;
};

export type TechnologyUnitUpdateOneRequiredWithoutTechnologyChargesNestedInput = {
  connect?: InputMaybe<TechnologyUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TechnologyUnitCreateOrConnectWithoutTechnologyChargesInput>;
  create?: InputMaybe<TechnologyUnitCreateWithoutTechnologyChargesInput>;
  update?: InputMaybe<TechnologyUnitUpdateToOneWithWhereWithoutTechnologyChargesInput>;
  upsert?: InputMaybe<TechnologyUnitUpsertWithoutTechnologyChargesInput>;
};

export type TechnologyUnitUpdateToOneWithWhereWithoutLibraryTechnologyInput = {
  data: TechnologyUnitUpdateWithoutLibraryTechnologyInput;
  where?: InputMaybe<TechnologyUnitWhereInput>;
};

export type TechnologyUnitUpdateToOneWithWhereWithoutTechnologyChargesInput = {
  data: TechnologyUnitUpdateWithoutTechnologyChargesInput;
  where?: InputMaybe<TechnologyUnitWhereInput>;
};

export type TechnologyUnitUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: TechnologyUnitUpdateWithoutCreatedByInput;
  where: TechnologyUnitWhereUniqueInput;
};

export type TechnologyUnitUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyUpdateManyWithoutTechnologyUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutTechnologyUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyUnitUpdateWithoutLibraryTechnologyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedTechnologyUnitsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  technologyCharges?: InputMaybe<TechnologyChargeUpdateManyWithoutTechnologyUnitNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyUnitUpdateWithoutTechnologyChargesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedTechnologyUnitsNestedInput>;
  libraryTechnology?: InputMaybe<LibraryTechnologyUpdateManyWithoutTechnologyUnitNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TechnologyUnitUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: TechnologyUnitCreateWithoutCreatedByInput;
  update: TechnologyUnitUpdateWithoutCreatedByInput;
  where: TechnologyUnitWhereUniqueInput;
};

export type TechnologyUnitUpsertWithoutLibraryTechnologyInput = {
  create: TechnologyUnitCreateWithoutLibraryTechnologyInput;
  update: TechnologyUnitUpdateWithoutLibraryTechnologyInput;
  where?: InputMaybe<TechnologyUnitWhereInput>;
};

export type TechnologyUnitUpsertWithoutTechnologyChargesInput = {
  create: TechnologyUnitCreateWithoutTechnologyChargesInput;
  update: TechnologyUnitUpdateWithoutTechnologyChargesInput;
  where?: InputMaybe<TechnologyUnitWhereInput>;
};

export type TechnologyUnitWhereInput = {
  AND?: InputMaybe<Array<TechnologyUnitWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyUnitWhereInput>>;
  OR?: InputMaybe<Array<TechnologyUnitWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  libraryTechnology?: InputMaybe<LibraryTechnologyListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  technologyCharges?: InputMaybe<TechnologyChargeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TechnologyUnitWhereUniqueInput = {
  AND?: InputMaybe<Array<TechnologyUnitWhereInput>>;
  NOT?: InputMaybe<Array<TechnologyUnitWhereInput>>;
  OR?: InputMaybe<Array<TechnologyUnitWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdById?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  libraryTechnology?: InputMaybe<LibraryTechnologyListRelationFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  technologyCharges?: InputMaybe<TechnologyChargeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum TemplateType {
  Firm = 'Firm',
  Vpd = 'VPD'
}

export type TestDesignInput = {
  designId: Scalars['Int']['input'];
  payload: TestDesignInputType;
};

export type TestDesignInputType = {
  adminFeeAmount?: InputMaybe<Scalars['String']['input']>;
  adminFeeRate?: InputMaybe<Scalars['String']['input']>;
  assignedResources?: InputMaybe<Array<Scalars['String']['input']>>;
  assumptions?: InputMaybe<Array<Scalars['String']['input']>>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByName?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  disburementsIncludingTax?: InputMaybe<Scalars['String']['input']>;
  disbursementLineItems?: InputMaybe<Array<DisbursementLineItemInput>>;
  disbursementsTax?: InputMaybe<Scalars['String']['input']>;
  disbursementsTaxAmount?: InputMaybe<Scalars['String']['input']>;
  disbursementsTotal?: InputMaybe<Scalars['String']['input']>;
  disbursementsTotalIncludingTax?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['String']['input']>;
  discountRate?: InputMaybe<Scalars['String']['input']>;
  excludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  exclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  feeEarnerOfficeId?: InputMaybe<Scalars['Float']['input']>;
  feeEarners?: InputMaybe<Array<FeeEarnerInput>>;
  feeRiskDiagram?: InputMaybe<Scalars['String']['input']>;
  feeRiskValid?: InputMaybe<Scalars['Boolean']['input']>;
  fixedFeeGrandTotal?: InputMaybe<Scalars['String']['input']>;
  fixedFeeLegalTotal?: InputMaybe<Scalars['String']['input']>;
  fixedGrandTotal?: InputMaybe<Scalars['String']['input']>;
  fixedLegalAdminCharge?: InputMaybe<Scalars['String']['input']>;
  fixedLegalFeeDiscount?: InputMaybe<Scalars['String']['input']>;
  fixedLegalFeeTax?: InputMaybe<Scalars['String']['input']>;
  fixedLegalFeeWithTax?: InputMaybe<Scalars['String']['input']>;
  fixedLegalTotalWithAdminFee?: InputMaybe<Scalars['String']['input']>;
  grandTotal?: InputMaybe<Scalars['String']['input']>;
  hasDisbursementTax?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisbursements?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasTechnologies?: InputMaybe<Scalars['Boolean']['input']>;
  hasUplifts?: InputMaybe<Scalars['Boolean']['input']>;
  includeAdminFee?: InputMaybe<Scalars['Boolean']['input']>;
  includeDisbursements?: InputMaybe<Scalars['Boolean']['input']>;
  isCappedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isEstimatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isEstimatedRangeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isFixedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isFixedFeeAlternative?: InputMaybe<Scalars['Boolean']['input']>;
  isMatterLevelPricing?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentageDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  leadFeeEarnerEmail?: InputMaybe<Scalars['String']['input']>;
  leadFeeEarnerName?: InputMaybe<Scalars['String']['input']>;
  legalFeeLineItems?: InputMaybe<Array<LegalFeeLineItemInput>>;
  legalFeeTaxAmount?: InputMaybe<Scalars['String']['input']>;
  legalFeeTotal?: InputMaybe<Scalars['String']['input']>;
  legalFeeTotalBeforeVisibleUplifts?: InputMaybe<Scalars['String']['input']>;
  legalFeeTotalIncludingTax?: InputMaybe<Scalars['String']['input']>;
  legalFeeUplifts?: InputMaybe<Array<LegalFeeUpliftInput>>;
  matterTitle?: InputMaybe<Scalars['String']['input']>;
  netAfterDiscount?: InputMaybe<Scalars['String']['input']>;
  netFeeTotal?: InputMaybe<Scalars['String']['input']>;
  netLegalFeeWithAdminFee?: InputMaybe<Scalars['String']['input']>;
  organisationalUnitId?: InputMaybe<Scalars['Float']['input']>;
  pricingLevel?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<Scalars['String']['input']>;
  riskTable?: InputMaybe<Scalars['String']['input']>;
  showFeeEarners?: InputMaybe<Scalars['Boolean']['input']>;
  showFeeRiskDiagram?: InputMaybe<Scalars['Boolean']['input']>;
  showRates?: InputMaybe<Scalars['Boolean']['input']>;
  showTasks?: InputMaybe<Scalars['Boolean']['input']>;
  showTax?: InputMaybe<Scalars['Boolean']['input']>;
  taxLabel?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['String']['input']>;
  technologyChargeLineItems?: InputMaybe<Array<Scalars['String']['input']>>;
  upliftsTotal?: InputMaybe<Scalars['String']['input']>;
};

export type TestDesignOutput = {
  __typename?: 'TestDesignOutput';
  html: Scalars['String']['output'];
};

export type TextBlock = {
  __typename?: 'TextBlock';
  content: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type TimeEntryCreateManyCurrencyInput = {
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId: Scalars['Int']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId: Scalars['Int']['input'];
  hourlyChargeRate: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryCreateManyCurrencyInputEnvelope = {
  data: Array<TimeEntryCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeEntryCreateManyExternalMatterInput = {
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId: Scalars['Int']['input'];
  hourlyChargeRate: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryCreateManyExternalMatterInputEnvelope = {
  data: Array<TimeEntryCreateManyExternalMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeEntryCreateManyFeeEarnerInput = {
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId: Scalars['Int']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  hourlyChargeRate: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  matterInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryCreateManyFeeEarnerInputEnvelope = {
  data: Array<TimeEntryCreateManyFeeEarnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeEntryCreateManyMatterInvoiceInput = {
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatterId: Scalars['Int']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId: Scalars['Int']['input'];
  hourlyChargeRate: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryCreateManyMatterInvoiceInputEnvelope = {
  data: Array<TimeEntryCreateManyMatterInvoiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeEntryCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyCurrencyInputEnvelope>;
};

export type TimeEntryCreateNestedManyWithoutExternalMatterInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyExternalMatterInputEnvelope>;
};

export type TimeEntryCreateNestedManyWithoutFeeEarnerInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyFeeEarnerInputEnvelope>;
};

export type TimeEntryCreateNestedManyWithoutMatterInvoiceInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutMatterInvoiceInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutMatterInvoiceInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyMatterInvoiceInputEnvelope>;
};

export type TimeEntryCreateOrConnectWithoutCurrencyInput = {
  create: TimeEntryCreateWithoutCurrencyInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryCreateOrConnectWithoutExternalMatterInput = {
  create: TimeEntryCreateWithoutExternalMatterInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryCreateOrConnectWithoutFeeEarnerInput = {
  create: TimeEntryCreateWithoutFeeEarnerInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryCreateOrConnectWithoutMatterInvoiceInput = {
  create: TimeEntryCreateWithoutMatterInvoiceInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryCreateWithoutCurrencyInput = {
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter: ExternalMatterCreateNestedOneWithoutTimeEntriesInput;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner: FeeEarnerCreateNestedOneWithoutTimeEntriesInput;
  hourlyChargeRate: Scalars['Float']['input'];
  matterInvoice?: InputMaybe<MatterInvoiceCreateNestedOneWithoutTimeEntryInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryCreateWithoutExternalMatterInput = {
  Currency?: InputMaybe<CurrencyCreateNestedOneWithoutTimeEntryInput>;
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner: FeeEarnerCreateNestedOneWithoutTimeEntriesInput;
  hourlyChargeRate: Scalars['Float']['input'];
  matterInvoice?: InputMaybe<MatterInvoiceCreateNestedOneWithoutTimeEntryInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryCreateWithoutFeeEarnerInput = {
  Currency?: InputMaybe<CurrencyCreateNestedOneWithoutTimeEntryInput>;
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter: ExternalMatterCreateNestedOneWithoutTimeEntriesInput;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  hourlyChargeRate: Scalars['Float']['input'];
  matterInvoice?: InputMaybe<MatterInvoiceCreateNestedOneWithoutTimeEntryInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryCreateWithoutMatterInvoiceInput = {
  Currency?: InputMaybe<CurrencyCreateNestedOneWithoutTimeEntryInput>;
  charge: Scalars['Float']['input'];
  cost: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter: ExternalMatterCreateNestedOneWithoutTimeEntriesInput;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner: FeeEarnerCreateNestedOneWithoutTimeEntriesInput;
  hourlyChargeRate: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TimeEntryListRelationFilter = {
  every?: InputMaybe<TimeEntryWhereInput>;
  none?: InputMaybe<TimeEntryWhereInput>;
  some?: InputMaybe<TimeEntryWhereInput>;
};

export type TimeEntryScalarWhereInput = {
  AND?: InputMaybe<Array<TimeEntryScalarWhereInput>>;
  NOT?: InputMaybe<Array<TimeEntryScalarWhereInput>>;
  OR?: InputMaybe<Array<TimeEntryScalarWhereInput>>;
  charge?: InputMaybe<FloatFilter>;
  cost?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  durationInMinutes?: InputMaybe<IntFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarnerId?: InputMaybe<IntFilter>;
  hourlyChargeRate?: InputMaybe<FloatFilter>;
  id?: InputMaybe<IntFilter>;
  matterInvoiceId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TimeEntryUpdateManyMutationInput = {
  charge?: InputMaybe<FloatFieldUpdateOperationsInput>;
  cost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  durationInMinutes?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hourlyChargeRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TimeEntryUpdateManyWithWhereWithoutCurrencyInput = {
  data: TimeEntryUpdateManyMutationInput;
  where: TimeEntryScalarWhereInput;
};

export type TimeEntryUpdateManyWithWhereWithoutExternalMatterInput = {
  data: TimeEntryUpdateManyMutationInput;
  where: TimeEntryScalarWhereInput;
};

export type TimeEntryUpdateManyWithWhereWithoutFeeEarnerInput = {
  data: TimeEntryUpdateManyMutationInput;
  where: TimeEntryScalarWhereInput;
};

export type TimeEntryUpdateManyWithWhereWithoutMatterInvoiceInput = {
  data: TimeEntryUpdateManyMutationInput;
  where: TimeEntryScalarWhereInput;
};

export type TimeEntryUpdateManyWithoutCurrencyNestedInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TimeEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<TimeEntryUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<TimeEntryUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<TimeEntryUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type TimeEntryUpdateManyWithoutExternalMatterNestedInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutExternalMatterInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutExternalMatterInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyExternalMatterInputEnvelope>;
  delete?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TimeEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<TimeEntryUpdateWithWhereUniqueWithoutExternalMatterInput>>;
  updateMany?: InputMaybe<Array<TimeEntryUpdateManyWithWhereWithoutExternalMatterInput>>;
  upsert?: InputMaybe<Array<TimeEntryUpsertWithWhereUniqueWithoutExternalMatterInput>>;
};

export type TimeEntryUpdateManyWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyFeeEarnerInputEnvelope>;
  delete?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TimeEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<TimeEntryUpdateWithWhereUniqueWithoutFeeEarnerInput>>;
  updateMany?: InputMaybe<Array<TimeEntryUpdateManyWithWhereWithoutFeeEarnerInput>>;
  upsert?: InputMaybe<Array<TimeEntryUpsertWithWhereUniqueWithoutFeeEarnerInput>>;
};

export type TimeEntryUpdateManyWithoutMatterInvoiceNestedInput = {
  connect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TimeEntryCreateOrConnectWithoutMatterInvoiceInput>>;
  create?: InputMaybe<Array<TimeEntryCreateWithoutMatterInvoiceInput>>;
  createMany?: InputMaybe<TimeEntryCreateManyMatterInvoiceInputEnvelope>;
  delete?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TimeEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<TimeEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<TimeEntryUpdateWithWhereUniqueWithoutMatterInvoiceInput>>;
  updateMany?: InputMaybe<Array<TimeEntryUpdateManyWithWhereWithoutMatterInvoiceInput>>;
  upsert?: InputMaybe<Array<TimeEntryUpsertWithWhereUniqueWithoutMatterInvoiceInput>>;
};

export type TimeEntryUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: TimeEntryUpdateWithoutCurrencyInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryUpdateWithWhereUniqueWithoutExternalMatterInput = {
  data: TimeEntryUpdateWithoutExternalMatterInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryUpdateWithWhereUniqueWithoutFeeEarnerInput = {
  data: TimeEntryUpdateWithoutFeeEarnerInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryUpdateWithWhereUniqueWithoutMatterInvoiceInput = {
  data: TimeEntryUpdateWithoutMatterInvoiceInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryUpdateWithoutCurrencyInput = {
  charge?: InputMaybe<FloatFieldUpdateOperationsInput>;
  cost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  durationInMinutes?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutTimeEntriesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneRequiredWithoutTimeEntriesNestedInput>;
  hourlyChargeRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  matterInvoice?: InputMaybe<MatterInvoiceUpdateOneWithoutTimeEntryNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TimeEntryUpdateWithoutExternalMatterInput = {
  Currency?: InputMaybe<CurrencyUpdateOneWithoutTimeEntryNestedInput>;
  charge?: InputMaybe<FloatFieldUpdateOperationsInput>;
  cost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  durationInMinutes?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneRequiredWithoutTimeEntriesNestedInput>;
  hourlyChargeRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  matterInvoice?: InputMaybe<MatterInvoiceUpdateOneWithoutTimeEntryNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TimeEntryUpdateWithoutFeeEarnerInput = {
  Currency?: InputMaybe<CurrencyUpdateOneWithoutTimeEntryNestedInput>;
  charge?: InputMaybe<FloatFieldUpdateOperationsInput>;
  cost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  durationInMinutes?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutTimeEntriesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hourlyChargeRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  matterInvoice?: InputMaybe<MatterInvoiceUpdateOneWithoutTimeEntryNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TimeEntryUpdateWithoutMatterInvoiceInput = {
  Currency?: InputMaybe<CurrencyUpdateOneWithoutTimeEntryNestedInput>;
  charge?: InputMaybe<FloatFieldUpdateOperationsInput>;
  cost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  durationInMinutes?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalMatter?: InputMaybe<ExternalMatterUpdateOneRequiredWithoutTimeEntriesNestedInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneRequiredWithoutTimeEntriesNestedInput>;
  hourlyChargeRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TimeEntryUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: TimeEntryCreateWithoutCurrencyInput;
  update: TimeEntryUpdateWithoutCurrencyInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryUpsertWithWhereUniqueWithoutExternalMatterInput = {
  create: TimeEntryCreateWithoutExternalMatterInput;
  update: TimeEntryUpdateWithoutExternalMatterInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryUpsertWithWhereUniqueWithoutFeeEarnerInput = {
  create: TimeEntryCreateWithoutFeeEarnerInput;
  update: TimeEntryUpdateWithoutFeeEarnerInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryUpsertWithWhereUniqueWithoutMatterInvoiceInput = {
  create: TimeEntryCreateWithoutMatterInvoiceInput;
  update: TimeEntryUpdateWithoutMatterInvoiceInput;
  where: TimeEntryWhereUniqueInput;
};

export type TimeEntryWhereInput = {
  AND?: InputMaybe<Array<TimeEntryWhereInput>>;
  Currency?: InputMaybe<CurrencyNullableRelationFilter>;
  NOT?: InputMaybe<Array<TimeEntryWhereInput>>;
  OR?: InputMaybe<Array<TimeEntryWhereInput>>;
  charge?: InputMaybe<FloatFilter>;
  cost?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  durationInMinutes?: InputMaybe<IntFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalMatter?: InputMaybe<ExternalMatterRelationFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerRelationFilter>;
  feeEarnerId?: InputMaybe<IntFilter>;
  hourlyChargeRate?: InputMaybe<FloatFilter>;
  id?: InputMaybe<IntFilter>;
  matterInvoice?: InputMaybe<MatterInvoiceNullableRelationFilter>;
  matterInvoiceId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TimeEntryWhereUniqueInput = {
  AND?: InputMaybe<Array<TimeEntryWhereInput>>;
  Currency?: InputMaybe<CurrencyNullableRelationFilter>;
  NOT?: InputMaybe<Array<TimeEntryWhereInput>>;
  OR?: InputMaybe<Array<TimeEntryWhereInput>>;
  charge?: InputMaybe<FloatFilter>;
  cost?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  durationInMinutes?: InputMaybe<IntFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalMatter?: InputMaybe<ExternalMatterRelationFilter>;
  externalMatterId?: InputMaybe<IntFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarner?: InputMaybe<FeeEarnerRelationFilter>;
  feeEarnerId?: InputMaybe<IntFilter>;
  hourlyChargeRate?: InputMaybe<FloatFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterInvoice?: InputMaybe<MatterInvoiceNullableRelationFilter>;
  matterInvoiceId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TimeRangeAndSingle = {
  __typename?: 'TimeRangeAndSingle';
  timeLower: Maybe<Scalars['Float']['output']>;
  timeSingle: Maybe<Scalars['Float']['output']>;
  timeUpper: Maybe<Scalars['Float']['output']>;
};

export enum TimeSeriesRange {
  AllTime = 'AllTime',
  Last3Months = 'Last3Months',
  Last6Months = 'Last6Months',
  Last12Months = 'Last12Months',
  LastMonth = 'LastMonth',
  SinceVpd = 'SinceVpd'
}

export type TimeSeriesUsageData = {
  __typename?: 'TimeSeriesUsageData';
  externalMattersStatusCounts: Array<CountByField>;
  practiceAreaCounts: Array<CountByField>;
  timeLabelString: Scalars['String']['output'];
  totalCount: Scalars['Float']['output'];
};

export type TotalWithGroupsResult = {
  __typename?: 'TotalWithGroupsResult';
  items: Array<GroupedResult>;
  total: Scalars['Float']['output'];
};

export type TotalWithGroupsResultMixedUnits = {
  __typename?: 'TotalWithGroupsResultMixedUnits';
  matterId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalPercentage: Scalars['Float']['output'];
};

export type TotalWithLegalFeeGroupsResult = {
  __typename?: 'TotalWithLegalFeeGroupsResult';
  items: Array<GroupedLegalFeeResult>;
  total: Array<LegalFee>;
};

export type UpdateActiveNotificationRulesInput = {
  active: Scalars['Boolean']['input'];
  notificationRuleIds: Array<Scalars['Float']['input']>;
};

export type UpdateBrandInput = {
  footer?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Float']['input'];
  includeTasksInProposalOutput?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  organisationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  proposalFont?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientReportOptionsInput = {
  includeBillingChart?: InputMaybe<Scalars['Boolean']['input']>;
  includeCostProjectionDiagram?: InputMaybe<Scalars['Boolean']['input']>;
  matterId: Scalars['Float']['input'];
};

export type UpdateClientReportOutputInput = {
  designChanged?: InputMaybe<Scalars['Boolean']['input']>;
  designTemplateId: Scalars['Float']['input'];
  htmlContent: Scalars['String']['input'];
  matterId: Scalars['Float']['input'];
  parts: Array<UpdatePartsInput>;
};

export type UpdateDesignsInput = {
  data: OutputDesignUpdateInput;
  id: Scalars['Int']['input'];
};

export type UpdateDisbursementInput = {
  data: DisbursementUpdateInput;
  id: Scalars['Int']['input'];
};

export type UpdateDiscountsInput = {
  data: DiscountUpdateInput;
  id: Scalars['Float']['input'];
};

export type UpdateLibraryAssumptionsResult = {
  __typename?: 'UpdateLibraryAssumptionsResult';
  matterIds: Array<Scalars['Int']['output']>;
  updatedAssumptions: Array<LibraryAssumption>;
};

export type UpdateLibraryExclusionsResult = {
  __typename?: 'UpdateLibraryExclusionsResult';
  matterIds: Array<Scalars['Int']['output']>;
  updatedExclusions: Array<LibraryExclusion>;
};

export type UpdateLibraryTechnologyInput = {
  data: LibraryTechnologyUpdate;
  id: Scalars['Int']['input'];
};

export type UpdateManyAssumptionsInput = {
  id: Scalars['Int']['input'];
  payload: AssumptionUpdateInput;
};

export type UpdateManyExclusionsInput = {
  data: ExclusionUpdateInput;
  id: Scalars['Float']['input'];
};

export type UpdateManyFeeEarnerLevelsInput = {
  id: Scalars['Int']['input'];
  payload: FeeEarnerLevelUpdateInput;
};

export type UpdateManyOrganisationalUnitsInput = {
  id: Scalars['Int']['input'];
  payload: OrganisationalUnitUpdateInput;
};

export type UpdateManyTechnologyRatesInput = {
  items: Array<UpdateTechnologyRatesInput>;
};

export type UpdateManyTechnologyRatesResult = {
  __typename?: 'UpdateManyTechnologyRatesResult';
  count: Scalars['Int']['output'];
};

export type UpdateManyTemplatesInput = {
  id: Scalars['Int']['input'];
  payload: MatterUpdateInput;
};

export type UpdateManyUpliftsInput = {
  data: UpliftUpdateInput;
  id: Scalars['Float']['input'];
};

export type UpdateManyWorkInput = {
  id: Scalars['Float']['input'];
  payload: WorkUpdateInput;
};

export type UpdateMatterCollaboratorsInput = {
  matterId: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type UpdateNotificationRulesInput = {
  accruedBudgetThreshold?: InputMaybe<Scalars['Float']['input']>;
  accruedTimeThreshold?: InputMaybe<Scalars['Float']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeGpmThreshold?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  notifyFeeEarnerLevels?: InputMaybe<Array<Scalars['Float']['input']>>;
  notifyOrganisationalUnits?: InputMaybe<Array<Scalars['Float']['input']>>;
  notifyUsers?: InputMaybe<Array<Scalars['Float']['input']>>;
  proposalFeeThreshold?: InputMaybe<Scalars['Float']['input']>;
  proposalGpmThreshold?: InputMaybe<Scalars['Float']['input']>;
  thresholdBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdFilter?: InputMaybe<Scalars['Float']['input']>;
  triggerBooleanType?: InputMaybe<Scalars['Boolean']['input']>;
  triggerClients?: InputMaybe<Array<Scalars['Float']['input']>>;
  triggerFeeEarnerLevels?: InputMaybe<Array<Scalars['Float']['input']>>;
  triggerMatters?: InputMaybe<Array<Scalars['Float']['input']>>;
  triggerOrganisationalUnits?: InputMaybe<Array<Scalars['Float']['input']>>;
  triggerUsers?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateNotificationRulesResult = {
  __typename?: 'UpdateNotificationRulesResult';
  active: Scalars['Boolean']['output'];
  updatedIds: Array<Scalars['Float']['output']>;
};

export type UpdatePartsInput = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['Boolean']['input']>;
  html: Scalars['String']['input'];
};

export type UpdatePhasesInput = {
  id: Scalars['Float']['input'];
  payload: PhaseUpdateInput;
};

export type UpdateProposalOptionsInput = {
  includeDiagram?: InputMaybe<Scalars['Boolean']['input']>;
  includeDisbursements?: InputMaybe<Scalars['Boolean']['input']>;
  includeGantt?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  matterId: Scalars['Float']['input'];
  showFeeEarners?: InputMaybe<Scalars['Boolean']['input']>;
  showRates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProposalOutputInput = {
  designChanged?: InputMaybe<Scalars['Boolean']['input']>;
  designTemplateId: Scalars['Float']['input'];
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  matterId: Scalars['Float']['input'];
  parts?: InputMaybe<Array<UpdatePartsInput>>;
  selectedOfficeId?: InputMaybe<Scalars['Float']['input']>;
  selectedOrganisationalUnitId?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTaskInput = {
  data: TaskUpdateInput;
  id: Scalars['Float']['input'];
};

export type UpdateTechnologyChargeInput = {
  data: TechnologyChargeUpdateInput;
  id: Scalars['Int']['input'];
};

export type UpdateTechnologyRatesInput = {
  data: TechnologyRatesUpdate;
  id: Scalars['Int']['input'];
};

export type UpdateTechnologyUnitInput = {
  data: TechnologyUnitUpdate;
  id: Scalars['Int']['input'];
};

export type Uplift = {
  __typename?: 'Uplift';
  amount: Scalars['Float']['output'];
  autoFocus: Maybe<Scalars['Boolean']['output']>;
  baseUplift: Maybe<LibraryUplift>;
  baseUpliftId: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  includeOnProposal: Maybe<Scalars['Boolean']['output']>;
  matterId: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  type: UpliftType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type UpliftCreateInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  includeOnProposal?: InputMaybe<Scalars['Boolean']['input']>;
  libraryUplift?: InputMaybe<LibraryUpliftCreateNestedOneWithoutUpliftsInput>;
  matter: MatterCreateNestedOneWithoutUpliftsInput;
  order: Scalars['Int']['input'];
  type: UpliftType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UpliftCreateManyMatterInput = {
  amount: Scalars['Float']['input'];
  baseUpliftId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeOnProposal?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  type: UpliftType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UpliftCreateManyMatterInputEnvelope = {
  data: Array<UpliftCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpliftCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<UpliftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpliftCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<UpliftCreateWithoutMatterInput>>;
  createMany?: InputMaybe<UpliftCreateManyMatterInputEnvelope>;
};

export type UpliftCreateOrConnectWithoutMatterInput = {
  create: UpliftCreateWithoutMatterInput;
  where: UpliftWhereUniqueInput;
};

export type UpliftCreateWithoutMatterInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  includeOnProposal?: InputMaybe<Scalars['Boolean']['input']>;
  libraryUplift?: InputMaybe<LibraryUpliftCreateNestedOneWithoutUpliftsInput>;
  order: Scalars['Int']['input'];
  type: UpliftType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UpliftListRelationFilter = {
  every?: InputMaybe<UpliftWhereInput>;
  none?: InputMaybe<UpliftWhereInput>;
  some?: InputMaybe<UpliftWhereInput>;
};

export type UpliftScalarWhereInput = {
  AND?: InputMaybe<Array<UpliftScalarWhereInput>>;
  NOT?: InputMaybe<Array<UpliftScalarWhereInput>>;
  OR?: InputMaybe<Array<UpliftScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  baseUpliftId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeOnProposal?: InputMaybe<BoolNullableFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumUpliftTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum UpliftType {
  Amount = 'Amount',
  Percent = 'Percent'
}

export type UpliftUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeOnProposal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  libraryUplift?: InputMaybe<LibraryUpliftUpdateOneWithoutUpliftsNestedInput>;
  matter?: InputMaybe<MatterUpdateOneRequiredWithoutUpliftsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpliftTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UpliftUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeOnProposal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpliftTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UpliftUpdateManyWithWhereWithoutMatterInput = {
  data: UpliftUpdateManyMutationInput;
  where: UpliftScalarWhereInput;
};

export type UpliftUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<UpliftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpliftCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<UpliftCreateWithoutMatterInput>>;
  createMany?: InputMaybe<UpliftCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<UpliftWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpliftScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpliftWhereUniqueInput>>;
  set?: InputMaybe<Array<UpliftWhereUniqueInput>>;
  update?: InputMaybe<Array<UpliftUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<UpliftUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<UpliftUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type UpliftUpdateWithWhereUniqueWithoutMatterInput = {
  data: UpliftUpdateWithoutMatterInput;
  where: UpliftWhereUniqueInput;
};

export type UpliftUpdateWithoutMatterInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  includeOnProposal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  libraryUplift?: InputMaybe<LibraryUpliftUpdateOneWithoutUpliftsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpliftTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UpliftUpsertWithWhereUniqueWithoutMatterInput = {
  create: UpliftCreateWithoutMatterInput;
  update: UpliftUpdateWithoutMatterInput;
  where: UpliftWhereUniqueInput;
};

export type UpliftWhereInput = {
  AND?: InputMaybe<Array<UpliftWhereInput>>;
  NOT?: InputMaybe<Array<UpliftWhereInput>>;
  OR?: InputMaybe<Array<UpliftWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  baseUpliftId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  includeOnProposal?: InputMaybe<BoolNullableFilter>;
  libraryUplift?: InputMaybe<LibraryUpliftNullableRelationFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumUpliftTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UpliftWhereUniqueInput = {
  AND?: InputMaybe<Array<UpliftWhereInput>>;
  NOT?: InputMaybe<Array<UpliftWhereInput>>;
  OR?: InputMaybe<Array<UpliftWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  baseUpliftId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeOnProposal?: InputMaybe<BoolNullableFilter>;
  libraryUplift?: InputMaybe<LibraryUpliftNullableRelationFilter>;
  matter?: InputMaybe<MatterRelationFilter>;
  matterId?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumUpliftTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UsageReportQueryInput = {
  startEndDate?: InputMaybe<StartEndDate>;
  timeRange?: InputMaybe<TimeSeriesRange>;
};

export type UsageReportQueryResult = {
  __typename?: 'UsageReportQueryResult';
  aggregateData: AggregateUsageData;
  timeSeriesData: Array<TimeSeriesUsageData>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  displayName: Scalars['String']['output'];
  externalCreatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  externalUpdatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  feeEarnerId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastLoginAt: Maybe<Scalars['DateTimeISO']['output']>;
  quickUpdateShownAt: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userName: Scalars['String']['output'];
};

export type UserCreateNestedManyWithoutFavouriteMattersInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutFavouriteMattersInput>>;
  create?: InputMaybe<Array<UserCreateWithoutFavouriteMattersInput>>;
};

export type UserCreateNestedOneWithoutClientPermissionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutClientPermissionsInput>;
  create?: InputMaybe<UserCreateWithoutClientPermissionsInput>;
};

export type UserCreateNestedOneWithoutCollaboratorCreatedByUserInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCollaboratorCreatedByUserInput>;
  create?: InputMaybe<UserCreateWithoutCollaboratorCreatedByUserInput>;
};

export type UserCreateNestedOneWithoutCollaboratorUserInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCollaboratorUserInput>;
  create?: InputMaybe<UserCreateWithoutCollaboratorUserInput>;
};

export type UserCreateNestedOneWithoutCreatedLibraryAssumptionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedLibraryAssumptionsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedLibraryAssumptionsInput>;
};

export type UserCreateNestedOneWithoutCreatedLibraryExclusionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedLibraryExclusionsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedLibraryExclusionsInput>;
};

export type UserCreateNestedOneWithoutCreatedLibraryTechnologiesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedLibraryTechnologiesInput>;
  create?: InputMaybe<UserCreateWithoutCreatedLibraryTechnologiesInput>;
};

export type UserCreateNestedOneWithoutCreatedMatterCompletionLogsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedMatterCompletionLogsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedMatterCompletionLogsInput>;
};

export type UserCreateNestedOneWithoutCreatedTechnologyUnitsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedTechnologyUnitsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedTechnologyUnitsInput>;
};

export type UserCreateNestedOneWithoutDeletedMattersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDeletedMattersInput>;
  create?: InputMaybe<UserCreateWithoutDeletedMattersInput>;
};

export type UserCreateNestedOneWithoutDeletedParentMattersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDeletedParentMattersInput>;
  create?: InputMaybe<UserCreateWithoutDeletedParentMattersInput>;
};

export type UserCreateNestedOneWithoutFeeEarnerInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFeeEarnerInput>;
  create?: InputMaybe<UserCreateWithoutFeeEarnerInput>;
};

export type UserCreateNestedOneWithoutLinkingLogsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLinkingLogsInput>;
  create?: InputMaybe<UserCreateWithoutLinkingLogsInput>;
};

export type UserCreateNestedOneWithoutMatterPermissionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMatterPermissionsInput>;
  create?: InputMaybe<UserCreateWithoutMatterPermissionsInput>;
};

export type UserCreateNestedOneWithoutNotificationRulesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationRulesInput>;
  create?: InputMaybe<UserCreateWithoutNotificationRulesInput>;
};

export type UserCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<UserCreateWithoutNotificationsInput>;
};

export type UserCreateNestedOneWithoutNotifyRulesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotifyRulesInput>;
  create?: InputMaybe<UserCreateWithoutNotifyRulesInput>;
};

export type UserCreateNestedOneWithoutTriggeredRulesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTriggeredRulesInput>;
  create?: InputMaybe<UserCreateWithoutTriggeredRulesInput>;
};

export type UserCreateOrConnectWithoutClientPermissionsInput = {
  create: UserCreateWithoutClientPermissionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCollaboratorCreatedByUserInput = {
  create: UserCreateWithoutCollaboratorCreatedByUserInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCollaboratorUserInput = {
  create: UserCreateWithoutCollaboratorUserInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedLibraryAssumptionsInput = {
  create: UserCreateWithoutCreatedLibraryAssumptionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedLibraryExclusionsInput = {
  create: UserCreateWithoutCreatedLibraryExclusionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedLibraryTechnologiesInput = {
  create: UserCreateWithoutCreatedLibraryTechnologiesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedMatterCompletionLogsInput = {
  create: UserCreateWithoutCreatedMatterCompletionLogsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedTechnologyUnitsInput = {
  create: UserCreateWithoutCreatedTechnologyUnitsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDeletedMattersInput = {
  create: UserCreateWithoutDeletedMattersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDeletedParentMattersInput = {
  create: UserCreateWithoutDeletedParentMattersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFavouriteMattersInput = {
  create: UserCreateWithoutFavouriteMattersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFeeEarnerInput = {
  create: UserCreateWithoutFeeEarnerInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLinkingLogsInput = {
  create: UserCreateWithoutLinkingLogsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMatterPermissionsInput = {
  create: UserCreateWithoutMatterPermissionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotificationRulesInput = {
  create: UserCreateWithoutNotificationRulesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotificationsInput = {
  create: UserCreateWithoutNotificationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotifyRulesInput = {
  create: UserCreateWithoutNotifyRulesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTriggeredRulesInput = {
  create: UserCreateWithoutTriggeredRulesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutClientPermissionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCollaboratorCreatedByUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCollaboratorUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCreatedLibraryAssumptionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCreatedLibraryExclusionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCreatedLibraryTechnologiesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCreatedMatterCompletionLogsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutCreatedTechnologyUnitsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutDeletedMattersInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutDeletedParentMattersInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutFavouriteMattersInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutFeeEarnerInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutLinkingLogsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutMatterPermissionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutNotificationRulesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutNotificationsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutNotifyRulesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserCreateWithoutTriggeredRulesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputCreateNestedManyWithoutCreatedByUserInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartCreateNestedManyWithoutCreatedByUserInput>;
  ProposalOutput?: InputMaybe<ProposalOutputCreateNestedManyWithoutCreatedByUserInput>;
  clientPermissions?: InputMaybe<ClientPermissionCreateNestedManyWithoutUserInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorCreateNestedManyWithoutCreatedByUserInput>;
  collaboratorUser?: InputMaybe<CollaboratorCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementCreateNestedManyWithoutCreatedByInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionCreateNestedManyWithoutCreatedByInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyCreateNestedManyWithoutCreatedByInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogCreateNestedManyWithoutCreatedByUserInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitCreateNestedManyWithoutCreatedByInput>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedMatters?: InputMaybe<MatterCreateNestedManyWithoutDeletedByInput>;
  deletedParentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutDeletedByInput>;
  displayName: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalDeletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  favouriteMatters?: InputMaybe<MatterCreateNestedManyWithoutFavouritedByInput>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutUsersInput>;
  lastLoginAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  linkingLogs?: InputMaybe<LinkingLogCreateNestedManyWithoutUserInput>;
  matterPermissions?: InputMaybe<MatterPermissionCreateNestedManyWithoutUserInput>;
  matters?: InputMaybe<MatterCreateNestedManyWithoutCreatedByInput>;
  notificationRules?: InputMaybe<NotificationRuleCreateNestedManyWithoutCreatedByInput>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyCreateNestedManyWithoutUserInput>;
  outputDesigns?: InputMaybe<OutputDesignCreateNestedManyWithoutCreatedByUserInput>;
  parentMatters?: InputMaybe<ParentMatterCreateNestedManyWithoutCreatedByInput>;
  quickUpdateShownAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userName: Scalars['String']['input'];
  userSettings?: InputMaybe<UserSettingsCreateNestedOneWithoutUserInput>;
};

export type UserFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  restrictedClientId?: InputMaybe<Scalars['Float']['input']>;
  restrictedExternalMatterId?: InputMaybe<Scalars['Float']['input']>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserNullableRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserPage = {
  __typename?: 'UserPage';
  count: Scalars['Int']['output'];
  users: Array<User>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  displayName?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lastLoginAt?: InputMaybe<DateTimeNullableFilter>;
  quickUpdateShownAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userName?: InputMaybe<StringFilter>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  createdAt: Scalars['DateTimeISO']['output'];
  customPaletteHex: Maybe<Scalars['String']['output']>;
  darkTheme: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type UserSettingsCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<UserSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserSettingsCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<UserSettingsCreateWithoutUserInput>;
};

export type UserSettingsCreateOrConnectWithoutUserInput = {
  create: UserSettingsCreateWithoutUserInput;
  where: UserSettingsWhereUniqueInput;
};

export type UserSettingsCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customPaletteHex?: InputMaybe<Scalars['String']['input']>;
  darkTheme?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserSettingsNullableRelationFilter = {
  is?: InputMaybe<UserSettingsWhereInput>;
  isNot?: InputMaybe<UserSettingsWhereInput>;
};

export type UserSettingsUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customPaletteHex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  darkTheme?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserSettingsUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<UserSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserSettingsCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<UserSettingsCreateWithoutUserInput>;
  delete?: InputMaybe<UserSettingsWhereInput>;
  disconnect?: InputMaybe<UserSettingsWhereInput>;
  update?: InputMaybe<UserSettingsUpdateToOneWithWhereWithoutUserInput>;
  upsert?: InputMaybe<UserSettingsUpsertWithoutUserInput>;
};

export type UserSettingsUpdateToOneWithWhereWithoutUserInput = {
  data: UserSettingsUpdateWithoutUserInput;
  where?: InputMaybe<UserSettingsWhereInput>;
};

export type UserSettingsUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customPaletteHex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  darkTheme?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserSettingsUpsertWithoutUserInput = {
  create: UserSettingsCreateWithoutUserInput;
  update: UserSettingsUpdateWithoutUserInput;
  where?: InputMaybe<UserSettingsWhereInput>;
};

export type UserSettingsWhereInput = {
  AND?: InputMaybe<Array<UserSettingsWhereInput>>;
  NOT?: InputMaybe<Array<UserSettingsWhereInput>>;
  OR?: InputMaybe<Array<UserSettingsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customPaletteHex?: InputMaybe<StringNullableFilter>;
  darkTheme?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UserSettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserSettingsWhereInput>>;
  NOT?: InputMaybe<Array<UserSettingsWhereInput>>;
  OR?: InputMaybe<Array<UserSettingsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customPaletteHex?: InputMaybe<StringNullableFilter>;
  darkTheme?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UserUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutFavouriteMattersInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutFavouriteMattersNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutFavouriteMattersInput>>;
  create?: InputMaybe<Array<UserCreateWithoutFavouriteMattersInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutFavouriteMattersInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutFavouriteMattersInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutFavouriteMattersInput>>;
};

export type UserUpdateOneRequiredWithoutClientPermissionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutClientPermissionsInput>;
  create?: InputMaybe<UserCreateWithoutClientPermissionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutClientPermissionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutClientPermissionsInput>;
};

export type UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCollaboratorCreatedByUserInput>;
  create?: InputMaybe<UserCreateWithoutCollaboratorCreatedByUserInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCollaboratorCreatedByUserInput>;
  upsert?: InputMaybe<UserUpsertWithoutCollaboratorCreatedByUserInput>;
};

export type UserUpdateOneRequiredWithoutCollaboratorUserNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCollaboratorUserInput>;
  create?: InputMaybe<UserCreateWithoutCollaboratorUserInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCollaboratorUserInput>;
  upsert?: InputMaybe<UserUpsertWithoutCollaboratorUserInput>;
};

export type UserUpdateOneRequiredWithoutCreatedMatterCompletionLogsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedMatterCompletionLogsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedMatterCompletionLogsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedMatterCompletionLogsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedMatterCompletionLogsInput>;
};

export type UserUpdateOneRequiredWithoutLinkingLogsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLinkingLogsInput>;
  create?: InputMaybe<UserCreateWithoutLinkingLogsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutLinkingLogsInput>;
  upsert?: InputMaybe<UserUpsertWithoutLinkingLogsInput>;
};

export type UserUpdateOneRequiredWithoutMatterPermissionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMatterPermissionsInput>;
  create?: InputMaybe<UserCreateWithoutMatterPermissionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutMatterPermissionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutMatterPermissionsInput>;
};

export type UserUpdateOneRequiredWithoutNotificationsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<UserCreateWithoutNotificationsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotificationsInput>;
};

export type UserUpdateOneRequiredWithoutNotifyRulesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotifyRulesInput>;
  create?: InputMaybe<UserCreateWithoutNotifyRulesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNotifyRulesInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotifyRulesInput>;
};

export type UserUpdateOneRequiredWithoutTriggeredRulesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTriggeredRulesInput>;
  create?: InputMaybe<UserCreateWithoutTriggeredRulesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutTriggeredRulesInput>;
  upsert?: InputMaybe<UserUpsertWithoutTriggeredRulesInput>;
};

export type UserUpdateOneWithoutCreatedLibraryAssumptionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedLibraryAssumptionsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedLibraryAssumptionsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedLibraryAssumptionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedLibraryAssumptionsInput>;
};

export type UserUpdateOneWithoutCreatedLibraryExclusionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedLibraryExclusionsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedLibraryExclusionsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedLibraryExclusionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedLibraryExclusionsInput>;
};

export type UserUpdateOneWithoutCreatedLibraryTechnologiesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedLibraryTechnologiesInput>;
  create?: InputMaybe<UserCreateWithoutCreatedLibraryTechnologiesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedLibraryTechnologiesInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedLibraryTechnologiesInput>;
};

export type UserUpdateOneWithoutCreatedTechnologyUnitsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedTechnologyUnitsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedTechnologyUnitsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedTechnologyUnitsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedTechnologyUnitsInput>;
};

export type UserUpdateOneWithoutDeletedMattersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDeletedMattersInput>;
  create?: InputMaybe<UserCreateWithoutDeletedMattersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutDeletedMattersInput>;
  upsert?: InputMaybe<UserUpsertWithoutDeletedMattersInput>;
};

export type UserUpdateOneWithoutDeletedParentMattersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDeletedParentMattersInput>;
  create?: InputMaybe<UserCreateWithoutDeletedParentMattersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutDeletedParentMattersInput>;
  upsert?: InputMaybe<UserUpsertWithoutDeletedParentMattersInput>;
};

export type UserUpdateOneWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFeeEarnerInput>;
  create?: InputMaybe<UserCreateWithoutFeeEarnerInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutFeeEarnerInput>;
  upsert?: InputMaybe<UserUpsertWithoutFeeEarnerInput>;
};

export type UserUpdateOneWithoutNotificationRulesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationRulesInput>;
  create?: InputMaybe<UserCreateWithoutNotificationRulesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNotificationRulesInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotificationRulesInput>;
};

export type UserUpdateToOneWithWhereWithoutClientPermissionsInput = {
  data: UserUpdateWithoutClientPermissionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCollaboratorCreatedByUserInput = {
  data: UserUpdateWithoutCollaboratorCreatedByUserInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCollaboratorUserInput = {
  data: UserUpdateWithoutCollaboratorUserInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedLibraryAssumptionsInput = {
  data: UserUpdateWithoutCreatedLibraryAssumptionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedLibraryExclusionsInput = {
  data: UserUpdateWithoutCreatedLibraryExclusionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedLibraryTechnologiesInput = {
  data: UserUpdateWithoutCreatedLibraryTechnologiesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedMatterCompletionLogsInput = {
  data: UserUpdateWithoutCreatedMatterCompletionLogsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedTechnologyUnitsInput = {
  data: UserUpdateWithoutCreatedTechnologyUnitsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutDeletedMattersInput = {
  data: UserUpdateWithoutDeletedMattersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutDeletedParentMattersInput = {
  data: UserUpdateWithoutDeletedParentMattersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutFeeEarnerInput = {
  data: UserUpdateWithoutFeeEarnerInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutLinkingLogsInput = {
  data: UserUpdateWithoutLinkingLogsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMatterPermissionsInput = {
  data: UserUpdateWithoutMatterPermissionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNotificationRulesInput = {
  data: UserUpdateWithoutNotificationRulesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNotificationsInput = {
  data: UserUpdateWithoutNotificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNotifyRulesInput = {
  data: UserUpdateWithoutNotifyRulesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutTriggeredRulesInput = {
  data: UserUpdateWithoutTriggeredRulesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutFavouriteMattersInput = {
  data: UserUpdateWithoutFavouriteMattersInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutClientPermissionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCollaboratorCreatedByUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCollaboratorUserInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedLibraryAssumptionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedLibraryExclusionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedLibraryTechnologiesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedMatterCompletionLogsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedTechnologyUnitsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutDeletedMattersInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutDeletedParentMattersInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutFavouriteMattersInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutFeeEarnerInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutLinkingLogsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutMatterPermissionsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutNotificationRulesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutNotificationsInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutNotifyRulesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpdateWithoutTriggeredRulesInput = {
  ClientReportOutput?: InputMaybe<ClientReportOutputUpdateManyWithoutCreatedByUserNestedInput>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartUpdateManyWithoutCreatedByUserNestedInput>;
  ProposalOutput?: InputMaybe<ProposalOutputUpdateManyWithoutCreatedByUserNestedInput>;
  clientPermissions?: InputMaybe<ClientPermissionUpdateManyWithoutUserNestedInput>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorUpdateManyWithoutCreatedByUserNestedInput>;
  collaboratorUser?: InputMaybe<CollaboratorUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionUpdateManyWithoutCreatedByNestedInput>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyUpdateManyWithoutCreatedByNestedInput>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogUpdateManyWithoutCreatedByUserNestedInput>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitUpdateManyWithoutCreatedByNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedMatters?: InputMaybe<MatterUpdateManyWithoutDeletedByNestedInput>;
  deletedParentMatters?: InputMaybe<ParentMatterUpdateManyWithoutDeletedByNestedInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCreatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalDeletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  favouriteMatters?: InputMaybe<MatterUpdateManyWithoutFavouritedByNestedInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutUsersNestedInput>;
  lastLoginAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkingLogs?: InputMaybe<LinkingLogUpdateManyWithoutUserNestedInput>;
  matterPermissions?: InputMaybe<MatterPermissionUpdateManyWithoutUserNestedInput>;
  matters?: InputMaybe<MatterUpdateManyWithoutCreatedByNestedInput>;
  notificationRules?: InputMaybe<NotificationRuleUpdateManyWithoutCreatedByNestedInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput>;
  outputDesigns?: InputMaybe<OutputDesignUpdateManyWithoutCreatedByUserNestedInput>;
  parentMatters?: InputMaybe<ParentMatterUpdateManyWithoutCreatedByNestedInput>;
  quickUpdateShownAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userName?: InputMaybe<StringFieldUpdateOperationsInput>;
  userSettings?: InputMaybe<UserSettingsUpdateOneWithoutUserNestedInput>;
};

export type UserUpsertWithWhereUniqueWithoutFavouriteMattersInput = {
  create: UserCreateWithoutFavouriteMattersInput;
  update: UserUpdateWithoutFavouriteMattersInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutClientPermissionsInput = {
  create: UserCreateWithoutClientPermissionsInput;
  update: UserUpdateWithoutClientPermissionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCollaboratorCreatedByUserInput = {
  create: UserCreateWithoutCollaboratorCreatedByUserInput;
  update: UserUpdateWithoutCollaboratorCreatedByUserInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCollaboratorUserInput = {
  create: UserCreateWithoutCollaboratorUserInput;
  update: UserUpdateWithoutCollaboratorUserInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedLibraryAssumptionsInput = {
  create: UserCreateWithoutCreatedLibraryAssumptionsInput;
  update: UserUpdateWithoutCreatedLibraryAssumptionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedLibraryExclusionsInput = {
  create: UserCreateWithoutCreatedLibraryExclusionsInput;
  update: UserUpdateWithoutCreatedLibraryExclusionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedLibraryTechnologiesInput = {
  create: UserCreateWithoutCreatedLibraryTechnologiesInput;
  update: UserUpdateWithoutCreatedLibraryTechnologiesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedMatterCompletionLogsInput = {
  create: UserCreateWithoutCreatedMatterCompletionLogsInput;
  update: UserUpdateWithoutCreatedMatterCompletionLogsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedTechnologyUnitsInput = {
  create: UserCreateWithoutCreatedTechnologyUnitsInput;
  update: UserUpdateWithoutCreatedTechnologyUnitsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutDeletedMattersInput = {
  create: UserCreateWithoutDeletedMattersInput;
  update: UserUpdateWithoutDeletedMattersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutDeletedParentMattersInput = {
  create: UserCreateWithoutDeletedParentMattersInput;
  update: UserUpdateWithoutDeletedParentMattersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutFeeEarnerInput = {
  create: UserCreateWithoutFeeEarnerInput;
  update: UserUpdateWithoutFeeEarnerInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutLinkingLogsInput = {
  create: UserCreateWithoutLinkingLogsInput;
  update: UserUpdateWithoutLinkingLogsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutMatterPermissionsInput = {
  create: UserCreateWithoutMatterPermissionsInput;
  update: UserUpdateWithoutMatterPermissionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNotificationRulesInput = {
  create: UserCreateWithoutNotificationRulesInput;
  update: UserUpdateWithoutNotificationRulesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNotificationsInput = {
  create: UserCreateWithoutNotificationsInput;
  update: UserUpdateWithoutNotificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNotifyRulesInput = {
  create: UserCreateWithoutNotifyRulesInput;
  update: UserUpdateWithoutNotifyRulesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutTriggeredRulesInput = {
  create: UserCreateWithoutTriggeredRulesInput;
  update: UserUpdateWithoutTriggeredRulesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  ClientReportOutput?: InputMaybe<ClientReportOutputListRelationFilter>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartListRelationFilter>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartListRelationFilter>;
  ProposalOutput?: InputMaybe<ProposalOutputListRelationFilter>;
  clientPermissions?: InputMaybe<ClientPermissionListRelationFilter>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorListRelationFilter>;
  collaboratorUser?: InputMaybe<CollaboratorListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionListRelationFilter>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementListRelationFilter>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionListRelationFilter>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyListRelationFilter>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogListRelationFilter>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedMatters?: InputMaybe<MatterListRelationFilter>;
  deletedParentMatters?: InputMaybe<ParentMatterListRelationFilter>;
  displayName?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  favouriteMatters?: InputMaybe<MatterListRelationFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lastLoginAt?: InputMaybe<DateTimeNullableFilter>;
  linkingLogs?: InputMaybe<LinkingLogListRelationFilter>;
  matterPermissions?: InputMaybe<MatterPermissionListRelationFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  notificationRules?: InputMaybe<NotificationRuleListRelationFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyListRelationFilter>;
  outputDesigns?: InputMaybe<OutputDesignListRelationFilter>;
  parentMatters?: InputMaybe<ParentMatterListRelationFilter>;
  quickUpdateShownAt?: InputMaybe<DateTimeNullableFilter>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userName?: InputMaybe<StringFilter>;
  userSettings?: InputMaybe<UserSettingsNullableRelationFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  ClientReportOutput?: InputMaybe<ClientReportOutputListRelationFilter>;
  ClientReportOutputPart?: InputMaybe<ClientReportOutputPartListRelationFilter>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  ProposalOuputPart?: InputMaybe<ProposalOuputPartListRelationFilter>;
  ProposalOutput?: InputMaybe<ProposalOutputListRelationFilter>;
  clientPermissions?: InputMaybe<ClientPermissionListRelationFilter>;
  collaboratorCreatedByUser?: InputMaybe<CollaboratorListRelationFilter>;
  collaboratorUser?: InputMaybe<CollaboratorListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdLibraryAssumptions?: InputMaybe<LibraryAssumptionListRelationFilter>;
  createdLibraryDisbursements?: InputMaybe<LibraryDisbursementListRelationFilter>;
  createdLibraryExclusions?: InputMaybe<LibraryExclusionListRelationFilter>;
  createdLibraryTechnologies?: InputMaybe<LibraryTechnologyListRelationFilter>;
  createdMatterCompletionLogs?: InputMaybe<MatterCompletionLogListRelationFilter>;
  createdTechnologyUnits?: InputMaybe<TechnologyUnitListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedMatters?: InputMaybe<MatterListRelationFilter>;
  deletedParentMatters?: InputMaybe<ParentMatterListRelationFilter>;
  displayName?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeNullableFilter>;
  externalDeletedAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<StringNullableFilter>;
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  favouriteMatters?: InputMaybe<MatterListRelationFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastLoginAt?: InputMaybe<DateTimeNullableFilter>;
  linkingLogs?: InputMaybe<LinkingLogListRelationFilter>;
  matterPermissions?: InputMaybe<MatterPermissionListRelationFilter>;
  matters?: InputMaybe<MatterListRelationFilter>;
  notificationRules?: InputMaybe<NotificationRuleListRelationFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  notifyRules?: InputMaybe<NotificationRuleUserNotifyListRelationFilter>;
  outputDesigns?: InputMaybe<OutputDesignListRelationFilter>;
  parentMatters?: InputMaybe<ParentMatterListRelationFilter>;
  quickUpdateShownAt?: InputMaybe<DateTimeNullableFilter>;
  triggeredRules?: InputMaybe<NotificationRuleUserTriggerListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userSettings?: InputMaybe<UserSettingsNullableRelationFilter>;
};

export type UuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum VpdDataImportType {
  Client = 'Client',
  ClientPermissions = 'ClientPermissions',
  Currency = 'Currency',
  ExternalMatter = 'ExternalMatter',
  FeeEarner = 'FeeEarner',
  FeeEarnerLevel = 'FeeEarnerLevel',
  LibraryAssumption = 'LibraryAssumption',
  LibraryDisbursement = 'LibraryDisbursement',
  LibraryExclusion = 'LibraryExclusion',
  LibraryUplift = 'LibraryUplift',
  MatterInvoice = 'MatterInvoice',
  MatterPermissions = 'MatterPermissions',
  OfficeLocation = 'OfficeLocation',
  OrganisationalUnit = 'OrganisationalUnit',
  PermissionSettings = 'PermissionSettings',
  Rate = 'Rate',
  TimeEntry = 'TimeEntry',
  User = 'User'
}

export type Work = {
  __typename?: 'Work';
  cost: PriceRangeAndSingle;
  costRate: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  feeEarner: Maybe<FeeEarner>;
  feeEarnerId: Maybe<Scalars['Int']['output']>;
  feeEarnerLevel: Maybe<FeeEarnerLevel>;
  feeEarnerLevelId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  matterId: Maybe<Scalars['Int']['output']>;
  phaseId: Maybe<Scalars['Int']['output']>;
  price: PriceRangeAndSingle;
  selectedRate: Maybe<RateResult>;
  selectedRateId: Maybe<Scalars['Int']['output']>;
  timeLower: Maybe<Scalars['Int']['output']>;
  timeSingle: Maybe<Scalars['Int']['output']>;
  timeUpper: Maybe<Scalars['Int']['output']>;
  topDownRateDiscount: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  workEffort: Maybe<Scalars['Float']['output']>;
};

export type WorkCreateInput = {
  Matter?: InputMaybe<MatterCreateNestedOneWithoutWorkInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutWorkInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutWorkInput>;
  phase?: InputMaybe<PhaseCreateNestedOneWithoutWorkInput>;
  selectedRate?: InputMaybe<RateCreateNestedOneWithoutWorkInput>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateManyFeeEarnerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  phaseId?: InputMaybe<Scalars['Int']['input']>;
  selectedRateId?: InputMaybe<Scalars['Int']['input']>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateManyFeeEarnerInputEnvelope = {
  data: Array<WorkCreateManyFeeEarnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkCreateManyFeeEarnerLevelInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  phaseId?: InputMaybe<Scalars['Int']['input']>;
  selectedRateId?: InputMaybe<Scalars['Int']['input']>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateManyFeeEarnerLevelInputEnvelope = {
  data: Array<WorkCreateManyFeeEarnerLevelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkCreateManyMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phaseId?: InputMaybe<Scalars['Int']['input']>;
  selectedRateId?: InputMaybe<Scalars['Int']['input']>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateManyMatterInputEnvelope = {
  data: Array<WorkCreateManyMatterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkCreateManyPhaseInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  selectedRateId?: InputMaybe<Scalars['Int']['input']>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateManyPhaseInputEnvelope = {
  data: Array<WorkCreateManyPhaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkCreateManySelectedRateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerId?: InputMaybe<Scalars['Int']['input']>;
  feeEarnerLevelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<Scalars['Int']['input']>;
  phaseId?: InputMaybe<Scalars['Int']['input']>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateManySelectedRateInputEnvelope = {
  data: Array<WorkCreateManySelectedRateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkCreateNestedManyWithoutFeeEarnerInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<WorkCreateManyFeeEarnerInputEnvelope>;
};

export type WorkCreateNestedManyWithoutFeeEarnerLevelInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<WorkCreateManyFeeEarnerLevelInputEnvelope>;
};

export type WorkCreateNestedManyWithoutMatterInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutMatterInput>>;
  createMany?: InputMaybe<WorkCreateManyMatterInputEnvelope>;
};

export type WorkCreateNestedManyWithoutPhaseInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutPhaseInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutPhaseInput>>;
  createMany?: InputMaybe<WorkCreateManyPhaseInputEnvelope>;
};

export type WorkCreateNestedManyWithoutSelectedRateInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutSelectedRateInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutSelectedRateInput>>;
  createMany?: InputMaybe<WorkCreateManySelectedRateInputEnvelope>;
};

export type WorkCreateOrConnectWithoutFeeEarnerInput = {
  create: WorkCreateWithoutFeeEarnerInput;
  where: WorkWhereUniqueInput;
};

export type WorkCreateOrConnectWithoutFeeEarnerLevelInput = {
  create: WorkCreateWithoutFeeEarnerLevelInput;
  where: WorkWhereUniqueInput;
};

export type WorkCreateOrConnectWithoutMatterInput = {
  create: WorkCreateWithoutMatterInput;
  where: WorkWhereUniqueInput;
};

export type WorkCreateOrConnectWithoutPhaseInput = {
  create: WorkCreateWithoutPhaseInput;
  where: WorkWhereUniqueInput;
};

export type WorkCreateOrConnectWithoutSelectedRateInput = {
  create: WorkCreateWithoutSelectedRateInput;
  where: WorkWhereUniqueInput;
};

export type WorkCreateWithoutFeeEarnerInput = {
  Matter?: InputMaybe<MatterCreateNestedOneWithoutWorkInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutWorkInput>;
  phase?: InputMaybe<PhaseCreateNestedOneWithoutWorkInput>;
  selectedRate?: InputMaybe<RateCreateNestedOneWithoutWorkInput>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateWithoutFeeEarnerLevelInput = {
  Matter?: InputMaybe<MatterCreateNestedOneWithoutWorkInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutWorkInput>;
  phase?: InputMaybe<PhaseCreateNestedOneWithoutWorkInput>;
  selectedRate?: InputMaybe<RateCreateNestedOneWithoutWorkInput>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateWithoutMatterInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutWorkInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutWorkInput>;
  phase?: InputMaybe<PhaseCreateNestedOneWithoutWorkInput>;
  selectedRate?: InputMaybe<RateCreateNestedOneWithoutWorkInput>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateWithoutPhaseInput = {
  Matter?: InputMaybe<MatterCreateNestedOneWithoutWorkInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutWorkInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutWorkInput>;
  selectedRate?: InputMaybe<RateCreateNestedOneWithoutWorkInput>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkCreateWithoutSelectedRateInput = {
  Matter?: InputMaybe<MatterCreateNestedOneWithoutWorkInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  feeEarner?: InputMaybe<FeeEarnerCreateNestedOneWithoutWorkInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelCreateNestedOneWithoutWorkInput>;
  phase?: InputMaybe<PhaseCreateNestedOneWithoutWorkInput>;
  timeLower?: InputMaybe<Scalars['Int']['input']>;
  timeSingle?: InputMaybe<Scalars['Int']['input']>;
  timeUpper?: InputMaybe<Scalars['Int']['input']>;
  topDownRateDiscount?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workEffort?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkItem = {
  __typename?: 'WorkItem';
  id: Scalars['Float']['output'];
  resourceAndTime: Array<ResourceAndTime>;
  title: Scalars['String']['output'];
};

export type WorkListRelationFilter = {
  every?: InputMaybe<WorkWhereInput>;
  none?: InputMaybe<WorkWhereInput>;
  some?: InputMaybe<WorkWhereInput>;
};

export type WorkScalarWhereInput = {
  AND?: InputMaybe<Array<WorkScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  phaseId?: InputMaybe<IntNullableFilter>;
  selectedRateId?: InputMaybe<IntNullableFilter>;
  timeLower?: InputMaybe<IntNullableFilter>;
  timeSingle?: InputMaybe<IntNullableFilter>;
  timeUpper?: InputMaybe<IntNullableFilter>;
  topDownRateDiscount?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workEffort?: InputMaybe<FloatNullableFilter>;
};

export type WorkUpdateInput = {
  Matter?: InputMaybe<MatterUpdateOneWithoutWorkNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutWorkNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutWorkNestedInput>;
  phase?: InputMaybe<PhaseUpdateOneWithoutWorkNestedInput>;
  selectedRate?: InputMaybe<RateUpdateOneWithoutWorkNestedInput>;
  timeLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeSingle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workEffort?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type WorkUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeSingle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workEffort?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type WorkUpdateManyWithWhereWithoutFeeEarnerInput = {
  data: WorkUpdateManyMutationInput;
  where: WorkScalarWhereInput;
};

export type WorkUpdateManyWithWhereWithoutFeeEarnerLevelInput = {
  data: WorkUpdateManyMutationInput;
  where: WorkScalarWhereInput;
};

export type WorkUpdateManyWithWhereWithoutMatterInput = {
  data: WorkUpdateManyMutationInput;
  where: WorkScalarWhereInput;
};

export type WorkUpdateManyWithWhereWithoutPhaseInput = {
  data: WorkUpdateManyMutationInput;
  where: WorkScalarWhereInput;
};

export type WorkUpdateManyWithWhereWithoutSelectedRateInput = {
  data: WorkUpdateManyMutationInput;
  where: WorkScalarWhereInput;
};

export type WorkUpdateManyWithoutFeeEarnerLevelNestedInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutFeeEarnerLevelInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutFeeEarnerLevelInput>>;
  createMany?: InputMaybe<WorkCreateManyFeeEarnerLevelInputEnvelope>;
  delete?: InputMaybe<Array<WorkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkUpdateWithWhereUniqueWithoutFeeEarnerLevelInput>>;
  updateMany?: InputMaybe<Array<WorkUpdateManyWithWhereWithoutFeeEarnerLevelInput>>;
  upsert?: InputMaybe<Array<WorkUpsertWithWhereUniqueWithoutFeeEarnerLevelInput>>;
};

export type WorkUpdateManyWithoutFeeEarnerNestedInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutFeeEarnerInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutFeeEarnerInput>>;
  createMany?: InputMaybe<WorkCreateManyFeeEarnerInputEnvelope>;
  delete?: InputMaybe<Array<WorkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkUpdateWithWhereUniqueWithoutFeeEarnerInput>>;
  updateMany?: InputMaybe<Array<WorkUpdateManyWithWhereWithoutFeeEarnerInput>>;
  upsert?: InputMaybe<Array<WorkUpsertWithWhereUniqueWithoutFeeEarnerInput>>;
};

export type WorkUpdateManyWithoutMatterNestedInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutMatterInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutMatterInput>>;
  createMany?: InputMaybe<WorkCreateManyMatterInputEnvelope>;
  delete?: InputMaybe<Array<WorkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkUpdateWithWhereUniqueWithoutMatterInput>>;
  updateMany?: InputMaybe<Array<WorkUpdateManyWithWhereWithoutMatterInput>>;
  upsert?: InputMaybe<Array<WorkUpsertWithWhereUniqueWithoutMatterInput>>;
};

export type WorkUpdateManyWithoutPhaseNestedInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutPhaseInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutPhaseInput>>;
  createMany?: InputMaybe<WorkCreateManyPhaseInputEnvelope>;
  delete?: InputMaybe<Array<WorkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkUpdateWithWhereUniqueWithoutPhaseInput>>;
  updateMany?: InputMaybe<Array<WorkUpdateManyWithWhereWithoutPhaseInput>>;
  upsert?: InputMaybe<Array<WorkUpsertWithWhereUniqueWithoutPhaseInput>>;
};

export type WorkUpdateManyWithoutSelectedRateNestedInput = {
  connect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkCreateOrConnectWithoutSelectedRateInput>>;
  create?: InputMaybe<Array<WorkCreateWithoutSelectedRateInput>>;
  createMany?: InputMaybe<WorkCreateManySelectedRateInputEnvelope>;
  delete?: InputMaybe<Array<WorkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkUpdateWithWhereUniqueWithoutSelectedRateInput>>;
  updateMany?: InputMaybe<Array<WorkUpdateManyWithWhereWithoutSelectedRateInput>>;
  upsert?: InputMaybe<Array<WorkUpsertWithWhereUniqueWithoutSelectedRateInput>>;
};

export type WorkUpdateWithWhereUniqueWithoutFeeEarnerInput = {
  data: WorkUpdateWithoutFeeEarnerInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpdateWithWhereUniqueWithoutFeeEarnerLevelInput = {
  data: WorkUpdateWithoutFeeEarnerLevelInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpdateWithWhereUniqueWithoutMatterInput = {
  data: WorkUpdateWithoutMatterInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpdateWithWhereUniqueWithoutPhaseInput = {
  data: WorkUpdateWithoutPhaseInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpdateWithWhereUniqueWithoutSelectedRateInput = {
  data: WorkUpdateWithoutSelectedRateInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpdateWithoutFeeEarnerInput = {
  Matter?: InputMaybe<MatterUpdateOneWithoutWorkNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutWorkNestedInput>;
  phase?: InputMaybe<PhaseUpdateOneWithoutWorkNestedInput>;
  selectedRate?: InputMaybe<RateUpdateOneWithoutWorkNestedInput>;
  timeLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeSingle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workEffort?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type WorkUpdateWithoutFeeEarnerLevelInput = {
  Matter?: InputMaybe<MatterUpdateOneWithoutWorkNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutWorkNestedInput>;
  phase?: InputMaybe<PhaseUpdateOneWithoutWorkNestedInput>;
  selectedRate?: InputMaybe<RateUpdateOneWithoutWorkNestedInput>;
  timeLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeSingle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workEffort?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type WorkUpdateWithoutMatterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutWorkNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutWorkNestedInput>;
  phase?: InputMaybe<PhaseUpdateOneWithoutWorkNestedInput>;
  selectedRate?: InputMaybe<RateUpdateOneWithoutWorkNestedInput>;
  timeLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeSingle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workEffort?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type WorkUpdateWithoutPhaseInput = {
  Matter?: InputMaybe<MatterUpdateOneWithoutWorkNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutWorkNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutWorkNestedInput>;
  selectedRate?: InputMaybe<RateUpdateOneWithoutWorkNestedInput>;
  timeLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeSingle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workEffort?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type WorkUpdateWithoutSelectedRateInput = {
  Matter?: InputMaybe<MatterUpdateOneWithoutWorkNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feeEarner?: InputMaybe<FeeEarnerUpdateOneWithoutWorkNestedInput>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelUpdateOneWithoutWorkNestedInput>;
  phase?: InputMaybe<PhaseUpdateOneWithoutWorkNestedInput>;
  timeLower?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeSingle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  timeUpper?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  topDownRateDiscount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workEffort?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type WorkUpsertWithWhereUniqueWithoutFeeEarnerInput = {
  create: WorkCreateWithoutFeeEarnerInput;
  update: WorkUpdateWithoutFeeEarnerInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpsertWithWhereUniqueWithoutFeeEarnerLevelInput = {
  create: WorkCreateWithoutFeeEarnerLevelInput;
  update: WorkUpdateWithoutFeeEarnerLevelInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpsertWithWhereUniqueWithoutMatterInput = {
  create: WorkCreateWithoutMatterInput;
  update: WorkUpdateWithoutMatterInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpsertWithWhereUniqueWithoutPhaseInput = {
  create: WorkCreateWithoutPhaseInput;
  update: WorkUpdateWithoutPhaseInput;
  where: WorkWhereUniqueInput;
};

export type WorkUpsertWithWhereUniqueWithoutSelectedRateInput = {
  create: WorkCreateWithoutSelectedRateInput;
  update: WorkUpdateWithoutSelectedRateInput;
  where: WorkWhereUniqueInput;
};

export type WorkWhereInput = {
  AND?: InputMaybe<Array<WorkWhereInput>>;
  Matter?: InputMaybe<MatterNullableRelationFilter>;
  NOT?: InputMaybe<Array<WorkWhereInput>>;
  OR?: InputMaybe<Array<WorkWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelNullableRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  matterId?: InputMaybe<IntNullableFilter>;
  phase?: InputMaybe<PhaseNullableRelationFilter>;
  phaseId?: InputMaybe<IntNullableFilter>;
  selectedRate?: InputMaybe<RateNullableRelationFilter>;
  selectedRateId?: InputMaybe<IntNullableFilter>;
  timeLower?: InputMaybe<IntNullableFilter>;
  timeSingle?: InputMaybe<IntNullableFilter>;
  timeUpper?: InputMaybe<IntNullableFilter>;
  topDownRateDiscount?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workEffort?: InputMaybe<FloatNullableFilter>;
};

export type WorkWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkWhereInput>>;
  Matter?: InputMaybe<MatterNullableRelationFilter>;
  NOT?: InputMaybe<Array<WorkWhereInput>>;
  OR?: InputMaybe<Array<WorkWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  feeEarner?: InputMaybe<FeeEarnerNullableRelationFilter>;
  feeEarnerId?: InputMaybe<IntNullableFilter>;
  feeEarnerLevel?: InputMaybe<FeeEarnerLevelNullableRelationFilter>;
  feeEarnerLevelId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matterId?: InputMaybe<IntNullableFilter>;
  phase?: InputMaybe<PhaseNullableRelationFilter>;
  phaseId?: InputMaybe<IntNullableFilter>;
  selectedRate?: InputMaybe<RateNullableRelationFilter>;
  selectedRateId?: InputMaybe<IntNullableFilter>;
  timeLower?: InputMaybe<IntNullableFilter>;
  timeSingle?: InputMaybe<IntNullableFilter>;
  timeUpper?: InputMaybe<IntNullableFilter>;
  topDownRateDiscount?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workEffort?: InputMaybe<FloatNullableFilter>;
};

export type Workplan = {
  __typename?: 'Workplan';
  lineItems: Array<WorkItem>;
  matterId: Scalars['Float']['output'];
  matterTitle: Scalars['String']['output'];
  rates: Array<WorkplanRate>;
  resourceAndTimeTotals: Array<WorkplanResourceAndTimeTotal>;
};

export type WorkplanFeeEarner = {
  __typename?: 'WorkplanFeeEarner';
  feeEarnerLevel: WorkplanFeeEarnerLevel;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type WorkplanFeeEarnerLevel = {
  __typename?: 'WorkplanFeeEarnerLevel';
  description: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  order: Scalars['Float']['output'];
};

export type WorkplanRate = {
  __typename?: 'WorkplanRate';
  description: Scalars['String']['output'];
  feeEarner: Maybe<WorkplanFeeEarner>;
  feeEarnerLevel: Maybe<WorkplanFeeEarnerLevel>;
  id: Scalars['Float']['output'];
};

export type WorkplanResourceAndTimeTotal = {
  __typename?: 'WorkplanResourceAndTimeTotal';
  rateId: Scalars['Float']['output'];
  timeRange: TimeRangeAndSingle;
};

export type TextFilterArg = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FilteredDesignsQueryVariables = Exact<{
  filter: OutputDesignWhereInput;
}>;


export type FilteredDesignsQuery = { __typename?: 'Query', filteredDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, description: string | null, htmlContent: string, type: OutputDesignType, active: boolean, default: boolean, groupItemId: number | null, removeTemplateMargin: boolean, defaultForOrgUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null }> | null };

export type FindDesignQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type FindDesignQuery = { __typename?: 'Query', findDesign: { __typename?: 'OutputDesign', id: number, htmlContent: string } | null };

export type TestDesignMutationVariables = Exact<{
  input: TestDesignInput;
}>;


export type TestDesignMutation = { __typename?: 'Mutation', testDesign: { __typename?: 'TestDesignOutput', html: string } };

export type CloneDesignMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CloneDesignMutation = { __typename?: 'Mutation', cloneDesign: { __typename?: 'OutputDesign', id: number } };

export type CreateDesignMutationVariables = Exact<{
  data: OutputDesignCreateInput;
}>;


export type CreateDesignMutation = { __typename?: 'Mutation', createDesign: { __typename?: 'OutputDesign', id: number } };

export type UpdateDesignsMutationVariables = Exact<{
  data: Array<UpdateDesignsInput> | UpdateDesignsInput;
  designType: Scalars['String']['input'];
}>;


export type UpdateDesignsMutation = { __typename?: 'Mutation', updateDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, description: string | null, htmlContent: string, type: OutputDesignType, active: boolean }> };

export type DeleteDesignMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteDesignMutation = { __typename?: 'Mutation', deleteDesign: boolean };

export type GetProposalMergeTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProposalMergeTagsQuery = { __typename?: 'Query', getProposalMergeTagFields: Array<{ __typename?: 'MergeTag', title: string, value: string }> | null };

export type GetClientReportMergeTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientReportMergeTagsQuery = { __typename?: 'Query', getClientReportMergeTagFields: Array<{ __typename?: 'MergeTag', title: string, value: string }> | null };

export type GetTextBlocksQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type GetTextBlocksQuery = { __typename?: 'Query', getTextBlocks: Array<{ __typename?: 'TextBlock', content: string, id: number, title: string }> };

export type MutationMutationVariables = Exact<{ [key: string]: never; }>;


export type MutationMutation = { __typename?: 'Mutation', resetExistingProposals: boolean };

export type CurrentPdfOptionsQueryVariables = Exact<{
  outputDesignId: Scalars['Float']['input'];
}>;


export type CurrentPdfOptionsQuery = { __typename?: 'Query', currentPdfOptions: { __typename?: 'PDFOptions', headerImageName: string | null, footerImageName: string | null, contentBeforeName: string | null, contentAfterName: string | null } };

export type DeletePdfOptionMutationVariables = Exact<{
  option: Scalars['String']['input'];
  outputDesignId: Scalars['Float']['input'];
}>;


export type DeletePdfOptionMutation = { __typename?: 'Mutation', deletePdfOption: { __typename?: 'OutputDesign', id: number } };

export type UploadHeaderImageMutationVariables = Exact<{
  headerInput: HeaderInput;
}>;


export type UploadHeaderImageMutation = { __typename?: 'Mutation', uploadHeaderImage: boolean };

export type UploadFooterImageMutationVariables = Exact<{
  footerInput: FooterInput;
}>;


export type UploadFooterImageMutation = { __typename?: 'Mutation', uploadFooterImage: boolean };

export type UploadPdfAttachmentMutationVariables = Exact<{
  pdfAttachment: PdfAttachment;
}>;


export type UploadPdfAttachmentMutation = { __typename?: 'Mutation', uploadPDFAttachment: boolean };

export type GroupItemChildFragmentFragment = { __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null };

export type GroupItemFragmentFragment = { __typename?: 'GroupItem', id: number, name: string, entityType: GroupedEntityType, description: string | null, parentId: number | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null };

export type GroupItemsQueryVariables = Exact<{
  groupedEntityType: Scalars['String']['input'];
}>;


export type GroupItemsQuery = { __typename?: 'Query', groupItems: Array<{ __typename?: 'GroupItem', id: number, name: string, entityType: GroupedEntityType, description: string | null, parentId: number | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, children: Array<{ __typename?: 'GroupItem', id: number, name: string, description: string | null, parentId: number | null, entityType: GroupedEntityType, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null, outputDesigns: Array<{ __typename?: 'OutputDesign', id: number, title: string, active: boolean }> | null }> | null }> };

export type CreateGroupItemMutationVariables = Exact<{
  createInput: CreateGroupItem;
}>;


export type CreateGroupItemMutation = { __typename?: 'Mutation', createGroupItem: { __typename?: 'GroupItem', id: number, name: string, description: string | null, entityType: GroupedEntityType, parentId: number | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null } };

export type UpdateGroupItemMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  updateInput: GroupItemUpdateInput;
}>;


export type UpdateGroupItemMutation = { __typename?: 'Mutation', updateGroupItem: { __typename?: 'GroupItem', id: number, name: string, description: string | null, entityType: GroupedEntityType, parentId: number | null, parent: { __typename?: 'GroupItem', id: number, name: string, description: string | null } | null } };

export type DynamicTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type DynamicTagsQuery = { __typename?: 'Query', dynamicTags: Array<{ __typename?: 'DynamicTag', id: number, name: string, token: string, dynamicTagEntries: Array<{ __typename?: 'DynamicTagEntries', id: number, contents: string, contentType: DynamicTagContentType, dynamicTagId: number, condition: { __typename?: 'DynamicTagCondition', id: number, officeId: number | null, organisationalUnitId: number | null, condition: DynamicTagConditionAndOr | null } | null }> }> };

export type CreateDynamicTagMutationVariables = Exact<{
  createInput: DynamicTagCreateInput;
}>;


export type CreateDynamicTagMutation = { __typename?: 'Mutation', createDynamicTag: { __typename?: 'DynamicTag', id: number } };

export type UpdateDynamicTagMutationVariables = Exact<{
  update: DynamicTagUpdateInput;
  updateDynamicTagId: Scalars['Int']['input'];
}>;


export type UpdateDynamicTagMutation = { __typename?: 'Mutation', updateDynamicTag: { __typename?: 'DynamicTag', id: number } };

export type DeleteDynamicTagMutationVariables = Exact<{
  deleteDynamicTagId: Scalars['Int']['input'];
}>;


export type DeleteDynamicTagMutation = { __typename?: 'Mutation', deleteDynamicTag: { __typename?: 'DynamicTag', id: number } };

export type ExistingDynamicTagImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExistingDynamicTagImagesQuery = { __typename?: 'Query', existingDynamicTagImages: Array<{ __typename?: 'ExistingDynamicTagImages', name: string, url: string, width: number, height: number }> };

export type TaxonomyQueryVariables = Exact<{ [key: string]: never; }>;


export type TaxonomyQuery = { __typename?: 'Query', taxonomy: Array<{ __typename?: 'Taxonomy', id: number, createdAt: any, updatedAt: any, key: TaxonomyKey, value: string }> };

export type UpdateTaxonomyMutationVariables = Exact<{
  value: Scalars['String']['input'];
  key: Scalars['String']['input'];
  updateTaxonomyId: Scalars['Float']['input'];
}>;


export type UpdateTaxonomyMutation = { __typename?: 'Mutation', updateTaxonomy: { __typename?: 'Taxonomy', id: number, createdAt: any, updatedAt: any, key: TaxonomyKey, value: string } };

export type UpdateParentMatterMutationVariables = Exact<{
  updateInput: ParentMatterUpdateInput;
  updateParentMatterId: Scalars['Int']['input'];
}>;


export type UpdateParentMatterMutation = { __typename?: 'Mutation', updateParentMatter: { __typename?: 'ParentMatter', id: number, reference: string, status: MatterStatus, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, externalId: string | null, type: number }, matters: Array<{ __typename?: 'Matter', id: number, order: number | null, reference: string }> } };

export type ParentMatterPartsFragment = { __typename: 'Matter', id: number, title: string, status: MatterStatus, reference: string, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, pricingTarget: PricingTarget | null, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, order: number | null, waiveAdminCharge: boolean | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, technologyCharges: Array<{ __typename?: 'TechnologyCharge', autoFocus: boolean | null, id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, gpmDangerThreshold: { __typename?: 'GpmDangerThresholdResult', gpmDangerThreshold: number, source: string } };

export type ParentMatterPhasesPartsFragment = { __typename?: 'ParentMatterPhase', id: number, title: string, parentMatterId: number, order: number, includeInProposalOutput: boolean | null, matters: Array<{ __typename: 'Matter', id: number, title: string, status: MatterStatus, reference: string, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, pricingTarget: PricingTarget | null, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, order: number | null, waiveAdminCharge: boolean | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, technologyCharges: Array<{ __typename?: 'TechnologyCharge', autoFocus: boolean | null, id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, gpmDangerThreshold: { __typename?: 'GpmDangerThresholdResult', gpmDangerThreshold: number, source: string } }> };

export type FindParentMatterQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FindParentMatterQuery = { __typename?: 'Query', findParentMatter: { __typename?: 'ParentMatter', id: number, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, includeFeeEarnersInProposalOutput: boolean | null, status: MatterStatus, title: string, reference: string, phases: Array<{ __typename?: 'ParentMatterPhase', id: number, title: string, parentMatterId: number, order: number, includeInProposalOutput: boolean | null, matters: Array<{ __typename: 'Matter', id: number, title: string, status: MatterStatus, reference: string, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, pricingTarget: PricingTarget | null, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, order: number | null, waiveAdminCharge: boolean | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, technologyCharges: Array<{ __typename?: 'TechnologyCharge', autoFocus: boolean | null, id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, gpmDangerThreshold: { __typename?: 'GpmDangerThresholdResult', gpmDangerThreshold: number, source: string } }> }>, client: { __typename?: 'Client', id: number, name: string, excludeTax: boolean, gpmDangerThreshold: number | null, externalReference: string | null } } | null };

export type UpdateProposalHtmlMutationVariables = Exact<{
  update: UpdateProposalOutputInput;
}>;


export type UpdateProposalHtmlMutation = { __typename?: 'Mutation', updateProposalHtml: boolean };

export type ProposalByMatterIdQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type ProposalByMatterIdQuery = { __typename?: 'Query', proposalByMatterId: { __typename?: 'ProposalResult', html: string, outputTemplateId: number, outputTemplateName: string, selectedOfficeId: number | null, selectedOrganisationalUnitId: number | null, proposal: { __typename?: 'Proposal', includeTasks: boolean, includeRatesInProposalOutput: boolean, includeFeeEarnersInProposalOutput: boolean, feeRiskInclude: boolean, feeRiskCappedFeeInclude: boolean, feeRiskValid: boolean, ganttAvailable: boolean, ganttInclude: boolean } } };

export type UpdateProposalOptionsMutationVariables = Exact<{
  updateOptions: UpdateProposalOptionsInput;
}>;


export type UpdateProposalOptionsMutation = { __typename?: 'Mutation', updateProposalOptions: { __typename?: 'ProposalOptionsUpdateResult', includeTasks: boolean, includeDiagram: boolean, showFeeEarners: boolean, showRates: boolean } };

export type FilteredExternalMattersCountWithAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type FilteredExternalMattersCountWithAmountQuery = { __typename?: 'Query', filteredExternalMattersCountWithAmount: { __typename?: 'ExternalMatterUnlinkedSummary', totalAmount: number, totalCount: number } };

export type CollaboratorFragmentFragment = { __typename?: 'Collaborator', userId: number, createdByUser: { __typename?: 'User', id: number, displayName: string } };

export type AccruedFeeFragmentFragment = { __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualTimeAccrued: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, currencySymbol: string, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, collaborators: Array<{ __typename?: 'Collaborator', userId: number, createdByUser: { __typename?: 'User', id: number, displayName: string } }>, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }>, subMatters: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, currencySymbol: string, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }> }> };

export type AccruedTimeFragmentFragment = { __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string };

export type AssumptionFragmentFragment = { __typename?: 'Assumption', autoFocus: boolean | null, id: number, text: string, order: number, default: boolean | null, mandatory: boolean | null };

export type BaseMatterPartsFragment = { __typename: 'Matter', id: number, reference: string, title: string, updatedAt: any, status: MatterStatus, externalMatterId: number | null, externalReference: string | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, currency: { __typename?: 'Currency', id: number, code: string } };

export type BrandPartsFragment = { __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string, lineBreakInLists: boolean };

export type DisbursementPartsFragment = { __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any };

export type DiscountPartsFragment = { __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number };

export type ExclusionFragmentFragment = { __typename: 'Exclusion', autoFocus: boolean | null, id: number, text: string, order: number, matterId: number, default: boolean | null, mandatory: boolean | null, fromLibraryExclusionId: number | null };

export type ExternalMatterPartsFragment = { __typename: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, createdAt: any, updatedAt: any, externalCreatedAt: any | null, externalUpdatedAt: any | null, externalReference: string | null, taxStatus: ExternalMatterTaxStatus, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', createdAt: any, updatedAt: any, id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, matter: { __typename?: 'Matter', id: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null };

export type FeeEarnerPartsFragment = { __typename: 'FeeEarner', createdAt: any, updatedAt: any, id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null };

export type LibraryAssumptionFragmentFragment = { __typename: 'LibraryAssumption', id: number, createdAt: any, updatedAt: any, text: string, mandatory: boolean | null, default: boolean | null, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number, name: string }> | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null };

export type LibraryDisbursementFragmentFragment = { __typename: 'LibraryDisbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null };

export type LibraryExclusionFragmentFragment = { __typename: 'LibraryExclusion', id: number, text: string, mandatory: boolean | null, default: boolean | null, createdAt: any, updatedAt: any, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number, name: string }> | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null };

export type LibraryMatterPartsFragment = { __typename: 'Matter', id: number, title: string, client: { __typename?: 'Client', name: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, phases: Array<{ __typename?: 'Phase', id: number, title: string, tasks: Array<{ __typename?: 'Task', id: number, title: string }> | null }> | null };

export type LibraryTechnologyPartsFragment = { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null };

export type MatterPartsFragment = { __typename: 'Matter', id: number, title: string, status: MatterStatus, reference: string, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, description: string, order: number, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null };

export type MatterTemplatePartsFragment = { __typename: 'Matter', id: number, title: string, pricingType: PricingType, pricingLevel: PricingLevel, status: MatterStatus, createdAt: any, updatedAt: any, taxStatus: TaxStatus, templateType: TemplateType | null, includeTasksInProposalOutput: boolean | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, disbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null };

export type MatterTemplateListItemPartsFragment = { __typename: 'Matter', id: number, title: string, createdAt: any, updatedAt: any, templateType: TemplateType | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null };

export type NotificationRulePartsFragment = { __typename: 'NotificationRule', id: number, name: string, updatedAt: any, active: boolean, proposalGpmThreshold: number | null, proposalFeeThreshold: number | null, activeGpmThreshold: number | null, accruedBudgetThreshold: number | null, accruedTimeThreshold: number | null, triggerBooleanType: boolean, thresholdBooleanType: boolean, thresholdFilter: number | null, createdBy: { __typename?: 'User', id: number } | null, triggerUsers: Array<{ __typename?: 'User', id: number, displayName: string, userName: string }> | null, triggerClients: Array<{ __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null }> | null, triggerMatters: Array<{ __typename?: 'Matter', id: number, title: string, externalReference: string | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null } | null }> | null, triggerFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, notifyUsers: Array<{ __typename?: 'User', id: number, displayName: string }> | null, notifyFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, triggerOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, notifyOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null };

export type OrganisationalUnitPartsFragment = { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null };

export type PhasePartsFragment = { __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null };

export type PricePartsFragment = { __typename: 'Price', amount: number };

export type PriceOptionsPartsFragment = { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null };

export type PriceRangePartsFragment = { __typename: 'PriceRange', lower: number | null, upper: number | null };

export type RatePartsFragment = { __typename: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, type: string | null, isLevelRate: boolean | null, feeEarner: { __typename?: 'FeeEarner', id: number } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string } | null, client: { __typename?: 'Client', id: number } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number } | null };

export type SettingsPartsFragment = { __typename: 'Settings', id: number, gpmDangerThreshold: number, gpmWarningThreshold: number | null, organisationPmsName: string | null, taxLevelPercent: number, taxLabel: TaxLabel, restrictGpmVisibility: boolean, showGpmSlider: boolean, enableAi: boolean, enableTechPricing: boolean, enableWordExport: boolean, administrationCharge: number, decimalTimeInput: boolean, systemFont: string, autoCloseIntervalInDays: number, staleMatterWarningThresholdInDays: number, defaultCountryCode: string | null, enablePiiFiltering: boolean, showLibraryAssumptionsExclusions: boolean, numberOfAiSuggestionsToShow: number, showClarifyingQuestions: boolean, taxEnabled: boolean, taxEnabledOptionDefault: boolean, currency: { __typename?: 'Currency', id: number, name: string, symbol: string, code: string } };

export type TaskPartsFragment = { __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null };

export type TaxPartsFragment = { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number };

export type TaxRangePartsFragment = { __typename: 'TaxRange', taxRate: number, taxAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, totalRangeIncludingTax: { __typename: 'PriceRange', lower: number | null, upper: number | null } };

export type TeamMembershipPartsFragment = { __typename?: 'TeamMembership', id: number, matterId: number, rateId: number, feeEarnerId: number | null, rate: { __typename?: 'RateResult', id: number, amount: number, description: string, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null };

export type TechnologyChargePartsFragment = { __typename?: 'TechnologyCharge', id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } };

export type TechnologyRatePartsFragment = { __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } };

export type TechnologyUnitPartsFragment = { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null };

export type UpliftPartsFragment = { __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, includeOnProposal: boolean | null, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null };

export type WorkPartsFragment = { __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } };

export type CreateAssumptionsMutationVariables = Exact<{
  input: Array<AssumptionCreateInput> | AssumptionCreateInput;
}>;


export type CreateAssumptionsMutation = { __typename?: 'Mutation', createAssumptions: Array<{ __typename?: 'Assumption', id: number, text: string, order: number, fromLibraryAssumptionId: number | null }> };

export type CreateLibraryAssumptionMutationVariables = Exact<{
  data: LibraryAssumptionCreateInput;
}>;


export type CreateLibraryAssumptionMutation = { __typename?: 'Mutation', createLibraryAssumption: { __typename: 'LibraryAssumption', id: number, createdAt: any, updatedAt: any, text: string, mandatory: boolean | null, default: boolean | null, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number, name: string }> | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } };

export type DeleteAssumptionsMutationVariables = Exact<{
  assumptionIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DeleteAssumptionsMutation = { __typename?: 'Mutation', deleteAssumptions: { __typename?: 'DeleteAssumptionsResult', assumptionIds: Array<number> } };

export type UpdateAssumptionMutationVariables = Exact<{
  input: Array<UpdateManyAssumptionsInput> | UpdateManyAssumptionsInput;
}>;


export type UpdateAssumptionMutation = { __typename?: 'Mutation', updateAssumption: { __typename?: 'Assumption', id: number, text: string, order: number, createdAt: any, updatedAt: any, matterId: number, fromLibraryAssumptionId: number | null } };

export type UpdateAssumptionsMutationVariables = Exact<{
  input: Array<UpdateManyAssumptionsInput> | UpdateManyAssumptionsInput;
}>;


export type UpdateAssumptionsMutation = { __typename?: 'Mutation', updateAssumptions: Array<{ __typename?: 'Assumption', id: number, text: string, order: number }> };

export type UpdateLibraryAssumptionsMutationVariables = Exact<{
  data: Array<LibraryAssumptionUpdate> | LibraryAssumptionUpdate;
}>;


export type UpdateLibraryAssumptionsMutation = { __typename?: 'Mutation', updateLibraryAssumptions: { __typename?: 'UpdateLibraryAssumptionsResult', matterIds: Array<number>, updatedAssumptions: Array<{ __typename?: 'LibraryAssumption', id: number, text: string, mandatory: boolean | null, default: boolean | null, createdAt: any, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', name: string, id: number }> | null }> } };

export type CopyLibraryPhaseMutationVariables = Exact<{
  matterId: Scalars['Float']['input'];
  phaseId: Scalars['Float']['input'];
}>;


export type CopyLibraryPhaseMutation = { __typename?: 'Mutation', copyLibraryPhase: { __typename?: 'CopyLibraryPhaseResult', phase: { __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }, assumptions: Array<{ __typename?: 'Assumption', autoFocus: boolean | null, id: number, text: string, order: number, default: boolean | null, mandatory: boolean | null }>, exclusions: Array<{ __typename: 'Exclusion', autoFocus: boolean | null, id: number, text: string, order: number, matterId: number, default: boolean | null, mandatory: boolean | null, fromLibraryExclusionId: number | null }>, disbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> } };

export type CopyMatterPhasesMutationVariables = Exact<{
  targetMatterId: Scalars['Float']['input'];
  copiedMatterId: Scalars['Float']['input'];
}>;


export type CopyMatterPhasesMutation = { __typename?: 'Mutation', copyMatterPhases: { __typename?: 'CopyMatterPhasesResult', phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }>, assumptions: Array<{ __typename?: 'Assumption', autoFocus: boolean | null, id: number, text: string, order: number, default: boolean | null, mandatory: boolean | null }>, exclusions: Array<{ __typename: 'Exclusion', autoFocus: boolean | null, id: number, text: string, order: number, matterId: number, default: boolean | null, mandatory: boolean | null, fromLibraryExclusionId: number | null }>, disbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> } };

export type CopyPricingMutationVariables = Exact<{
  pricingMatterId: Scalars['Int']['input'];
  targetMatterId: Scalars['Int']['input'];
  copyScope: Scalars['Boolean']['input'];
  copyResourcing: Scalars['Boolean']['input'];
  rateReplacements: Array<RateReplacement> | RateReplacement;
}>;


export type CopyPricingMutation = { __typename?: 'Mutation', copyPricing: { __typename?: 'Matter', id: number, teamMemberships: Array<{ __typename?: 'TeamMembership', id: number, matterId: number, rateId: number, feeEarnerId: number | null, rate: { __typename?: 'RateResult', id: number, amount: number, description: string, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null } };

export type CopyResourcingMutationVariables = Exact<{
  resourcingMatterId: Scalars['Int']['input'];
  targetMatterId: Scalars['Int']['input'];
  rateReplacements: Array<RateReplacement> | RateReplacement;
}>;


export type CopyResourcingMutation = { __typename?: 'Mutation', copyResourcing: { __typename: 'Matter', id: number, title: string, pricingType: PricingType, pricingLevel: PricingLevel, pricingTarget: PricingTarget | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, includeOnProposal: boolean | null, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, phases: Array<{ __typename?: 'Phase', id: number, title: string, description: string, order: number, tasks: Array<{ __typename?: 'Task', id: number, order: number, title: string, createdAt: any, phaseId: number, updatedAt: any, markedComplete: boolean }> | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null, teamMemberships: Array<{ __typename?: 'TeamMembership', id: number, matterId: number, rateId: number, feeEarnerId: number | null, rate: { __typename?: 'RateResult', id: number, amount: number, description: string, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }> | null } };

export type CopyScopeMutationVariables = Exact<{
  scopeMatterId: Scalars['Int']['input'];
  targetMatterId: Scalars['Int']['input'];
}>;


export type CopyScopeMutation = { __typename?: 'Mutation', copyScope: { __typename?: 'Matter', id: number, phases: Array<{ __typename?: 'Phase', title: string, order: number, description: string, tasks: Array<{ __typename?: 'Task', id: number, phaseId: number, title: string, order: number }> | null }> | null } };

export type CreateBrandMutationVariables = Exact<{
  data: BrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string, lineBreakInLists: boolean } };

export type CreateClientMutationVariables = Exact<{
  data: ClientCreateInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: number, name: string, externalId: string | null, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null } };

export type CreateAndAddDiscountMutationVariables = Exact<{
  matterId: Scalars['Float']['input'];
  data: DiscountCreateInput;
}>;


export type CreateAndAddDiscountMutation = { __typename?: 'Mutation', createAndAddDiscount: { __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number } };

export type CreateLibraryTechnologyMutationVariables = Exact<{
  data: LibraryTechnologyCreateInput;
}>;


export type CreateLibraryTechnologyMutation = { __typename?: 'Mutation', createLibraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } };

export type CreateManyTechnologyRatesMutationVariables = Exact<{
  data: CreateManyTechnologyRatesInput;
}>;


export type CreateManyTechnologyRatesMutation = { __typename?: 'Mutation', createManyTechnologyRates: { __typename?: 'CreateManyTechnologyRatesResult', count: number } };

export type CreateMatterTemplateMutationVariables = Exact<{
  cloneTemplateId: InputMaybe<Scalars['Float']['input']>;
  data: MatterCreateInput;
}>;


export type CreateMatterTemplateMutation = { __typename?: 'Mutation', createMatterTemplate: { __typename: 'Matter', id: number, title: string, pricingType: PricingType, pricingLevel: PricingLevel, status: MatterStatus, createdAt: any, updatedAt: any, taxStatus: TaxStatus, templateType: TemplateType | null, includeTasksInProposalOutput: boolean | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, disbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null } };

export type CreateMatterMutationVariables = Exact<{
  data: MatterCreateInput;
  createFromOptions: InputMaybe<CreateFromOptions>;
  parentPhaseId: InputMaybe<Scalars['Int']['input']>;
  parentId: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateMatterMutation = { __typename?: 'Mutation', createMatter: { __typename: 'Matter', id: number, title: string, status: MatterStatus, reference: string, createdAt: any, updatedAt: any, template: boolean, parentMatterPhaseId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, officeLocationId: number | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, description: string, order: number, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, officeLocation: { __typename?: 'OfficeLocation', id: number, name: string, countryCode: string, taxLabel: TaxLabel | null, taxLevelPercent: number | null } | null, currency: { __typename?: 'Currency', id: number, code: string } } };

export type CreateNotificationRuleMutationVariables = Exact<{
  data: NotificationRuleCreateInput;
}>;


export type CreateNotificationRuleMutation = { __typename?: 'Mutation', createNotificationRule: { __typename: 'NotificationRule', id: number, name: string, updatedAt: any, active: boolean, proposalGpmThreshold: number | null, proposalFeeThreshold: number | null, activeGpmThreshold: number | null, accruedBudgetThreshold: number | null, accruedTimeThreshold: number | null, triggerBooleanType: boolean, thresholdBooleanType: boolean, thresholdFilter: number | null, createdBy: { __typename?: 'User', id: number } | null, triggerUsers: Array<{ __typename?: 'User', id: number, displayName: string, userName: string }> | null, triggerClients: Array<{ __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null }> | null, triggerMatters: Array<{ __typename?: 'Matter', id: number, title: string, externalReference: string | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null } | null }> | null, triggerFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, notifyUsers: Array<{ __typename?: 'User', id: number, displayName: string }> | null, notifyFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, triggerOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, notifyOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null } };

export type CreateOrUpdateMatterCompletionLogMutationVariables = Exact<{
  matterId: Scalars['Float']['input'];
  completionPercentage: Scalars['Float']['input'];
}>;


export type CreateOrUpdateMatterCompletionLogMutation = { __typename?: 'Mutation', createOrUpdateMatterCompletionLog: { __typename?: 'MatterCompletionLog', id: number, matterId: number, completionPercentage: number, createdAt: any } };

export type CreateParentMatterMutationVariables = Exact<{
  clientId: Scalars['Int']['input'];
  createInput: Scalars['String']['input'];
  phases: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateParentMatterMutation = { __typename?: 'Mutation', createParentMatter: { __typename?: 'ParentMatter', id: number } };

export type CreateAndAddPhaseMutationVariables = Exact<{
  data: PhaseCreateInput;
  matterId: Scalars['Float']['input'];
}>;


export type CreateAndAddPhaseMutation = { __typename?: 'Mutation', createAndAddPhase: { __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null } };

export type CreateAndAddPhasesMutationVariables = Exact<{
  data: Array<PhaseCreateInput> | PhaseCreateInput;
  matterId: Scalars['Float']['input'];
}>;


export type CreateAndAddPhasesMutation = { __typename?: 'Mutation', createAndAddPhases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> };

export type CreateRateMutationVariables = Exact<{
  data: RateCreateInput;
}>;


export type CreateRateMutation = { __typename?: 'Mutation', createRate: { __typename: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, type: string | null, isLevelRate: boolean | null, feeEarner: { __typename?: 'FeeEarner', id: number } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string } | null, client: { __typename?: 'Client', id: number } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number } | null } };

export type CreateAndAddTaskMutationVariables = Exact<{
  phaseId: Scalars['Float']['input'];
  data: TaskCreateInput;
}>;


export type CreateAndAddTaskMutation = { __typename?: 'Mutation', createAndAddTask: { __typename?: 'Task', id: number, title: string, order: number, html: string | null, phaseId: number, createdAt: any, updatedAt: any, markedComplete: boolean } };

export type CreateAndAddTasksMutationVariables = Exact<{
  data: Array<TaskCreateInput> | TaskCreateInput;
  phaseId: Scalars['Float']['input'];
}>;


export type CreateAndAddTasksMutation = { __typename?: 'Mutation', createAndAddTasks: Array<{ __typename?: 'Task', id: number, title: string, order: number, html: string | null, phaseId: number, createdAt: any, updatedAt: any, markedComplete: boolean }> };

export type CreateAndAddTechnologyChargeMutationVariables = Exact<{
  data: TechnologyChargeCreateInput;
}>;


export type CreateAndAddTechnologyChargeMutation = { __typename?: 'Mutation', createAndAddTechnologyCharge: { __typename?: 'TechnologyCharge', id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } } };

export type CreateTechnologyUnitMutationVariables = Exact<{
  data: TechnologyUnitCreateInput;
}>;


export type CreateTechnologyUnitMutation = { __typename?: 'Mutation', createTechnologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } };

export type CreateAndAddUpliftMutationVariables = Exact<{
  matterId: Scalars['Float']['input'];
  data: UpliftCreateInput;
}>;


export type CreateAndAddUpliftMutation = { __typename?: 'Mutation', createAndAddUplift: { __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, includeOnProposal: boolean | null, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null } };

export type CreateAndAddWorkMutationVariables = Exact<{
  data: WorkCreateInput;
}>;


export type CreateAndAddWorkMutation = { __typename?: 'Mutation', createAndAddWork: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> };

export type AssignWorksToPhaseMutationVariables = Exact<{
  data: Array<WorkCreateInput> | WorkCreateInput;
}>;


export type AssignWorksToPhaseMutation = { __typename?: 'Mutation', assignWorksToPhase: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> };

export type CreateFileDataImportMutationVariables = Exact<{
  upload: Scalars['Upload']['input'];
  type: VpdDataImportType;
}>;


export type CreateFileDataImportMutation = { __typename?: 'Mutation', createFileDataImport: { __typename?: 'DataImportResult', dataFrameResults: Array<{ __typename?: 'DataFrameImportResult', succeeded: boolean, message: string, details: Array<{ __typename?: 'DataImportDetail', type: DataImportDetailType, rowNumber: number | null, messages: Array<string> }> }> } };

export type DeleteAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllNotificationsMutation = { __typename?: 'Mutation', deleteAllNotifications: { __typename?: 'DeleteAllNotificationsResult', success: boolean } };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteBrandMutation = { __typename?: 'Mutation', deleteBrand: { __typename?: 'DeleteBrandResult', brandId: number } };

export type DeleteDiscountMutationVariables = Exact<{
  discountId: Scalars['Float']['input'];
}>;


export type DeleteDiscountMutation = { __typename?: 'Mutation', deleteDiscount: { __typename?: 'DeleteDiscountResult', discountId: number } };

export type DeleteNotificationRuleMutationVariables = Exact<{
  notificationRuleId: Scalars['Float']['input'];
}>;


export type DeleteNotificationRuleMutation = { __typename?: 'Mutation', deleteNotificationRule: { __typename?: 'DeleteNotificationRuleResult', notificationRuleId: number } };

export type DeleteNotificationRulesMutationVariables = Exact<{
  notificationRuleIds: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type DeleteNotificationRulesMutation = { __typename?: 'Mutation', deleteNotificationRules: { __typename?: 'DeleteNotificationRulesResult', notificationRuleIds: Array<number> | null } };

export type DeleteNotificationMutationVariables = Exact<{
  notificationId: Scalars['Float']['input'];
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification: { __typename?: 'DeleteNotificationResult', notificationId: number } };

export type DeletePhaseMutationVariables = Exact<{
  phaseId: Scalars['Float']['input'];
}>;


export type DeletePhaseMutation = { __typename?: 'Mutation', deletePhase: { __typename?: 'DeletePhaseResult', phaseId: number } };

export type DeletePhasesMutationVariables = Exact<{
  phaseIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DeletePhasesMutation = { __typename?: 'Mutation', deletePhases: { __typename?: 'DeletePhasesResult', phasesIds: Array<number> } };

export type DeleteTaskMutationVariables = Exact<{
  taskId: Scalars['Float']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'DeleteTaskResult', taskId: number } };

export type DeleteTasksMutationVariables = Exact<{
  phaseId: Scalars['Float']['input'];
}>;


export type DeleteTasksMutation = { __typename?: 'Mutation', deleteTasks: { __typename?: 'DeleteTasksResult', tasksIds: Array<number> } };

export type DeleteTechnologyChargeMutationVariables = Exact<{
  technologyChargeId: Scalars['Float']['input'];
}>;


export type DeleteTechnologyChargeMutation = { __typename?: 'Mutation', deleteTechnologyCharge: { __typename?: 'DeleteTechnologyChargeResult', technologyChargeId: number } };

export type DeleteTechnologyUnitMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTechnologyUnitMutation = { __typename?: 'Mutation', deleteTechnologyUnit: { __typename?: 'TechnologyUnit', id: number } };

export type DeleteUpliftMutationVariables = Exact<{
  upliftId: Scalars['Float']['input'];
}>;


export type DeleteUpliftMutation = { __typename?: 'Mutation', deleteUplift: { __typename?: 'DeleteUpliftResult', upliftId: number } };

export type DeleteWorkMutationVariables = Exact<{
  workId: Scalars['Float']['input'];
}>;


export type DeleteWorkMutation = { __typename?: 'Mutation', deleteWork: { __typename?: 'DeleteWorkResult', workId: number } };

export type CreateAndAddDisbursementMutationVariables = Exact<{
  data: DisbursementCreateInput;
}>;


export type CreateAndAddDisbursementMutation = { __typename?: 'Mutation', createAndAddDisbursement: { __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any } };

export type CreateLibraryDisbursementMutationVariables = Exact<{
  data: LibraryDisbursementCreate;
}>;


export type CreateLibraryDisbursementMutation = { __typename?: 'Mutation', createLibraryDisbursement: { __typename?: 'LibraryDisbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus } };

export type DeleteDisbursementMutationVariables = Exact<{
  disbursementId: Scalars['Float']['input'];
}>;


export type DeleteDisbursementMutation = { __typename?: 'Mutation', deleteDisbursement: { __typename?: 'DeleteDisbursementResult', disbursementId: number } };

export type UpdateDisbursementMutationVariables = Exact<{
  disbursement: UpdateDisbursementInput;
}>;


export type UpdateDisbursementMutation = { __typename?: 'Mutation', updateDisbursement: { __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any } };

export type UpdateDisbursementsMutationVariables = Exact<{
  data: Array<DisburmentUpdate> | DisburmentUpdate;
}>;


export type UpdateDisbursementsMutation = { __typename?: 'Mutation', updateDisbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> };

export type UpdateLibraryDisbursementsMutationVariables = Exact<{
  data: Array<LibraryDisbursementUpdate> | LibraryDisbursementUpdate;
}>;


export type UpdateLibraryDisbursementsMutation = { __typename?: 'Mutation', updateLibraryDisbursements: Array<{ __typename?: 'LibraryDisbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus }> };

export type CreateExclusionsMutationVariables = Exact<{
  input: Array<ExclusionCreateInput> | ExclusionCreateInput;
}>;


export type CreateExclusionsMutation = { __typename?: 'Mutation', createExclusions: Array<{ __typename: 'Exclusion', autoFocus: boolean | null, id: number, text: string, order: number, matterId: number, default: boolean | null, mandatory: boolean | null, fromLibraryExclusionId: number | null }> };

export type CreateLibraryExclusionMutationVariables = Exact<{
  data: LibraryExclusionCreateInput;
}>;


export type CreateLibraryExclusionMutation = { __typename?: 'Mutation', createLibraryExclusion: { __typename?: 'LibraryExclusion', id: number, text: string, mandatory: boolean | null, default: boolean | null, createdAt: any, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', name: string, id: number }> | null } };

export type DeleteExclusionsMutationVariables = Exact<{
  input: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DeleteExclusionsMutation = { __typename?: 'Mutation', deleteExclusions: { __typename?: 'DeleteExclusionsResult', exclusionIds: Array<number> } };

export type UpdateExclusionMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  input: ExclusionUpdateInput;
}>;


export type UpdateExclusionMutation = { __typename?: 'Mutation', updateExclusion: { __typename: 'Exclusion', autoFocus: boolean | null, id: number, text: string, order: number, matterId: number, default: boolean | null, mandatory: boolean | null, fromLibraryExclusionId: number | null } };

export type UpdateExclusionsMutationVariables = Exact<{
  input: Array<UpdateManyExclusionsInput> | UpdateManyExclusionsInput;
}>;


export type UpdateExclusionsMutation = { __typename?: 'Mutation', updateExclusions: Array<{ __typename: 'Exclusion', autoFocus: boolean | null, id: number, text: string, order: number, matterId: number, default: boolean | null, mandatory: boolean | null, fromLibraryExclusionId: number | null }> };

export type UpdateLibraryExclusionsMutationVariables = Exact<{
  data: Array<LibraryExclusionUpdate> | LibraryExclusionUpdate;
}>;


export type UpdateLibraryExclusionsMutation = { __typename?: 'Mutation', updateLibraryExclusions: { __typename?: 'UpdateLibraryExclusionsResult', matterIds: Array<number>, updatedExclusions: Array<{ __typename?: 'LibraryExclusion', id: number, text: string, mandatory: boolean | null, default: boolean | null, createdAt: any, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', name: string, id: number }> | null }> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResult', success: boolean } };

export type QuickLinkMatterMutationVariables = Exact<{
  input: QuickLinkMatterInput;
}>;


export type QuickLinkMatterMutation = { __typename?: 'Mutation', quickLinkMatter: { __typename?: 'Matter', id: number, title: string, status: MatterStatus, externalMatter: { __typename?: 'ExternalMatter', id: number } | null, client: { __typename?: 'Client', id: number, name: string } | null } };

export type ReplaceTeamMemberMutationVariables = Exact<{
  teamMemberToAdd: TeamMembershipIds;
  teamMemberToRemove: TeamMembershipIds;
  matterId: Scalars['Int']['input'];
}>;


export type ReplaceTeamMemberMutation = { __typename?: 'Mutation', replaceTeamMember: { __typename?: 'Matter', teamMemberships: Array<{ __typename?: 'TeamMembership', id: number, matterId: number, rateId: number, feeEarnerId: number | null, rate: { __typename?: 'RateResult', id: number, amount: number, description: string, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null } };

export type ToggleFavouriteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  favourite: Scalars['Boolean']['input'];
}>;


export type ToggleFavouriteMutation = { __typename?: 'Mutation', toggleFavourite: { __typename?: 'Matter', isFavourite: boolean } };

export type ToggleIncludeInProposalMutationVariables = Exact<{
  include: Scalars['Boolean']['input'];
  toggleIncludeInProposalId: Scalars['Float']['input'];
}>;


export type ToggleIncludeInProposalMutation = { __typename?: 'Mutation', toggleIncludeInProposal: { __typename?: 'ParentMatterPhase', id: number, includeInProposalOutput: boolean | null } };

export type UpdateActiveNotificationRulesMutationVariables = Exact<{
  data: UpdateActiveNotificationRulesInput;
}>;


export type UpdateActiveNotificationRulesMutation = { __typename?: 'Mutation', updateActiveNotificationRules: { __typename?: 'UpdateNotificationRulesResult', updatedIds: Array<number>, active: boolean } };

export type UpdateBrandMutationVariables = Exact<{
  data: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand: { __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string, lineBreakInLists: boolean } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: ClientUpdateInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: number, name: string, externalReference: string | null, excludeTax: boolean } };

export type UpdateDiscountMutationVariables = Exact<{
  data: DiscountUpdateInput;
  id: Scalars['Float']['input'];
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount: { __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number } };

export type UpdateDiscountsMutationVariables = Exact<{
  data: Array<UpdateDiscountsInput> | UpdateDiscountsInput;
}>;


export type UpdateDiscountsMutation = { __typename?: 'Mutation', updateDiscounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> };

export type UpdateFeeEarnerLevelsMutationVariables = Exact<{
  input: Array<UpdateManyFeeEarnerLevelsInput> | UpdateManyFeeEarnerLevelsInput;
}>;


export type UpdateFeeEarnerLevelsMutation = { __typename?: 'Mutation', updateFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number, order: number, description: string, externalReference: string | null, restrictedGpmVisible: boolean }> };

export type UpdateLastLoginAtMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastLoginAtMutation = { __typename?: 'Mutation', updateLastLoginAt: { __typename?: 'User', id: number } };

export type UpdateLibraryTechnologiesMutationVariables = Exact<{
  data: Array<UpdateLibraryTechnologyInput> | UpdateLibraryTechnologyInput;
}>;


export type UpdateLibraryTechnologiesMutation = { __typename?: 'Mutation', updateLibraryTechnologies: Array<{ __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> };

export type UpdateManyTechnologyRatesMutationVariables = Exact<{
  data: UpdateManyTechnologyRatesInput;
}>;


export type UpdateManyTechnologyRatesMutation = { __typename?: 'Mutation', updateManyTechnologyRates: { __typename?: 'UpdateManyTechnologyRatesResult', count: number } };

export type UpdateManyWorkMutationVariables = Exact<{
  data: Array<UpdateManyWorkInput> | UpdateManyWorkInput;
}>;


export type UpdateManyWorkMutation = { __typename?: 'Mutation', updateManyWork: Array<{ __typename?: 'Work', id: number, timeSingle: number | null, cost: { __typename?: 'PriceRangeAndSingle', single: number | null } }> };

export type UpdateMatterCollaboratorsMutationVariables = Exact<{
  data: UpdateMatterCollaboratorsInput;
}>;


export type UpdateMatterCollaboratorsMutation = { __typename?: 'Mutation', updateMatterCollaborators: Array<{ __typename?: 'Collaborator', id: number, user: { __typename?: 'User', id: number, userName: string, displayName: string } }> };

export type UpdateParentMatterCollaboratorsMutationVariables = Exact<{
  data: UpdateMatterCollaboratorsInput;
}>;


export type UpdateParentMatterCollaboratorsMutation = { __typename?: 'Mutation', updateParentMatterCollaborators: Array<{ __typename?: 'Collaborator', id: number, user: { __typename?: 'User', id: number, userName: string, displayName: string } }> };

export type UpdateTeamMembersMutationVariables = Exact<{
  teamMembersToAdd: Array<TeamMembershipIds> | TeamMembershipIds;
  teamMembersToRemove: Array<TeamMembershipIds> | TeamMembershipIds;
  matterId: Scalars['Float']['input'];
}>;


export type UpdateTeamMembersMutation = { __typename?: 'Mutation', updateTeamMembers: { __typename?: 'Matter', teamMemberships: Array<{ __typename?: 'TeamMembership', id: number, matterId: number, rateId: number, feeEarnerId: number | null, rate: { __typename?: 'RateResult', id: number, amount: number, description: string, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null } };

export type UpdateMatterTemplateMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  data: MatterUpdateInput;
}>;


export type UpdateMatterTemplateMutation = { __typename?: 'Mutation', updateMatterTemplate: { __typename: 'Matter', id: number, title: string, pricingType: PricingType, pricingLevel: PricingLevel, status: MatterStatus, createdAt: any, updatedAt: any, taxStatus: TaxStatus, templateType: TemplateType | null, includeTasksInProposalOutput: boolean | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, disbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null } };

export type UpdateManyMatterTemplateMutationVariables = Exact<{
  input: Array<UpdateManyTemplatesInput> | UpdateManyTemplatesInput;
}>;


export type UpdateManyMatterTemplateMutation = { __typename?: 'Mutation', updateManyMatterTemplate: Array<{ __typename: 'Matter', id: number, title: string, pricingType: PricingType, pricingLevel: PricingLevel, status: MatterStatus, createdAt: any, updatedAt: any, taxStatus: TaxStatus, templateType: TemplateType | null, includeTasksInProposalOutput: boolean | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, disbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null }> };

export type UpdateMatterMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  data: MatterUpdateInput;
}>;


export type UpdateMatterMutation = { __typename?: 'Mutation', updateMatter: { __typename: 'Matter', id: number, reference: string, title: string, status: MatterStatus, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, pricingTarget: PricingTarget | null, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, waiveAdminCharge: boolean | null, startDate: any | null, deadlineDate: any | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, description: string, order: number, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null } };

export type UpdateNotificationRuleMutationVariables = Exact<{
  data: UpdateNotificationRulesInput;
}>;


export type UpdateNotificationRuleMutation = { __typename?: 'Mutation', updateNotificationRule: { __typename: 'NotificationRule', id: number, name: string, updatedAt: any, active: boolean, proposalGpmThreshold: number | null, proposalFeeThreshold: number | null, activeGpmThreshold: number | null, accruedBudgetThreshold: number | null, accruedTimeThreshold: number | null, triggerBooleanType: boolean, thresholdBooleanType: boolean, thresholdFilter: number | null, createdBy: { __typename?: 'User', id: number } | null, triggerUsers: Array<{ __typename?: 'User', id: number, displayName: string, userName: string }> | null, triggerClients: Array<{ __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null }> | null, triggerMatters: Array<{ __typename?: 'Matter', id: number, title: string, externalReference: string | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null } | null }> | null, triggerFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, notifyUsers: Array<{ __typename?: 'User', id: number, displayName: string }> | null, notifyFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, triggerOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, notifyOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null } };

export type UpdateOfficeLocationsByCountryMutationVariables = Exact<{
  input: OfficeLocationsUpdateInput;
}>;


export type UpdateOfficeLocationsByCountryMutation = { __typename?: 'Mutation', updateOfficeLocationsByCountry: Array<{ __typename?: 'OfficeLocation', id: number, countryCode: string, name: string, taxLabel: TaxLabel | null, taxLevelPercent: number | null }> };

export type UpdateOrganisationalUnitMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: OrganisationalUnitUpdateInput;
}>;


export type UpdateOrganisationalUnitMutation = { __typename?: 'Mutation', updateOrganisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null }> | null } };

export type UpdateOrganisationalUnitsMutationVariables = Exact<{
  input: Array<UpdateManyOrganisationalUnitsInput> | UpdateManyOrganisationalUnitsInput;
}>;


export type UpdateOrganisationalUnitsMutation = { __typename?: 'Mutation', updateOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null }> | null }> };

export type UpdatePhaseMutationVariables = Exact<{
  phaseId: Scalars['Int']['input'];
  matterId: Scalars['Int']['input'];
  data: PhaseUpdateInput;
}>;


export type UpdatePhaseMutation = { __typename?: 'Mutation', updatePhase: { __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null } };

export type UpdatePhasesMutationVariables = Exact<{
  data: Array<UpdatePhasesInput> | UpdatePhasesInput;
  matterId: Scalars['Int']['input'];
}>;


export type UpdatePhasesMutation = { __typename?: 'Mutation', updatePhases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> };

export type UpdateQuickUpdateShownAtMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateQuickUpdateShownAtMutation = { __typename?: 'Mutation', updateQuickUpdateShownAt: { __typename?: 'User', id: number } };

export type UpdateSettingsMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  data: SettingsUpdateInput;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings: { __typename: 'Settings', id: number, gpmDangerThreshold: number, gpmWarningThreshold: number | null, organisationPmsName: string | null, taxLevelPercent: number, taxLabel: TaxLabel, restrictGpmVisibility: boolean, showGpmSlider: boolean, enableAi: boolean, enableTechPricing: boolean, enableWordExport: boolean, administrationCharge: number, decimalTimeInput: boolean, systemFont: string, autoCloseIntervalInDays: number, staleMatterWarningThresholdInDays: number, defaultCountryCode: string | null, enablePiiFiltering: boolean, showLibraryAssumptionsExclusions: boolean, numberOfAiSuggestionsToShow: number, showClarifyingQuestions: boolean, taxEnabled: boolean, taxEnabledOptionDefault: boolean, currency: { __typename?: 'Currency', id: number, name: string, symbol: string, code: string } } };

export type UpdateTaskMutationVariables = Exact<{
  data: TaskUpdateInput;
  taskId: Scalars['Float']['input'];
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null } };

export type UpdateTasksMutationVariables = Exact<{
  data: Array<UpdateTaskInput> | UpdateTaskInput;
}>;


export type UpdateTasksMutation = { __typename?: 'Mutation', updateTasks: Array<{ __typename?: 'Task', id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> };

export type UpdateTechnologyChargeMutationVariables = Exact<{
  technologyCharge: UpdateTechnologyChargeInput;
}>;


export type UpdateTechnologyChargeMutation = { __typename?: 'Mutation', updateTechnologyCharge: { __typename?: 'TechnologyCharge', id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } } };

export type UpdateTechnologyChargesMutationVariables = Exact<{
  data: Array<UpdateTechnologyChargeInput> | UpdateTechnologyChargeInput;
}>;


export type UpdateTechnologyChargesMutation = { __typename?: 'Mutation', updateTechnologyCharges: Array<{ __typename?: 'TechnologyCharge', id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } }> };

export type UpdateTechnologyUnitsMutationVariables = Exact<{
  data: Array<UpdateTechnologyUnitInput> | UpdateTechnologyUnitInput;
}>;


export type UpdateTechnologyUnitsMutation = { __typename?: 'Mutation', updateTechnologyUnits: Array<{ __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> };

export type UpdateUpliftMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  data: UpliftUpdateInput;
}>;


export type UpdateUpliftMutation = { __typename?: 'Mutation', updateUplift: { __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, includeOnProposal: boolean | null, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null } };

export type UpdateUpliftsMutationVariables = Exact<{
  data: Array<UpdateManyUpliftsInput> | UpdateManyUpliftsInput;
}>;


export type UpdateUpliftsMutation = { __typename?: 'Mutation', updateUplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, includeOnProposal: boolean | null, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> };

export type UpdateUserSettingsMutationVariables = Exact<{
  data: UserSettingsUpdateInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettings', darkTheme: boolean, customPaletteHex: string | null } };

export type UpdateWorkMutationVariables = Exact<{
  workId: Scalars['Float']['input'];
  data: WorkUpdateInput;
}>;


export type UpdateWorkMutation = { __typename?: 'Mutation', updateWork: { __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } } };

export type FindAccruedFeesForMatterQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type FindAccruedFeesForMatterQuery = { __typename?: 'Query', findAccruedFeesForMatter: { __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualTimeAccrued: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, currencySymbol: string, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, collaborators: Array<{ __typename?: 'Collaborator', userId: number, createdByUser: { __typename?: 'User', id: number, displayName: string } }>, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }>, subMatters: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, currencySymbol: string, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }> }> } };

export type FindAccruedFeesForUserQueryVariables = Exact<{
  filter: AccruedFeeForUserPagination;
}>;


export type FindAccruedFeesForUserQuery = { __typename: 'Query', findAccruedFeesForUser: { __typename?: 'AccruedFeesForUser', total: number, items: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualTimeAccrued: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, currencySymbol: string, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, collaborators: Array<{ __typename?: 'Collaborator', userId: number, createdByUser: { __typename?: 'User', id: number, displayName: string } }>, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }>, subMatters: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, currencySymbol: string, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }> }> }> } };

export type FindAccruedFeesQueryVariables = Exact<{
  filter: AccruedFeePagination;
}>;


export type FindAccruedFeesQuery = { __typename: 'Query', findAccruedFees: { __typename?: 'AccruedFeesForUser', total: number, items: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualTimeAccrued: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, currencySymbol: string, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, collaborators: Array<{ __typename?: 'Collaborator', userId: number, createdByUser: { __typename?: 'User', id: number, displayName: string } }>, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }>, subMatters: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, currencySymbol: string, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }> }> }> } };

export type FindAllClientsQueryVariables = Exact<{
  offset: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindAllClientsQuery = { __typename?: 'Query', allClients: { __typename?: 'ClientResult', total: number, clients: Array<{ __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean }> } };

export type AllFeeEarnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFeeEarnersQuery = { __typename?: 'Query', allFeeEarners: Array<{ __typename: 'FeeEarner', createdAt: any, updatedAt: any, id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null }> };

export type FindAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllUsersQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: number, userName: string, displayName: string }> };

export type BedrockCheckMatterTitleIsDescriptiveQueryVariables = Exact<{
  matterTitle: Scalars['String']['input'];
}>;


export type BedrockCheckMatterTitleIsDescriptiveQuery = { __typename?: 'Query', bedrockCheckMatterTitleIsDescriptive: boolean };

export type BedrockStartStreamingClarifyingQuestionsMutationVariables = Exact<{
  matterTitle: Scalars['String']['input'];
  countryCode: InputMaybe<Scalars['String']['input']>;
}>;


export type BedrockStartStreamingClarifyingQuestionsMutation = { __typename?: 'Mutation', bedrockStartStreamingClarifyingQuestions: { __typename?: 'StartStreamingResponse', sessionId: string, success: boolean } };

export type StreamingClarifyingQuestionsSubscriptionVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type StreamingClarifyingQuestionsSubscription = { __typename?: 'Subscription', streamingClarifyingQuestions: { __typename?: 'StreamingClarifyingQuestionEvent', sessionId: string, eventType: string, error: string | null, totalQuestions: number | null, currentQuestionIndex: number | null, question: { __typename?: 'ClarifyingQuestion', id: string, label: string, allowOther: boolean, otherPlaceholder: string | null, options: Array<{ __typename?: 'QuestionOption', label: string, value: string }> } | null } };

export type BedrockStartStreamingMatterSummaryMutationVariables = Exact<{
  input: GenerateSummaryInput;
}>;


export type BedrockStartStreamingMatterSummaryMutation = { __typename?: 'Mutation', bedrockStartStreamingMatterSummary: { __typename?: 'StartStreamingResponse', sessionId: string, success: boolean } };

export type StreamingMatterSummarySubscriptionVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type StreamingMatterSummarySubscription = { __typename?: 'Subscription', streamingMatterSummary: { __typename?: 'StreamingMatterSummaryEvent', sessionId: string, eventType: string, chunk: string | null, fullSummary: string | null, error: string | null } };

export type BedrockGetPhasesAndTasksQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
  useLibraryData: Scalars['Boolean']['input'];
  refineMode: InputMaybe<Scalars['Boolean']['input']>;
  customPrompt: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
}>;


export type BedrockGetPhasesAndTasksQuery = { __typename?: 'Query', bedrockGetPhasesAndTasks: Array<{ __typename?: 'PhaseAndTasks', phaseTitle: string, tasks: Array<string> }> | null };

export type BedrockGetRoiAnalysisQueryVariables = Exact<{
  roiData: RoiAnalysisInput;
}>;


export type BedrockGetRoiAnalysisQuery = { __typename?: 'Query', bedrockRoiAnalyseAndRecommend: { __typename?: 'AnalysisAndRecommendations', analysis: string, recommendations: Array<string> } | null };

export type BedrockSuggestAssumptionsQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type BedrockSuggestAssumptionsQuery = { __typename?: 'Query', bedrockSuggestAssumptions: { __typename?: 'ChosenAndSuggested', chosen: Array<string>, suggested: Array<string> } | null };

export type BedrockSuggestExclusionsQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type BedrockSuggestExclusionsQuery = { __typename?: 'Query', bedrockSuggestExclusions: { __typename?: 'ChosenAndSuggested', chosen: Array<string>, suggested: Array<string> } | null };

export type BedrockSuggestPracticeAreasQueryVariables = Exact<{
  matterTitle: Scalars['String']['input'];
  practiceAreaName: InputMaybe<Scalars['String']['input']>;
}>;


export type BedrockSuggestPracticeAreasQuery = { __typename?: 'Query', bedrockSuggestPracticeAreas: { __typename?: 'PracticeAreaOptionsResult', organisationalUnits: Array<{ __typename?: 'PracticeAreaChoice', id: number, name: string, parent: { __typename?: 'PracticeAreaParent', id: number } | null }> } };

export type BedrockGetTasksForPhaseQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
  phaseId: Scalars['Float']['input'];
  refineMode: InputMaybe<Scalars['Boolean']['input']>;
  customPrompt: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
}>;


export type BedrockGetTasksForPhaseQuery = { __typename?: 'Query', bedrockGetTasksForPhase: { __typename?: 'Tasks', tasks: Array<string> } | null };

export type CurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', code: string, id: number, symbol: string, name: string, baseCurrency: boolean | null }> };

export type DataImportRecordsQueryVariables = Exact<{
  input: DataImportRecordsInput;
}>;


export type DataImportRecordsQuery = { __typename?: 'Query', dataImportRecordsQuery: { __typename?: 'PaginatedDataImportRecords', total: number, page: number, pageSize: number, items: Array<{ __typename?: 'DataImportRecord', entityType: DataImportEntityType, createdAt: any, createdCount: number, updatedCount: number, deletedCount: number, errorMessage: string | null }> } };

export type DataImportSchemaQueryVariables = Exact<{
  type: VpdDataImportType;
}>;


export type DataImportSchemaQuery = { __typename?: 'Query', dataImportSchema: { __typename?: 'DataImportSchemaDefinition', properties: Array<{ __typename?: 'DataImportSchemaProperty', name: string, type: string, minLength: number | null, maxLength: number | null, default: string | null, format: string | null, required: boolean }> } };

export type FindFeeEarnerLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindFeeEarnerLevelsQuery = { __typename?: 'Query', feeEarnerLevels: { __typename?: 'FeeEarnerLevelsResult', records: Array<{ __typename?: 'FeeEarnerLevel', id: number, description: string, externalReference: string | null, order: number, restrictedGpmVisible: boolean }> } };

export type FeeEarnerLevelsAndFeeEarnersQueryVariables = Exact<{ [key: string]: never; }>;


export type FeeEarnerLevelsAndFeeEarnersQuery = { __typename?: 'Query', feeEarnerLevels: { __typename?: 'FeeEarnerLevelsResult', records: Array<{ __typename?: 'FeeEarnerLevel', id: number, order: number, description: string, externalReference: string | null, feeEarners: Array<{ __typename?: 'FeeEarner', id: number, name: string }> | null }> } };

export type FeeEarnersByLevelQueryVariables = Exact<{
  feeEarnerLevelId: Scalars['Int']['input'];
}>;


export type FeeEarnersByLevelQuery = { __typename?: 'Query', feeEarnersByLevel: Array<{ __typename?: 'FeeEarner', id: number, name: string }> };

export type FindFeeEarnerByLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindFeeEarnerByLevelsQuery = { __typename?: 'Query', feeEarnerLevels: { __typename?: 'FeeEarnerLevelsResult', records: Array<{ __typename?: 'FeeEarnerLevel', id: number, description: string, externalReference: string | null }> } };

export type FilterUsersQueryVariables = Exact<{
  includeLoggedInUserFirst: InputMaybe<Scalars['Boolean']['input']>;
  filter: UserFilterInput;
  offset: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  restrictedExternalMatterId: InputMaybe<Scalars['Int']['input']>;
  restrictedClientId: InputMaybe<Scalars['Int']['input']>;
}>;


export type FilterUsersQuery = { __typename?: 'Query', filterUsers: { __typename?: 'UserPage', count: number, users: Array<{ __typename?: 'User', id: number, displayName: string, userName: string }> } };

export type FindFilteredClientsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  filter: FilterArg;
}>;


export type FindFilteredClientsQuery = { __typename?: 'Query', filteredClients: { __typename?: 'ClientResult', total: number, clients: Array<{ __typename?: 'Client', id: number, name: string, externalId: string | null, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null }> } };

export type FilterExternalMattersQueryVariables = Exact<{
  input: FilteredExternalMattersInput;
}>;


export type FilterExternalMattersQuery = { __typename?: 'Query', filteredExternalMatters: { __typename?: 'FilteredExternalMattersResult', total: number, externalMatters: Array<{ __typename: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, createdAt: any, updatedAt: any, externalCreatedAt: any | null, externalUpdatedAt: any | null, externalReference: string | null, taxStatus: ExternalMatterTaxStatus, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', createdAt: any, updatedAt: any, id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, matter: { __typename?: 'Matter', id: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null }> } };

export type FilterMattersQueryVariables = Exact<{
  input: FilteredMattersInput;
}>;


export type FilterMattersQuery = { __typename?: 'Query', filteredMatters: { __typename?: 'MatterPage', count: number, matters: Array<{ __typename: 'BaseMatterResult', reference: string, id: number, isParent: boolean, title: string, createdAt: any, updatedAt: any, status: MatterStatus, externalMatterId: number | null, externalReference: string | null, collaborators: Array<{ __typename?: 'Collaborator', userId: number, createdByUser: { __typename?: 'User', displayName: string, id: number } }> | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, currency: { __typename?: 'Currency', id: number, code: string } | null }> } };

export type FindAllBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllBrandsQuery = { __typename?: 'Query', findAllBrands: Array<{ __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string }> };

export type FindAllExternalMattersQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllExternalMattersQuery = { __typename?: 'Query', findAllExternalMatters: Array<{ __typename: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, createdAt: any, updatedAt: any, externalCreatedAt: any | null, externalUpdatedAt: any | null, externalReference: string | null, taxStatus: ExternalMatterTaxStatus, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', createdAt: any, updatedAt: any, id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, matter: { __typename?: 'Matter', id: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null }> };

export type FindAllLibraryUpliftsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllLibraryUpliftsQuery = { __typename?: 'Query', findAllLibraryUplifts: Array<{ __typename?: 'LibraryUplift', id: number, reason: string, group: string }> };

export type FindAllMattersQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllMattersQuery = { __typename?: 'Query', findAllMatters: Array<{ __typename: 'Matter', id: number, title: string, status: MatterStatus, reference: string, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, description: string, order: number, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, brand: { __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string, lineBreakInLists: boolean } | null }> };

export type FindClientsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type FindClientsByIdsQuery = { __typename?: 'Query', getClientsByIds: Array<{ __typename?: 'Client', id: number, name: string }> };

export type FindCumulativeAccruedFeesForExternalMatterQueryVariables = Exact<{
  externalMatterId: Scalars['Float']['input'];
}>;


export type FindCumulativeAccruedFeesForExternalMatterQuery = { __typename?: 'Query', findCumulativeAccruedFeesForExternalMatter: Array<{ __typename?: 'CumulativeAccruedFee', date: any, amount: number }> };

export type FindCumulativeAccruedFeesForMatterQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type FindCumulativeAccruedFeesForMatterQuery = { __typename?: 'Query', findCumulativeAccruedFeesForMatter: Array<{ __typename?: 'CumulativeAccruedFee', date: any, amount: number }> };

export type FindLatestSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindLatestSettingsQuery = { __typename?: 'Query', findLatestSettings: { __typename: 'Settings', id: number, gpmDangerThreshold: number, gpmWarningThreshold: number | null, organisationPmsName: string | null, taxLevelPercent: number, taxLabel: TaxLabel, restrictGpmVisibility: boolean, showGpmSlider: boolean, enableAi: boolean, enableTechPricing: boolean, enableWordExport: boolean, administrationCharge: number, decimalTimeInput: boolean, systemFont: string, autoCloseIntervalInDays: number, staleMatterWarningThresholdInDays: number, defaultCountryCode: string | null, enablePiiFiltering: boolean, showLibraryAssumptionsExclusions: boolean, numberOfAiSuggestionsToShow: number, showClarifyingQuestions: boolean, taxEnabled: boolean, taxEnabledOptionDefault: boolean, currency: { __typename?: 'Currency', id: number, name: string, symbol: string, code: string } } | null };

export type FindMatterCompletionLogsQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type FindMatterCompletionLogsQuery = { __typename?: 'Query', findMatterCompletionLogs: Array<{ __typename?: 'MatterCompletionLog', id: number, matterId: number, completionPercentage: number, createdAt: any }> };

export type FindMatterQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type FindMatterQuery = { __typename?: 'Query', findMatter: { __typename: 'Matter', id: number, reference: string, isFavourite: boolean, title: string, status: MatterStatus, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, pricingTarget: PricingTarget | null, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, includeFeeEarnersInProposalOutput: boolean | null, feeRiskInclude: boolean | null, feeRiskCappedFeeInclude: boolean | null, waiveAdminCharge: boolean | null, waiveAdminChargeReason: string | null, officeLocationId: number | null, confidential: boolean | null, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, aiGeneratedMatterSummary: string | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, externalId: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, externalId: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, technologyCharges: Array<{ __typename?: 'TechnologyCharge', autoFocus: boolean | null, id: number, description: string, currencyId: number | null, fixedAmount: number, baseAmount: number, percentage: number, type: TechnologyChargeType, unitCost: number, units: number, order: number, matterId: number, notes: string | null, libraryTechnologyId: number, technologyUnitId: number, createdAt: any, updatedAt: any, libraryTechnology: { __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null } }> | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, includeOnProposal: boolean | null, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, createdAt: any, matterId: number, updatedAt: any, description: string, order: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, tasks: Array<{ __typename?: 'Task', id: number, order: number, title: string, html: string | null, createdAt: any, phaseId: number, updatedAt: any, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, priceOptions: { __typename?: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, gpmDangerThreshold: { __typename?: 'GpmDangerThresholdResult', gpmDangerThreshold: number, gpmWarningThreshold: number | null, source: string }, brand: { __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string, lineBreakInLists: boolean } | null, teamMemberships: Array<{ __typename?: 'TeamMembership', id: number, matterId: number, rateId: number, feeEarnerId: number | null, rate: { __typename?: 'RateResult', id: number, amount: number, description: string, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }> | null, officeLocation: { __typename?: 'OfficeLocation', id: number, name: string, countryCode: string, taxLabel: TaxLabel | null, taxLevelPercent: number | null } | null, pinnedMatters: Array<{ __typename?: 'Matter', id: number }> | null } };

export type FindRelevantExternalMattersQueryVariables = Exact<{
  text: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  filter: InputMaybe<RelevantExternalMattersFilter>;
  fetchAccruedFees: InputMaybe<Scalars['Boolean']['input']>;
  unlinkedOnly: InputMaybe<Scalars['Boolean']['input']>;
  distanceThreshold?: InputMaybe<Scalars['Float']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  additionalSearchText: InputMaybe<Scalars['String']['input']>;
}>;


export type FindRelevantExternalMattersQuery = { __typename?: 'Query', findRelevantExternalMatters: { __typename?: 'RelevantExternalMattersWithAccruedFees', externalMatters: Array<{ __typename?: 'RelevantExternalMatterResult', relevanceScore: number | null, id: number, title: string, externalCreatedAt: any | null, externalReference: string | null, status: ExternalMatterStatus, taxStatus: ExternalMatterTaxStatus, currency: { __typename?: 'Currency', id: number, code: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, name: string } | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string } | null }>, accruedFees: Array<{ __typename?: 'BaseAccruedFee', clientName: string, actualFee: number, actualGpm: number, amountBilled: number, amountPaid: number, externalMatterId: number, matterTitle: string, currencySymbol: string, accruedTimes: Array<{ __typename?: 'AccruedTime', feeEarnerId: number, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, currencySymbol: string, feeEarnerLevelDescription: string, feeEarnerName: string }>, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, status: InvoiceStatusEnum | null, totalFeeNet: number, date: any | null }> }> } };

export type FindRelevantMattersQueryVariables = Exact<{
  text: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  filter: InputMaybe<RelevantMattersFilter>;
  fetchAccruedFees?: InputMaybe<Scalars['Boolean']['input']>;
  distanceThreshold?: InputMaybe<Scalars['Float']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  additionalSearchText: InputMaybe<Scalars['String']['input']>;
}>;


export type FindRelevantMattersQuery = { __typename?: 'Query', findRelevantMatters: { __typename?: 'RelevantMattersWithAccruedFees', matters: Array<{ __typename: 'RelevantMatterResult', relevanceScore: number | null, reference: string, id: number, isParent: boolean, isFavourite: boolean, title: string, template: boolean, pricingType: PricingType, pricingLevel: PricingLevel, pricingTarget: PricingTarget | null, updatedAt: any, createdAt: any, status: MatterStatus, externalMatterId: number | null, externalReference: string | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null, teamMemberships: Array<{ __typename?: 'TeamMembership', id: number, matterId: number, rateId: number, feeEarnerId: number | null, rate: { __typename?: 'RateResult', id: number, amount: number, description: string, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null }> | null }>, accruedFees: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualTimeAccrued: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, currencySymbol: string, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, collaborators: Array<{ __typename?: 'Collaborator', userId: number, createdByUser: { __typename?: 'User', id: number, displayName: string } }>, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }>, subMatters: Array<{ __typename: 'AccruedFee', matterTitle: string, matterId: number, matterCreatedAt: any, mostRecentTimeEntry: any | null, currencySymbol: string, externalMatterId: number | null, clientName: string, plannedGpm: number, actualFee: number, actualFeePercentage: number, actualFeeVariance: number, actualFeeRiskLevel: RiskLevel, actualGpm: number, actualGpmRiskLevel: RiskLevel, pricingType: PricingTypeEnum, gpmDangerThreshold: number, gpmWarningThreshold: number | null, gpmSource: string, percentageOnTarget: number, amountBilled: number, amountPaid: number, matter: { __typename: 'Matter', id: number, title: string }, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, agreedPrice: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } | null, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, accruedTimes: Array<{ __typename: 'AccruedTime', feeEarnerId: number, feeEarnerName: string, feeEarnerLevelDescription: string, actualDuration: number, actualDurationSinceLastInvoice: number, actualFee: number, actualFeeSinceLastInvoice: number, actualCost: number, actualCostSinceLastInvoice: number, durationAsPercentageOfTotalMatterDuration: number, currencySymbol: string }> }> }> } };

export type FindSimilarExternalMattersForMattersQueryVariables = Exact<{
  input: FindSimilarExternalMattersForMattersInput;
}>;


export type FindSimilarExternalMattersForMattersQuery = { __typename?: 'Query', findSimilarExternalMattersForMatters: { __typename?: 'SimilarExternalMattersForMattersResult', results: Array<{ __typename?: 'MatterExternalMattersResult', matterId: number, externalMatters: Array<{ __typename?: 'RelevantExternalMatterResult', id: number, title: string, clientId: number | null, relevanceScore: number | null, externalCreatedAt: any | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, name: string } | null }> }> } };

export type GetBrandQueryVariables = Exact<{
  brandId: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetBrandQuery = { __typename?: 'Query', getBrand: { __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string, lineBreakInLists: boolean } | null };

export type MatterSpecificRatesQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
  currencyCode: Scalars['String']['input'];
}>;


export type MatterSpecificRatesQuery = { __typename?: 'Query', matterSpecificRates: Array<{ __typename?: 'RateResult', id: number, type: string | null, isLevelRate: boolean | null, amount: number, description: string, feeEarner: { __typename?: 'FeeEarner', id: number } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number } | null }> | null };

export type GetPhaseQueryVariables = Exact<{
  phaseId: Scalars['Float']['input'];
}>;


export type GetPhaseQuery = { __typename?: 'Query', getPhase: { __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null } | null };

export type GetPhasesQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type GetPhasesQuery = { __typename?: 'Query', getPhases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> };

export type GetRatesQueryVariables = Exact<{
  filter: RateFilter;
}>;


export type GetRatesQuery = { __typename?: 'Query', getRates: Array<{ __typename?: 'RateResult', id: number, type: string | null, isLevelRate: boolean | null, amount: number, description: string, feeEarner: { __typename?: 'FeeEarner', id: number } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number } | null }> };

export type GetTaxInfoForMatterQueryVariables = Exact<{
  matterId: Scalars['Int']['input'];
}>;


export type GetTaxInfoForMatterQuery = { __typename?: 'Query', getTaxInfoForMatter: { __typename?: 'TaxInfo', taxLabel: TaxLabel | null, taxLevelPercent: number | null } | null };

export type GetTopDownRatesQueryVariables = Exact<{
  filter: RateFilter;
}>;


export type GetTopDownRatesQuery = { __typename?: 'Query', getTopDownRates: Array<{ __typename?: 'RateGroup', feeEarnerLevelId: number, order: number, rates: Array<{ __typename?: 'RateResult', id: number, type: string | null, isLevelRate: boolean | null, amount: number, description: string, feeEarner: { __typename?: 'FeeEarner', id: number } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number } | null, client: { __typename?: 'Client', id: number } | null }> }> };

export type HasInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type HasInvoicesQuery = { __typename?: 'Query', hasInvoices: boolean };

export type FindLibraryMattersQueryVariables = Exact<{ [key: string]: never; }>;


export type FindLibraryMattersQuery = { __typename?: 'Query', findAllMatters: Array<{ __typename: 'Matter', id: number, title: string, client: { __typename?: 'Client', name: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, phases: Array<{ __typename?: 'Phase', id: number, title: string, tasks: Array<{ __typename?: 'Task', id: number, title: string }> | null }> | null }> };

export type IntegrationRecordCountQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationRecordCountQuery = { __typename?: 'Query', integrationRecordCountQuery: { __typename?: 'IntegrationRecordCountQueryResult', organisationalUnits: number, officeLocations: number, feeEarnerLevels: number, feeEarners: number, users: number, clients: number, rates: number, externalMatters: number, timeEntries: number, matterPermissions: number, matterInvoices: number, currencies: number } };

export type FindLibraryExclusionsQueryVariables = Exact<{
  filter: LibraryExclusionWhereInput;
}>;


export type FindLibraryExclusionsQuery = { __typename?: 'Query', libraryExclusions: Array<{ __typename: 'LibraryExclusion', id: number, text: string, mandatory: boolean | null, default: boolean | null, createdAt: any, updatedAt: any, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number, name: string }> | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> | null };

export type FindLibraryAssumptionsQueryVariables = Exact<{
  filter: LibraryAssumptionWhereInput;
}>;


export type FindLibraryAssumptionsQuery = { __typename?: 'Query', libraryAssumptions: Array<{ __typename: 'LibraryAssumption', id: number, createdAt: any, updatedAt: any, text: string, mandatory: boolean | null, default: boolean | null, organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number, name: string }> | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> };

export type FindLibraryDisbursementsQueryVariables = Exact<{
  filter: LibraryDisbursementWhereInput;
}>;


export type FindLibraryDisbursementsQuery = { __typename?: 'Query', libraryDisbursements: Array<{ __typename: 'LibraryDisbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> };

export type FindLibraryTechnologiesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindLibraryTechnologiesQuery = { __typename?: 'Query', libraryTechnologies: Array<{ __typename: 'LibraryTechnology', id: number, description: string, technologyUnitId: number, type: TechnologyChargeType, createdAt: any, updatedAt: any, technologyUnit: { __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }, technologyRates: Array<{ __typename: 'TechnologyRates', id: number, currencyId: number, unitCost: number, fixedAmount: number, baseAmount: number, percentage: number, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }>, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> };

export type FindMatterAssumptionsQueryVariables = Exact<{
  input: Scalars['Float']['input'];
}>;


export type FindMatterAssumptionsQuery = { __typename?: 'Query', matterAssumptions: Array<{ __typename?: 'Assumption', autoFocus: boolean | null, matterId: number, createdAt: any, updatedAt: any, id: number, text: string, order: number, default: boolean | null, mandatory: boolean | null, fromLibraryAssumptionId: number | null }> };

export type FindMatterCollaboratorUserIdsQueryVariables = Exact<{
  matterId: Scalars['Int']['input'];
}>;


export type FindMatterCollaboratorUserIdsQuery = { __typename?: 'Query', matterCollaborators: Array<{ __typename?: 'Collaborator', id: number, user: { __typename?: 'User', id: number, userName: string, displayName: string } }> };

export type FindMatterExclusionsQueryVariables = Exact<{
  input: Scalars['Float']['input'];
}>;


export type FindMatterExclusionsQuery = { __typename?: 'Query', matterExclusions: Array<{ __typename: 'Exclusion', autoFocus: boolean | null, id: number, text: string, order: number, matterId: number, default: boolean | null, mandatory: boolean | null, fromLibraryExclusionId: number | null }> };

export type FindMatterTemplateListItemsQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Float']['input'];
  limit: Scalars['Float']['input'];
  templateType: InputMaybe<TemplateType>;
  orderBy: InputMaybe<FilteredMattersOrderBy>;
  orgUnitFilter: InputMaybe<Scalars['Float']['input']>;
}>;


export type FindMatterTemplateListItemsQuery = { __typename?: 'Query', matterTemplates: { __typename?: 'PaginatedMatterTemplates', total: number, items: Array<{ __typename: 'Matter', id: number, title: string, createdAt: any, updatedAt: any, templateType: TemplateType | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> } };

export type MatterTemplateQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type MatterTemplateQuery = { __typename?: 'Query', matterTemplate: { __typename: 'Matter', id: number, title: string, pricingType: PricingType, pricingLevel: PricingLevel, status: MatterStatus, createdAt: any, updatedAt: any, taxStatus: TaxStatus, templateType: TemplateType | null, includeTasksInProposalOutput: boolean | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, organisationalUnit: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number }> | null } | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, html: string | null, description: string, order: number, createdAt: any, updatedAt: any, matterId: number, markedComplete: boolean, completionPercentage: number | null, startDate: any | null, deadlineDate: any | null, priceOptions: { __typename: 'PriceOptions', id: number, estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, topDownFeeTarget: number | null, topDownHoursTarget: number | null, topDownRateDiscount: number | null } | null, tasks: Array<{ __typename: 'Task', createdAt: any, phaseId: number, updatedAt: any, id: number, title: string, html: string | null, order: number, markedComplete: boolean, startDate: any | null, deadlineDate: any | null }> | null, work: Array<{ __typename: 'Work', id: number, createdAt: any, phaseId: number | null, matterId: number | null, updatedAt: any, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, workEffort: number | null, topDownRateDiscount: number | null, costRate: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, createdAt: any, updatedAt: any, name: string, deprecated: boolean, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', createdAt: any, updatedAt: any, id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, createdAt: any, updatedAt: any, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null, deprecated: boolean, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, disbursements: Array<{ __typename?: 'Disbursement', id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null } };

export type GetAllPerformanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPerformanceQuery = { __typename?: 'Query', getAllPerformance: { __typename?: 'PerformanceResult', mattersStatus: Array<{ __typename?: 'MattersStatusPerformance', count: number, status: MatterStatusEnum }>, mattersPerArea: Array<{ __typename?: 'MattersByAreaPerformance', count: number, organisationalUnitName: string }> } };

export type NotificationPartsFragment = { __typename?: 'Notification', id: number, matterId: number | null, title: string, type: NotificationType, description: string, message: string | null };

export type FindNotificationsQueryVariables = Exact<{
  type: InputMaybe<Scalars['String']['input']>;
}>;


export type FindNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: number, matterId: number | null, title: string, type: NotificationType, description: string, message: string | null, isParent: boolean }> };

export type NotificationRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationRulesQuery = { __typename?: 'Query', notificationRules: Array<{ __typename: 'NotificationRule', id: number, name: string, updatedAt: any, active: boolean, proposalGpmThreshold: number | null, proposalFeeThreshold: number | null, activeGpmThreshold: number | null, accruedBudgetThreshold: number | null, accruedTimeThreshold: number | null, triggerBooleanType: boolean, thresholdBooleanType: boolean, thresholdFilter: number | null, createdBy: { __typename?: 'User', id: number } | null, triggerUsers: Array<{ __typename?: 'User', id: number, displayName: string, userName: string }> | null, triggerClients: Array<{ __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null }> | null, triggerMatters: Array<{ __typename?: 'Matter', id: number, title: string, externalReference: string | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number, excludeTax: boolean, gpmDangerThreshold: number | null } | null }> | null, triggerFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, notifyUsers: Array<{ __typename?: 'User', id: number, displayName: string }> | null, notifyFeeEarnerLevels: Array<{ __typename?: 'FeeEarnerLevel', id: number }> | null, triggerOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, notifyOrganisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number }> | null, currency: { __typename?: 'Currency', id: number, code: string, symbol: string } | null }> };

export type NotifyCountQueryVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  roleIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  organisationalUnitIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type NotifyCountQuery = { __typename?: 'Query', countNotifyUsers: number };

export type FindOfficeLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindOfficeLocationsQuery = { __typename?: 'Query', officeLocations: Array<{ __typename?: 'OfficeLocation', id: number, countryCode: string, name: string, externalReference: string | null, taxLabel: TaxLabel | null, taxLevelPercent: number | null }> };

export type FindOrganisationalUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindOrganisationalUnitsQuery = { __typename?: 'Query', organisationalUnits: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null, parent: { __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null } | null, children: Array<{ __typename?: 'OrganisationalUnit', id: number, externalReference: string | null, name: string, order: number, gpmDangerThreshold: number | null, gpmWarningThreshold: number | null }> | null }> };

export type PhasesQueryVariables = Exact<{
  findParentMatterId: Scalars['Int']['input'];
}>;


export type PhasesQuery = { __typename?: 'Query', findParentMatter: { __typename?: 'ParentMatter', phases: Array<{ __typename?: 'ParentMatterPhase', id: number, order: number, title: string }> } | null };

export type ProposalPartsFragment = { __typename?: 'Proposal', matterId: number, pricingLevel: PricingLevelEnum, pricingType: PricingTypeEnum, status: MatterStatusEnum, clientName: string, matterTitle: string, includeTasks: boolean, includeRatesInProposalOutput: boolean, includeFeeEarnersInProposalOutput: boolean, excludeTax: boolean, assumptions: Array<string>, exclusions: Array<string>, feeRiskInclude: boolean, feeRiskCappedFeeInclude: boolean, assignedResources: Array<{ __typename?: 'AssignedResource', feeEarnerLevelDescription: string, feeEarnerName: string | null, rate: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeLineItems: Array<{ __typename?: 'LegalFeeLineItem', title: string, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, tasks: Array<{ __typename?: 'TaskItem', id: number, order: number, title: string, phaseId: number, createdAt: any, updatedAt: any }> }>, legalFeeTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeTotalBeforeVisibleUplifts: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeUplifts: Array<{ __typename?: 'LegalFeeUpliftLineItem', reason: string, rate: number, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number } | { __typename?: 'PriceRangeDiscount', discountRateRange: { __typename?: 'PercentageRange', lower: number, upper: number }, discountAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, discountedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number } | { __typename?: 'PriceRangeAdminCharge', adminChargeRate: number, adminChargeAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, adminChargedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number } | { __typename: 'TaxRange', taxRate: number, taxAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, totalRangeIncludingTax: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, disbursementLineItems: Array<{ __typename?: 'DisbursementLineItem', name: string, amount: number }>, disbursementsTotal: { __typename: 'Price', amount: number }, disbursementsTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, grandTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, fixedLegalFeeTotal: { __typename: 'Price', amount: number }, fixedLegalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, fixedLegalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number }, fixedLegalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number }, fixedGrandTotal: { __typename: 'Price', amount: number }, priceOptions: { __typename?: 'FeeRiskPriceOptions', estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, fixedChosen: number | null, cappedChosen: number | null } };

export type GenerateParentProposalQueryVariables = Exact<{
  parentId: Scalars['Float']['input'];
}>;


export type GenerateParentProposalQuery = { __typename?: 'Query', generateParentProposal: { __typename?: 'ParentProposalResult', collated: { __typename?: 'Proposal', matterId: number, pricingLevel: PricingLevelEnum, pricingType: PricingTypeEnum, status: MatterStatusEnum, clientName: string, matterTitle: string, includeTasks: boolean, includeRatesInProposalOutput: boolean, includeFeeEarnersInProposalOutput: boolean, excludeTax: boolean, assumptions: Array<string>, exclusions: Array<string>, feeRiskInclude: boolean, feeRiskCappedFeeInclude: boolean, assignedResources: Array<{ __typename?: 'AssignedResource', feeEarnerLevelDescription: string, feeEarnerName: string | null, rate: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeLineItems: Array<{ __typename?: 'LegalFeeLineItem', title: string, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, tasks: Array<{ __typename?: 'TaskItem', id: number, order: number, title: string, phaseId: number, createdAt: any, updatedAt: any }> }>, legalFeeTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeTotalBeforeVisibleUplifts: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeUplifts: Array<{ __typename?: 'LegalFeeUpliftLineItem', reason: string, rate: number, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number } | { __typename?: 'PriceRangeDiscount', discountRateRange: { __typename?: 'PercentageRange', lower: number, upper: number }, discountAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, discountedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number } | { __typename?: 'PriceRangeAdminCharge', adminChargeRate: number, adminChargeAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, adminChargedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number } | { __typename: 'TaxRange', taxRate: number, taxAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, totalRangeIncludingTax: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, disbursementLineItems: Array<{ __typename?: 'DisbursementLineItem', name: string, amount: number }>, disbursementsTotal: { __typename: 'Price', amount: number }, disbursementsTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, grandTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, fixedLegalFeeTotal: { __typename: 'Price', amount: number }, fixedLegalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, fixedLegalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number }, fixedLegalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number }, fixedGrandTotal: { __typename: 'Price', amount: number }, priceOptions: { __typename?: 'FeeRiskPriceOptions', estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, fixedChosen: number | null, cappedChosen: number | null } }, items: Array<{ __typename?: 'Proposal', matterId: number, pricingLevel: PricingLevelEnum, pricingType: PricingTypeEnum, status: MatterStatusEnum, clientName: string, matterTitle: string, includeTasks: boolean, includeRatesInProposalOutput: boolean, includeFeeEarnersInProposalOutput: boolean, excludeTax: boolean, assumptions: Array<string>, exclusions: Array<string>, feeRiskInclude: boolean, feeRiskCappedFeeInclude: boolean, assignedResources: Array<{ __typename?: 'AssignedResource', feeEarnerLevelDescription: string, feeEarnerName: string | null, rate: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeLineItems: Array<{ __typename?: 'LegalFeeLineItem', title: string, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, tasks: Array<{ __typename?: 'TaskItem', id: number, order: number, title: string, phaseId: number, createdAt: any, updatedAt: any }> }>, legalFeeTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeTotalBeforeVisibleUplifts: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeUplifts: Array<{ __typename?: 'LegalFeeUpliftLineItem', reason: string, rate: number, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number } | { __typename?: 'PriceRangeDiscount', discountRateRange: { __typename?: 'PercentageRange', lower: number, upper: number }, discountAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, discountedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number } | { __typename?: 'PriceRangeAdminCharge', adminChargeRate: number, adminChargeAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, adminChargedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number } | { __typename: 'TaxRange', taxRate: number, taxAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, totalRangeIncludingTax: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, disbursementLineItems: Array<{ __typename?: 'DisbursementLineItem', name: string, amount: number }>, disbursementsTotal: { __typename: 'Price', amount: number }, disbursementsTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, grandTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, fixedLegalFeeTotal: { __typename: 'Price', amount: number }, fixedLegalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, fixedLegalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number }, fixedLegalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number }, fixedGrandTotal: { __typename: 'Price', amount: number }, priceOptions: { __typename?: 'FeeRiskPriceOptions', estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, fixedChosen: number | null, cappedChosen: number | null } }> } };

export type GenerateProposalQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type GenerateProposalQuery = { __typename?: 'Query', generateProposal: { __typename?: 'Proposal', matterId: number, pricingLevel: PricingLevelEnum, pricingType: PricingTypeEnum, status: MatterStatusEnum, clientName: string, matterTitle: string, includeTasks: boolean, includeRatesInProposalOutput: boolean, excludeTax: boolean, assumptions: Array<string>, exclusions: Array<string>, feeRiskInclude: boolean, feeRiskCappedFeeInclude: boolean, assignedResources: Array<{ __typename?: 'AssignedResource', feeEarnerLevelDescription: string, feeEarnerName: string | null, rate: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeLineItems: Array<{ __typename?: 'LegalFeeLineItem', title: string, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, tasks: Array<{ __typename?: 'TaskItem', id: number, order: number, title: string, phaseId: number, createdAt: any, updatedAt: any }> }>, legalFeeTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeTotalBeforeVisibleUplifts: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, legalFeeUplifts: Array<{ __typename?: 'LegalFeeUpliftLineItem', reason: string, rate: number, order: number, fee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null } }>, legalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number } | { __typename?: 'PriceRangeDiscount', discountRateRange: { __typename?: 'PercentageRange', lower: number, upper: number }, discountAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, discountedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number } | { __typename?: 'PriceRangeAdminCharge', adminChargeRate: number, adminChargeAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, adminChargedAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, legalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number } | { __typename: 'TaxRange', taxRate: number, taxAmountRange: { __typename: 'PriceRange', lower: number | null, upper: number | null }, totalRangeIncludingTax: { __typename: 'PriceRange', lower: number | null, upper: number | null } }, disbursementLineItems: Array<{ __typename?: 'DisbursementLineItem', name: string, amount: number }>, disbursementsTotal: { __typename: 'Price', amount: number }, disbursementsTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, grandTotal: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, fixedLegalFeeTotal: { __typename: 'Price', amount: number }, fixedLegalFeeTax: { __typename: 'Tax', taxRate: number, taxAmount: number, totalIncludingTax: number }, fixedLegalFeeDiscount: { __typename?: 'PriceDiscount', discountRate: number, discountAmount: number, discountedAmount: number }, fixedLegalFeeAdminCharge: { __typename?: 'PriceAdminCharge', adminChargeRate: number, adminChargeAmount: number, adminChargedAmount: number }, fixedGrandTotal: { __typename: 'Price', amount: number }, priceOptions: { __typename?: 'FeeRiskPriceOptions', estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, feeRiskLower: number | null, feeRiskUpper: number | null, fixedChosen: number | null, cappedChosen: number | null } } };

export type RoiQueryQueryVariables = Exact<{
  input: RoiQueryInput;
}>;


export type RoiQueryQuery = { __typename?: 'Query', roiQuery: { __typename?: 'RoiQueryResult', roiTimeSeriesDataJSON: string, timeIntervalsJSON: string } };

export type FindTechnologyUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindTechnologyUnitsQuery = { __typename?: 'Query', technologyUnits: Array<{ __typename: 'TechnologyUnit', id: number, name: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null }> };

export type TextFilterMattersQueryVariables = Exact<{
  filter: TextFilterArg;
}>;


export type TextFilterMattersQuery = { __typename?: 'Query', textFilteredMatters: { __typename?: 'MatterResult', total: number, matters: Array<{ __typename: 'Matter', id: number, title: string, client: { __typename?: 'Client', id: number, name: string } | null }> } };

export type UsageReportQueryVariables = Exact<{
  input: UsageReportQueryInput;
}>;


export type UsageReportQuery = { __typename?: 'Query', usageReportQuery: { __typename?: 'UsageReportQueryResult', timeSeriesData: Array<{ __typename?: 'TimeSeriesUsageData', timeLabelString: string, totalCount: number, practiceAreaCounts: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, externalMattersStatusCounts: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }> }>, aggregateData: { __typename?: 'AggregateUsageData', totalCount: number, mattersByUser: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number, metaData: Array<{ __typename?: 'MetaData', key: string, value: string }> | null }>, mattersByStatus: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, externalMattersByStatus: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, mattersByLinkedUnlinked: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, mattersByPracticeArea: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, templatesByPracticeArea: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, practiceAreas: Array<{ __typename?: 'AggregratePracticeAreaData', practiceArea: { __typename?: 'PracticeArea', id: number, name: string }, byStatus: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, byLinkedUnlinked: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }>, templatesByTemplateType: Array<{ __typename?: 'CountByField', field: string, id: number | null, count: number }> }> } } };

export type GetUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsQuery = { __typename?: 'Query', getUserSettings: { __typename?: 'UserSettings', darkTheme: boolean, customPaletteHex: string | null } };

export type GenerateWorkplanQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
}>;


export type GenerateWorkplanQuery = { __typename?: 'Query', generateWorkplan: { __typename?: 'Workplan', matterId: number, matterTitle: string, rates: Array<{ __typename?: 'WorkplanRate', id: number, description: string, feeEarner: { __typename?: 'WorkplanFeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'WorkplanFeeEarnerLevel', id: number, description: string, order: number } } | null, feeEarnerLevel: { __typename?: 'WorkplanFeeEarnerLevel', id: number, description: string, order: number } | null }>, lineItems: Array<{ __typename?: 'WorkItem', id: number, title: string, resourceAndTime: Array<{ __typename?: 'ResourceAndTime', rateId: number, timeRange: { __typename?: 'TimeRangeAndSingle', timeLower: number | null, timeUpper: number | null, timeSingle: number | null } }> }>, resourceAndTimeTotals: Array<{ __typename?: 'WorkplanResourceAndTimeTotal', rateId: number, timeRange: { __typename?: 'TimeRangeAndSingle', timeLower: number | null, timeUpper: number | null, timeSingle: number | null } }> } };

export type CreatedOrUpdatedMatterSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CreatedOrUpdatedMatterSubscription = { __typename?: 'Subscription', createdOrUpdatedMatter: { __typename: 'Matter', id: number, title: string, status: MatterStatus, reference: string, createdAt: any, updatedAt: any, template: boolean, parentMatterId: number | null, externalMatterId: number | null, externalReference: string | null, pricingType: PricingType, pricingLevel: PricingLevel, taxStatus: TaxStatus, includeTasksInProposalOutput: boolean | null, includeRatesInProposalOutput: boolean | null, parent: { __typename?: 'ParentMatter', id: number, title: string, matters: Array<{ __typename?: 'Matter', id: number, title: string }> } | null, externalMatter: { __typename?: 'ExternalMatter', id: number, title: string, status: ExternalMatterStatus, externalReference: string | null, leadFeeEarner: { __typename?: 'FeeEarner', id: number, name: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null } | null, createdBy: { __typename?: 'User', id: number, userName: string, displayName: string } | null, client: { __typename?: 'Client', id: number, name: string, externalReference: string | null, type: number } | null, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, disbursements: Array<{ __typename: 'Disbursement', autoFocus: boolean | null, id: number, name: string, amount: number, vatStatus: TaxLabelStatus, order: number, updatedAt: any }> | null, uplifts: Array<{ __typename: 'Uplift', autoFocus: boolean | null, id: number, amount: number, type: UpliftType, order: number, baseUplift: { __typename?: 'LibraryUplift', id: number, reason: string } | null }> | null, discounts: Array<{ __typename: 'Discount', autoFocus: boolean | null, id: number, reason: string, amount: number, type: DiscountType, order: number }> | null, phases: Array<{ __typename: 'Phase', autoFocus: boolean | null, id: number, title: string, description: string, order: number, priceOptions: { __typename?: 'PriceOptions', estimatedGpm: number | null, estimatedSuggested: number | null, estimatedChosen: number | null, estimatedRangeGpm: number | null, estimatedRangeSuggestedLower: number | null, estimatedRangeSuggestedUpper: number | null, estimatedRangeChosenLower: number | null, estimatedRangeChosenUpper: number | null, fixedGpm: number | null, fixedSuggested: number | null, fixedChosen: number | null, cappedChosen: number | null, cappedGpm: number | null, cappedSuggested: number | null } | null, work: Array<{ __typename: 'Work', id: number, phaseId: number | null, timeLower: number | null, timeUpper: number | null, timeSingle: number | null, price: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null }, selectedRate: { __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null } | null, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, feeEarner: { __typename?: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number, description: string, order: number } | null, rates: Array<{ __typename?: 'RateResult', id: number, description: string, amount: number, clientId: number | null, feeEarnerId: number | null, feeEarnerLevelId: number | null }> | null, practiceArea: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, cost: { __typename?: 'PriceRangeAndSingle', lower: number | null, upper: number | null, single: number | null } }> | null }> | null, organisationalUnit: { __typename: 'OrganisationalUnit', id: number, name: string, parent: { __typename?: 'OrganisationalUnit', id: number, name: string } | null } | null, leadFeeEarner: { __typename: 'FeeEarner', id: number, name: string, feeEarnerLevel: { __typename?: 'FeeEarnerLevel', id: number } | null } | null, brand: { __typename: 'Brand', id: number, organisationName: string | null, organisationLogo: string | null, footer: string | null, includeTasksInProposalOutput: boolean, includeRatesInProposalOutput: boolean, proposalFont: string, isDefault: boolean, numberedListFormat: string, lineBreakInLists: boolean } | null } };

export type FileDataImportCompletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FileDataImportCompletedSubscription = { __typename?: 'Subscription', fileDataImportCompleted: { __typename?: 'DataImportProcessedPayload', entityType: string, created: number, updated: number, deleted: number, importErrors: Array<string>, totalErrors: number } };

export type FileDataImportProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FileDataImportProgressSubscription = { __typename?: 'Subscription', fileDataImportProgress: { __typename?: 'DataImportProgress', percentage: number, hasError: boolean } };

export type NewNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewNotificationSubscription = { __typename?: 'Subscription', newNotification: { __typename?: 'NotificationResult', id: number, title: string, type: NotificationType, description: string, matterId: number | null, message: string | null, isParent: boolean } };

export type UpdateClientReportHtmlMutationVariables = Exact<{
  update: UpdateClientReportOutputInput;
}>;


export type UpdateClientReportHtmlMutation = { __typename?: 'Mutation', updateClientReportHtml: boolean };

export type ClientReportByMatterIdQueryVariables = Exact<{
  matterId: Scalars['Float']['input'];
  costProjectionSvgString: Scalars['String']['input'];
}>;


export type ClientReportByMatterIdQuery = { __typename?: 'Query', clientReportByMatterId: { __typename?: 'ClientReportResult', html: string, outputTemplateId: number, outputTemplateName: string, clientReport: { __typename?: 'ClientReport', matterTitle: string, clientName: string, currencySymbol: string, actualFee: number, overBudget: number, amountBilled: number, amountPaid: number, billingChart: string, includeBillingChart: boolean, costProjectionDiagram: string, includeCostProjectionDiagram: boolean, deadline: any | null, plannedFee: { __typename: 'Price', amount: number } | { __typename: 'PriceRange', lower: number | null, upper: number | null }, invoices: Array<{ __typename?: 'Invoice', id: number, description: string, date: any | null, status: InvoiceStatusEnum | null, totalFeeNet: number }>, cumulativeAccruedFees: Array<{ __typename?: 'CumulativeAccruedFee', date: any, amount: number }>, matterCompletionLogs: Array<{ __typename?: 'MatterCompletionLog', createdAt: any, completionPercentage: number }> } } };

export type UpdateClientReportOptionsMutationVariables = Exact<{
  updateOptions: UpdateClientReportOptionsInput;
}>;


export type UpdateClientReportOptionsMutation = { __typename?: 'Mutation', updateClientReportOptions: { __typename?: 'ClientReportOptionsUpdateResult', includeCostProjectionDiagram: boolean, includeBillingChart: boolean } };

export type CurrentUserFeeEarnerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserFeeEarnerDataQuery = { __typename?: 'Query', currentUserFeeEarnerData: { __typename?: 'CurrentUserDataResult', feeEarnerLevelId: number | null, practiceAreaId: number | null, userId: number, displayName: string | null, restrictedGpmVisible: boolean | null, practiceAreaName: string | null, feeEarnerLevelDescription: string | null, currencyId: number | null, organisationalUnitId: number | null, officeLocationId: number | null, quickUpdateShownAt: any | null, feeEarnerId: number | null, officeLocationName: string | null } | null };

export const GroupItemChildFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupItemChildFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputDesigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<GroupItemChildFragmentFragment, unknown>;
export const GroupItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"outputDesigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupItemChildFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputDesigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<GroupItemFragmentFragment, unknown>;
export const TechnologyUnitPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<TechnologyUnitPartsFragment, unknown>;
export const TechnologyRatePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]} as unknown as DocumentNode<TechnologyRatePartsFragment, unknown>;
export const LibraryTechnologyPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]} as unknown as DocumentNode<LibraryTechnologyPartsFragment, unknown>;
export const TechnologyChargePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<TechnologyChargePartsFragment, unknown>;
export const TaskPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}}]} as unknown as DocumentNode<TaskPartsFragment, unknown>;
export const ParentMatterPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyChargeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTarget"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"waiveAdminCharge"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}}]} as unknown as DocumentNode<ParentMatterPartsFragment, unknown>;
export const ParentMatterPhasesPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentMatterPhasesParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParentMatterPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"includeInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentMatterParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyChargeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTarget"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"waiveAdminCharge"}}]}}]} as unknown as DocumentNode<ParentMatterPhasesPartsFragment, unknown>;
export const CollaboratorFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollaboratorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaborator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]} as unknown as DocumentNode<CollaboratorFragmentFragment, unknown>;
export const PricePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]} as unknown as DocumentNode<PricePartsFragment, unknown>;
export const PriceRangePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}}]} as unknown as DocumentNode<PriceRangePartsFragment, unknown>;
export const AccruedTimeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedTimeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"actualDuration"}},{"kind":"Field","name":{"kind":"Name","value":"actualDurationSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCostSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"durationAsPercentageOfTotalMatterDuration"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}}]}}]} as unknown as DocumentNode<AccruedTimeFragmentFragment, unknown>;
export const AccruedFeeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedFeeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollaboratorFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeAccrued"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollaboratorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaborator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedTimeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"actualDuration"}},{"kind":"Field","name":{"kind":"Name","value":"actualDurationSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCostSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"durationAsPercentageOfTotalMatterDuration"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}}]}}]} as unknown as DocumentNode<AccruedFeeFragmentFragment, unknown>;
export const AssumptionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssumptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assumption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}}]}}]} as unknown as DocumentNode<AssumptionFragmentFragment, unknown>;
export const BaseMatterPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BaseMatterPartsFragment, unknown>;
export const BrandPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}},{"kind":"Field","name":{"kind":"Name","value":"lineBreakInLists"}}]}}]} as unknown as DocumentNode<BrandPartsFragment, unknown>;
export const DiscountPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Discount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]} as unknown as DocumentNode<DiscountPartsFragment, unknown>;
export const ExclusionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryExclusionId"}}]}}]} as unknown as DocumentNode<ExclusionFragmentFragment, unknown>;
export const OrganisationalUnitPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationalUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganisationalUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrganisationalUnitPartsFragment, unknown>;
export const FeeEarnerPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeeEarnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEarner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FeeEarnerPartsFragment, unknown>;
export const ExternalMatterPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalMatter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationalUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeeEarnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationalUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganisationalUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeeEarnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEarner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExternalMatterPartsFragment, unknown>;
export const LibraryAssumptionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryAssumptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryAssumption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<LibraryAssumptionFragmentFragment, unknown>;
export const LibraryDisbursementFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryDisbursementFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryDisbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<LibraryDisbursementFragmentFragment, unknown>;
export const LibraryExclusionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryExclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<LibraryExclusionFragmentFragment, unknown>;
export const LibraryMatterPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<LibraryMatterPartsFragment, unknown>;
export const MatterPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}}]}}]} as unknown as DocumentNode<MatterPartsFragment, unknown>;
export const PriceOptionsPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}}]} as unknown as DocumentNode<PriceOptionsPartsFragment, unknown>;
export const WorkPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]} as unknown as DocumentNode<WorkPartsFragment, unknown>;
export const PhasePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]} as unknown as DocumentNode<PhasePartsFragment, unknown>;
export const DisbursementPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<DisbursementPartsFragment, unknown>;
export const MatterTemplatePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<MatterTemplatePartsFragment, unknown>;
export const MatterTemplateListItemPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterTemplateListItemParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<MatterTemplateListItemPartsFragment, unknown>;
export const NotificationRulePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationRuleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proposalGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFeeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"activeGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedBudgetThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"triggerBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdFilter"}},{"kind":"Field","name":{"kind":"Name","value":"triggerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerClients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]} as unknown as DocumentNode<NotificationRulePartsFragment, unknown>;
export const RatePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RateResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isLevelRate"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RatePartsFragment, unknown>;
export const SettingsPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"organisationPmsName"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictGpmVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"showGpmSlider"}},{"kind":"Field","name":{"kind":"Name","value":"enableAi"}},{"kind":"Field","name":{"kind":"Name","value":"enableTechPricing"}},{"kind":"Field","name":{"kind":"Name","value":"enableWordExport"}},{"kind":"Field","name":{"kind":"Name","value":"administrationCharge"}},{"kind":"Field","name":{"kind":"Name","value":"decimalTimeInput"}},{"kind":"Field","name":{"kind":"Name","value":"systemFont"}},{"kind":"Field","name":{"kind":"Name","value":"autoCloseIntervalInDays"}},{"kind":"Field","name":{"kind":"Name","value":"staleMatterWarningThresholdInDays"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"enablePiiFiltering"}},{"kind":"Field","name":{"kind":"Name","value":"showLibraryAssumptionsExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAiSuggestionsToShow"}},{"kind":"Field","name":{"kind":"Name","value":"showClarifyingQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"taxEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"taxEnabledOptionDefault"}}]}}]} as unknown as DocumentNode<SettingsPartsFragment, unknown>;
export const TeamMembershipPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMembershipParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TeamMembershipPartsFragment, unknown>;
export const UpliftPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpliftParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Uplift"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeOnProposal"}}]}}]} as unknown as DocumentNode<UpliftPartsFragment, unknown>;
export const NotificationPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<NotificationPartsFragment, unknown>;
export const TaxPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tax"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalIncludingTax"}}]}}]} as unknown as DocumentNode<TaxPartsFragment, unknown>;
export const TaxRangePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRangeIncludingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}}]} as unknown as DocumentNode<TaxRangePartsFragment, unknown>;
export const ProposalPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProposalParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Proposal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasks"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeFeeEarnersInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"assignedResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTotalBeforeVisibleUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRangeDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeAdminCharge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRangeAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementsTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementsTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assumptions"}},{"kind":"Field","name":{"kind":"Name","value":"exclusions"}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeAdminCharge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedGrandTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskInclude"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskCappedFeeInclude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tax"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalIncludingTax"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRangeIncludingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]} as unknown as DocumentNode<ProposalPartsFragment, unknown>;
export const FilteredDesignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilteredDesigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OutputDesignWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredDesigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContent"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"defaultForOrgUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupItemId"}},{"kind":"Field","name":{"kind":"Name","value":"removeTemplateMargin"}}]}}]}}]} as unknown as DocumentNode<FilteredDesignsQuery, FilteredDesignsQueryVariables>;
export const FindDesignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findDesign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findDesign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContent"}}]}}]}}]} as unknown as DocumentNode<FindDesignQuery, FindDesignQueryVariables>;
export const TestDesignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TestDesign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TestDesignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testDesign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}}]}}]}}]} as unknown as DocumentNode<TestDesignMutation, TestDesignMutationVariables>;
export const CloneDesignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CloneDesign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cloneDesign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CloneDesignMutation, CloneDesignMutationVariables>;
export const CreateDesignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDesign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OutputDesignCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDesign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDesignMutation, CreateDesignMutationVariables>;
export const UpdateDesignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDesigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDesignsInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDesigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"designType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContent"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<UpdateDesignsMutation, UpdateDesignsMutationVariables>;
export const DeleteDesignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDesign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDesign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDesignMutation, DeleteDesignMutationVariables>;
export const GetProposalMergeTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProposalMergeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProposalMergeTagFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetProposalMergeTagsQuery, GetProposalMergeTagsQueryVariables>;
export const GetClientReportMergeTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientReportMergeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getClientReportMergeTagFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetClientReportMergeTagsQuery, GetClientReportMergeTagsQueryVariables>;
export const GetTextBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTextBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTextBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetTextBlocksQuery, GetTextBlocksQueryVariables>;
export const MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Mutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetExistingProposals"}}]}}]} as unknown as DocumentNode<MutationMutation, MutationMutationVariables>;
export const CurrentPdfOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentPdfOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outputDesignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPdfOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"outputDesignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outputDesignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headerImageName"}},{"kind":"Field","name":{"kind":"Name","value":"footerImageName"}},{"kind":"Field","name":{"kind":"Name","value":"contentBeforeName"}},{"kind":"Field","name":{"kind":"Name","value":"contentAfterName"}}]}}]}}]} as unknown as DocumentNode<CurrentPdfOptionsQuery, CurrentPdfOptionsQueryVariables>;
export const DeletePdfOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePdfOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"option"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outputDesignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePdfOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"option"},"value":{"kind":"Variable","name":{"kind":"Name","value":"option"}}},{"kind":"Argument","name":{"kind":"Name","value":"outputDesignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outputDesignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePdfOptionMutation, DeletePdfOptionMutationVariables>;
export const UploadHeaderImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadHeaderImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"headerInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeaderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadHeaderImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"headerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"headerInput"}}}]}]}}]} as unknown as DocumentNode<UploadHeaderImageMutation, UploadHeaderImageMutationVariables>;
export const UploadFooterImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFooterImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"footerInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FooterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFooterImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"footerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"footerInput"}}}]}]}}]} as unknown as DocumentNode<UploadFooterImageMutation, UploadFooterImageMutationVariables>;
export const UploadPdfAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadPDFAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdfAttachment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PDFAttachment"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadPDFAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pdfAttachment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdfAttachment"}}}]}]}}]} as unknown as DocumentNode<UploadPdfAttachmentMutation, UploadPdfAttachmentMutationVariables>;
export const GroupItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupedEntityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupedEntityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupedEntityType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupItemChildFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputDesigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"outputDesigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupItemChildFragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupItemsQuery, GroupItemsQueryVariables>;
export const CreateGroupItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGroupItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupItem"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroupItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGroupItemMutation, CreateGroupItemMutationVariables>;
export const UpdateGroupItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGroupItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupItemUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupItemMutation, UpdateGroupItemMutationVariables>;
export const DynamicTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DynamicTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dynamicTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicTagEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contents"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicTagId"}},{"kind":"Field","name":{"kind":"Name","value":"condition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"officeId"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DynamicTagsQuery, DynamicTagsQueryVariables>;
export const CreateDynamicTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDynamicTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DynamicTagCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDynamicTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDynamicTagMutation, CreateDynamicTagMutationVariables>;
export const UpdateDynamicTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDynamicTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DynamicTagUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDynamicTagId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDynamicTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDynamicTagId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDynamicTagMutation, UpdateDynamicTagMutationVariables>;
export const DeleteDynamicTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDynamicTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteDynamicTagId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDynamicTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteDynamicTagId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDynamicTagMutation, DeleteDynamicTagMutationVariables>;
export const ExistingDynamicTagImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"existingDynamicTagImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"existingDynamicTagImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]} as unknown as DocumentNode<ExistingDynamicTagImagesQuery, ExistingDynamicTagImagesQueryVariables>;
export const TaxonomyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Taxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<TaxonomyQuery, TaxonomyQueryVariables>;
export const UpdateTaxonomyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTaxonomy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateTaxonomyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaxonomy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTaxonomyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateTaxonomyMutation, UpdateTaxonomyMutationVariables>;
export const UpdateParentMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateParentMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParentMatterUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateParentMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParentMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateParentMatterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateParentMatterMutation, UpdateParentMatterMutationVariables>;
export const FindParentMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindParentMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findParentMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeFeeEarnersInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentMatterPhasesParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyChargeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTarget"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"waiveAdminCharge"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParentMatterPhasesParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParentMatterPhase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"includeInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParentMatterParts"}}]}}]}}]} as unknown as DocumentNode<FindParentMatterQuery, FindParentMatterQueryVariables>;
export const UpdateProposalHtmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProposalHtml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProposalOutputInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProposalHtml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}]}]}}]} as unknown as DocumentNode<UpdateProposalHtmlMutation, UpdateProposalHtmlMutationVariables>;
export const ProposalByMatterIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProposalByMatterId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proposalByMatterId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"proposal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includeTasks"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeFeeEarnersInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskInclude"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskCappedFeeInclude"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskValid"}},{"kind":"Field","name":{"kind":"Name","value":"ganttAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"ganttInclude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"outputTemplateName"}},{"kind":"Field","name":{"kind":"Name","value":"selectedOfficeId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedOrganisationalUnitId"}}]}}]}}]} as unknown as DocumentNode<ProposalByMatterIdQuery, ProposalByMatterIdQueryVariables>;
export const UpdateProposalOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProposalOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateOptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProposalOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProposalOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includeTasks"}},{"kind":"Field","name":{"kind":"Name","value":"includeDiagram"}},{"kind":"Field","name":{"kind":"Name","value":"showFeeEarners"}},{"kind":"Field","name":{"kind":"Name","value":"showRates"}}]}}]}}]} as unknown as DocumentNode<UpdateProposalOptionsMutation, UpdateProposalOptionsMutationVariables>;
export const FilteredExternalMattersCountWithAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilteredExternalMattersCountWithAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredExternalMattersCountWithAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FilteredExternalMattersCountWithAmountQuery, FilteredExternalMattersCountWithAmountQueryVariables>;
export const CreateAssumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAssumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssumptionCreateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryAssumptionId"}}]}}]}}]} as unknown as DocumentNode<CreateAssumptionsMutation, CreateAssumptionsMutationVariables>;
export const CreateLibraryAssumptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLibraryAssumption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryAssumptionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLibraryAssumption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryAssumptionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryAssumptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryAssumption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<CreateLibraryAssumptionMutation, CreateLibraryAssumptionMutationVariables>;
export const DeleteAssumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAssumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assumptionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assumptionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assumptionIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assumptionIds"}}]}}]}}]} as unknown as DocumentNode<DeleteAssumptionsMutation, DeleteAssumptionsMutationVariables>;
export const UpdateAssumptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssumption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyAssumptionsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssumption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryAssumptionId"}}]}}]}}]} as unknown as DocumentNode<UpdateAssumptionMutation, UpdateAssumptionMutationVariables>;
export const UpdateAssumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyAssumptionsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<UpdateAssumptionsMutation, UpdateAssumptionsMutationVariables>;
export const UpdateLibraryAssumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLibraryAssumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryAssumptionUpdate"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLibraryAssumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedAssumptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterIds"}}]}}]}}]} as unknown as DocumentNode<UpdateLibraryAssumptionsMutation, UpdateLibraryAssumptionsMutationVariables>;
export const CopyLibraryPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyLibraryPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyLibraryPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assumptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssumptionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExclusionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssumptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assumption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryExclusionId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CopyLibraryPhaseMutation, CopyLibraryPhaseMutationVariables>;
export const CopyMatterPhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyMatterPhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copiedMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyMatterPhases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"targetMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"copiedMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copiedMatterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assumptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssumptionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExclusionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssumptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assumption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryExclusionId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CopyMatterPhasesMutation, CopyMatterPhasesMutationVariables>;
export const CopyPricingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyPricing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricingMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyScope"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyResourcing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rateReplacements"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RateReplacement"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyPricing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pricingMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricingMatterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"copyScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyScope"}}},{"kind":"Argument","name":{"kind":"Name","value":"copyResourcing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyResourcing"}}},{"kind":"Argument","name":{"kind":"Name","value":"rateReplacements"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rateReplacements"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMembershipParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMembershipParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<CopyPricingMutation, CopyPricingMutationVariables>;
export const CopyResourcingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyResourcing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourcingMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rateReplacements"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RateReplacement"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyResourcing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resourcingMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourcingMatterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rateReplacements"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rateReplacements"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeOnProposal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTarget"}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMembershipParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMembershipParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CopyResourcingMutation, CopyResourcingMutationVariables>;
export const CopyScopeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyScope"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scopeMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyScope"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scopeMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scopeMatterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetMatterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CopyScopeMutation, CopyScopeMutationVariables>;
export const CreateBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}},{"kind":"Field","name":{"kind":"Name","value":"lineBreakInLists"}}]}}]} as unknown as DocumentNode<CreateBrandMutation, CreateBrandMutationVariables>;
export const CreateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]}}]} as unknown as DocumentNode<CreateClientMutation, CreateClientMutationVariables>;
export const CreateAndAddDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Discount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]} as unknown as DocumentNode<CreateAndAddDiscountMutation, CreateAndAddDiscountMutationVariables>;
export const CreateLibraryTechnologyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLibraryTechnology"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnologyCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLibraryTechnology"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<CreateLibraryTechnologyMutation, CreateLibraryTechnologyMutationVariables>;
export const CreateManyTechnologyRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateManyTechnologyRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateManyTechnologyRatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyTechnologyRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<CreateManyTechnologyRatesMutation, CreateManyTechnologyRatesMutationVariables>;
export const CreateMatterTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMatterTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cloneTemplateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatterCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMatterTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cloneTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cloneTemplateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatterTemplateParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}}]}}]} as unknown as DocumentNode<CreateMatterTemplateMutation, CreateMatterTemplateMutationVariables>;
export const CreateMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatterCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createFromOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFromOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentPhaseId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"createFromOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createFromOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentPhaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentPhaseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterPhaseId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseMatterParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<CreateMatterMutation, CreateMatterMutationVariables>;
export const CreateNotificationRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNotificationRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationRuleCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNotificationRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationRuleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationRuleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proposalGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFeeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"activeGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedBudgetThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"triggerBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdFilter"}},{"kind":"Field","name":{"kind":"Name","value":"triggerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerClients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]} as unknown as DocumentNode<CreateNotificationRuleMutation, CreateNotificationRuleMutationVariables>;
export const CreateOrUpdateMatterCompletionLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrUpdateMatterCompletionLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completionPercentage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrUpdateMatterCompletionLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"completionPercentage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completionPercentage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateOrUpdateMatterCompletionLogMutation, CreateOrUpdateMatterCompletionLogMutationVariables>;
export const CreateParentMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateParentMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phases"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createParentMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"phases"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phases"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateParentMatterMutation, CreateParentMatterMutationVariables>;
export const CreateAndAddPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhaseCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<CreateAndAddPhaseMutation, CreateAndAddPhaseMutationVariables>;
export const CreateAndAddPhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddPhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhaseCreateInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddPhases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<CreateAndAddPhasesMutation, CreateAndAddPhasesMutationVariables>;
export const CreateRateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RateCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RateParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RateResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isLevelRate"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRateMutation, CreateRateMutationVariables>;
export const CreateAndAddTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}}]}}]}}]} as unknown as DocumentNode<CreateAndAddTaskMutation, CreateAndAddTaskMutationVariables>;
export const CreateAndAddTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskCreateInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}}]}}]}}]} as unknown as DocumentNode<CreateAndAddTasksMutation, CreateAndAddTasksMutationVariables>;
export const CreateAndAddTechnologyChargeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddTechnologyCharge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyChargeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddTechnologyCharge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyChargeParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CreateAndAddTechnologyChargeMutation, CreateAndAddTechnologyChargeMutationVariables>;
export const CreateTechnologyUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTechnologyUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnitCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTechnologyUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<CreateTechnologyUnitMutation, CreateTechnologyUnitMutationVariables>;
export const CreateAndAddUpliftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddUplift"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpliftCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddUplift"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpliftParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpliftParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Uplift"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeOnProposal"}}]}}]} as unknown as DocumentNode<CreateAndAddUpliftMutation, CreateAndAddUpliftMutationVariables>;
export const CreateAndAddWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]} as unknown as DocumentNode<CreateAndAddWorkMutation, CreateAndAddWorkMutationVariables>;
export const AssignWorksToPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignWorksToPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkCreateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignWorksToPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]} as unknown as DocumentNode<AssignWorksToPhaseMutation, AssignWorksToPhaseMutationVariables>;
export const CreateFileDataImportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFileDataImport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VpdDataImportType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFileDataImport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"upload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataFrameResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"succeeded"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rowNumber"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateFileDataImportMutation, CreateFileDataImportMutationVariables>;
export const DeleteAllNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAllNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAllNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteAllNotificationsMutation, DeleteAllNotificationsMutationVariables>;
export const DeleteBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}}]}}]} as unknown as DocumentNode<DeleteBrandMutation, DeleteBrandMutationVariables>;
export const DeleteDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"discountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountId"}}]}}]}}]} as unknown as DocumentNode<DeleteDiscountMutation, DeleteDiscountMutationVariables>;
export const DeleteNotificationRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNotificationRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationRuleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNotificationRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationRuleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationRuleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationRuleId"}}]}}]}}]} as unknown as DocumentNode<DeleteNotificationRuleMutation, DeleteNotificationRuleMutationVariables>;
export const DeleteNotificationRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNotificationRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationRuleIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNotificationRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationRuleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationRuleIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationRuleIds"}}]}}]}}]} as unknown as DocumentNode<DeleteNotificationRulesMutation, DeleteNotificationRulesMutationVariables>;
export const DeleteNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationId"}}]}}]}}]} as unknown as DocumentNode<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const DeletePhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phaseId"}}]}}]}}]} as unknown as DocumentNode<DeletePhaseMutation, DeletePhaseMutationVariables>;
export const DeletePhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePhases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phaseIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phasesIds"}}]}}]}}]} as unknown as DocumentNode<DeletePhasesMutation, DeletePhasesMutationVariables>;
export const DeleteTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskId"}}]}}]}}]} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const DeleteTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasksIds"}}]}}]}}]} as unknown as DocumentNode<DeleteTasksMutation, DeleteTasksMutationVariables>;
export const DeleteTechnologyChargeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTechnologyCharge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"technologyChargeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTechnologyCharge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"technologyChargeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"technologyChargeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technologyChargeId"}}]}}]}}]} as unknown as DocumentNode<DeleteTechnologyChargeMutation, DeleteTechnologyChargeMutationVariables>;
export const DeleteTechnologyUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTechnologyUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTechnologyUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTechnologyUnitMutation, DeleteTechnologyUnitMutationVariables>;
export const DeleteUpliftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUplift"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upliftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUplift"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"upliftId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upliftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upliftId"}}]}}]}}]} as unknown as DocumentNode<DeleteUpliftMutation, DeleteUpliftMutationVariables>;
export const DeleteWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workId"}}]}}]}}]} as unknown as DocumentNode<DeleteWorkMutation, DeleteWorkMutationVariables>;
export const CreateAndAddDisbursementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndAddDisbursement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisbursementCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndAddDisbursement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CreateAndAddDisbursementMutation, CreateAndAddDisbursementMutationVariables>;
export const CreateLibraryDisbursementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLibraryDisbursement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryDisbursementCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLibraryDisbursement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}}]}}]}}]} as unknown as DocumentNode<CreateLibraryDisbursementMutation, CreateLibraryDisbursementMutationVariables>;
export const DeleteDisbursementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDisbursement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disbursementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDisbursement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"disbursementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disbursementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disbursementId"}}]}}]}}]} as unknown as DocumentNode<DeleteDisbursementMutation, DeleteDisbursementMutationVariables>;
export const UpdateDisbursementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDisbursement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disbursement"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDisbursementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDisbursement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"disbursement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disbursement"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<UpdateDisbursementMutation, UpdateDisbursementMutationVariables>;
export const UpdateDisbursementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDisbursements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisburmentUpdate"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDisbursements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<UpdateDisbursementsMutation, UpdateDisbursementsMutationVariables>;
export const UpdateLibraryDisbursementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLibraryDisbursements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryDisbursementUpdate"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLibraryDisbursements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}}]}}]}}]} as unknown as DocumentNode<UpdateLibraryDisbursementsMutation, UpdateLibraryDisbursementsMutationVariables>;
export const CreateExclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createExclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExclusionCreateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExclusionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryExclusionId"}}]}}]} as unknown as DocumentNode<CreateExclusionsMutation, CreateExclusionsMutationVariables>;
export const CreateLibraryExclusionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLibraryExclusion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryExclusionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLibraryExclusion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateLibraryExclusionMutation, CreateLibraryExclusionMutationVariables>;
export const DeleteExclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteExclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exclusionIds"}}]}}]}}]} as unknown as DocumentNode<DeleteExclusionsMutation, DeleteExclusionsMutationVariables>;
export const UpdateExclusionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateExclusion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExclusionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExclusion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExclusionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryExclusionId"}}]}}]} as unknown as DocumentNode<UpdateExclusionMutation, UpdateExclusionMutationVariables>;
export const UpdateExclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateExclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyExclusionsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExclusionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryExclusionId"}}]}}]} as unknown as DocumentNode<UpdateExclusionsMutation, UpdateExclusionsMutationVariables>;
export const UpdateLibraryExclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLibraryExclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryExclusionUpdate"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLibraryExclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedExclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterIds"}}]}}]}}]} as unknown as DocumentNode<UpdateLibraryExclusionsMutation, UpdateLibraryExclusionsMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const QuickLinkMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QuickLinkMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuickLinkMatterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quickLinkMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<QuickLinkMatterMutation, QuickLinkMatterMutationVariables>;
export const ReplaceTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"replaceTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberToAdd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembershipIds"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberToRemove"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembershipIds"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replaceTeamMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamMemberToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberToAdd"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamMemberToRemove"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberToRemove"}}},{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMembershipParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMembershipParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<ReplaceTeamMemberMutation, ReplaceTeamMemberMutationVariables>;
export const ToggleFavouriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleFavourite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favourite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleFavourite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"favourite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favourite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isFavourite"}}]}}]}}]} as unknown as DocumentNode<ToggleFavouriteMutation, ToggleFavouriteMutationVariables>;
export const ToggleIncludeInProposalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleIncludeInProposal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toggleIncludeInProposalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleIncludeInProposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"include"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toggleIncludeInProposalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"includeInProposalOutput"}}]}}]}}]} as unknown as DocumentNode<ToggleIncludeInProposalMutation, ToggleIncludeInProposalMutationVariables>;
export const UpdateActiveNotificationRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateActiveNotificationRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateActiveNotificationRulesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateActiveNotificationRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedIds"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<UpdateActiveNotificationRulesMutation, UpdateActiveNotificationRulesMutationVariables>;
export const UpdateBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBrandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}},{"kind":"Field","name":{"kind":"Name","value":"lineBreakInLists"}}]}}]} as unknown as DocumentNode<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const UpdateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}}]}}]}}]} as unknown as DocumentNode<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Discount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]} as unknown as DocumentNode<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const UpdateDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDiscountsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Discount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]} as unknown as DocumentNode<UpdateDiscountsMutation, UpdateDiscountsMutationVariables>;
export const UpdateFeeEarnerLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFeeEarnerLevels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyFeeEarnerLevelsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFeeEarnerLevels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedGpmVisible"}}]}}]}}]} as unknown as DocumentNode<UpdateFeeEarnerLevelsMutation, UpdateFeeEarnerLevelsMutationVariables>;
export const UpdateLastLoginAtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLastLoginAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLastLoginAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLastLoginAtMutation, UpdateLastLoginAtMutationVariables>;
export const UpdateLibraryTechnologiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLibraryTechnologies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLibraryTechnologyInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLibraryTechnologies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<UpdateLibraryTechnologiesMutation, UpdateLibraryTechnologiesMutationVariables>;
export const UpdateManyTechnologyRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyTechnologyRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyTechnologyRatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyTechnologyRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<UpdateManyTechnologyRatesMutation, UpdateManyTechnologyRatesMutationVariables>;
export const UpdateManyWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyWorkInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateManyWorkMutation, UpdateManyWorkMutationVariables>;
export const UpdateMatterCollaboratorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMatterCollaborators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMatterCollaboratorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMatterCollaborators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMatterCollaboratorsMutation, UpdateMatterCollaboratorsMutationVariables>;
export const UpdateParentMatterCollaboratorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateParentMatterCollaborators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMatterCollaboratorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParentMatterCollaborators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateParentMatterCollaboratorsMutation, UpdateParentMatterCollaboratorsMutationVariables>;
export const UpdateTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamMembersToAdd"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembershipIds"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamMembersToRemove"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembershipIds"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTeamMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamMembersToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamMembersToAdd"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamMembersToRemove"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamMembersToRemove"}}},{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMembershipParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMembershipParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>;
export const UpdateMatterTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMatterTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatterUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMatterTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatterTemplateParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}}]}}]} as unknown as DocumentNode<UpdateMatterTemplateMutation, UpdateMatterTemplateMutationVariables>;
export const UpdateManyMatterTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyMatterTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyTemplatesInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyMatterTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatterTemplateParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}}]}}]} as unknown as DocumentNode<UpdateManyMatterTemplateMutation, UpdateManyMatterTemplateMutationVariables>;
export const UpdateMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatterUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTarget"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"waiveAdminCharge"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}}]}}]} as unknown as DocumentNode<UpdateMatterMutation, UpdateMatterMutationVariables>;
export const UpdateNotificationRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotificationRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNotificationRulesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationRuleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationRuleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proposalGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFeeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"activeGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedBudgetThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"triggerBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdFilter"}},{"kind":"Field","name":{"kind":"Name","value":"triggerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerClients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationRuleMutation, UpdateNotificationRuleMutationVariables>;
export const UpdateOfficeLocationsByCountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOfficeLocationsByCountry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OfficeLocationsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOfficeLocationsByCountry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}}]}}]}}]} as unknown as DocumentNode<UpdateOfficeLocationsByCountryMutation, UpdateOfficeLocationsByCountryMutationVariables>;
export const UpdateOrganisationalUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganisationalUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganisationalUnitUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganisationalUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganisationalUnitMutation, UpdateOrganisationalUnitMutationVariables>;
export const UpdateOrganisationalUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganisationalUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyOrganisationalUnitsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganisationalUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganisationalUnitsMutation, UpdateOrganisationalUnitsMutationVariables>;
export const UpdatePhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhaseUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<UpdatePhaseMutation, UpdatePhaseMutationVariables>;
export const UpdatePhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePhasesInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<UpdatePhasesMutation, UpdatePhasesMutationVariables>;
export const UpdateQuickUpdateShownAtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateQuickUpdateShownAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuickUpdateShownAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateQuickUpdateShownAtMutation, UpdateQuickUpdateShownAtMutationVariables>;
export const UpdateSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"organisationPmsName"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictGpmVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"showGpmSlider"}},{"kind":"Field","name":{"kind":"Name","value":"enableAi"}},{"kind":"Field","name":{"kind":"Name","value":"enableTechPricing"}},{"kind":"Field","name":{"kind":"Name","value":"enableWordExport"}},{"kind":"Field","name":{"kind":"Name","value":"administrationCharge"}},{"kind":"Field","name":{"kind":"Name","value":"decimalTimeInput"}},{"kind":"Field","name":{"kind":"Name","value":"systemFont"}},{"kind":"Field","name":{"kind":"Name","value":"autoCloseIntervalInDays"}},{"kind":"Field","name":{"kind":"Name","value":"staleMatterWarningThresholdInDays"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"enablePiiFiltering"}},{"kind":"Field","name":{"kind":"Name","value":"showLibraryAssumptionsExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAiSuggestionsToShow"}},{"kind":"Field","name":{"kind":"Name","value":"showClarifyingQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"taxEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"taxEnabledOptionDefault"}}]}}]} as unknown as DocumentNode<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const UpdateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}}]}}]} as unknown as DocumentNode<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}}]}}]} as unknown as DocumentNode<UpdateTasksMutation, UpdateTasksMutationVariables>;
export const UpdateTechnologyChargeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTechnologyCharge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"technologyCharge"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTechnologyChargeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTechnologyCharge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"technologyCharge"},"value":{"kind":"Variable","name":{"kind":"Name","value":"technologyCharge"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyChargeParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<UpdateTechnologyChargeMutation, UpdateTechnologyChargeMutationVariables>;
export const UpdateTechnologyChargesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTechnologyCharges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTechnologyChargeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTechnologyCharges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyChargeParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<UpdateTechnologyChargesMutation, UpdateTechnologyChargesMutationVariables>;
export const UpdateTechnologyUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTechnologyUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTechnologyUnitInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTechnologyUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<UpdateTechnologyUnitsMutation, UpdateTechnologyUnitsMutationVariables>;
export const UpdateUpliftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUplift"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpliftUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUplift"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpliftParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpliftParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Uplift"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeOnProposal"}}]}}]} as unknown as DocumentNode<UpdateUpliftMutation, UpdateUpliftMutationVariables>;
export const UpdateUpliftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUplifts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManyUpliftsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUplifts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpliftParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpliftParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Uplift"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeOnProposal"}}]}}]} as unknown as DocumentNode<UpdateUpliftsMutation, UpdateUpliftsMutationVariables>;
export const UpdateUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSettingsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"darkTheme"}},{"kind":"Field","name":{"kind":"Name","value":"customPaletteHex"}}]}}]}}]} as unknown as DocumentNode<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UpdateWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]} as unknown as DocumentNode<UpdateWorkMutation, UpdateWorkMutationVariables>;
export const FindAccruedFeesForMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAccruedFeesForMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAccruedFeesForMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedFeeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollaboratorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaborator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedTimeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"actualDuration"}},{"kind":"Field","name":{"kind":"Name","value":"actualDurationSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCostSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"durationAsPercentageOfTotalMatterDuration"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedFeeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollaboratorFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeAccrued"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<FindAccruedFeesForMatterQuery, FindAccruedFeesForMatterQueryVariables>;
export const FindAccruedFeesForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAccruedFeesForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedFeeForUserPagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"findAccruedFeesForUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedFeeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollaboratorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaborator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedTimeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"actualDuration"}},{"kind":"Field","name":{"kind":"Name","value":"actualDurationSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCostSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"durationAsPercentageOfTotalMatterDuration"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedFeeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollaboratorFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeAccrued"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<FindAccruedFeesForUserQuery, FindAccruedFeesForUserQueryVariables>;
export const FindAccruedFeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAccruedFees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedFeePagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"findAccruedFees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedFeeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollaboratorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaborator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedTimeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"actualDuration"}},{"kind":"Field","name":{"kind":"Name","value":"actualDurationSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCostSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"durationAsPercentageOfTotalMatterDuration"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedFeeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollaboratorFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeAccrued"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<FindAccruedFeesQuery, FindAccruedFeesQueryVariables>;
export const FindAllClientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindAllClients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allClients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}}]}}]}}]}}]} as unknown as DocumentNode<FindAllClientsQuery, FindAllClientsQueryVariables>;
export const AllFeeEarnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllFeeEarners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allFeeEarners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeeEarnerParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeeEarnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEarner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AllFeeEarnersQuery, AllFeeEarnersQueryVariables>;
export const FindAllUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindAllUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<FindAllUsersQuery, FindAllUsersQueryVariables>;
export const BedrockCheckMatterTitleIsDescriptiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BedrockCheckMatterTitleIsDescriptive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockCheckMatterTitleIsDescriptive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterTitle"}}}]}]}}]} as unknown as DocumentNode<BedrockCheckMatterTitleIsDescriptiveQuery, BedrockCheckMatterTitleIsDescriptiveQueryVariables>;
export const BedrockStartStreamingClarifyingQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BedrockStartStreamingClarifyingQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockStartStreamingClarifyingQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BedrockStartStreamingClarifyingQuestionsMutation, BedrockStartStreamingClarifyingQuestionsMutationVariables>;
export const StreamingClarifyingQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"StreamingClarifyingQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamingClarifyingQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"allowOther"}},{"kind":"Field","name":{"kind":"Name","value":"otherPlaceholder"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"currentQuestionIndex"}}]}}]}}]} as unknown as DocumentNode<StreamingClarifyingQuestionsSubscription, StreamingClarifyingQuestionsSubscriptionVariables>;
export const BedrockStartStreamingMatterSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BedrockStartStreamingMatterSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSummaryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockStartStreamingMatterSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BedrockStartStreamingMatterSummaryMutation, BedrockStartStreamingMatterSummaryMutationVariables>;
export const StreamingMatterSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"StreamingMatterSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamingMatterSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"chunk"}},{"kind":"Field","name":{"kind":"Name","value":"fullSummary"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<StreamingMatterSummarySubscription, StreamingMatterSummarySubscriptionVariables>;
export const BedrockGetPhasesAndTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BedrockGetPhasesAndTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useLibraryData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refineMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customPrompt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockGetPhasesAndTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useLibraryData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useLibraryData"}}},{"kind":"Argument","name":{"kind":"Name","value":"refineMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refineMode"}}},{"kind":"Argument","name":{"kind":"Name","value":"customPrompt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customPrompt"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phaseTitle"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}}]}}]}}]} as unknown as DocumentNode<BedrockGetPhasesAndTasksQuery, BedrockGetPhasesAndTasksQueryVariables>;
export const BedrockGetRoiAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BedrockGetRoiAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roiData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoiAnalysisInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockRoiAnalyseAndRecommend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roiData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roiData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analysis"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}}]}}]}}]} as unknown as DocumentNode<BedrockGetRoiAnalysisQuery, BedrockGetRoiAnalysisQueryVariables>;
export const BedrockSuggestAssumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BedrockSuggestAssumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockSuggestAssumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chosen"}},{"kind":"Field","name":{"kind":"Name","value":"suggested"}}]}}]}}]} as unknown as DocumentNode<BedrockSuggestAssumptionsQuery, BedrockSuggestAssumptionsQueryVariables>;
export const BedrockSuggestExclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BedrockSuggestExclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockSuggestExclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chosen"}},{"kind":"Field","name":{"kind":"Name","value":"suggested"}}]}}]}}]} as unknown as DocumentNode<BedrockSuggestExclusionsQuery, BedrockSuggestExclusionsQueryVariables>;
export const BedrockSuggestPracticeAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BedrockSuggestPracticeAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"practiceAreaName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockSuggestPracticeAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"practiceAreaName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"practiceAreaName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BedrockSuggestPracticeAreasQuery, BedrockSuggestPracticeAreasQueryVariables>;
export const BedrockGetTasksForPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BedrockGetTasksForPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refineMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customPrompt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrockGetTasksForPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refineMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refineMode"}}},{"kind":"Argument","name":{"kind":"Name","value":"customPrompt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customPrompt"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"}}]}}]}}]} as unknown as DocumentNode<BedrockGetTasksForPhaseQuery, BedrockGetTasksForPhaseQueryVariables>;
export const CurrenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseCurrency"}}]}}]}}]} as unknown as DocumentNode<CurrenciesQuery, CurrenciesQueryVariables>;
export const DataImportRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportRecordsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportRecordsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}}]}}]}}]} as unknown as DocumentNode<DataImportRecordsQuery, DataImportRecordsQueryVariables>;
export const DataImportSchemaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportSchema"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VpdDataImportType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportSchema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"minLength"}},{"kind":"Field","name":{"kind":"Name","value":"maxLength"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]}}]} as unknown as DocumentNode<DataImportSchemaQuery, DataImportSchemaQueryVariables>;
export const FindFeeEarnerLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedGpmVisible"}}]}}]}}]}}]} as unknown as DocumentNode<FindFeeEarnerLevelsQuery, FindFeeEarnerLevelsQueryVariables>;
export const FeeEarnerLevelsAndFeeEarnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeeEarnerLevelsAndFeeEarners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FeeEarnerLevelsAndFeeEarnersQuery, FeeEarnerLevelsAndFeeEarnersQueryVariables>;
export const FeeEarnersByLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeeEarnersByLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeEarnerLevelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnersByLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feeEarnerLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeEarnerLevelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FeeEarnersByLevelQuery, FeeEarnersByLevelQueryVariables>;
export const FindFeeEarnerByLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFeeEarnerByLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}}]}}]}}]} as unknown as DocumentNode<FindFeeEarnerByLevelsQuery, FindFeeEarnerByLevelsQueryVariables>;
export const FilterUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeLoggedInUserFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restrictedExternalMatterId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restrictedClientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeLoggedInUserFirst"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeLoggedInUserFirst"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"restrictedExternalMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restrictedExternalMatterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"restrictedClientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restrictedClientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}}]}}]} as unknown as DocumentNode<FilterUsersQuery, FilterUsersQueryVariables>;
export const FindFilteredClientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFilteredClients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterArg"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredClients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindFilteredClientsQuery, FindFilteredClientsQueryVariables>;
export const FilterExternalMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterExternalMatters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilteredExternalMattersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredExternalMatters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalMatterParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationalUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganisationalUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeeEarnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEarner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalMatter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationalUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeeEarnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]} as unknown as DocumentNode<FilterExternalMattersQuery, FilterExternalMattersQueryVariables>;
export const FilterMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterMatters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilteredMattersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredMatters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isParent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FilterMattersQuery, FilterMattersQueryVariables>;
export const FindAllBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAllBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}}]}}]}}]} as unknown as DocumentNode<FindAllBrandsQuery, FindAllBrandsQueryVariables>;
export const FindAllExternalMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAllExternalMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllExternalMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalMatterParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationalUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganisationalUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeeEarnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEarner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalMatter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationalUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeeEarnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]} as unknown as DocumentNode<FindAllExternalMattersQuery, FindAllExternalMattersQueryVariables>;
export const FindAllLibraryUpliftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAllLibraryUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllLibraryUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]} as unknown as DocumentNode<FindAllLibraryUpliftsQuery, FindAllLibraryUpliftsQueryVariables>;
export const FindAllMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAllMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}},{"kind":"Field","name":{"kind":"Name","value":"lineBreakInLists"}}]}}]} as unknown as DocumentNode<FindAllMattersQuery, FindAllMattersQueryVariables>;
export const FindClientsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindClientsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getClientsByIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindClientsByIdsQuery, FindClientsByIdsQueryVariables>;
export const FindCumulativeAccruedFeesForExternalMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindCumulativeAccruedFeesForExternalMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCumulativeAccruedFeesForExternalMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalMatterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMatterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<FindCumulativeAccruedFeesForExternalMatterQuery, FindCumulativeAccruedFeesForExternalMatterQueryVariables>;
export const FindCumulativeAccruedFeesForMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindCumulativeAccruedFeesForMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCumulativeAccruedFeesForMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<FindCumulativeAccruedFeesForMatterQuery, FindCumulativeAccruedFeesForMatterQueryVariables>;
export const FindLatestSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindLatestSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findLatestSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"organisationPmsName"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictGpmVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"showGpmSlider"}},{"kind":"Field","name":{"kind":"Name","value":"enableAi"}},{"kind":"Field","name":{"kind":"Name","value":"enableTechPricing"}},{"kind":"Field","name":{"kind":"Name","value":"enableWordExport"}},{"kind":"Field","name":{"kind":"Name","value":"administrationCharge"}},{"kind":"Field","name":{"kind":"Name","value":"decimalTimeInput"}},{"kind":"Field","name":{"kind":"Name","value":"systemFont"}},{"kind":"Field","name":{"kind":"Name","value":"autoCloseIntervalInDays"}},{"kind":"Field","name":{"kind":"Name","value":"staleMatterWarningThresholdInDays"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"enablePiiFiltering"}},{"kind":"Field","name":{"kind":"Name","value":"showLibraryAssumptionsExclusions"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAiSuggestionsToShow"}},{"kind":"Field","name":{"kind":"Name","value":"showClarifyingQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"taxEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"taxEnabledOptionDefault"}}]}}]} as unknown as DocumentNode<FindLatestSettingsQuery, FindLatestSettingsQueryVariables>;
export const FindMatterCompletionLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMatterCompletionLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMatterCompletionLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FindMatterCompletionLogsQuery, FindMatterCompletionLogsQueryVariables>;
export const FindMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"isFavourite"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyChargeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeOnProposal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTarget"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeFeeEarnersInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMembershipParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskInclude"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskCappedFeeInclude"}},{"kind":"Field","name":{"kind":"Name","value":"waiveAdminCharge"}},{"kind":"Field","name":{"kind":"Name","value":"waiveAdminChargeReason"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confidential"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"pinnedMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedMatterSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyChargeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologyId"}},{"kind":"Field","name":{"kind":"Name","value":"libraryTechnology"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}},{"kind":"Field","name":{"kind":"Name","value":"lineBreakInLists"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMembershipParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FindMatterQuery, FindMatterQueryVariables>;
export const FindRelevantExternalMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindRelevantExternalMatters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RelevantExternalMattersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fetchAccruedFees"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unlinkedOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distanceThreshold"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}},"defaultValue":{"kind":"IntValue","value":"2"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalSearchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findRelevantExternalMatters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"fetchAccruedFees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchAccruedFees"}}},{"kind":"Argument","name":{"kind":"Name","value":"unlinkedOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unlinkedOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"distanceThreshold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distanceThreshold"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxResults"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}}},{"kind":"Argument","name":{"kind":"Name","value":"additionalSearchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalSearchText"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relevanceScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"actualDuration"}},{"kind":"Field","name":{"kind":"Name","value":"actualDurationSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCostSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindRelevantExternalMattersQuery, FindRelevantExternalMattersQueryVariables>;
export const FindRelevantMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindRelevantMatters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RelevantMattersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fetchAccruedFees"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distanceThreshold"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}},"defaultValue":{"kind":"IntValue","value":"2"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalSearchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findRelevantMatters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"fetchAccruedFees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchAccruedFees"}}},{"kind":"Argument","name":{"kind":"Name","value":"distanceThreshold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distanceThreshold"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxResults"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}}},{"kind":"Argument","name":{"kind":"Name","value":"additionalSearchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalSearchText"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"relevanceScore"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isParent"}},{"kind":"Field","name":{"kind":"Name","value":"isFavourite"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTarget"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMembershipParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedFeeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollaboratorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collaborator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedTimeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedTime"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"actualDuration"}},{"kind":"Field","name":{"kind":"Name","value":"actualDurationSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCostSinceLastInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"durationAsPercentageOfTotalMatterDuration"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMembershipParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccruedFeeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccruedFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollaboratorFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeAccrued"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"matter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentTimeEntry"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"agreedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeVariance"}},{"kind":"Field","name":{"kind":"Name","value":"actualFeeRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpm"}},{"kind":"Field","name":{"kind":"Name","value":"actualGpmRiskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmSource"}},{"kind":"Field","name":{"kind":"Name","value":"percentageOnTarget"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccruedTimeFragment"}}]}}]}}]}}]} as unknown as DocumentNode<FindRelevantMattersQuery, FindRelevantMattersQueryVariables>;
export const FindSimilarExternalMattersForMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindSimilarExternalMattersForMatters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FindSimilarExternalMattersForMattersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSimilarExternalMattersForMatters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relevanceScore"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindSimilarExternalMattersForMattersQuery, FindSimilarExternalMattersForMattersQueryVariables>;
export const GetBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}},{"kind":"Field","name":{"kind":"Name","value":"lineBreakInLists"}}]}}]} as unknown as DocumentNode<GetBrandQuery, GetBrandQueryVariables>;
export const MatterSpecificRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"matterSpecificRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currencyCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterSpecificRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"currencyCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currencyCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isLevelRate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MatterSpecificRatesQuery, MatterSpecificRatesQueryVariables>;
export const GetPhaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPhase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<GetPhaseQuery, GetPhaseQueryVariables>;
export const GetPhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPhases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}}]} as unknown as DocumentNode<GetPhasesQuery, GetPhasesQueryVariables>;
export const GetRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RateFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isLevelRate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetRatesQuery, GetRatesQueryVariables>;
export const GetTaxInfoForMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTaxInfoForMatter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTaxInfoForMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}}]}}]}}]} as unknown as DocumentNode<GetTaxInfoForMatterQuery, GetTaxInfoForMatterQueryVariables>;
export const GetTopDownRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTopDownRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RateFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTopDownRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isLevelRate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTopDownRatesQuery, GetTopDownRatesQueryVariables>;
export const HasInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasInvoices"}}]}}]} as unknown as DocumentNode<HasInvoicesQuery, HasInvoicesQueryVariables>;
export const FindLibraryMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindLibraryMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryMatterParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryMatterParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<FindLibraryMattersQuery, FindLibraryMattersQueryVariables>;
export const IntegrationRecordCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntegrationRecordCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationRecordCountQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocations"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevels"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarners"}},{"kind":"Field","name":{"kind":"Name","value":"users"}},{"kind":"Field","name":{"kind":"Name","value":"clients"}},{"kind":"Field","name":{"kind":"Name","value":"rates"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatters"}},{"kind":"Field","name":{"kind":"Name","value":"timeEntries"}},{"kind":"Field","name":{"kind":"Name","value":"matterPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"matterInvoices"}},{"kind":"Field","name":{"kind":"Name","value":"currencies"}}]}}]}}]} as unknown as DocumentNode<IntegrationRecordCountQuery, IntegrationRecordCountQueryVariables>;
export const FindLibraryExclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindLibraryExclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryExclusionWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryExclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryExclusionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryExclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<FindLibraryExclusionsQuery, FindLibraryExclusionsQueryVariables>;
export const FindLibraryAssumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindLibraryAssumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryAssumptionWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryAssumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryAssumptionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryAssumptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryAssumption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<FindLibraryAssumptionsQuery, FindLibraryAssumptionsQueryVariables>;
export const FindLibraryDisbursementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindLibraryDisbursements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryDisbursementWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryDisbursements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryDisbursementFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryDisbursementFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryDisbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<FindLibraryDisbursementsQuery, FindLibraryDisbursementsQueryVariables>;
export const FindLibraryTechnologiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindLibraryTechnologies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryTechnologies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LibraryTechnologyParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyRateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyRates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LibraryTechnologyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LibraryTechnology"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"technologyUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyRateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<FindLibraryTechnologiesQuery, FindLibraryTechnologiesQueryVariables>;
export const FindMatterAssumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMatterAssumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterAssumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryAssumptionId"}}]}}]}}]} as unknown as DocumentNode<FindMatterAssumptionsQuery, FindMatterAssumptionsQueryVariables>;
export const FindMatterCollaboratorUserIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMatterCollaboratorUserIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterCollaborators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<FindMatterCollaboratorUserIdsQuery, FindMatterCollaboratorUserIdsQueryVariables>;
export const FindMatterExclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMatterExclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterExclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExclusionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExclusionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exclusion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"fromLibraryExclusionId"}}]}}]} as unknown as DocumentNode<FindMatterExclusionsQuery, FindMatterExclusionsQueryVariables>;
export const FindMatterTemplateListItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMatterTemplateListItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilteredMattersOrderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgUnitFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"templateType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgUnitFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgUnitFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatterTemplateListItemParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterTemplateListItemParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<FindMatterTemplateListItemsQuery, FindMatterTemplateListItemsQueryVariables>;
export const MatterTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"matterTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatterTemplateParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceOptionsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"topDownFeeTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownHoursTarget"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Work"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"workEffort"}},{"kind":"Field","name":{"kind":"Name","value":"topDownRateDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhaseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Phase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"markedComplete"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDate"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatterTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Matter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceOptionsParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhaseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}}]}}]} as unknown as DocumentNode<MatterTemplateQuery, MatterTemplateQueryVariables>;
export const GetAllPerformanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPerformance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllPerformance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mattersStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mattersPerArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnitName"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllPerformanceQuery, GetAllPerformanceQueryVariables>;
export const FindNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"isParent"}}]}}]}}]} as unknown as DocumentNode<FindNotificationsQuery, FindNotificationsQueryVariables>;
export const NotificationRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationRuleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationRuleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proposalGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFeeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"activeGpmThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedBudgetThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"accruedTimeThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"triggerBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdBooleanType"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdFilter"}},{"kind":"Field","name":{"kind":"Name","value":"triggerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerClients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerMatters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyFeeEarnerLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]} as unknown as DocumentNode<NotificationRulesQuery, NotificationRulesQueryVariables>;
export const NotifyCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotifyCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationalUnitIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countNotifyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisationalUnitIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationalUnitIds"}}}]}]}}]} as unknown as DocumentNode<NotifyCountQuery, NotifyCountQueryVariables>;
export const FindOfficeLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOfficeLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"officeLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}},{"kind":"Field","name":{"kind":"Name","value":"taxLevelPercent"}}]}}]}}]} as unknown as DocumentNode<FindOfficeLocationsQuery, FindOfficeLocationsQueryVariables>;
export const FindOrganisationalUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOrganisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationalUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"gpmDangerThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"gpmWarningThreshold"}}]}}]}}]}}]} as unknown as DocumentNode<FindOrganisationalUnitsQuery, FindOrganisationalUnitsQueryVariables>;
export const PhasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Phases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"findParentMatterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findParentMatter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"findParentMatterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<PhasesQuery, PhasesQueryVariables>;
export const GenerateParentProposalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"generateParentProposal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateParentProposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProposalParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProposalParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tax"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalIncludingTax"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRangeIncludingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProposalParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Proposal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasks"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeFeeEarnersInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"assignedResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTotalBeforeVisibleUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRangeDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeAdminCharge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRangeAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementsTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementsTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assumptions"}},{"kind":"Field","name":{"kind":"Name","value":"exclusions"}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeAdminCharge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedGrandTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskInclude"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskCappedFeeInclude"}}]}}]} as unknown as DocumentNode<GenerateParentProposalQuery, GenerateParentProposalQueryVariables>;
export const GenerateProposalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"generateProposal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateProposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasks"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"excludeTax"}},{"kind":"Field","name":{"kind":"Name","value":"assignedResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerName"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTotalBeforeVisibleUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeUplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRangeDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeAdminCharge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRangeAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalFeeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementsTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursementsTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assumptions"}},{"kind":"Field","name":{"kind":"Name","value":"exclusions"}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedLegalFeeAdminCharge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAdminCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminChargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"adminChargedAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixedGrandTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskLower"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskInclude"}},{"kind":"Field","name":{"kind":"Name","value":"feeRiskCappedFeeInclude"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tax"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalIncludingTax"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmountRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRangeIncludingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}}]}}]} as unknown as DocumentNode<GenerateProposalQuery, GenerateProposalQueryVariables>;
export const RoiQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roiQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoiQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roiQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roiTimeSeriesDataJSON"}},{"kind":"Field","name":{"kind":"Name","value":"timeIntervalsJSON"}}]}}]}}]} as unknown as DocumentNode<RoiQueryQuery, RoiQueryQueryVariables>;
export const FindTechnologyUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindTechnologyUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technologyUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnologyUnitParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnologyUnitParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechnologyUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<FindTechnologyUnitsQuery, FindTechnologyUnitsQueryVariables>;
export const TextFilterMattersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TextFilterMatters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"textFilterArg"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textFilteredMatters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TextFilterMattersQuery, TextFilterMattersQueryVariables>;
export const UsageReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsageReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsageReportQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usageReportQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeSeriesData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeLabelString"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"practiceAreaCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMattersStatusCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"mattersByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mattersByStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMattersByStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mattersByLinkedUnlinked"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mattersByPracticeArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templatesByPracticeArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"byStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"byLinkedUnlinked"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templatesByTemplateType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsageReportQuery, UsageReportQueryVariables>;
export const GetUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"darkTheme"}},{"kind":"Field","name":{"kind":"Name","value":"customPaletteHex"}}]}}]}}]} as unknown as DocumentNode<GetUserSettingsQuery, GetUserSettingsQueryVariables>;
export const GenerateWorkplanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"generateWorkplan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateWorkplan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"resourceAndTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceAndTimeTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenerateWorkplanQuery, GenerateWorkplanQueryVariables>;
export const CreatedOrUpdatedMatterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CreatedOrUpdatedMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdOrUpdatedMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"parentMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"matters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMatterId"}},{"kind":"Field","name":{"kind":"Name","value":"externalMatter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uplifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"baseUplift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"autoFocus"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"priceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeGpm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeSuggestedUpper"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenLower"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedRangeChosenUpper"}},{"kind":"Field","name":{"kind":"Name","value":"fixedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuggested"}},{"kind":"Field","name":{"kind":"Name","value":"fixedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedChosen"}},{"kind":"Field","name":{"kind":"Name","value":"cappedGpm"}},{"kind":"Field","name":{"kind":"Name","value":"cappedSuggested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phaseId"}},{"kind":"Field","name":{"kind":"Name","value":"timeLower"}},{"kind":"Field","name":{"kind":"Name","value":"timeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"timeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"single"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadFeeEarner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"taxStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"disbursements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisbursementParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisbursementParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Disbursement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vatStatus"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisationName"}},{"kind":"Field","name":{"kind":"Name","value":"organisationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"includeTasksInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"includeRatesInProposalOutput"}},{"kind":"Field","name":{"kind":"Name","value":"proposalFont"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"numberedListFormat"}},{"kind":"Field","name":{"kind":"Name","value":"lineBreakInLists"}}]}}]} as unknown as DocumentNode<CreatedOrUpdatedMatterSubscription, CreatedOrUpdatedMatterSubscriptionVariables>;
export const FileDataImportCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FileDataImportCompleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDataImportCompleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"importErrors"}},{"kind":"Field","name":{"kind":"Name","value":"totalErrors"}}]}}]}}]} as unknown as DocumentNode<FileDataImportCompletedSubscription, FileDataImportCompletedSubscriptionVariables>;
export const FileDataImportProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FileDataImportProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDataImportProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"hasError"}}]}}]}}]} as unknown as DocumentNode<FileDataImportProgressSubscription, FileDataImportProgressSubscriptionVariables>;
export const NewNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NewNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"matterId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"isParent"}}]}}]}}]} as unknown as DocumentNode<NewNotificationSubscription, NewNotificationSubscriptionVariables>;
export const UpdateClientReportHtmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClientReportHtml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClientReportOutputInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClientReportHtml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}]}]}}]} as unknown as DocumentNode<UpdateClientReportHtmlMutation, UpdateClientReportHtmlMutationVariables>;
export const ClientReportByMatterIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientReportByMatterId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"costProjectionSvgString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientReportByMatterId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"costProjectionSvgString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"costProjectionSvgString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"clientReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matterTitle"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"}},{"kind":"Field","name":{"kind":"Name","value":"plannedFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceParts"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceRangeParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualFee"}},{"kind":"Field","name":{"kind":"Name","value":"overBudget"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalFeeNet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountBilled"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"billingChart"}},{"kind":"Field","name":{"kind":"Name","value":"includeBillingChart"}},{"kind":"Field","name":{"kind":"Name","value":"costProjectionDiagram"}},{"kind":"Field","name":{"kind":"Name","value":"includeCostProjectionDiagram"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeAccruedFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matterCompletionLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"outputTemplateName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Price"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceRangeParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}}]} as unknown as DocumentNode<ClientReportByMatterIdQuery, ClientReportByMatterIdQueryVariables>;
export const UpdateClientReportOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClientReportOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateOptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClientReportOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClientReportOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includeCostProjectionDiagram"}},{"kind":"Field","name":{"kind":"Name","value":"includeBillingChart"}}]}}]}}]} as unknown as DocumentNode<UpdateClientReportOptionsMutation, UpdateClientReportOptionsMutationVariables>;
export const CurrentUserFeeEarnerDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserFeeEarnerData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserFeeEarnerData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelId"}},{"kind":"Field","name":{"kind":"Name","value":"practiceAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedGpmVisible"}},{"kind":"Field","name":{"kind":"Name","value":"practiceAreaName"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerLevelDescription"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"organisationalUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"quickUpdateShownAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeEarnerId"}},{"kind":"Field","name":{"kind":"Name","value":"officeLocationName"}}]}}]}}]} as unknown as DocumentNode<CurrentUserFeeEarnerDataQuery, CurrentUserFeeEarnerDataQueryVariables>;